import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import * as React from 'react';
import React__default, { useState, useRef, useEffect, useLayoutEffect, cloneElement, useImperativeHandle, useMemo, useCallback, useContext, memo } from 'react';
import { findDOMNode, createPortal } from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$f = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$f.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$4 = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue$2 = function getValue(n, scale) {
  return get$3(scale, n, n);
};

var get$3 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get$3(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$3(props.theme, 'breakpoints', defaults$4.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue$2 : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$2 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth$1 = function getWidth(n, scale) {
  return get$3(scale, n, !isNumber$2(n) || n > 1 ? n : n * 100 + '%');
};

var config$7 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth$1
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$7);

var config$6 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
var color = system(config$6);

var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$5);

var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$4);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$3);

var config$2 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$2.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$2.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$2.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$2.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$2.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$2.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$2.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$2.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$2.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$2.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$2.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$2.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$2.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$2.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$2.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$2.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$2);

var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
var background = system(config$1);

var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$1.space
  }
};
var position = system(config);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber$1(n)) {
    return get$3(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$3(scale, absolute, absolute);

  if (!isNumber$1(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);

system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get$2 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales$2 = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get$2(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$2(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$2({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get$2(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$2({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get$2(theme, val))(theme);
        result = _extends$2({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get$2(aliases, key, key);
      var scaleName = get$2(scales$2, prop);
      var scale = get$2(theme, scaleName, get$2(theme, prop, {}));
      var transform = get$2(transforms, prop, get$2);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
var css$1 = css;

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css$1(get$3(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get$3(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
variant({
  key: 'buttons'
});
variant({
  key: 'textStyles',
  prop: 'textStyle'
});
variant({
  key: 'colorStyles',
  prop: 'colors'
});

layout.width;
    layout.height;
    layout.minWidth;
    layout.minHeight;
    layout.maxWidth;
    layout.maxHeight;
    layout.size;
    layout.verticalAlign;
    layout.display;
    layout.overflow;
    layout.overflowX;
    layout.overflowY;
color.opacity;
typography.fontSize;
    typography.fontFamily;
    typography.fontWeight;
    typography.lineHeight;
    typography.textAlign;
    typography.fontStyle;
    typography.letterSpacing;
flexbox.alignItems;
    flexbox.alignContent;
    flexbox.justifyItems;
    flexbox.justifyContent;
    flexbox.flexWrap;
    flexbox.flexDirection;
    flexbox.flex;
    flexbox.flexGrow;
    flexbox.flexShrink;
    flexbox.flexBasis;
    flexbox.justifySelf;
    flexbox.alignSelf;
    flexbox.order;
grid.gridGap;
    grid.gridColumnGap;
    grid.gridRowGap;
    grid.gridColumn;
    grid.gridRow;
    grid.gridAutoFlow;
    grid.gridAutoColumns;
    grid.gridAutoRows;
    grid.gridTemplateColumns;
    grid.gridTemplateRows;
    grid.gridTemplateAreas;
    grid.gridArea;
border.borderWidth;
    border.borderStyle;
    border.borderColor;
    border.borderTop;
    border.borderRight;
    border.borderBottom;
    border.borderLeft;
    border.borderRadius;
background.backgroundImage;
    background.backgroundSize;
    background.backgroundPosition;
    background.backgroundRepeat;
position.zIndex;
    position.top;
    position.right;
    position.bottom;
    position.left;

var Box = styled.div(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), background, border, layout, position, space);
var templateObject_1$Z;

var Flex = styled(Box)(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), flexbox);
var FlexWithGap = styled(Box)(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  display: flex;\n  ", ";\n  gap: ", ";\n"], ["\n  display: flex;\n  ", ";\n  gap: ", ";\n"])), flexbox, function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1$Y, templateObject_2$F;

var Grid$2 = styled(Box)(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  display: grid;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  ", "\n  ", "\n"])), flexbox, grid);
var GridWithGap = styled(Box)(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  display: grid;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: grid;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var gridGaps = _a.gridGaps;
    return gridGaps && "grid-grap: ".concat(gridGaps, ";");
}, function (_a) {
    var gridRowGaps = _a.gridRowGaps;
    return gridRowGaps && "row-gap: ".concat(gridRowGaps, ";");
}, function (_a) {
    var gridColumnGaps = _a.gridColumnGaps;
    return gridColumnGaps && "column-gap: ".concat(gridColumnGaps, ";");
}, flexbox, grid);
var templateObject_1$X, templateObject_2$E;

var CoinIco = "data:image/svg+xml,%3Csvg%20width%3D%2297%22%20height%3D%2224%22%20viewBox%3D%220%200%2097%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Crect%20width%3D%2220%22%20height%3D%2220%22%20fill%3D%22url%28%23pattern0%29%22%2F%3E%3Cpath%20d%3D%22M35.28%2014.472C35.28%2015.3893%2035.0667%2016.04%2034.64%2016.424C34.224%2016.808%2033.5307%2017%2032.56%2017H29.36V5.8H32.368C33.3173%205.8%2034.0107%205.992%2034.448%206.376C34.896%206.76%2035.12%207.4%2035.12%208.296V9.208C35.12%2010.0293%2034.8267%2010.648%2034.24%2011.064C34.9333%2011.448%2035.28%2012.104%2035.28%2013.032V14.472ZM33.728%208.152C33.728%207.74667%2033.632%207.45333%2033.44%207.272C33.2587%207.09067%2032.9653%207%2032.56%207H30.752V10.536H32.56C32.8907%2010.536%2033.168%2010.4293%2033.392%2010.216C33.616%2010.0027%2033.728%209.72%2033.728%209.368V8.152ZM33.888%2012.888C33.888%2012.536%2033.7813%2012.2587%2033.568%2012.056C33.3547%2011.8427%2033.072%2011.736%2032.72%2011.736H30.752V15.8H32.704C33.1093%2015.8%2033.408%2015.7093%2033.6%2015.528C33.792%2015.336%2033.888%2015.0373%2033.888%2014.632V12.888ZM44.5126%2014.28C44.5126%2015.1867%2044.262%2015.8693%2043.7606%2016.328C43.27%2016.776%2042.5606%2017%2041.6326%2017H41.2326C40.3046%2017%2039.59%2016.776%2039.0886%2016.328C38.598%2015.8693%2038.3526%2015.1867%2038.3526%2014.28V5.8H39.7446V14.584C39.7446%2014.9147%2039.8673%2015.1973%2040.1126%2015.432C40.358%2015.6667%2040.678%2015.784%2041.0726%2015.784H41.7926C42.1873%2015.784%2042.5073%2015.6667%2042.7526%2015.432C42.998%2015.1973%2043.1206%2014.9147%2043.1206%2014.584V5.8H44.5126V14.28ZM51.2012%2013.24H49.8732L48.3052%206.952V17H47.0892V5.8H49.3132L50.5932%2011.528L51.8892%205.8H54.0492V17H52.8012V6.952L51.2012%2013.24ZM62.5779%2010.12C62.5779%2010.984%2062.3485%2011.624%2061.8899%2012.04C61.4312%2012.4453%2060.7539%2012.648%2059.8579%2012.648H58.1939V17H56.8019V5.8H59.8259C60.7325%205.8%2061.4152%206.00267%2061.8739%206.408C62.3432%206.80267%2062.5779%207.432%2062.5779%208.296V10.12ZM61.1859%208.152C61.1859%207.74667%2061.0899%207.45333%2060.8979%207.272C60.7165%207.09067%2060.4232%207%2060.0179%207H58.1939V11.448H60.0179C60.4232%2011.448%2060.7165%2011.3573%2060.8979%2011.176C61.0899%2010.984%2061.1859%2010.6853%2061.1859%2010.28V8.152Z%22%20fill%3D%22white%22%2F%3E%3Cdefs%3E%3Cpattern%20id%3D%22pattern0%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23image0_8819_313236%22%20transform%3D%22scale%280.00684932%29%22%2F%3E%3C%2Fpattern%3E%3Cimage%20id%3D%22image0_8819_313236%22%20width%3D%22146%22%20height%3D%22146%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAJIAAACSCAYAAACue5OOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw%2FeHBhY2tldCBiZWdpbj0i77u%2FIiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8%2BIDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0ZGNTE3NzVFQTExRUI4RUQ3RkFFNEM3QzRCMjNEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0ZGNTE4NzVFQTExRUI4RUQ3RkFFNEM3QzRCMjNEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDRkY1MTU3NUVBMTFFQjhFRDdGQUU0QzdDNEIyM0QiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDRkY1MTY3NUVBMTFFQjhFRDdGQUU0QzdDNEIyM0QiLz4gPC9yZGY6RGVzY3JpcHRpb24%2BIDwvcmRmOlJERj4gPC94OnhtcG1ldGE%2BIDw%2FeHBhY2tldCBlbmQ9InIiPz66AC3jAAAE%2FUlEQVR42uyd3U3bUBiGXTf3pBM0170JG%2BANyAZNNzADVBixgJmAsEGYAGeCmhuuwwSFAfpz3BoJooQ48XH8fvbzSFFUFQkTP3nf7%2FjkZxAY5%2Ff3L1N3dx3AC4vyPnO3pbvl4eVD3vQvHXTggTvGnTecrNwXT7Zndzcv5Zo7sZ58%2F9IQkXrBkbt9LZP7pxNr5m6Rz1%2FwoQPV9gdPatVg4hIq67VI5bPqDh%2B8CBXXmaWsVxu15m%2Bu%2BuGemAkigQ%2FOnUy5u436JlLEuffOuLhksOswblYk94cO3d1nzntjq7y78hpd5xOJNGqe66oyWRaJ%2BUhIJhIJqpA6mY5JJPAxM2XlXNodkcpnxxHn9%2BAyzbuWSKRRO5xsumiJSLAr5%2BsuWFoViUG7XWZdEWnMuWy94iLTIvl%2BHQ3sTWI9kZiPBFPJokgkkg4xiQQ%2BOH1ZwZkSqTxodvy1mFhMJNIIkRCpq0O3RZEYtDVHjii0aD%2FoPcFDQ9ZTa8Ijh6VEQiRdhpZEYj4SHjlIJPCCJZHY8Uek%2BstLThUiMR8hEvMRkEiASG%2Fmo1HAW48QiVpDJGoNqrIgkaA3icSOvz6ZtEjs%2BJthqZ5IzEc2yNVFIpEszEeXDzmJBLVXbNLDNh82aoa5%2BqqNWjOyYlMXiVrT5%2FHlaycQCWrXGtUGdZlJi8SOv61aU04kak2f9PU%2FVEWi1rR5DlY%2BRxKRYK%2FZaPV7cVVFYsffUK1JisRbj%2BS5cWm0lBeJWpOfjeJ1%2F6EoEokkXGmrsxGJBLvyuG42khSJHX9pppvSSDGRqDVNrpxE2Xs%2FoCYStaZZacm2HyKRYBuT9yqNRIIqnL3emDUhEl8vKkdx4TGt%2BsNKiUQa6XAfbLjwuImB0MEv3e2CcyhBWmUuAvBOyEMAiASIBIgEgEiASIBIgEgAiASIBIgE%2FWPvTdtfp%2F9264c8hK3z9PE2yM2KFPz%2FbBxeqC%2BAe1J%2FcjK1ulsf7nngvNtDi6nVGSni3CGSD5F4NaMWY9cSIxIJfDAhkcAHkSmRymU%2F7%2FZApNqJRBppctTmnIRI3cKUSAzauhxbEmnM%2BZJlaEIk18GkESJ5SSTmI6rNi0gkEpBIICASO%2F7gK5GoNfAiErWmT25BJBJJnycLIpFIUE8kdvzNkKknEmlEtSFSX2jzbUlVRWLQ1mdhYfnPjj9L%2F3oisePPoO0rkZiPEMmLSCSSPvcW3rJNIukza%2FsAwi3zETv%2BNphLi0Stmam1pbpI1Jo%2BqcJBkEi2eVaoNRKpA7NR26u1rSKVb%2F9lx1%2BbROVAQmrNLDcKQ3YVkag10giRSCMdkU44X7IrtVjtoMINgzbzkXClqazUqiQStaZJcRU7VTwwRLLFVPXAQpb%2BZjhT%2BKqIyiKx4y%2FJQrXS3kskak2Lx6Dlz9DeVyRqTWupP1FcpSGSLWLluYhqs8E3J9HMysGGK4P2KGDHX4ELSxKtSyRqrX2KfbTE2kGH1JoUV06iqcUDHyASM1ETicSOPxLVSyR2%2FFuhuE4UWVniV00kau2w3BePeRckQqQWV2ZlEi278gcNWPofvMpi6%2FPQRpHY8T8IxSeqTbuUQusSiVprNoUS9ZeB%2BBKJWmtuFoot7N4jkm6NxV1ZkVFt7QhU1FjWtz98wI6%2FtwpL%2B5RA6xKJWtuP4oJisYyf9WEGqiIStbZbdRWfRzTv6jIekZpJnEKWoq6yPs49u%2FBXgAEAyd8l4rFQOH8AAAAASUVORK5CYII%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var CornerIco = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAsCAYAAAANUxr1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgB7dKrEYAwEIThC0MTeAQVIOi/CAQ+DkoAS9bsMDxyCfvJUzezf7B+2O1smYNl1Jgzeohpu3FKDtEsa1OajPHXUFy35JC7KU3G+GsID7mb0mSM/4bQ101pMqa8htDbTWkypvyG0NNNaTKmvobQ3aY0GVN/Q+hqU5qM+V9DiDWlyRg1hLApTca4e+gA1Mk8RFoN36MAAAAASUVORK5CYII=";

var siteWidth = 1200;
var BOX_SHADOW_WIDTH$5 = 4;

function useHover() {
    var _a = useState(false), value = _a[0], setValue = _a[1];
    var ref = useRef(null);
    var handleMouseOver = function () { return setValue(true); };
    var handleMouseOut = function () { return setValue(false); };
    useEffect(function () {
        var node = ref.current;
        if (node) {
            node.addEventListener('mouseover', handleMouseOver);
            node.addEventListener('mouseout', handleMouseOut);
            return function () {
                node.removeEventListener('mouseover', handleMouseOver);
                node.removeEventListener('mouseout', handleMouseOut);
            };
        }
    }, [ref.current]);
    return [ref, value];
}

/*
 * If window object don't loaded now we use useLayoutEffect which will be call
 * when DOM will be loaded
 * */
var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

var breakpointMap = {
    xs: 370,
    sm: 576,
    md: 852,
    lg: 968,
    xl: 1080,
    xxl: 1200,
};
var breakpoints = Object.values(breakpointMap).map(function (breakpoint) { return "".concat(breakpoint, "px"); });
var mediaQueries$1 = {
    xs: "@media screen and (max-width: ".concat(breakpointMap.xs, "px)"),
    sm: "@media screen and (max-width: ".concat(breakpointMap.sm, "px)"),
    md: "@media screen and (max-width: ".concat(breakpointMap.md, "px)"),
    lg: "@media screen and (max-width: ".concat(breakpointMap.lg, "px)"),
    xl: "@media screen and (max-width: ".concat(breakpointMap.xl, "px)"),
    xxl: "@media screen and (max-width: ".concat(breakpointMap.xxl, "px)"),
    nav: "@media screen and (max-width: ".concat(breakpointMap.lg, "px)"),
};
var shadows = {
    level1: '0px 2px 12px -8px rgba(25, 19, 38, 0.1), 0px 1px 1px rgba(25, 19, 38, 0.05)',
    active: '0px 0px 0px 1px #0098A1, 0px 0px 4px 8px rgba(31, 199, 212, 0.4)',
    success: '0px 0px 0px 1px #31D0AA, 0px 0px 0px 4px rgba(49, 208, 170, 0.2)',
    warning: '0px 0px 0px 1px #ED4B9E, 0px 0px 0px 4px rgba(237, 75, 158, 0.2)',
    focus: '0px 0px 0px 1px #7645D9, 0px 0px 0px 4px rgba(118, 69, 217, 0.6)',
    inset: 'inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)',
    tooltip: '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 4px 12px -8px rgba(14, 14, 44, 0.1)',
};
var spacing = [0, 4, 8, 16, 24, 32, 48, 64];
var zIndices = {
    dropdown: 10,
    modal: 100,
};
var base = {
    siteWidth: siteWidth,
    breakpoints: breakpoints,
    mediaQueries: mediaQueries$1,
    spacing: spacing,
    shadows: shadows,
    zIndices: zIndices,
};

/**
 * Can't use the media queries from "base.mediaQueries" because of how matchMedia works
 * In order for the listener to trigger we need have the media query with a range, e.g.
 * (min-width: 370px) and (max-width: 576px)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 */
var mediaQueries = (function () {
    var prevMinWidth = 0;
    return Object.keys(breakpointMap).reduce(function (accum, size, index) {
        var _a, _b;
        // Largest size is just a min-width of second highest max-width
        if (index === Object.keys(breakpointMap).length - 1) {
            return __assign(__assign({}, accum), (_a = {}, _a[size] = "(min-width: ".concat(prevMinWidth, "px)"), _a));
        }
        var minWidth = prevMinWidth;
        var breakpoint = breakpointMap[size];
        // Min width for next iteration
        prevMinWidth = breakpoint + 1;
        return __assign(__assign({}, accum), (_b = {}, _b[size] = "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(breakpoint, "px)"), _b));
    }, {});
})();
var getKey = function (size) {
    return "is".concat(size.charAt(0).toUpperCase()).concat(size.slice(1));
};
var getState = function () {
    var s = Object.keys(mediaQueries).reduce(function (accum, size) {
        var _a, _b;
        var _c;
        var key = getKey(size);
        if (typeof window === 'undefined') {
            return __assign(__assign({}, accum), (_a = {}, _a[key] = false, _a));
        }
        var mql = window.matchMedia(mediaQueries[size]);
        return __assign(__assign({}, accum), (_b = {}, _b[key] = (_c = mql === null || mql === void 0 ? void 0 : mql.matches) !== null && _c !== void 0 ? _c : false, _b));
    }, {});
    return s;
};
var useMatchBreakpoints = function () {
    var _a = useState(function () { return getState(); }), state = _a[0], setState = _a[1];
    useIsomorphicEffect(function () {
        // Create listeners for each media query returning a function to unsubscribe
        var handlers = Object.keys(mediaQueries).map(function (size) {
            var mql = window.matchMedia(mediaQueries[size]);
            var handler = function (matchMediaQuery) {
                var key = getKey(size);
                setState(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[key] = matchMediaQuery.matches, _a)));
                });
            };
            // Safari < 14 fix
            if (mql.addEventListener) {
                mql.addEventListener('change', handler);
            }
            return function () {
                // Safari < 14 fix
                if (mql.removeEventListener) {
                    mql.removeEventListener('change', handler);
                }
            };
        });
        setState(getState());
        return function () {
            handlers.forEach(function (unsubscribe) {
                unsubscribe();
            });
        };
    }, []);
    return __assign(__assign({}, state), { isMobile: state.isXs || state.isSm, isTablet: state.isMd || state.isLg, isDesktop: state.isXl || state.isXxl });
};

var IconSize;
(function (IconSize) {
    IconSize["S"] = "16px";
    IconSize["M"] = "24px";
    IconSize["L"] = "32px";
    IconSize["XL"] = "48px";
})(IconSize || (IconSize = {}));
var Orientation;
(function (Orientation) {
    Orientation["VERTICAL"] = "vertical";
    Orientation["HORIZONTAL"] = "horizontal";
})(Orientation || (Orientation = {}));
var VerticalOrientation;
(function (VerticalOrientation) {
    VerticalOrientation["UP"] = "up";
    VerticalOrientation["DOWN"] = "down";
})(VerticalOrientation || (VerticalOrientation = {}));
var HorizontalOrientation;
(function (HorizontalOrientation) {
    HorizontalOrientation["LEFT"] = "left";
    HorizontalOrientation["RIGHT"] = "right";
})(HorizontalOrientation || (HorizontalOrientation = {}));

var BORDER_WIDTH$1 = 4;
var PADDING_L = '4px 12px';
var PADDING_XL = '6px 24px';
var MIN_HEIGHT_L = '32px';
var MIN_HEIGHT_XL = '48px';
var FONT_SIZE_L = '16px';
var FONT_SIZE_XL = '24px';
var LINE_HEIGHT_L = '24px';
var LINE_HEIGHT_XL = '36px';
var GAP$1 = '4px';

var createPixelInsetBorder$1 = function (borderColor, insetTLColor, insetBRColor, borderWidth) {
    var width = borderWidth ? borderWidth : 2;
    return "".concat(width, "px 0px 0px 0px ").concat(insetBRColor, ", \n      0px ").concat(width, "px 0px 0px ").concat(insetBRColor, ", \n      -").concat(width, "px 0px 0px 0px ").concat(insetTLColor, ", \n      0px -").concat(width, "px 0px 0px ").concat(insetTLColor, ", \n      -").concat(2 * width, "px 0px 0px 0px ").concat(borderColor, ", \n      ").concat(2 * width, "px 0px 0px 0px ").concat(borderColor, ", \n      0px ").concat(2 * width, "px 0px 0px ").concat(borderColor, ", \n      0px -").concat(2 * width, "px 0px 0px ").concat(borderColor, ", \n      0px 0px 0px ").concat(width, "px ").concat(borderColor);
};
var createSimpleShadowBorder = function (borderColor, borderWidth, bottomBorderColor) {
    var width = borderWidth ? borderWidth : 2;
    return "".concat(width, "px 0px ").concat(bottomBorderColor !== null && bottomBorderColor !== void 0 ? bottomBorderColor : borderColor, ", \n      0px ").concat(width, "px ").concat(bottomBorderColor !== null && bottomBorderColor !== void 0 ? bottomBorderColor : borderColor, ", \n      -").concat(width, "px 0px ").concat(borderColor, ", \n      0px -").concat(width, "px ").concat(borderColor);
};

var getBackgroundNormal = function (theme, primary, secondary) {
    return primary
        ? theme.colors.primary1.vividTangelo
        : secondary
            ? theme.colors.primary2.midnightGreen
            : 'transparent';
};
var getDepositBackground = function (theme, primary, secondary, selected) {
    return selected
        ? theme.colors.secondary.green
        : getBackgroundNormal(theme, primary, secondary);
};
var getBackgroundHover = function (theme, primary, secondary) {
    return primary
        ? theme.colors.primary1.bigFootFeet
        : secondary
            ? theme.colors.primary2.darkSlateGray
            : 'none';
};
var getBackgroundDisabled = function (theme, primary, secondary) {
    return primary
        ? theme.colors.primary1.saddleBrown
        : secondary
            ? theme.colors.primary2.darkRichBlack
            : 'none';
};
var getBackgroundPressed$1 = function (theme, primary, secondary) {
    return primary
        ? theme.colors.primary1.chocolate
        : secondary
            ? theme.colors.primary2.greenCyprus
            : 'none';
};
var getBoxShadowNormal = function (theme, primary, secondary) {
    return primary
        ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary1.bigFootFeet, theme.colors.primary1.lightBrown, BORDER_WIDTH$1)
        : secondary
            ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkSlateGray, theme.colors.primary2.darkRichBlack, BORDER_WIDTH$1)
            : 'none';
};
var getDepositBoxShadow = function (theme, primary, secondary, selected) {
    return selected
        ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.secondary.lightGreen, theme.colors.secondary.darkGreen, BORDER_WIDTH$1)
        : getBoxShadowNormal(theme, primary, secondary);
};
var getBoxShadowHover$1 = function (theme, primary, secondary) {
    return primary
        ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary1.middleYellowRed, theme.colors.primary1.chocolate, BORDER_WIDTH$1)
        : secondary
            ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.richBlack, BORDER_WIDTH$1)
            : 'none';
};
var getBoxShadowDisabled = function (theme, primary, secondary) {
    return primary
        ? createPixelInsetBorder$1(theme.colors.primary2.darkRichBlack, theme.colors.primary1.sepia, theme.colors.primary1.lightBrown, BORDER_WIDTH$1)
        : secondary
            ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkGreen, theme.colors.primary2.richBlack, BORDER_WIDTH$1)
            : 'none';
};
var getBoxShadowPressed = function (theme, primary, secondary) {
    return primary
        ? createPixelInsetBorder$1(theme.colors.primary2.darkRichBlack, theme.colors.primary1.saddleBrown, theme.colors.primary1.vividTangelo, BORDER_WIDTH$1)
        : secondary
            ? createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkRichBlack, theme.colors.primary2.darkSlateGray, BORDER_WIDTH$1)
            : 'none';
};
var getColorNormal = function (theme) {
    return theme.colors.typography.input;
};
var getDepositColor = function (theme, selected) {
    return selected ? theme.colors.primary2.darkRichBlack : getColorNormal(theme);
};
var getColorHover = function (theme, primary, secondary) {
    return primary || secondary
        ? theme.colors.typography.input
        : theme.colors.primary1.vividTangelo;
};
var getColorDisabled = function (theme, primary, secondary) {
    return primary
        ? theme.colors.primary1.chocolate
        : secondary
            ? theme.colors.primary2.darkSlateGray
            : theme.colors.primary2.myrtleGreen;
};
var getColorPressed = function (theme, primary, secondary) {
    return primary || secondary
        ? theme.colors.typography.input
        : theme.colors.primary1.lightBrown;
};
var getPadding$1 = function (size) {
    return size === IconSize.L ? PADDING_L : PADDING_XL;
};
var getMinHeight = function (size) {
    return size === IconSize.L ? MIN_HEIGHT_L : MIN_HEIGHT_XL;
};
var getFontSize$1 = function (size) {
    return size === IconSize.L ? FONT_SIZE_L : FONT_SIZE_XL;
};
var getLineHeight = function (size) {
    return size === IconSize.L ? LINE_HEIGHT_L : LINE_HEIGHT_XL;
};

var Button$2 = styled.button(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  background-color: ", ";\n  border: 0;\n  box-shadow: ", ";\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  outline: 0;\n  padding: ", ";\n  min-height: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  cursor: pointer;\n  z-index: ", ";\n  font-family: 'Share Tech Mono', sans-serif;\n  ", "\n  ", "\n\n  &:hover {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border: 0;\n  box-shadow: ", ";\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  outline: 0;\n  padding: ", ";\n  min-height: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  display: flex;\n  align-items: center;\n  flex-direction: ", ";\n  justify-content: ", ";\n  gap: ", ";\n  cursor: pointer;\n  z-index: ", ";\n  font-family: 'Share Tech Mono', sans-serif;\n  ", "\n  ", "\n\n  &:hover {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBackgroundNormal(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBoxShadowNormal(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme;
    return getColorNormal(theme);
}, function (_a) {
    var theme = _a.theme;
    return getColorNormal(theme);
}, function (_a) {
    var size = _a.size;
    return getPadding$1(size);
}, function (_a) {
    var size = _a.size;
    return getMinHeight(size);
}, function (_a) {
    var size = _a.size;
    return getFontSize$1(size);
}, function (_a) {
    var size = _a.size;
    return getLineHeight(size);
}, function (_a) {
    var flexDirection = _a.flexDirection;
    return flexDirection || '';
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent || 'space-evenly';
}, function (_a) {
    var gap = _a.gap;
    return gap || GAP$1;
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex || '0';
}, space, layout, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorHover(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorHover(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBackgroundHover(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBoxShadowHover$1(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorDisabled(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorDisabled(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBackgroundDisabled(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBoxShadowDisabled(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorPressed(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getColorPressed(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBackgroundPressed$1(theme, primary, secondary);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary;
    return getBoxShadowPressed(theme, primary, secondary);
});
Button$2.defaultProps = {
    width: 'auto',
    height: 'auto',
};
var DepositButton = styled(Button$2)(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary, selected = _a.selected;
    return getDepositBackground(theme, primary, secondary, selected);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary, selected = _a.selected;
    return getDepositBoxShadow(theme, primary, secondary, selected);
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return getDepositColor(theme, selected);
}, function (_a) {
    var padding = _a.padding;
    return padding;
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary, selected = _a.selected;
    return getDepositBackground(theme, primary, secondary, selected);
}, function (_a) {
    var theme = _a.theme, primary = _a.primary, secondary = _a.secondary, selected = _a.selected;
    return getDepositBoxShadow(theme, primary, secondary, selected);
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return getDepositColor(theme, selected);
});
var templateObject_1$W, templateObject_2$D;

var getBoxShadow$4 = function (_a) {
    var theme = _a.theme;
    return "".concat(BOX_SHADOW_WIDTH$5, "px 0px 0px 0px ").concat(theme.colors.primary2.deepTeal, ", \n      0px ").concat(BOX_SHADOW_WIDTH$5, "px 0px 0px ").concat(theme.colors.primary2.deepTeal, ", \n      -").concat(BOX_SHADOW_WIDTH$5, "px 0px 0px 0px ").concat(theme.colors.primary2.darkSlateGray, ", \n      0px -").concat(BOX_SHADOW_WIDTH$5, "px 0px 0px ").concat(theme.colors.primary2.greenCyprus, ", \n      -").concat(2 * BOX_SHADOW_WIDTH$5, "px 0px 0px 0px ").concat(theme.colors.primary2.darkGreen, ", \n      ").concat(2 * BOX_SHADOW_WIDTH$5, "px 0px 0px 0px ").concat(theme.colors.primary2.darkGreen, ", \n      0px ").concat(2 * BOX_SHADOW_WIDTH$5, "px 0px 0px ").concat(theme.colors.primary2.darkGreen, ", \n      0px -").concat(2 * BOX_SHADOW_WIDTH$5, "px 0px 0px ").concat(theme.colors.primary2.darkGreen, ", \n      0px 0px 0px ").concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.darkGreen);
};
var getSocketBoxShadow = function (_a) {
    var theme = _a.theme;
    return createSimpleShadowBorder(theme.colors.primary2.darkGreen, BOX_SHADOW_WIDTH$5, theme.colors.primary2.darkGreen);
};
var getSocketBoxShadowActive = function (_a) {
    var theme = _a.theme;
    return createSimpleShadowBorder(theme.colors.primary2.darkGreen, BOX_SHADOW_WIDTH$5, theme.colors.primary2.myrtleGreen);
};

var tags = {
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
};
var scales$1 = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    XXL: 'xxl',
};

var fontWeightReqular = 400;
var fontWeightSemiBold = 600;
var sizes = {
    sm: '12px',
    md: '14px',
    lg: '16px',
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$d = Array.isArray;

var isArray_1 = isArray$d;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$d = freeGlobal || freeSelf || Function('return this')();

var _root = root$d;

var root$c = _root;

/** Built-in value references. */
var Symbol$7 = root$c.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$5 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$8;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$b(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$b;

var baseGetTag$7 = _baseGetTag,
    isObjectLike$a = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$a(value) && baseGetTag$7(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$5;

var isArray$c = isArray_1,
    isSymbol$4 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$c(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$a(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$a;

var baseGetTag$6 = _baseGetTag,
    isObject$9 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$9(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$6(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$b = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$b['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$8 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$8(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$6(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$b.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var getNative$5 = _getNative,
    root$a = _root;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$5(root$a, 'Map');

var _Map = Map$3;

var Hash = _Hash,
    ListCache$3 = _ListCache,
    Map$2 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$2 || ListCache$3),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var MapCache$2 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$2;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$3;

var Symbol$4 = _Symbol,
    arrayMap$2 = _arrayMap,
    isArray$b = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$b(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$1) + '';
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$5(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$5;

var isArray$a = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$4 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$6(value, object) {
  if (isArray$a(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$4(value));
}

var _castPath = castPath$6;

var isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey$6;

var castPath$5 = _castPath,
    toKey$5 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$5(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$4;

var baseGet$3 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

var getThemeValue = function (path, fallback) {
    return function (theme) {
        return get_1(theme, path, fallback);
    };
};

var getColor$1 = function (_a) {
    var color = _a.color, theme = _a.theme;
    return getThemeValue("colors.".concat(color), color)(theme);
};
var getFontSize = function (_a) {
    var fontSize = _a.fontSize, size = _a.size;
    return fontSize || sizes[size || sizes.md];
};
var getFontWeight = function (_a) {
    var bold = _a.bold;
    return bold ? fontWeightSemiBold : fontWeightReqular;
};

var Text = styled.div(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n"])), getColor$1, getFontSize, getFontWeight, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform && "text-transform: ".concat(textTransform, ";");
}, function (_a) {
    var ellipsis = _a.ellipsis;
    return ellipsis &&
        "white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;";
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
}, function (_a) {
    var fontSize = _a.fontSize;
    return getFontSize({ fontSize: fontSize, size: sizes.sm });
}, space, typography, layout);
Text.defaultProps = {
    color: 'text',
    size: 'md',
    ellipsis: false,
    fontFamily: 'Roboto mono',
};
var SmallText = styled(Text).attrs({ size: 'sm' })(templateObject_2$C || (templateObject_2$C = __makeTemplateObject([""], [""])));
var MediumText = styled(Text).attrs({ size: 'md' })(templateObject_3$w || (templateObject_3$w = __makeTemplateObject([""], [""])));
var LargeText = styled(Text).attrs({ size: 'lg' })(templateObject_4$m || (templateObject_4$m = __makeTemplateObject([""], [""])));
var templateObject_1$V, templateObject_2$C, templateObject_3$w, templateObject_4$m;

var _a$1;
var style = (_a$1 = {},
    _a$1[scales$1.SM] = {
        fontSize: '14px',
        fontSizeLg: '16px',
    },
    _a$1[scales$1.MD] = {
        fontSize: '16px',
        fontSizeLg: '18px',
    },
    _a$1[scales$1.LG] = {
        fontSize: '20px',
        fontSizeLg: '24px',
    },
    _a$1[scales$1.XL] = {
        fontSize: '24px',
        fontSizeLg: '32px',
    },
    _a$1[scales$1.XXL] = {
        fontSize: '32px',
        fontSizeLg: '40px',
    },
    _a$1);
var Heading = styled(Text)(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  font-family: Share Tech Mono;\n  font-size: ", ";\n  font-weight: 400;\n  line-height: ", ";\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-family: Share Tech Mono;\n  font-size: ", ";\n  font-weight: 400;\n  line-height: ", ";\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var scale = _a.scale;
    return style[scale || scales$1.SM].fontSize;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return (lineHeight ? lineHeight : "110%");
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.lg;
}, function (_a) {
    var scale = _a.scale;
    return style[scale || scales$1.SM].fontSize;
});
Heading.defaultProps = {
    as: tags.H2,
};
var templateObject_1$U;

var INFOBOX_BORDER_WIDTH = 4;
var DEFAULT_BORDER_COLOR = 'primary2.deepTeal';
var DEFAULT_BACKGROUND_COLOR = 'primary2.darkSlateGray';

var getColorOrDefault = function (theme, color, defaultColor) {
    if (!color) {
        return getThemeValue("colors.".concat(defaultColor), defaultColor)(theme);
    }
    return getThemeValue("colors.".concat(color), color)(theme);
};

var getInfoBoxBackgroundColor = function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor;
    return getColorOrDefault(theme, backgroundColor, DEFAULT_BACKGROUND_COLOR);
};
var getInfoBoxBorderColor = function (_a) {
    var theme = _a.theme, borderColor = _a.borderColor;
    return createSimpleShadowBorder(getColorOrDefault(theme, borderColor, DEFAULT_BORDER_COLOR), INFOBOX_BORDER_WIDTH, getColorOrDefault(theme, borderColor, DEFAULT_BORDER_COLOR));
};

var InfoBoxBgSm = "data:image/svg+xml,%3Csvg%20width%3D%22308%22%20height%3D%2268%22%20viewBox%3D%220%200%20308%2068%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Crect%20width%3D%22308%22%20height%3D%2268%22%20fill%3D%22url%28%23pattern0%29%22%2F%3E%3Cdefs%3E%3Cpattern%20id%3D%22pattern0%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23image0_8139_293844%22%20transform%3D%22scale%280.00324675%200.0147059%29%22%2F%3E%3C%2Fpattern%3E%3Cimage%20id%3D%22image0_8139_293844%22%20width%3D%22308%22%20height%3D%2268%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAATQAAABECAYAAAAP1MnqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC%2FSURBVHgB7dpBAYAwAMPADf%2BeAR3pnYh82vv%2BDkDAcwAiBA3IEDQAAAAAABhx%2FdCACisnkCFoQIagAQAAAADACD80IMPKCWQIGpAhaAAAAAAAMMIPDciwcgIZggZkCBoAAAAAAIzwQwMyrJxAhqABGYIGAAAAAAAj%2FNCADCsnkCFoQIagAQAAAADACD80IMPKCWQIGpAhaAAAAAAAMMIPDciwcgIZggZkCBoAAAAAAIzwQwMyrJxAhqABGYIGZHyuCiQcXlwgfQAAAABJRU5ErkJggg%3D%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var InfoBoxBg = "data:image/svg+xml,%3Csvg%20width%3D%22308%22%20height%3D%2276%22%20viewBox%3D%220%200%20308%2076%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Crect%20width%3D%22308%22%20height%3D%2276%22%20fill%3D%22url%28%23pattern0%29%22%2F%3E%3Cdefs%3E%3Cpattern%20id%3D%22pattern0%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23image0_8139_293845%22%20transform%3D%22scale%280.00324675%200.0131579%29%22%2F%3E%3C%2Fpattern%3E%3Cimage%20id%3D%22image0_8139_293845%22%20width%3D%22308%22%20height%3D%2276%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAATQAAABMCAYAAADjh0uHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADSSURBVHgB7dpBAYAwAMPADf%2BeAR3pnYh82vv%2BDkDAcwAiBA3IEDQAAAAAABhx%2FdCACisnkCFoQIagAQAAAADACD80IMPKCWQIGpAhaAAAAAAAMMIPDciwcgIZggZkCBoAAAAAAIzwQwMyrJxAhqABGYIGAAAAAAAj%2FNCADCsnkCFoQIagAQAAAADACD80IMPKCWQIGpAhaAAAAAAAMMIPDciwcgIZggZkCBoAAAAAAIzwQwMyrJxAhqABGYIGAAAAAAAj%2FNCADCsnkCFoQIagARkfYQcoH9KDkKIAAAAASUVORK5CYII%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var InfoBox = styled(Flex)(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  position: relative;\n  padding: 12px;\n  min-width: 192px;\n  min-height: 68px;\n  gap: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n  ", "\n  ", " {\n    padding: ", ";\n    max-width: 188px;\n    min-width: 188px;\n  }\n  & > * {\n    z-index: 1;\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.04;\n    background-image: url(", ");\n    background-size: cover;\n    background-repeat: repeat;\n    background-position: center center;\n  }\n"], ["\n  position: relative;\n  padding: 12px;\n  min-width: 192px;\n  min-height: 68px;\n  gap: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n  ", "\n  ", " {\n    padding: ", ";\n    max-width: 188px;\n    min-width: 188px;\n  }\n  & > * {\n    z-index: 1;\n  }\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.04;\n    background-image: url(", ");\n    background-size: cover;\n    background-repeat: repeat;\n    background-position: center center;\n  }\n"])), function (_a) {
    var gap = _a.gap;
    return (gap ? gap : '6px');
}, getInfoBoxBackgroundColor, getInfoBoxBorderColor, space, layout, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
}, function (_a) {
    var padding = _a.padding;
    return (padding ? padding : '12px');
}, InfoBoxBg);
var LightInfoBox = styled(InfoBox)(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
});
var DarkInfoBox = styled(InfoBox).attrs({
    backgroundColor: 'primary2.deepTeal',
})(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), function (_a) {
    var marginTop = _a.marginTop;
    return marginTop || '-14px';
});
var LightInfoBoxSm = styled(InfoBox).attrs({
    minWidth: 150,
    minHeight: 68,
    backgroundImage: InfoBoxBgSm,
})(templateObject_4$l || (templateObject_4$l = __makeTemplateObject([""], [""])));
var DarkInfoBoxSm = styled(InfoBox).attrs({
    backgroundColor: 'primary2.deepTeal',
    borderColor: 'primary2.darkGreen',
    minWidth: 150,
    minHeight: 68,
    backgroundImage: InfoBoxBgSm,
})(templateObject_5$g || (templateObject_5$g = __makeTemplateObject([""], [""])));
var templateObject_1$T, templateObject_2$B, templateObject_3$v, templateObject_4$l, templateObject_5$g;

var VESTING_BUMP_TITLE = 'BUMP';
var VESTING_CLAIMED_TITLE = 'Claimed';
var VESTING_UNVESTED_TITLE = 'Unvested';
var VESTING_VESTED_TITLE = 'Vested';
var VESTING_CLAIM_BUTTON_TITLE = 'Claim';
var VESTING_CLAIM_STAKE_BUTTON_TITLE = 'Claim & Stake';

var TooltipWrap = styled.div(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  span {\n    position: relative;\n    display: inline-block;\n    &.question-holder {\n      position: relative;\n      z-index: 9999 !important;\n    }\n    &.mouse-holder {\n      position: absolute;\n      padding: 10px 22px;\n      top: 0;\n      z-index: 999 !important;\n      margin: -16px 0 8px 16px;\n      left: -13px;\n      margin: ", ";\n      right: ", ";\n      left: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  span {\n    position: relative;\n    display: inline-block;\n    &.question-holder {\n      position: relative;\n      z-index: 9999 !important;\n    }\n    &.mouse-holder {\n      position: absolute;\n      padding: 10px 22px;\n      top: 0;\n      z-index: 999 !important;\n      margin: -16px 0 8px 16px;\n      left: -13px;\n      margin: ", ";\n      right: ", ";\n      left: ", ";\n    }\n  }\n"])), function (_a) {
    var reverse = _a.reverse;
    return reverse ? '-16px 16px 8px 0' : '-16px 0 8px 16px';
}, function (_a) {
    var reverse = _a.reverse;
    return (reverse ? '0' : '');
}, function (_a) {
    var reverse = _a.reverse;
    return (reverse ? '' : '-14px');
});
var StyledReactTooltip = styled.div(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  appearance: none;\n  background-color: ", ";\n  min-height: 32px;\n  border: 0;\n  border-radius: 0 !important;\n  font-size: 12px;\n  font-family: 'Roboto Mono', sans-serif;\n  line-height: 16px;\n  padding: 8px 10px !important;\n  opacity: 0;\n  visibility: hidden;\n  max-width: 173px;\n  z-index: 9999 !important;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  /* position: absolute;\n  margin: 8px 8px 8px 26px;\n  right: ", ";*/\n  box-shadow: ", ";\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  appearance: none;\n  background-color: ", ";\n  min-height: 32px;\n  border: 0;\n  border-radius: 0 !important;\n  font-size: 12px;\n  font-family: 'Roboto Mono', sans-serif;\n  line-height: 16px;\n  padding: 8px 10px !important;\n  opacity: 0;\n  visibility: hidden;\n  max-width: 173px;\n  z-index: 9999 !important;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  /* position: absolute;\n  margin: 8px 8px 8px 26px;\n  right: ", ";*/\n  box-shadow: ", ";\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var reverse = _a.reverse;
    return (reverse ? '16px' : '');
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.secondary.white, theme.colors.secondary.white, theme.colors.secondary.white, 4);
});
var templateObject_1$S, templateObject_2$A;

var QuestionCircleIcon = "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20opacity%3D%220.7%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.00024%202.66336C5.05288%202.66336%202.66357%205.05267%202.66357%208.00003C2.66357%2010.9474%205.05288%2013.3367%208.00024%2013.3367C10.9476%2013.3367%2013.3369%2010.9474%2013.3369%208.00003C13.3337%205.05399%2010.9463%202.66655%208.00024%202.66336ZM8.00024%2011.1131C7.63182%2011.1131%207.33316%2010.8144%207.33316%2010.446C7.33316%2010.0776%207.63182%209.77892%208.00024%209.77892C8.36866%209.77892%208.66732%2010.0776%208.66732%2010.446C8.66732%2010.8144%208.36866%2011.1131%208.00024%2011.1131ZM8.44496%208.81698C8.44488%208.64007%208.54966%208.47994%208.7118%208.40917V8.40962C9.52609%208.05423%209.95331%207.15253%209.7126%206.2973C9.4719%205.44207%208.63709%204.89556%207.75697%205.01706C6.87686%205.13856%206.22134%205.8908%206.22135%206.77926C6.22135%207.02488%206.42046%207.22399%206.66607%207.22399C6.91169%207.22399%207.1108%207.02488%207.1108%206.77926C7.11057%206.33498%207.43822%205.95866%207.87831%205.89776C8.31841%205.83686%208.73594%206.11004%208.85638%206.53769C8.97682%206.96535%208.76322%207.41628%208.35602%207.594C7.86975%207.80622%207.55544%208.28641%207.55552%208.81698C7.55552%209.0626%207.75463%209.2617%208.00024%209.2617C8.24585%209.2617%208.44496%209.0626%208.44496%208.81698Z%22%20fill%3D%22white%22%2F%3E%3Cmask%20id%3D%22mask0_8410_38805%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%222%22%20y%3D%222%22%20width%3D%2212%22%20height%3D%2212%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.00024%202.66336C5.05288%202.66336%202.66357%205.05267%202.66357%208.00003C2.66357%2010.9474%205.05288%2013.3367%208.00024%2013.3367C10.9476%2013.3367%2013.3369%2010.9474%2013.3369%208.00003C13.3337%205.05399%2010.9463%202.66655%208.00024%202.66336ZM8.00024%2011.1131C7.63182%2011.1131%207.33316%2010.8144%207.33316%2010.446C7.33316%2010.0776%207.63182%209.77892%208.00024%209.77892C8.36866%209.77892%208.66732%2010.0776%208.66732%2010.446C8.66732%2010.8144%208.36866%2011.1131%208.00024%2011.1131ZM8.44496%208.81698C8.44488%208.64007%208.54966%208.47994%208.7118%208.40917V8.40962C9.52609%208.05423%209.95331%207.15253%209.7126%206.2973C9.4719%205.44207%208.63709%204.89556%207.75697%205.01706C6.87686%205.13856%206.22134%205.8908%206.22135%206.77926C6.22135%207.02488%206.42046%207.22399%206.66607%207.22399C6.91169%207.22399%207.1108%207.02488%207.1108%206.77926C7.11057%206.33498%207.43822%205.95866%207.87831%205.89776C8.31841%205.83686%208.73594%206.11004%208.85638%206.53769C8.97682%206.96535%208.76322%207.41628%208.35602%207.594C7.86975%207.80622%207.55544%208.28641%207.55552%208.81698C7.55552%209.0626%207.75463%209.2617%208.00024%209.2617C8.24585%209.2617%208.44496%209.0626%208.44496%208.81698Z%22%20fill%3D%22white%22%2F%3E%3C%2Fmask%3E%3Cg%20mask%3D%22url%28%23mask0_8410_38805%29%22%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var QuestionCircle = React__default.forwardRef(function (_, ref) { return (React__default.createElement("img", { ref: ref, src: QuestionCircleIcon, alt: "QuestionCircle Icon" })); });

var Tooltip = function (_a) {
    var tooltipValue = _a.tooltipValue, children = _a.children, reverse = _a.reverse, place = _a.place;
    var _b = useState(''), open = _b[0], setOpen = _b[1];
    var toolBar = useRef(null);
    return (React__default.createElement(TooltipWrap, { reverse: reverse, place: place },
        children,
        React__default.createElement("span", null,
            React__default.createElement("span", { className: "question-holder", onMouseEnter: function () {
                    if (open === '') {
                        setOpen('active');
                    }
                } },
                React__default.createElement(QuestionCircle, null)),
            React__default.createElement("span", { className: "mouse-holder", onMouseLeave: function () {
                    setOpen('');
                } },
                React__default.createElement(StyledReactTooltip, { ref: toolBar, className: open }, tooltipValue)))));
};

var VestingWrap = styled.div(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  display: flex;\n  gap: 40px;\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n  .vested-block {\n    gap: 30px;\n    @media (max-width: 768px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  }\n"], ["\n  display: flex;\n  gap: 40px;\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n  .vested-block {\n    gap: 30px;\n    @media (max-width: 768px) {\n      align-items: flex-start;\n      flex-direction: column;\n    }\n  }\n"])));
var VestingText = function (_a) {
    var title = _a.title, tooltipValue = _a.tooltipValue, bumpBalance = _a.bumpBalance, inUSD = _a.inUSD, direction = _a.direction;
    return (React__default.createElement(FlexWithGap, { flexDirection: "column", justifyContent: "space-between", gap: "4px" },
        tooltipValue ? (React__default.createElement(Tooltip, { tooltipValue: tooltipValue },
            React__default.createElement(Heading, { as: "h4", color: "primary2.cambridgeBlue" }, title))) : (React__default.createElement("div", null,
            React__default.createElement(Heading, { as: "h4", color: "primary2.cambridgeBlue" }, title))),
        parseFloat(bumpBalance) > 0 && (React__default.createElement(FlexWithGap, { gap: "4px", alignItems: "start", flexDirection: direction ? direction : 'row' },
            React__default.createElement(Flex, { alignItems: "center" },
                React__default.createElement(MediumText, { color: "white", fontWeight: "500" }, bumpBalance),
                React__default.createElement(SmallText, { bold: true, color: "primary2.cambridgeBlue", marginLeft: "4px" }, VESTING_BUMP_TITLE)),
            inUSD && (React__default.createElement(MediumText, { color: "white", fontWeight: "500" },
                "($",
                inUSD,
                ")")))),
        parseFloat(bumpBalance) === 0 && (React__default.createElement(MediumText, { color: "white", fontWeight: "500" }, "-"))));
};
var Vesting = function (props) {
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(VestingWrap, null,
        React__default.createElement(InfoBox, null,
            React__default.createElement(VestingText, { title: VESTING_CLAIMED_TITLE, tooltipValue: "Tooltip", bumpBalance: props.claimedBalance })),
        React__default.createElement(InfoBox, null,
            React__default.createElement(VestingText, { title: VESTING_UNVESTED_TITLE, tooltipValue: "ToolTip", bumpBalance: props.unVestedBalance })),
        React__default.createElement(InfoBox, { className: "vested-block", alignItems: "center", paddingRight: 16, padding: isMobile ? '12px 12px 16px 12px' : '' },
            React__default.createElement(VestingText, { title: VESTING_VESTED_TITLE, tooltipValue: "Tooltip", bumpBalance: props.vestedBalance }),
            React__default.createElement(Flex, null,
                React__default.createElement(Button$2, { size: IconSize.L, primary: true, secondary: false, onClick: props.onClaim },
                    React__default.createElement(Heading, { as: "h4" }, VESTING_CLAIM_BUTTON_TITLE))),
            React__default.createElement(Flex, null,
                React__default.createElement(Button$2, { size: IconSize.L, primary: true, secondary: false, onClick: props.onClaimAndStake },
                    React__default.createElement(Heading, { as: "h4" }, VESTING_CLAIM_STAKE_BUTTON_TITLE))))));
};
var templateObject_1$R;

var BumpWrap = styled.div(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n"], ["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, getBoxShadow$4);
var HeaderWrap = styled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  position: relative;\n  margin-top: -10px;\n"], ["\n  position: relative;\n  margin-top: -10px;\n"])));
var LineBlock = styled.div(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n  background-color: ", ";\n  height: 28px;\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  box-shadow: ", ";\n\n  span {\n    border-top: 4px solid ", ";\n    border-bottom: 4px solid\n      ", ";\n    background-color: ", ";\n    padding: 2px 0;\n    width: 100%;\n  }\n"], ["\n  background-color: ", ";\n  height: 28px;\n  margin-top: 6px;\n  display: flex;\n  align-items: center;\n  box-shadow: ", ";\n\n  span {\n    border-top: 4px solid ", ";\n    border-bottom: 4px solid\n      ", ";\n    background-color: ", ";\n    padding: 2px 0;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenCyprus;
}, function (_a) {
    var theme = _a.theme;
    return "\n    0px ".concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.darkGreen, ",\n    0px ").concat(BOX_SHADOW_WIDTH$5 * 2, "px ").concat(theme.colors.primary2.greenCyprus, "\n  ");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
});
var BalanceBlock = styled.div(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  padding: 28px 32px;\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  ", " {\n    flex-direction: column;\n  }\n\n  .balance-box {\n    order: 1;\n    @media (max-width: 768px) {\n      order: 2;\n    }\n  }\n\n  .available-bond {\n    order: 2;\n    @media (max-width: 768px) {\n      order: 3;\n    }\n  }\n\n  .bridge-btn {\n    order: 3;\n    @media (max-width: 768px) {\n      order: 4;\n    }\n  }\n"], ["\n  padding: 28px 32px;\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  ", " {\n    flex-direction: column;\n  }\n\n  .balance-box {\n    order: 1;\n    @media (max-width: 768px) {\n      order: 2;\n    }\n  }\n\n  .available-bond {\n    order: 2;\n    @media (max-width: 768px) {\n      order: 3;\n    }\n  }\n\n  .bridge-btn {\n    order: 3;\n    @media (max-width: 768px) {\n      order: 4;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var VestingBlock = styled.div(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  padding: 0 28px 32px;\n"], ["\n  padding: 0 28px 32px;\n"])));
var SocketController = styled.ul(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  list-style: none;\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  order: 3;\n  @media (max-width: 768px) {\n    order: 1;\n    flex-direction: row;\n    margin-left: 0;\n  }\n"], ["\n  list-style: none;\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  order: 3;\n  @media (max-width: 768px) {\n    order: 1;\n    flex-direction: row;\n    margin-left: 0;\n  }\n"])));
var Socket = styled.li(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  width: 28px;\n  height: 8px;\n  box-shadow: ", ";\n\n  &.protect {\n    background-color: #4c8956;\n\n    &.active {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n  }\n\n  &.stake {\n    background-color: #198989;\n\n    &.active {\n      background-color: #54d3d3;\n      box-shadow: ", ";\n    }\n  }\n\n  &.earn {\n    background-color: ", ";\n\n    &.active {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n  }\n"], ["\n  width: 28px;\n  height: 8px;\n  box-shadow: ", ";\n\n  &.protect {\n    background-color: #4c8956;\n\n    &.active {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n  }\n\n  &.stake {\n    background-color: #198989;\n\n    &.active {\n      background-color: #54d3d3;\n      box-shadow: ", ";\n    }\n  }\n\n  &.earn {\n    background-color: ", ";\n\n    &.active {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n  }\n"])), getSocketBoxShadow, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
}, getSocketBoxShadowActive, getSocketBoxShadowActive, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary1.saddleBrown;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary1.vividTangelo;
}, getSocketBoxShadowActive);
var TabWrap = styled.div(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  margin-top: -4px;\n\n  div {\n    box-shadow: ", ";\n    padding-left: 36px;\n    display: flex;\n    align-items: center;\n    width: 129px;\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  display: flex;\n  margin-top: -4px;\n\n  div {\n    box-shadow: ", ";\n    padding-left: 36px;\n    display: flex;\n    align-items: center;\n    width: 129px;\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    -".concat(BOX_SHADOW_WIDTH$5, "px 0px ").concat(theme.colors.primary2.darkSlateGray, ",\n    0px -").concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.darkSlateGray, ",\n    -").concat(BOX_SHADOW_WIDTH$5 * 2, "px 0px ").concat(theme.colors.primary2.darkGreen, ",\n    0px -").concat(BOX_SHADOW_WIDTH$5 * 2, "px ").concat(theme.colors.primary2.darkGreen, ",\n    -").concat(BOX_SHADOW_WIDTH$5, "px -").concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.darkGreen, ",\n    0px ").concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.midnightGreen, "\n  ");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
});
var CornerBump = styled.img(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  margin-top: -", "px;\n  box-shadow: ", ";\n"], ["\n  margin-top: -", "px;\n  box-shadow: ", ";\n"])), BOX_SHADOW_WIDTH$5, function (_a) {
    var theme = _a.theme;
    return "0px ".concat(BOX_SHADOW_WIDTH$5, "px ").concat(theme.colors.primary2.midnightGreen);
});
var BlockSeparator = styled.div(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  width: 100%;\n  border-top: 4px solid ", ";\n  border-bottom: 4px solid ", ";\n  height: 8px;\n  margin-bottom: 20px;\n"], ["\n  width: 100%;\n  border-top: 4px solid ", ";\n  border-bottom: 4px solid ", ";\n  height: 8px;\n  margin-bottom: 20px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
});
var BumpSection = function (_a) {
    var balance = _a.balance, vesting = _a.vesting, socketState = _a.socketState, availableBond = _a.availableBond, availableBondInUSD = _a.availableBondInUSD;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(BumpWrap, null,
        React__default.createElement(HeaderWrap, null,
            React__default.createElement(TabWrap, null,
                React__default.createElement("div", null,
                    React__default.createElement("img", { style: { marginTop: '16px' }, src: CoinIco, alt: "coin-ico" })),
                React__default.createElement(CornerBump, { src: CornerIco, alt: "corner" })),
            React__default.createElement(LineBlock, null,
                React__default.createElement("span", null))),
        React__default.createElement(BalanceBlock, null,
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement(InfoBox, { alignItems: !isMobile ? 'center' : '', px: "20px", className: "balance-box", minWidth: "300px", justifyContent: "space-between", flexDirection: !isMobile ? 'row' : 'column', gap: isMobile ? '16px' : '', padding: isMobile ? '12px 12px 16px 12px' : '' },
                    React__default.createElement(VestingText, { direction: isMobile ? 'column' : 'row', title: "Balance", bumpBalance: balance.bumpBalance, inUSD: balance.inUSD }),
                    React__default.createElement(Flex, { marginLeft: !isMobile ? '30px' : '8px' },
                        React__default.createElement(Button$2, { size: IconSize.L, primary: true, className: "buy-btn" },
                            React__default.createElement(Heading, { as: "h4" }, "Buy BUMP")))),
                availableBond && (React__default.createElement(LightInfoBox, { alignItems: "center", px: "20px", minWidth: "300px", justifyContent: "space-between", className: "available-bond", marginTop: "0" },
                    React__default.createElement(VestingText, { direction: isMobile ? 'column' : 'row', title: "Available Bond", bumpBalance: availableBond, inUSD: availableBondInUSD })))),
            React__default.createElement(SocketController, null,
                React__default.createElement(Socket, { className: "protect ".concat(socketState.protect && 'active') }),
                React__default.createElement(Socket, { className: "earn ".concat(socketState.earn && 'active') }),
                React__default.createElement(Socket, { className: "stake ".concat(socketState.stake && 'active') }))),
        vesting.isVestingEnabled && React__default.createElement(BlockSeparator, null),
        vesting.isVestingEnabled && (React__default.createElement(VestingBlock, null,
            React__default.createElement(Vesting, __assign({}, vesting))))));
};
var templateObject_1$Q, templateObject_2$z, templateObject_3$u, templateObject_4$k, templateObject_5$f, templateObject_6$e, templateObject_7$9, templateObject_8$8, templateObject_9$5, templateObject_10$5;

var BOX_SHADOW_WIDTH$4 = 4;
var DOUBLE_BOX_SHADOW_WIDTH$1 = BOX_SHADOW_WIDTH$4 * 2;
var OUTSIDE_RADIATOR_WIDTH = -BOX_SHADOW_WIDTH$4 * 3;

var StyledCardContainer = styled(Box)(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  width: 100%;\n  box-shadow: ", ";\n  z-index: 10;\n"], ["\n  width: 100%;\n  box-shadow: ", ";\n  z-index: 10;\n"])), function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkSlateGray, theme.colors.primary2.darkGreen, BOX_SHADOW_WIDTH$4);
});
var CardHeader = styled(Flex)(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", "px 0\n      ", ",\n    0 ", "px ", ";\n  position: relative;\n  z-index: 10;\n"], ["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", "px 0\n      ", ",\n    0 ", "px ", ";\n  position: relative;\n  z-index: 10;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var SideRadiator = styled(Box)(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8%;\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8%;\n"])));
var CardContent = styled(Flex)(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  ", " {\n    flex-direction: column;\n    padding-top: 24px;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  ", " {\n    flex-direction: column;\n    padding-top: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var SideLedge$1 = styled(Box)(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: ", "px;\n  height: 40px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: ", "px;\n  height: 40px;\n  background-color: ", ";\n"])), BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
});
var LeftSideLedge = styled(SideLedge$1)(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  left: -", "px;\n  box-shadow: -", "px 0 ", ",\n    -", "px 0 ", ";\n"], ["\n  left: -", "px;\n  box-shadow: -", "px 0 ", ",\n    -", "px 0 ", ";\n"])), BOX_SHADOW_WIDTH$4, DOUBLE_BOX_SHADOW_WIDTH$1, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
var RightSideLedge = styled(SideLedge$1)(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  right: -", "px;\n  box-shadow: ", "px 0\n      ", ",\n    ", "px 0 ", ";\n"], ["\n  right: -", "px;\n  box-shadow: ", "px 0\n      ", ",\n    ", "px 0 ", ";\n"])), BOX_SHADOW_WIDTH$4, DOUBLE_BOX_SHADOW_WIDTH$1, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
});
var BottomSideLedgeWrapper = styled(Flex)(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  align-items: start;\n  position: absolute;\n  top: calc(100% - 14px);\n  left: 50%;\n  transform: translateX(-50%);\n  height: ", ";\n"], ["\n  align-items: start;\n  position: absolute;\n  top: calc(100% - 14px);\n  left: 50%;\n  transform: translateX(-50%);\n  height: ", ";\n"])), function (_a) {
    var height = _a.height;
    return height;
});
styled(Box)(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  height: 100%;\n  width: 49px;\n  background-image: url(", ");\n  background-position: center center;\n  background-repeat: no-repeat;\n"], ["\n  height: 100%;\n  width: 49px;\n  background-image: url(", ");\n  background-position: center center;\n  background-repeat: no-repeat;\n"])), function (_a) {
    var icon = _a.icon;
    return icon;
});
var BottomSideLedgeCenter = styled(Box)(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  height: calc(100% - ", "px);\n  width: ", ";\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n  margin-top: 4px;\n"], ["\n  height: calc(100% - ", "px);\n  width: ", ";\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n  margin-top: 4px;\n"])), DOUBLE_BOX_SHADOW_WIDTH$1 + 2, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
}, DOUBLE_BOX_SHADOW_WIDTH$1, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var templateObject_1$P, templateObject_2$y, templateObject_3$t, templateObject_4$j, templateObject_5$e, templateObject_6$d, templateObject_7$8, templateObject_8$7, templateObject_9$4, templateObject_10$4;

var StyledHorizontalLine$1 = styled(Box)(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  width: 100%;\n  max-width: ", ";\n  height: 0;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n"], ["\n  width: 100%;\n  max-width: ", ";\n  height: 0;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenCyprus;
}, BOX_SHADOW_WIDTH$4, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
});
var StyledRadiator$1 = styled(Flex)(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  flex-direction: column;\n  gap: 4px;\n"])));
var Radiator$1 = function (_a) {
    var alignItems = _a.alignItems, maxLineWidth = _a.maxLineWidth, props = __rest(_a, ["alignItems", "maxLineWidth"]);
    return (React__default.createElement(StyledRadiator$1, __assign({ alignItems: alignItems }, props),
        React__default.createElement(StyledHorizontalLine$1, { maxWidth: maxLineWidth }),
        React__default.createElement(StyledHorizontalLine$1, { maxWidth: maxLineWidth }),
        React__default.createElement(StyledHorizontalLine$1, { maxWidth: maxLineWidth }),
        React__default.createElement(StyledHorizontalLine$1, { maxWidth: maxLineWidth })));
};
var templateObject_1$O, templateObject_2$x;

var Header$4 = function (_a) {
    var children = _a.children, radiatorWidth = _a.radiatorWidth, headerPadding = _a.headerPadding;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(CardHeader, { padding: headerPadding ? headerPadding : '12px 10%' },
        React__default.createElement(SideRadiator, { left: OUTSIDE_RADIATOR_WIDTH },
            React__default.createElement(Radiator$1, { alignItems: "flex-start", maxLineWidth: radiatorWidth }),
            isMobile && (React__default.createElement(Radiator$1, { alignItems: "flex-start", maxLineWidth: radiatorWidth, marginTop: "4px" }))),
        children,
        React__default.createElement(SideRadiator, { right: OUTSIDE_RADIATOR_WIDTH },
            React__default.createElement(Radiator$1, { alignItems: "flex-end", maxLineWidth: radiatorWidth }),
            isMobile && (React__default.createElement(Radiator$1, { alignItems: "flex-end", maxLineWidth: radiatorWidth, marginTop: "4px" })))));
};
var Content$2 = function (_a) {
    var children = _a.children, bottomLeftCorner = _a.bottomLeftCorner, bottomRightCorner = _a.bottomRightCorner, bottomLedgeHeight = _a.bottomLedgeHeight, bottomLedgeCenterWidth = _a.bottomLedgeCenterWidth;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(Box, { width: "100%", height: isMobile ? '100%' : '146px', position: "relative" },
        React__default.createElement(LeftSideLedge, null),
        React__default.createElement(RightSideLedge, null),
        React__default.createElement(BottomSideLedgeWrapper, { height: bottomLedgeHeight },
            React__default.createElement("img", { src: bottomLeftCorner, style: {
                    marginRight: '-1px',
                    marginTop: '2px',
                    width: '49px',
                    height: '100%',
                } }),
            React__default.createElement(BottomSideLedgeCenter, { width: bottomLedgeCenterWidth }),
            React__default.createElement("img", { src: bottomRightCorner, style: {
                    marginLeft: '-1px',
                    marginTop: '2px',
                    width: '49px',
                    height: '100%',
                } })),
        React__default.createElement(CardContent, null, children)));
};
var Card = function (_a) {
    var header = _a.header, content = _a.content, bottomLeftCorner = _a.bottomLeftCorner, bottomRightCorner = _a.bottomRightCorner, bottomLedgeHeight = _a.bottomLedgeHeight, bottomLedgeCenterWidth = _a.bottomLedgeCenterWidth, radiatorWidth = _a.radiatorWidth, headerPadding = _a.headerPadding, props = __rest(_a, ["header", "content", "bottomLeftCorner", "bottomRightCorner", "bottomLedgeHeight", "bottomLedgeCenterWidth", "radiatorWidth", "headerPadding"]);
    return (React__default.createElement(StyledCardContainer, __assign({}, props),
        React__default.createElement(Header$4, { radiatorWidth: radiatorWidth, headerPadding: headerPadding }, header),
        React__default.createElement(Content$2, { bottomLeftCorner: bottomLeftCorner, bottomRightCorner: bottomRightCorner, bottomLedgeHeight: bottomLedgeHeight, bottomLedgeCenterWidth: bottomLedgeCenterWidth }, content)));
};

var AssetCard = function (_a) {
    var header = _a.header, content = _a.content, bottomLeftCorner = _a.bottomLeftCorner, bottomRightCorner = _a.bottomRightCorner, bottomLedgeHeight = _a.bottomLedgeHeight, bottomLedgeCenterWidth = _a.bottomLedgeCenterWidth, radiatorWidth = _a.radiatorWidth, headerPadding = _a.headerPadding, props = __rest(_a, ["header", "content", "bottomLeftCorner", "bottomRightCorner", "bottomLedgeHeight", "bottomLedgeCenterWidth", "radiatorWidth", "headerPadding"]);
    return (React__default.createElement(Card, __assign({ bottomLeftCorner: bottomLeftCorner, bottomRightCorner: bottomRightCorner, bottomLedgeHeight: bottomLedgeHeight, bottomLedgeCenterWidth: bottomLedgeCenterWidth, header: header, content: content, radiatorWidth: radiatorWidth, headerPadding: headerPadding }, props)));
};

var BOTTOM_LEDGE_HEIGHT = '38px';
var BOTTOM_LEDGE_WIDTH = '1030px';
var BOTTOM_LEDGE_WIDTH_MOBILE = '240px';
var RADIATOR_WIDTH = '36px';

var lightColors = {
    primary1: {
        peachPuf: '#F8D5BD',
        macaroniAndCheese: '#F3B990',
        middleYellowRed: '#F1AB7A',
        bigFootFeet: '#EC8F4E',
        vividTangelo: '#E07A29',
        chocolate: '#D0671F',
        lightBrown: '#B95C1B',
        saddleBrown: '#8B4514',
        sepia: '#743911',
        teal: '#12BFD4',
    },
    primary2: {
        cambridgeBlue: '#99B6B9',
        desaturatedCyan: '#669197',
        myrtleGreen: '#336D74',
        darkSlateGray: '#195A62',
        midnightGreen: '#004851',
        richBlack: '#003A41',
        darkRichBlack: '#003239',
        darkGreen: '#002428',
        greenBlack: '#000E10',
        greenCyprus: '#004047',
        blueDianne: '#1F575F',
        cyprus: '#023A42',
        aqua: '#00E7FF',
        deepTeal: '#002D33',
        internationalOrange: '#FF5000',
    },
    typography: {
        white: '#FFFFFF',
        input: 'rgba(255, 255, 255, 0.95)',
        disable: 'rgba(255, 255, 255, 0.2)',
        placeholder: 'rgba(255, 255, 255, 0.6)',
        earnDepositValue: 'rgba(255, 255, 255, 0.7);',
        earnDepositTextDescription: 'rgba(255, 255, 255, 0.8)',
        gray: '#B2BDBF',
        baliHai: '#8CA6AE',
    },
    background: {
        confirmationBox: 'rgba(18, 191, 212, 0.3)',
        confirmDeposit: 'rgba(0, 231, 255, 0.1)',
        assetConfirmationBox: '#008899',
    },
    secondary: {
        red: '#FF2E00',
        orange: '#E24017',
        green: '#60C770',
        lightGreen: '#9EDAA8',
        lightDarkGreen: '#2E813B',
        darkGreen: '#30A042',
        extraDarkGreen: '#278135',
        darkBlue: '#2775CA',
        blue: '#0092A1',
        turquoise: '#00FFFF',
        lightBlue: '#33B9FF',
        black: '#000000',
        white: '#FFFFFF',
        violet: '#7289DA',
        lightViolet: '#819BF8',
        darkViolet: '#4E65B5',
        greennyGrey: '#5E979E',
    },
};

var lightTheme = __assign(__assign({}, base), { colors: lightColors });

var CustomThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? lightTheme : _b, children = _a.children;
    return (React__default.createElement(ThemeProvider, { theme: theme }, children));
};

var getFormattedPercents$1 = function (percents) {
    if (percents >= 0)
        return "+".concat(percents.toFixed(2));
    return "".concat(percents.toFixed(2));
};
var isZero$1 = function (amount) {
    return parseFloat(amount) === 0 || amount === '';
};
var getFormattedAmountWithSymbol$1 = function (amount, symbol) {
    if (parseFloat(amount) > 0)
        return "".concat(amount, " ").concat(symbol);
    return '-';
};
var getFormattedAmount = function (amount) {
    if (parseFloat(amount) > 0)
        return amount;
    return '-';
};
var getPercentsColor$1 = function (percents) {
    if (percents >= 0)
        return lightColors.secondary.green;
    return lightColors.secondary.red;
};

var CheckIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Checkbox = styled.input.attrs({ type: 'checkbox' })(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  appearance: none;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  height: 32px;\n  min-width: 32px;\n  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  border: none;\n  border-radius: 0;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:hover:not(:disabled):checked {\n    ", " {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n    box-shadow: ", ";\n    background-color: ", ";\n  }\n\n  &:checked {\n    background-color: ", ";\n    &:before {\n      content: '';\n      display: block;\n      width: 32px;\n      height: 32px;\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-position: center center;\n    }\n  }\n\n  &:disabled {\n    background-color: ", ";\n    box-shadow: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  appearance: none;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  height: 32px;\n  min-width: 32px;\n  transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  border: none;\n  border-radius: 0;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:hover:not(:disabled):checked {\n    ", " {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n    box-shadow: ", ";\n    background-color: ", ";\n  }\n\n  &:checked {\n    background-color: ", ";\n    &:before {\n      content: '';\n      display: block;\n      width: 32px;\n      height: 32px;\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-position: center center;\n    }\n  }\n\n  &:disabled {\n    background-color: ", ";\n    box-shadow: ", ";\n    cursor: not-allowed;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, 4);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, 4);
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.desaturatedCyan, theme.colors.primary2.desaturatedCyan, 4);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.desaturatedCyan;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, CheckIcon32, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkGreen, theme.colors.primary2.darkGreen, 4);
});
var templateObject_1$N;

var reactAliceCarousel = {};

var lib = {};

var utils$2 = {};

var calculateDirection$1 = {};

var types$3 = {};

Object.defineProperty(types$3, "__esModule", {
  value: true
});
types$3.TraceDirectionKey = types$3.Direction = types$3.Axis = void 0;
var TraceDirectionKey;
types$3.TraceDirectionKey = TraceDirectionKey;

(function (TraceDirectionKey) {
  TraceDirectionKey["NEGATIVE"] = "NEGATIVE";
  TraceDirectionKey["POSITIVE"] = "POSITIVE";
  TraceDirectionKey["NONE"] = "NONE";
})(TraceDirectionKey || (types$3.TraceDirectionKey = TraceDirectionKey = {}));

var Direction;
types$3.Direction = Direction;

(function (Direction) {
  Direction["TOP"] = "TOP";
  Direction["LEFT"] = "LEFT";
  Direction["RIGHT"] = "RIGHT";
  Direction["BOTTOM"] = "BOTTOM";
  Direction["NONE"] = "NONE";
})(Direction || (types$3.Direction = Direction = {}));

var Axis;
types$3.Axis = Axis;

(function (Axis) {
  Axis["X"] = "x";
  Axis["Y"] = "y";
})(Axis || (types$3.Axis = Axis = {}));

Object.defineProperty(calculateDirection$1, "__esModule", {
  value: true
});
calculateDirection$1.calculateDirection = calculateDirection;

var _types$5 = types$3;

function calculateDirection(trace) {
  var direction;
  var negative = _types$5.TraceDirectionKey.NEGATIVE;
  var positive = _types$5.TraceDirectionKey.POSITIVE;
  var current = trace[trace.length - 1];
  var previous = trace[trace.length - 2] || 0;

  if (trace.every(function (i) {
    return i === 0;
  })) {
    return _types$5.TraceDirectionKey.NONE;
  }

  direction = current > previous ? positive : negative;

  if (current === 0) {
    direction = previous < 0 ? positive : negative;
  }

  return direction;
}

var calculateDirectionDelta$1 = {};

Object.defineProperty(calculateDirectionDelta$1, "__esModule", {
  value: true
});
calculateDirectionDelta$1.calculateDirectionDelta = calculateDirectionDelta;

var _types$4 = types$3;

var _ = utils$2;

function calculateDirectionDelta(traceDirections) {
  var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var length = traceDirections.length;
  var i = length - 1;
  var direction = _types$4.TraceDirectionKey.NONE;

  for (; i >= 0; i--) {
    var current = traceDirections[i];
    var currentKey = (0, _.getDirectionKey)(current);
    var currentValue = (0, _.getDirectionValue)(current[currentKey]);
    var prev = traceDirections[i - 1] || {};
    var prevKey = (0, _.getDirectionKey)(prev);
    var prevValue = (0, _.getDirectionValue)(prev[prevKey]);
    var difference = (0, _.getDifference)(currentValue, prevValue);

    if (difference >= delta) {
      direction = currentKey;
      break;
    } else {
      direction = prevKey;
    }
  }

  return direction;
}

var calculateDuration$1 = {};

Object.defineProperty(calculateDuration$1, "__esModule", {
  value: true
});
calculateDuration$1.calculateDuration = calculateDuration;

function calculateDuration() {
  var prevTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nextTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return prevTime ? nextTime - prevTime : 0;
}

var calculateMovingPosition$1 = {};

Object.defineProperty(calculateMovingPosition$1, "__esModule", {
  value: true
});
calculateMovingPosition$1.calculateMovingPosition = calculateMovingPosition;

function calculateMovingPosition(e) {
  if ('changedTouches' in e) {
    var touches = e.changedTouches && e.changedTouches[0];
    return {
      x: touches && touches.clientX,
      y: touches && touches.clientY
    };
  }

  return {
    x: e.clientX,
    y: e.clientY
  };
}

var calculatePosition$1 = {};

function _typeof$3(obj) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$3(obj); }

Object.defineProperty(calculatePosition$1, "__esModule", {
  value: true
});
calculatePosition$1.calculatePosition = calculatePosition;

var Utils$1 = _interopRequireWildcard$3(utils$2);

var _types$3 = types$3;

function _getRequireWildcardCache$1(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$1 = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$3(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof$3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache$1(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function calculatePosition(state, options) {
  var start = state.start,
      x = state.x,
      y = state.y,
      traceX = state.traceX,
      traceY = state.traceY;
  var rotatePosition = options.rotatePosition,
      directionDelta = options.directionDelta;
  var deltaX = rotatePosition.x - x;
  var deltaY = y - rotatePosition.y;
  var absX = Math.abs(deltaX);
  var absY = Math.abs(deltaY);
  Utils$1.updateTrace(traceX, deltaX);
  Utils$1.updateTrace(traceY, deltaY);
  var directionX = Utils$1.resolveDirection(traceX, _types$3.Axis.X, directionDelta);
  var directionY = Utils$1.resolveDirection(traceY, _types$3.Axis.Y, directionDelta);
  var duration = Utils$1.calculateDuration(start, Date.now());
  var velocity = Utils$1.calculateVelocity(absX, absY, duration);
  return {
    absX: absX,
    absY: absY,
    deltaX: deltaX,
    deltaY: deltaY,
    directionX: directionX,
    directionY: directionY,
    duration: duration,
    positionX: rotatePosition.x,
    positionY: rotatePosition.y,
    velocity: velocity
  };
}

var calculateTraceDirections$1 = {};

Object.defineProperty(calculateTraceDirections$1, "__esModule", {
  value: true
});
calculateTraceDirections$1.calculateTraceDirections = calculateTraceDirections;

var _types$2 = types$3;

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calculateTraceDirections() {
  var trace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ticks = [];
  var positive = _types$2.TraceDirectionKey.POSITIVE;
  var negative = _types$2.TraceDirectionKey.NEGATIVE;
  var i = 0;
  var tick = [];
  var direction = _types$2.TraceDirectionKey.NONE;

  for (; i < trace.length; i++) {
    var current = trace[i];
    var prev = trace[i - 1];

    if (tick.length) {
      var currentDirection = current > prev ? positive : negative;

      if (direction === _types$2.TraceDirectionKey.NONE) {
        direction = currentDirection;
      }

      if (currentDirection === direction) {
        tick.push(current);
      } else {
        ticks.push(_defineProperty$3({}, direction, tick.slice()));
        tick = [];
        tick.push(current);
        direction = currentDirection;
      }
    } else {
      if (current !== 0) {
        direction = current > 0 ? positive : negative;
      }

      tick.push(current);
    }
  }

  if (tick.length) {
    ticks.push(_defineProperty$3({}, direction, tick));
  }

  return ticks;
}

var calculateVelocity$1 = {};

Object.defineProperty(calculateVelocity$1, "__esModule", {
  value: true
});
calculateVelocity$1.calculateVelocity = calculateVelocity;

function calculateVelocity(x, y, time) {
  var magnitude = Math.sqrt(x * x + y * y);
  return magnitude / (time || 1);
}

var checkIsMoreThanSingleTouches$1 = {};

Object.defineProperty(checkIsMoreThanSingleTouches$1, "__esModule", {
  value: true
});
checkIsMoreThanSingleTouches$1.checkIsMoreThanSingleTouches = void 0;

var checkIsMoreThanSingleTouches = function checkIsMoreThanSingleTouches(e) {
  return Boolean(e.touches && e.touches.length > 1);
};

checkIsMoreThanSingleTouches$1.checkIsMoreThanSingleTouches = checkIsMoreThanSingleTouches;

var checkIsPassiveSupported$1 = {};

var createOptions$1 = {};

Object.defineProperty(createOptions$1, "__esModule", {
  value: true
});
createOptions$1.createOptions = createOptions;

function createOptions() {
  var proxy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Object.defineProperty(proxy, 'passive', {
    get: function get() {
      this.isPassiveSupported = true;
      return true;
    },
    enumerable: true
  });
  return proxy;
}

Object.defineProperty(checkIsPassiveSupported$1, "__esModule", {
  value: true
});
checkIsPassiveSupported$1.checkIsPassiveSupported = checkIsPassiveSupported;
checkIsPassiveSupported$1.noop = void 0;

var _createOptions = createOptions$1;

function checkIsPassiveSupported(isPassiveSupported) {
  if (typeof isPassiveSupported === 'boolean') {
    return isPassiveSupported;
  }

  var proxy = {
    isPassiveSupported: isPassiveSupported
  };

  try {
    var options = (0, _createOptions.createOptions)(proxy);
    window.addEventListener('checkIsPassiveSupported', noop$3, options);
    window.removeEventListener('checkIsPassiveSupported', noop$3, options);
  } catch (err) {}

  return proxy.isPassiveSupported;
}

var noop$3 = function noop() {};

checkIsPassiveSupported$1.noop = noop$3;

var checkIsTouchEventsSupported$1 = {};

Object.defineProperty(checkIsTouchEventsSupported$1, "__esModule", {
  value: true
});
checkIsTouchEventsSupported$1.checkIsTouchEventsSupported = void 0;

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }

var checkIsTouchEventsSupported = function checkIsTouchEventsSupported() {
  return (typeof window === "undefined" ? "undefined" : _typeof$2(window)) === 'object' && ('ontouchstart' in window || Boolean(window.navigator.maxTouchPoints));
};

checkIsTouchEventsSupported$1.checkIsTouchEventsSupported = checkIsTouchEventsSupported;

var common$1 = {};

Object.defineProperty(common$1, "__esModule", {
  value: true
});
common$1.resolveAxisDirection = common$1.getDirectionValue = common$1.getDirectionKey = common$1.getDifference = void 0;

var _types$1 = types$3;

var getDirectionKey = function getDirectionKey() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = Object.keys(object).toString();

  switch (key) {
    case _types$1.TraceDirectionKey.POSITIVE:
      return _types$1.TraceDirectionKey.POSITIVE;

    case _types$1.TraceDirectionKey.NEGATIVE:
      return _types$1.TraceDirectionKey.NEGATIVE;

    default:
      return _types$1.TraceDirectionKey.NONE;
  }
};

common$1.getDirectionKey = getDirectionKey;

var getDirectionValue = function getDirectionValue() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return values[values.length - 1] || 0;
};

common$1.getDirectionValue = getDirectionValue;

var getDifference = function getDifference() {
  var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Math.abs(x - y);
};

common$1.getDifference = getDifference;

var resolveAxisDirection = function resolveAxisDirection(axis, key) {
  var negative = _types$1.Direction.LEFT;
  var positive = _types$1.Direction.RIGHT;
  var direction = _types$1.Direction.NONE;

  if (axis === _types$1.Axis.Y) {
    negative = _types$1.Direction.BOTTOM;
    positive = _types$1.Direction.TOP;
  }

  if (key === _types$1.TraceDirectionKey.NEGATIVE) {
    direction = negative;
  }

  if (key === _types$1.TraceDirectionKey.POSITIVE) {
    direction = positive;
  }

  return direction;
};

common$1.resolveAxisDirection = resolveAxisDirection;

var getInitialState$1 = {};

Object.defineProperty(getInitialState$1, "__esModule", {
  value: true
});
getInitialState$1.getInitialState = void 0;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getInitialState = function getInitialState() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread$1({
    x: 0,
    y: 0,
    start: 0,
    isSwiping: false,
    traceX: [],
    traceY: []
  }, options);
};

getInitialState$1.getInitialState = getInitialState;

var getInitialProps$1 = {};

Object.defineProperty(getInitialProps$1, "__esModule", {
  value: true
});
getInitialProps$1.getInitialProps = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getInitialProps = function getInitialProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    element: null,
    target: null,
    delta: 10,
    directionDelta: 0,
    rotationAngle: 0,
    mouseTrackingEnabled: false,
    touchTrackingEnabled: true,
    preventDefaultTouchmoveEvent: false,
    preventTrackingOnMouseleave: false
  }, props);
};

getInitialProps$1.getInitialProps = getInitialProps;

var getOptions$1 = {};

Object.defineProperty(getOptions$1, "__esModule", {
  value: true
});
getOptions$1.getOptions = getOptions;

function getOptions() {
  var isPassiveSupported = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (isPassiveSupported) {
    return {
      passive: false
    };
  }

  return {};
}

var resolveDirection$1 = {};

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

Object.defineProperty(resolveDirection$1, "__esModule", {
  value: true
});
resolveDirection$1.resolveDirection = resolveDirection;

var Utils = _interopRequireWildcard$2(utils$2);

var _types = types$3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$2(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function resolveDirection(trace) {
  var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _types.Axis.X;
  var directionDelta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (directionDelta) {
    var directions = Utils.calculateTraceDirections(trace);

    var _direction = Utils.calculateDirectionDelta(directions, directionDelta);

    return Utils.resolveAxisDirection(axis, _direction);
  }

  var direction = Utils.calculateDirection(trace);
  return Utils.resolveAxisDirection(axis, direction);
}

var rotateByAngle$1 = {};

Object.defineProperty(rotateByAngle$1, "__esModule", {
  value: true
});
rotateByAngle$1.rotateByAngle = rotateByAngle;

function rotateByAngle(position) {
  var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (angle === 0) {
    return position;
  }

  var x = position.x,
      y = position.y;
  var angleInRadians = Math.PI / 180 * angle;
  var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
  var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
  return {
    x: rotatedX,
    y: rotatedY
  };
}

var updateTrace$1 = {};

Object.defineProperty(updateTrace$1, "__esModule", {
  value: true
});
updateTrace$1.updateTrace = updateTrace;

function updateTrace(trace, value) {
  var last = trace[trace.length - 1];

  if (last !== value) {
    trace.push(value);
  }

  return trace;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calculateDirection = calculateDirection$1;

Object.keys(_calculateDirection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateDirection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateDirection[key];
    }
  });
});

var _calculateDirectionDelta = calculateDirectionDelta$1;

Object.keys(_calculateDirectionDelta).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateDirectionDelta[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateDirectionDelta[key];
    }
  });
});

var _calculateDuration = calculateDuration$1;

Object.keys(_calculateDuration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateDuration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateDuration[key];
    }
  });
});

var _calculateMovingPosition = calculateMovingPosition$1;

Object.keys(_calculateMovingPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateMovingPosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateMovingPosition[key];
    }
  });
});

var _calculatePosition = calculatePosition$1;

Object.keys(_calculatePosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculatePosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculatePosition[key];
    }
  });
});

var _calculateTraceDirections = calculateTraceDirections$1;

Object.keys(_calculateTraceDirections).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateTraceDirections[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateTraceDirections[key];
    }
  });
});

var _calculateVelocity = calculateVelocity$1;

Object.keys(_calculateVelocity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculateVelocity[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _calculateVelocity[key];
    }
  });
});

var _checkIsMoreThanSingleTouches = checkIsMoreThanSingleTouches$1;

Object.keys(_checkIsMoreThanSingleTouches).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkIsMoreThanSingleTouches[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsMoreThanSingleTouches[key];
    }
  });
});

var _checkIsPassiveSupported = checkIsPassiveSupported$1;

Object.keys(_checkIsPassiveSupported).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkIsPassiveSupported[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsPassiveSupported[key];
    }
  });
});

var _checkIsTouchEventsSupported = checkIsTouchEventsSupported$1;

Object.keys(_checkIsTouchEventsSupported).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkIsTouchEventsSupported[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkIsTouchEventsSupported[key];
    }
  });
});

var _common = common$1;

Object.keys(_common).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _common[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _common[key];
    }
  });
});

var _createOptions = createOptions$1;

Object.keys(_createOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createOptions[key];
    }
  });
});

var _getInitialState = getInitialState$1;

Object.keys(_getInitialState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getInitialState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialState[key];
    }
  });
});

var _getInitialProps = getInitialProps$1;

Object.keys(_getInitialProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getInitialProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getInitialProps[key];
    }
  });
});

var _getOptions = getOptions$1;

Object.keys(_getOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getOptions[key];
    }
  });
});

var _resolveDirection = resolveDirection$1;

Object.keys(_resolveDirection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resolveDirection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _resolveDirection[key];
    }
  });
});

var _rotateByAngle = rotateByAngle$1;

Object.keys(_rotateByAngle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _rotateByAngle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _rotateByAngle[key];
    }
  });
});

var _updateTrace = updateTrace$1;

Object.keys(_updateTrace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateTrace[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _updateTrace[key];
    }
  });
});
}(utils$2));

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var Utils = _interopRequireWildcard(utils$2);

var _types = types$3;

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VanillaSwipe = /*#__PURE__*/function () {
  function VanillaSwipe(props) {
    _classCallCheck(this, VanillaSwipe);

    _defineProperty(this, "state", void 0);

    _defineProperty(this, "props", void 0);

    this.state = Utils.getInitialState();
    this.props = Utils.getInitialProps(props);
    this.handleSwipeStart = this.handleSwipeStart.bind(this);
    this.handleSwipeMove = this.handleSwipeMove.bind(this);
    this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  _createClass(VanillaSwipe, [{
    key: "init",
    value: function init() {
      this.setupTouchListeners();
      this.setupMouseListeners();
    }
  }, {
    key: "update",
    value: function update(props) {
      var prevProps = this.props;
      var nextProps = Object.assign({}, prevProps, props);

      if (prevProps.element !== nextProps.element || prevProps.target !== nextProps.target) {
        this.destroy();
        this.props = nextProps;
        this.init();
        return;
      }

      this.props = nextProps;

      if (prevProps.mouseTrackingEnabled !== nextProps.mouseTrackingEnabled || prevProps.preventTrackingOnMouseleave !== nextProps.preventTrackingOnMouseleave) {
        this.cleanupMouseListeners();
        nextProps.mouseTrackingEnabled ? this.setupMouseListeners() : this.cleanupMouseListeners();
      }

      if (prevProps.touchTrackingEnabled !== nextProps.touchTrackingEnabled) {
        this.cleanupTouchListeners();
        nextProps.touchTrackingEnabled ? this.setupTouchListeners() : this.cleanupTouchListeners();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cleanupMouseListeners();
      this.cleanupTouchListeners();
      this.state = Utils.getInitialState();
      this.props = Utils.getInitialProps();
    }
  }, {
    key: "setupTouchListeners",
    value: function setupTouchListeners() {
      var _this$props = this.props,
          element = _this$props.element,
          target = _this$props.target,
          touchTrackingEnabled = _this$props.touchTrackingEnabled;

      if (element && touchTrackingEnabled) {
        var listener = target || element;
        var isPassiveSupported = Utils.checkIsPassiveSupported();
        var options = Utils.getOptions(isPassiveSupported);
        listener.addEventListener('touchstart', this.handleSwipeStart, options);
        listener.addEventListener('touchmove', this.handleSwipeMove, options);
        listener.addEventListener('touchend', this.handleSwipeEnd, options);
      }
    }
  }, {
    key: "cleanupTouchListeners",
    value: function cleanupTouchListeners() {
      var _this$props2 = this.props,
          element = _this$props2.element,
          target = _this$props2.target;
      var listener = target || element;

      if (listener) {
        listener.removeEventListener('touchstart', this.handleSwipeStart);
        listener.removeEventListener('touchmove', this.handleSwipeMove);
        listener.removeEventListener('touchend', this.handleSwipeEnd);
      }
    }
  }, {
    key: "setupMouseListeners",
    value: function setupMouseListeners() {
      var _this$props3 = this.props,
          element = _this$props3.element,
          mouseTrackingEnabled = _this$props3.mouseTrackingEnabled,
          preventTrackingOnMouseleave = _this$props3.preventTrackingOnMouseleave;

      if (mouseTrackingEnabled && element) {
        element.addEventListener('mousedown', this.handleMouseDown);
        element.addEventListener('mousemove', this.handleMouseMove);
        element.addEventListener('mouseup', this.handleMouseUp);

        if (preventTrackingOnMouseleave) {
          element.addEventListener('mouseleave', this.handleMouseLeave);
        }
      }
    }
  }, {
    key: "cleanupMouseListeners",
    value: function cleanupMouseListeners() {
      var element = this.props.element;

      if (element) {
        element.removeEventListener('mousedown', this.handleMouseDown);
        element.removeEventListener('mousemove', this.handleMouseMove);
        element.removeEventListener('mouseup', this.handleMouseUp);
        element.removeEventListener('mouseleave', this.handleMouseLeave);
      }
    }
  }, {
    key: "getEventData",
    value: function getEventData(e) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        directionDelta: 0
      };
      var rotationAngle = this.props.rotationAngle;
      var directionDelta = options.directionDelta;
      var movingPosition = Utils.calculateMovingPosition(e);
      var rotatePosition = Utils.rotateByAngle(movingPosition, rotationAngle);
      return Utils.calculatePosition(this.state, {
        rotatePosition: rotatePosition,
        directionDelta: directionDelta
      });
    }
  }, {
    key: "handleSwipeStart",
    value: function handleSwipeStart(e) {
      if (Utils.checkIsMoreThanSingleTouches(e)) return;
      var rotationAngle = this.props.rotationAngle;
      var movingPosition = Utils.calculateMovingPosition(e);

      var _Utils$rotateByAngle = Utils.rotateByAngle(movingPosition, rotationAngle),
          x = _Utils$rotateByAngle.x,
          y = _Utils$rotateByAngle.y;

      this.state = Utils.getInitialState({
        isSwiping: false,
        start: Date.now(),
        x: x,
        y: y
      });
    }
  }, {
    key: "handleSwipeMove",
    value: function handleSwipeMove(e) {
      var _this$state = this.state,
          x = _this$state.x,
          y = _this$state.y,
          isSwiping = _this$state.isSwiping;
      if (!x || !y || Utils.checkIsMoreThanSingleTouches(e)) return;
      var directionDelta = this.props.directionDelta || 0;

      var _this$getEventData = this.getEventData(e, {
        directionDelta: directionDelta
      }),
          absX = _this$getEventData.absX,
          absY = _this$getEventData.absY,
          deltaX = _this$getEventData.deltaX,
          deltaY = _this$getEventData.deltaY,
          directionX = _this$getEventData.directionX,
          directionY = _this$getEventData.directionY,
          duration = _this$getEventData.duration,
          velocity = _this$getEventData.velocity;

      var _this$props4 = this.props,
          delta = _this$props4.delta,
          preventDefaultTouchmoveEvent = _this$props4.preventDefaultTouchmoveEvent,
          onSwipeStart = _this$props4.onSwipeStart,
          onSwiping = _this$props4.onSwiping;
      if (e.cancelable && preventDefaultTouchmoveEvent) e.preventDefault();
      if (absX < Number(delta) && absY < Number(delta) && !isSwiping) return;

      if (onSwipeStart && !isSwiping) {
        onSwipeStart(e, {
          deltaX: deltaX,
          deltaY: deltaY,
          absX: absX,
          absY: absY,
          directionX: directionX,
          directionY: directionY,
          duration: duration,
          velocity: velocity
        });
      }

      this.state.isSwiping = true;

      if (onSwiping) {
        onSwiping(e, {
          deltaX: deltaX,
          deltaY: deltaY,
          absX: absX,
          absY: absY,
          directionX: directionX,
          directionY: directionY,
          duration: duration,
          velocity: velocity
        });
      }
    }
  }, {
    key: "handleSwipeEnd",
    value: function handleSwipeEnd(e) {
      var _this$props5 = this.props,
          onSwiped = _this$props5.onSwiped,
          onTap = _this$props5.onTap;

      if (this.state.isSwiping) {
        var directionDelta = this.props.directionDelta || 0;
        var position = this.getEventData(e, {
          directionDelta: directionDelta
        });
        onSwiped && onSwiped(e, position);
      } else {
        var _position = this.getEventData(e);

        onTap && onTap(e, _position);
      }

      this.state = Utils.getInitialState();
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      var target = this.props.target;

      if (target) {
        if (target === e.target) {
          this.handleSwipeStart(e);
        }
      } else {
        this.handleSwipeStart(e);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      this.handleSwipeMove(e);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(e) {
      var isSwiping = this.state.isSwiping;
      var target = this.props.target;

      if (target) {
        if (target === e.target || isSwiping) {
          this.handleSwipeEnd(e);
        }
      } else {
        this.handleSwipeEnd(e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(e) {
      var isSwiping = this.state.isSwiping;

      if (isSwiping) {
        this.handleSwipeEnd(e);
      }
    }
  }], [{
    key: "isTouchEventsSupported",
    value: function isTouchEventsSupported() {
      return Utils.checkIsTouchEventsSupported();
    }
  }]);

  return VanillaSwipe;
}();

exports["default"] = VanillaSwipe;
}(lib));

var defaultProps$1 = {};

var types$2 = {};

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.Modifiers=exports.Classnames=exports.AutoplayDirection=exports.ControlsStrategy=exports.AutoPlayStrategy=exports.AnimationType=exports.EventType=void 0,function(e){e.ACTION="action",e.INIT="init",e.RESIZE="resize",e.UPDATE="update";}(exports.EventType||(exports.EventType={})),function(e){e.FADEOUT="fadeout",e.SLIDE="slide";}(exports.AnimationType||(exports.AnimationType={})),function(e){e.DEFAULT="default",e.ALL="all",e.ACTION="action",e.NONE="none";}(exports.AutoPlayStrategy||(exports.AutoPlayStrategy={})),function(e){e.DEFAULT="default",e.ALTERNATE="alternate",e.RESPONSIVE="responsive";}(exports.ControlsStrategy||(exports.ControlsStrategy={})),function(e){e.RTL="rtl",e.LTR="ltr";}(exports.AutoplayDirection||(exports.AutoplayDirection={})),function(e){e.ANIMATED="animated animated-out fadeOut",e.ROOT="alice-carousel",e.WRAPPER="alice-carousel__wrapper",e.STAGE="alice-carousel__stage",e.STAGE_ITEM="alice-carousel__stage-item",e.DOTS="alice-carousel__dots",e.DOTS_ITEM="alice-carousel__dots-item",e.PLAY_BTN="alice-carousel__play-btn",e.PLAY_BTN_ITEM="alice-carousel__play-btn-item",e.PLAY_BTN_WRAPPER="alice-carousel__play-btn-wrapper",e.SLIDE_INFO="alice-carousel__slide-info",e.SLIDE_INFO_ITEM="alice-carousel__slide-info-item",e.BUTTON_PREV="alice-carousel__prev-btn",e.BUTTON_PREV_WRAPPER="alice-carousel__prev-btn-wrapper",e.BUTTON_PREV_ITEM="alice-carousel__prev-btn-item",e.BUTTON_NEXT="alice-carousel__next-btn",e.BUTTON_NEXT_WRAPPER="alice-carousel__next-btn-wrapper",e.BUTTON_NEXT_ITEM="alice-carousel__next-btn-item";}(exports.Classnames||(exports.Classnames={})),function(e){e.ACTIVE="__active",e.INACTIVE="__inactive",e.CLONED="__cloned",e.CUSTOM="__custom",e.PAUSE="__pause",e.SEPARATOR="__separator",e.SSR="__ssr",e.TARGET="__target";}(exports.Modifiers||(exports.Modifiers={}));
}(types$2));

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.defaultProps=void 0;var types_1=types$2;exports.defaultProps={activeIndex:0,animationDuration:400,animationEasingFunction:"ease",animationType:types_1.AnimationType.SLIDE,autoHeight:!1,autoWidth:!1,autoPlay:!1,autoPlayControls:!1,autoPlayDirection:types_1.AutoplayDirection.LTR,autoPlayInterval:400,autoPlayStrategy:types_1.AutoPlayStrategy.DEFAULT,children:void 0,controlsStrategy:types_1.ControlsStrategy.DEFAULT,disableButtonsControls:!1,disableDotsControls:!1,disableSlideInfo:!0,infinite:!1,innerWidth:0,items:void 0,keyboardNavigation:!1,mouseTracking:!1,name:"",paddingLeft:0,paddingRight:0,responsive:void 0,swipeDelta:20,swipeExtraPadding:200,ssrSilentMode:!0,touchTracking:!0,touchMoveDefaultEvents:!0,onInitialized:function(){},onResized:function(){},onResizeEvent:void 0,onSlideChange:function(){},onSlideChanged:function(){}};
}(defaultProps$1));

var views = {};

var SlideInfo = {};

var utils$1 = {};

var common = {};

var elements = {};

var mappers = {};

(function (exports) {
var __assign=function(){return (__assign=Object.assign||function(o){for(var t,r=1,n=arguments.length;r<n;r++)for(var i in t=arguments[r])Object.prototype.hasOwnProperty.call(t,i)&&(o[i]=t[i]);return o}).apply(this,arguments)};Object.defineProperty(exports,"__esModule",{value:!0}),exports.mapPositionCoords=exports.mapPartialCoords=void 0,exports.mapPartialCoords=function(o){return o.map(function(o){return {width:o.width,position:0}})},exports.mapPositionCoords=function(o,t){return void 0===t&&(t=0),o.map(function(o){return o.position>t?__assign(__assign({},o),{position:t}):o})};
}(mappers));

var math = {};

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.isVerticalTouchmoveDetected=exports.getFadeoutAnimationPosition=exports.getFadeoutAnimationIndex=exports.getSwipeTouchendIndex=exports.getSwipeTouchendPosition=exports.getSwipeTransformationCursor=exports.getTransformationItemIndex=exports.getSwipeShiftValue=exports.getItemCoords=exports.getIsLeftDirection=exports.shouldRecalculateSwipePosition=exports.getSwipeLimitMax=exports.getSwipeLimitMin=exports.shouldCancelSlideAnimation=exports.shouldRecalculateSlideIndex=exports.getUpdateSlidePositionIndex=exports.getActiveIndex=exports.getStartIndex=exports.getShiftIndex=void 0,exports.getShiftIndex=function(t,e){return (t=void 0===t?0:t)+(e=void 0===e?0:e)},exports.getStartIndex=function(t,e){if(void 0===t&&(t=0),e=void 0===e?0:e){if(e<=t)return e-1;if(0<t)return t}return 0},exports.getActiveIndex=function(t){var e=t.startIndex,e=void 0===e?0:e,i=t.itemsCount,t=t.infinite;return void 0!==t&&t?e:exports.getStartIndex(e,void 0===i?0:i)},exports.getUpdateSlidePositionIndex=function(t,e){return t<0?e-1:e<=t?0:t},exports.shouldRecalculateSlideIndex=function(t,e){return t<0||e<=t},exports.shouldCancelSlideAnimation=function(t,e){return t<0||e<=t},exports.getSwipeLimitMin=function(t,e){var i=t.itemsOffset,t=t.transformationSet,t=void 0===t?[]:t,o=e.infinite,e=e.swipeExtraPadding;if(o)return (t[void 0===i?0:i]||{}).position;o=(t[0]||{}).width;return Math.min(void 0===e?0:e,void 0===o?0:o)},exports.getSwipeLimitMax=function(t,e){var i=e.infinite,e=e.swipeExtraPadding,e=void 0===e?0:e,o=t.itemsCount,n=t.itemsOffset,r=t.itemsInSlide,r=void 0===r?1:r,t=t.transformationSet,t=void 0===t?[]:t;return i?(t[(void 0===o?1:o)+exports.getShiftIndex(r,void 0===n?0:n)]||{}).position||0:exports.getItemCoords(-r,t).position+e},exports.shouldRecalculateSwipePosition=function(t,e,i){return -e<=t||Math.abs(t)>=i},exports.getIsLeftDirection=function(t){return (t=void 0===t?0:t)<0},exports.getItemCoords=function(t,e){return (e=void 0===e?[]:e).slice(t=void 0===t?0:t)[0]||{position:0,width:0}},exports.getSwipeShiftValue=function(t,e){return void 0===t&&(t=0),void 0===e&&(e=[]),exports.getItemCoords(t,e).position},exports.getTransformationItemIndex=function(t,e){return void 0===e&&(e=0),(t=void 0===t?[]:t).findIndex(function(t){return t.position>=Math.abs(e)})},exports.getSwipeTransformationCursor=function(t,e,i){void 0===t&&(t=[]),void 0===e&&(e=0),void 0===i&&(i=0);t=exports.getTransformationItemIndex(t,e);return exports.getIsLeftDirection(i)?t:t-1},exports.getSwipeTouchendPosition=function(t,e,i){void 0===i&&(i=0);var o=t.infinite,n=t.autoWidth,r=t.isStageContentPartial,s=t.swipeAllowedPositionMax,t=t.transformationSet,i=exports.getSwipeTransformationCursor(t,i,e),e=exports.getItemCoords(i,t).position;if(!o){if(n&&r)return 0;if(s<e)return -s}return -e},exports.getSwipeTouchendIndex=function(t,e){var i=e.transformationSet,o=e.itemsInSlide,n=e.itemsOffset,r=e.itemsCount,s=e.infinite,d=e.isStageContentPartial,a=e.activeIndex,e=e.translate3d;if(!s&&(d||e===Math.abs(t)))return a;d=exports.getTransformationItemIndex(i,t);return s?d<(e=exports.getShiftIndex(o,n))?r-o-n+d:e+r<=d?d-(e+r):d-e:d},exports.getFadeoutAnimationIndex=function(t){var e=t.infinite,i=t.activeIndex,t=t.itemsInSlide;return e?i+t:i},exports.getFadeoutAnimationPosition=function(t,e){var i=e.activeIndex,e=e.stageWidth;return t<i?(i-t)*-e||0:(t-i)*e||0},exports.isVerticalTouchmoveDetected=function(t,e,i){return t<(i=void 0===i?0:i)||t<.1*e};
}(math));

(function (exports) {
var __assign=function(){return (__assign=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var o in e=arguments[r])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},common_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.getTransformMatrix=exports.getTranslateXProperty=exports.getTouchmoveTranslatePosition=exports.getTranslate3dProperty=exports.getRenderStageItemStyles=exports.getRenderStageStyles=exports.getTransitionProperty=exports.getRenderWrapperStyles=exports.animate=exports.shouldHandleResizeEvent=exports.getElementFirstChild=exports.getElementCursor=exports.getAutoheightProperty=exports.getElementDimensions=exports.getItemWidth=exports.createDefaultTransformationSet=exports.createAutowidthTransformationSet=exports.isElement=exports.createClones=exports.getItemsOffset=exports.getItemsCount=exports.getSlides=void 0,common),mappers_1=mappers,math_1=math;function getElementDimensions(t){return t&&t.getBoundingClientRect?{width:(t=t.getBoundingClientRect()).width,height:t.height}:{width:0,height:0}}function shouldHandleResizeEvent(t,e,r){return (e=void 0===e?{}:e).width!==(r=void 0===r?{}:r).width}function animate(t,e){var e=e||{},r=e.position,r=void 0===r?0:r,n=e.animationDuration,n=void 0===n?0:n,e=e.animationEasingFunction,e=void 0===e?"ease":e;return exports.isElement(t)&&(t.style.transition="transform "+n+"ms "+e+" 0ms",t.style.transform="translate3d("+r+"px, 0, 0)"),t}function getTranslateXProperty(t){t=getTransformMatrix(t),t=t&&t[4]||"";return Number(t)}function getTransformMatrix(t){return exports.isElement(t)&&getComputedStyle(t).transform.match(/(-?[0-9.]+)/g)||[]}exports.getSlides=function(t){var e=t.children,t=t.items;return e?e.length?e:[e]:void 0===t?[]:t},exports.getItemsCount=function(t){return exports.getSlides(t).length},exports.getItemsOffset=function(t){var e=t.infinite,r=t.paddingRight,t=t.paddingLeft;return e&&(t||r)?1:0},exports.createClones=function(t){var e=exports.getSlides(t);if(!t.infinite)return e;var r=exports.getItemsCount(t),n=exports.getItemsOffset(t),t=common_1.getItemsInSlide(r,t),o=Math.min(t,r)+n,i=e.slice(0,o),o=e.slice(-o);return n&&t===r&&(n=e[0],t=e.slice(-1)[0],o.unshift(t),i.push(n)),o.concat(e,i)},exports.isElement=function(t){try{return t instanceof Element||t instanceof HTMLDocument}catch(t){return !1}},exports.createAutowidthTransformationSet=function(t,i,e){void 0===i&&(i=0),void 0===e&&(e=!1);var s=0,a=!0,r=[];return exports.isElement(t)&&(r=Array.from(t.children||[]).reduce(function(t,e,r){var n=0,r=r-1,o=t[r],e=getElementDimensions(null==e?void 0:e.firstChild).width,e=void 0===e?0:e;return a=(s+=e)<=i,o&&(n=0==r?o.width:o.width+o.position),t.push({position:n,width:e}),t},[]),e||(r=a?mappers_1.mapPartialCoords(r):(t=s-i,mappers_1.mapPositionCoords(r,t)))),{coords:r,content:s,partial:a}},exports.createDefaultTransformationSet=function(t,o,e,r){void 0===r&&(r=!1);var i=0,s=!0,n=[],a=exports.getItemWidth(o,e);return n=t.reduce(function(t,e,r){var n=0,r=t[r-1];return s=(i+=a)<=o,r&&(n=a+r.position||0),t.push({width:a,position:n}),t},[]),{coords:n=r?n:s?mappers_1.mapPartialCoords(n):(e=i-o,mappers_1.mapPositionCoords(n,e)),content:i,partial:s}},exports.getItemWidth=function(t,e){return 0<e?t/e:t},exports.getElementDimensions=getElementDimensions,exports.getAutoheightProperty=function(t,e,r){var e=exports.getElementCursor(e,r),r=exports.getElementFirstChild(t,e);if(exports.isElement(r))return t=getComputedStyle(r),e=parseFloat(t.marginTop),t=parseFloat(t.marginBottom),Math.ceil(r.offsetHeight+e+t)},exports.getElementCursor=function(t,e){var r=e.activeIndex,e=e.itemsInSlide;return t.infinite?r+e+exports.getItemsOffset(t):r},exports.getElementFirstChild=function(t,e){t=t&&t.children||[];return t[e]&&t[e].firstChild||null},exports.shouldHandleResizeEvent=shouldHandleResizeEvent,exports.animate=animate,exports.getRenderWrapperStyles=function(t,e,r){var n=t||{},o=n.paddingLeft,i=n.paddingRight,s=n.autoHeight,n=n.animationDuration,s=s?exports.getAutoheightProperty(r,t,e):void 0;return {height:s,transition:s?"height "+n+"ms":void 0,paddingLeft:o+"px",paddingRight:i+"px"}},exports.getTransitionProperty=function(t){var t=t||{},e=t.animationDuration,t=t.animationEasingFunction;return "transform "+(void 0===e?0:e)+"ms "+(void 0===t?"ease":t)+" 0ms"},exports.getRenderStageStyles=function(t,e){t=(t||{}).translate3d,t="translate3d("+-(void 0===t?0:t)+"px, 0, 0)";return __assign(__assign({},e),{transform:t})},exports.getRenderStageItemStyles=function(t,e){var r=e.transformationSet,n=e.fadeoutAnimationIndex,o=e.fadeoutAnimationPosition,i=e.fadeoutAnimationProcessing,e=e.animationDuration,r=(r[t]||{}).width;return i&&n===t?{transform:"translateX("+o+"px)",animationDuration:e+"ms",width:r+"px"}:{width:r}},exports.getTranslate3dProperty=function(t,e){var r=t,n=e.infinite,o=e.itemsOffset,i=e.itemsInSlide,e=e.transformationSet;return ((void 0===e?[]:e)[r=n?t+math_1.getShiftIndex(void 0===i?0:i,void 0===o?0:o):r]||{}).position||0},exports.getTouchmoveTranslatePosition=function(t,e){return -(e-Math.floor(t))},exports.getTranslateXProperty=getTranslateXProperty,exports.getTransformMatrix=getTransformMatrix;
}(elements));

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.calculateInitialState=exports.getItemsInSlide=exports.getIsStageContentPartial=exports.concatClassnames=exports.canUseDOM=void 0;var elements_1=elements,math_1=math;exports.canUseDOM=function(){var t;try{return Boolean(null==(t=null===window||void 0===window?void 0:window.document)?void 0:t.createElement)}catch(t){return !1}},exports.concatClassnames=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return t.filter(Boolean).join(" ")},exports.getIsStageContentPartial=function(t,e,i){return void 0===e&&(e=0),void 0===i&&(i=0),!(t=void 0!==t&&t)&&i<=e},exports.getItemsInSlide=function(e,t){var i,n=1,o=t.responsive,a=t.autoWidth,s=t.infinite,t=t.innerWidth;return void 0!==a&&a?void 0!==s&&s?e:n:(o&&(a=Object.keys(o)).length&&(t||exports.canUseDOM())&&(i=t||window.innerWidth,a.forEach(function(t){Number(t)<i&&(n=Math.min(o[t].items,e)||n);})),n)},exports.calculateInitialState=function(t,e,i){void 0===i&&(i=!1);var n,o,a=t.animationDuration,a=void 0===a?0:a,s=t.infinite,s=void 0!==s&&s,r=t.autoPlay,r=void 0!==r&&r,l=t.autoWidth,l=void 0!==l&&l,m=elements_1.createClones(t),d=elements_1.getTransitionProperty(),u=elements_1.getItemsCount(t),c=elements_1.getItemsOffset(t),f=exports.getItemsInSlide(u,t),p=math_1.getStartIndex(t.activeIndex,u),p=math_1.getActiveIndex({startIndex:p,itemsCount:u,infinite:s}),g=elements_1.getElementDimensions(e).width,h=(o=(e=l?(n=(e=elements_1.createAutowidthTransformationSet(e,g,s)).coords,o=e.content,e.partial):(n=(e=elements_1.createDefaultTransformationSet(m,g,f,s)).coords,o=e.content,e.partial),o),math_1.getItemCoords(-f,n=n).position),v=math_1.getSwipeLimitMin({itemsOffset:c,transformationSet:n},t),t=math_1.getSwipeLimitMax({itemsCount:u,itemsOffset:c,itemsInSlide:f,transformationSet:n},t),S=math_1.getSwipeShiftValue(u,n);return {activeIndex:p,autoWidth:l,animationDuration:a,clones:m,infinite:s,itemsCount:u,itemsInSlide:f,itemsOffset:c,translate3d:elements_1.getTranslate3dProperty(p,{itemsInSlide:f,itemsOffset:c,transformationSet:n,autoWidth:l,infinite:s}),stageWidth:g,stageContentWidth:o,initialStageHeight:0,isStageContentPartial:e,isAutoPlaying:Boolean(r),isAutoPlayCanceledOnAction:!1,transformationSet:n,transition:d,fadeoutAnimationIndex:null,fadeoutAnimationPosition:null,fadeoutAnimationProcessing:!1,swipeLimitMin:v,swipeLimitMax:t,swipeAllowedPositionMax:h,swipeShiftValue:S,canUseDom:i||exports.canUseDOM()}};
}(common));

var classnames$1 = {};

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.isClonedItem=exports.isTargetItem=exports.isActiveItem=exports.getRenderStageItemClasses=void 0;var types_1=types$2,common_1=common,math_1=math;exports.getRenderStageItemClasses=function(e,t){void 0===e&&(e=0);var i=t.fadeoutAnimationIndex,s=exports.isActiveItem(e,t)?types_1.Modifiers.ACTIVE:"",r=exports.isClonedItem(e,t)?types_1.Modifiers.CLONED:"",t=exports.isTargetItem(e,t)?types_1.Modifiers.TARGET:"",e=e===i?types_1.Classnames.ANIMATED:"";return common_1.concatClassnames(types_1.Classnames.STAGE_ITEM,s,r,t,e)},exports.isActiveItem=function(e,t){void 0===e&&(e=0);var i=t.activeIndex,s=t.itemsInSlide,r=t.itemsOffset,n=t.infinite,t=t.autoWidth,o=math_1.getShiftIndex(s,r);if(t&&n)return e-o===i+r;t=i+o;return n?t<=e&&e<t+s:i<=e&&e<t},exports.isTargetItem=function(e,t){void 0===e&&(e=0);var i=t.activeIndex,s=t.itemsInSlide,r=t.itemsOffset,n=t.infinite,t=t.autoWidth,s=math_1.getShiftIndex(s,r);return n?t&&n?e-s===i+r:e===i+s:e===i},exports.isClonedItem=function(e,t){void 0===e&&(e=0);var i=t.itemsInSlide,s=t.itemsOffset,r=t.itemsCount,n=t.infinite,t=t.autoWidth;if(!n)return !1;if(t&&n)return e<i||r-1+i<e;t=math_1.getShiftIndex(i,s);return e<t||r-1+t<e};
}(classnames$1));

var timers = {};

(function (exports) {
function debounce(i,n){void 0===n&&(n=0);var u=void 0;return function(){for(var e=this,o=[],t=0;t<arguments.length;t++)o[t]=arguments[t];u&&(clearTimeout(u),u=void 0),u=window.setTimeout(function(){i.apply(e,o),u=void 0;},n);}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.debounce=void 0,exports.debounce=debounce;
}(timers));

var debug = {};

(function (exports) {
function debug(){for(var e=[],o=0;o<arguments.length;o++)e[o]=arguments[o];"development"===process.env.NODE_ENV&&console.debug.apply(console,e);}Object.defineProperty(exports,"__esModule",{value:!0}),exports.debug=void 0,exports.debug=debug;
}(debug));

var render = {};

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.getSlideItemInfo=exports.getSlideInfo=exports.getSlideIndexForMultipleItems=exports.getSlideIndexForNonMultipleItems=exports.getActiveSlideDotsLength=exports.getActiveSlideIndex=void 0,exports.getActiveSlideIndex=function(e,t){var t=t||{},i=t.activeIndex,o=t.itemsInSlide,t=t.itemsCount,i=i+o;return 1===o?exports.getSlideIndexForNonMultipleItems(i,o,t):exports.getSlideIndexForMultipleItems(i,o,t,e)},exports.getActiveSlideDotsLength=function(e,t){var i;return void 0===t&&(t=1),(e=void 0===e?0:e)&&t?(i=Math.floor(e/t),e%t==0?i-1:i):0},exports.getSlideIndexForNonMultipleItems=function(e,t,i){return e<t?i-t:i<e?0:e-1},exports.getSlideIndexForMultipleItems=function(e,t,i,o){var n=exports.getActiveSlideDotsLength(i,t);return e===i+t?0:o||e<t&&0!==e?n:0===e?i%t==0?n:n-1:0<t?Math.floor(e/t)-1:0},exports.getSlideInfo=function(e,t){void 0===t&&(t=0);e=(e=void 0===e?0:e)+1;return e<1?e=t:t<e&&(e=1),{item:e,itemsCount:t}},exports.getSlideItemInfo=function(e){var e=e||{},t=e.itemsInSlide,i=e.activeIndex,o=e.infinite,n=e.itemsCount;return e.isStageContentPartial?{isPrevSlideDisabled:!0,isNextSlideDisabled:!0}:{isPrevSlideDisabled:!1===o&&0===i,isNextSlideDisabled:!1===o&&n-t<=i}};
}(render));

var controls = {};

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.shouldCancelAutoPlayOnHover=exports.shouldCancelAutoPlayOnAction=exports.getItemIndexForDotNavigation=exports.checkIsTheLastDotIndex=exports.getDotsNavigationLength=exports.hasDotForEachSlide=exports.isStrategy=exports.shouldDisableButtons=exports.shouldDisableDots=exports.shouldDisableControls=void 0;var types_1=types$2;function shouldDisableControls(t,o){var t=(t||{}).controlsStrategy,o=o||{},e=o.itemsInSlide,s=o.itemsCount,o=o.autoWidth;if(exports.isStrategy(t,types_1.ControlsStrategy.RESPONSIVE))return !o&&e===s}function shouldDisableDots(t,o){return t.disableDotsControls||shouldDisableControls(t,o)}function shouldDisableButtons(t,o){return t.disableButtonsControls||!t.infinite&&shouldDisableControls(t,o)}exports.shouldDisableControls=shouldDisableControls,exports.shouldDisableDots=shouldDisableDots,exports.shouldDisableButtons=shouldDisableButtons,exports.isStrategy=function(t,o){return t&&t.includes(o)},exports.hasDotForEachSlide=function(t,o){return t||exports.isStrategy(o,types_1.ControlsStrategy.ALTERNATE)},exports.getDotsNavigationLength=function(t,o,e){return void 0===t&&(t=0),void 0===o&&(o=1),e?t:0!==Number(o)&&Math.ceil(t/o)||0},exports.checkIsTheLastDotIndex=function(t,o,e){return !o&&t===e-1},exports.getItemIndexForDotNavigation=function(t,o,e,s){return (o?e-s:t*s)||0},exports.shouldCancelAutoPlayOnAction=function(t){return (t=void 0===t?"":t)===types_1.AutoPlayStrategy.ACTION||t===types_1.AutoPlayStrategy.ALL},exports.shouldCancelAutoPlayOnHover=function(t){return (t=void 0===t?"":t)===types_1.AutoPlayStrategy.DEFAULT||t===types_1.AutoPlayStrategy.ALL};
}(controls));

(function (exports) {
var __createBinding=Object.create?function(e,r,t,o){void 0===o&&(o=t),Object.defineProperty(e,o,{enumerable:!0,get:function(){return r[t]}});}:function(e,r,t,o){e[o=void 0===o?t:o]=r[t];},__exportStar=function(e,r){for(var t in e)"default"===t||r.hasOwnProperty(t)||__createBinding(r,e,t);};Object.defineProperty(exports,"__esModule",{value:!0}),__exportStar(common,exports),__exportStar(elements,exports),__exportStar(classnames$1,exports),__exportStar(timers,exports),__exportStar(math,exports),__exportStar(debug,exports),__exportStar(render,exports),__exportStar(controls,exports),__exportStar(mappers,exports);
}(utils$1));

(function (exports) {
var __importDefault=function(e){return e&&e.__esModule?e:{default:e}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.SlideInfo=void 0,__importDefault(React__default)),types_1=types$2,utils_1=utils$1;exports.SlideInfo=function(e){var t=e.activeIndex,s=e.itemsCount,e=e.renderSlideInfo,t=utils_1.getSlideInfo(t,s).item;if("function"==typeof e)return react_1.default.createElement("div",{className:types_1.Classnames.SLIDE_INFO},e({item:t,itemsCount:s}));e=utils_1.concatClassnames(types_1.Classnames.SLIDE_INFO_ITEM,types_1.Modifiers.SEPARATOR);return react_1.default.createElement("div",{className:types_1.Classnames.SLIDE_INFO},react_1.default.createElement("span",{className:types_1.Classnames.SLIDE_INFO_ITEM},t),react_1.default.createElement("span",{className:e},"/"),react_1.default.createElement("span",{className:types_1.Classnames.SLIDE_INFO_ITEM},s))};
}(SlideInfo));

var StageItem = {};

(function (exports) {
var __importDefault=function(e){return e&&e.__esModule?e:{default:e}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.StageItem=void 0,__importDefault(React__default));exports.StageItem=function(e){var t=e.item,r=e.className,e=e.styles;return react_1.default.createElement("li",{style:e,className:r},t)};
}(StageItem));

var DotsNavigation = {};

(function (exports) {
var __importDefault=function(e){return e&&e.__esModule?e:{default:e}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.DotsNavigation=void 0,__importDefault(React__default)),types_1=types$2,utils_1=utils$1;exports.DotsNavigation=function(e){var o=e.state,n=e.onClick,r=e.onMouseEnter,l=e.onMouseLeave,t=e.controlsStrategy,u=e.renderDotsItem,c=o.itemsCount,_=o.itemsInSlide,d=o.infinite,e=o.autoWidth,m=o.activeIndex,f=utils_1.getSlideItemInfo(o).isNextSlideDisabled,v=utils_1.hasDotForEachSlide(e,t),p=utils_1.getDotsNavigationLength(c,_,v);return react_1.default.createElement("ul",{className:types_1.Classnames.DOTS},Array.from({length:c}).map(function(e,t){var i,s,a;if(t<p)return s=utils_1.checkIsTheLastDotIndex(t,Boolean(d),p),i=utils_1.getItemIndexForDotNavigation(t,s,c,_),s=utils_1.getActiveSlideIndex(f,o),v&&((s=m)<0?s=c-1:c<=m&&(s=0),i=t),s=s===t?types_1.Modifiers.ACTIVE:"",a=u?types_1.Modifiers.CUSTOM:"",a=utils_1.concatClassnames(types_1.Classnames.DOTS_ITEM,s,a),react_1.default.createElement("li",{key:"dot-item-"+t,onMouseEnter:r,onMouseLeave:l,onClick:function(){return n(i)},className:a},u&&u({isActive:s,activeIndex:t}))}))};
}(DotsNavigation));

var PlayPauseButton = {};

(function (exports) {
var __importDefault=function(e){return e&&e.__esModule?e:{default:e}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.PlayPauseButton=void 0,__importDefault(React__default)),types_1=types$2,utils_1=utils$1;exports.PlayPauseButton=function(e){var t=e.isPlaying,a=e.onClick,e=e.renderPlayPauseButton;if("function"==typeof e)return react_1.default.createElement("div",{className:types_1.Classnames.PLAY_BTN,onClick:a},e({isPlaying:t}));e=t?types_1.Modifiers.PAUSE:"",t=utils_1.concatClassnames(types_1.Classnames.PLAY_BTN_ITEM,e);return react_1.default.createElement("div",{className:types_1.Classnames.PLAY_BTN},react_1.default.createElement("div",{className:types_1.Classnames.PLAY_BTN_WRAPPER},react_1.default.createElement("div",{onClick:a,className:t})))};
}(PlayPauseButton));

var PrevNextButton = {};

(function (exports) {
var __importDefault=function(e){return e&&e.__esModule?e:{default:e}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),exports.PrevNextButton=void 0,__importDefault(React__default)),types_1=types$2,utils_1=utils$1;exports.PrevNextButton=function(e){var t=e.name,s=e.isDisabled,a=e.onClick,r=e.renderPrevButton,e=e.renderNextButton;if("function"==typeof r)return react_1.default.createElement("div",{className:types_1.Classnames.BUTTON_PREV,onClick:a},r({isDisabled:s}));if("function"==typeof e)return react_1.default.createElement("div",{className:types_1.Classnames.BUTTON_NEXT,onClick:a},e({isDisabled:s}));var r="prev"===t,e=r?"<":">",t=r?types_1.Classnames.BUTTON_PREV:types_1.Classnames.BUTTON_NEXT,l=r?types_1.Classnames.BUTTON_PREV_WRAPPER:types_1.Classnames.BUTTON_NEXT_WRAPPER,r=r?types_1.Classnames.BUTTON_PREV_ITEM:types_1.Classnames.BUTTON_NEXT_ITEM,s=s?types_1.Modifiers.INACTIVE:"",r=utils_1.concatClassnames(r,s);return react_1.default.createElement("div",{className:t},react_1.default.createElement("div",{className:l},react_1.default.createElement("p",{className:r,onClick:a},react_1.default.createElement("span",{"data-area":e}))))};
}(PrevNextButton));

(function (exports) {
Object.defineProperty(exports,"__esModule",{value:!0}),exports.PrevNextButton=exports.PlayPauseButton=exports.DotsNavigation=exports.StageItem=exports.SlideInfo=void 0;var SlideInfo_1=SlideInfo,StageItem_1=(Object.defineProperty(exports,"SlideInfo",{enumerable:!0,get:function(){return SlideInfo_1.SlideInfo}}),StageItem),DotsNavigation_1=(Object.defineProperty(exports,"StageItem",{enumerable:!0,get:function(){return StageItem_1.StageItem}}),DotsNavigation),PlayPauseButton_1=(Object.defineProperty(exports,"DotsNavigation",{enumerable:!0,get:function(){return DotsNavigation_1.DotsNavigation}}),PlayPauseButton),PrevNextButton_1=(Object.defineProperty(exports,"PlayPauseButton",{enumerable:!0,get:function(){return PlayPauseButton_1.PlayPauseButton}}),PrevNextButton);Object.defineProperty(exports,"PrevNextButton",{enumerable:!0,get:function(){return PrevNextButton_1.PrevNextButton}});
}(views));

(function (exports) {
var __extends=function(){var n=function(t,e){return (n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e;}||function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=e[i]);})(t,e)};return function(t,e){function i(){this.constructor=t;}n(t,e),t.prototype=null===e?Object.create(e):(i.prototype=e.prototype,new i);}}(),__assign=function(){return (__assign=Object.assign||function(t){for(var e,i=1,n=arguments.length;i<n;i++)for(var o in e=arguments[i])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)},__createBinding=Object.create?function(t,e,i,n){void 0===n&&(n=i),Object.defineProperty(t,n,{enumerable:!0,get:function(){return e[i]}});}:function(t,e,i,n){t[n=void 0===n?i:n]=e[i];},__setModuleDefault=Object.create?function(t,e){Object.defineProperty(t,"default",{enumerable:!0,value:e});}:function(t,e){t.default=e;},__importStar=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var i in t)"default"!==i&&Object.hasOwnProperty.call(t,i)&&__createBinding(e,t,i);return __setModuleDefault(e,t),e},__exportStar=function(t,e){for(var i in t)"default"===i||e.hasOwnProperty(i)||__createBinding(e,t,i);},__awaiter=function(t,a,r,l){return new(r=r||Promise)(function(i,e){function n(t){try{s(l.next(t));}catch(t){e(t);}}function o(t){try{s(l.throw(t));}catch(t){e(t);}}function s(t){var e;t.done?i(t.value):((e=t.value)instanceof r?e:new r(function(t){t(e);})).then(n,o);}s((l=l.apply(t,a||[])).next());})},__generator=function(n,o){var s,a,r,l={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]},t={next:e(0),throw:e(1),return:e(2)};return "function"==typeof Symbol&&(t[Symbol.iterator]=function(){return this}),t;function e(i){return function(t){var e=[i,t];if(s)throw new TypeError("Generator is already executing.");for(;l;)try{if(s=1,a&&(r=2&e[0]?a.return:e[0]?a.throw||((r=a.return)&&r.call(a),0):a.next)&&!(r=r.call(a,e[1])).done)return r;switch(a=0,(e=r?[2&e[0],r.value]:e)[0]){case 0:case 1:r=e;break;case 4:return l.label++,{value:e[1],done:!1};case 5:l.label++,a=e[1],e=[0];continue;case 7:e=l.ops.pop(),l.trys.pop();continue;default:if(!(r=0<(r=l.trys).length&&r[r.length-1])&&(6===e[0]||2===e[0])){l=0;continue}if(3===e[0]&&(!r||e[1]>r[0]&&e[1]<r[3])){l.label=e[1];break}if(6===e[0]&&l.label<r[1]){l.label=r[1],r=e;break}if(r&&l.label<r[2]){l.label=r[2],l.ops.push(e);break}r[2]&&l.ops.pop(),l.trys.pop();continue}e=o.call(n,l);}catch(t){e=[6,t],a=0;}finally{s=r=0;}if(5&e[0])throw e[1];return {value:e[0]?e[1]:void 0,done:!0}}}},__importDefault=function(t){return t&&t.__esModule?t:{default:t}},react_1=(Object.defineProperty(exports,"__esModule",{value:!0}),__importDefault(React__default)),vanilla_swipe_1=__importDefault(lib),defaultProps_1=defaultProps$1,Views=__importStar(views),Utils=__importStar(utils$1),types_1=types$2,AliceCarousel=(__exportStar(types$2,exports),function(e){function t(t){var s=e.call(this,t)||this;return s.swipeListener=null,s._handleKeyboardEvents=function(t){switch(t.code){case"Space":return s.props.autoPlay&&s._handlePlayPauseToggle();case"ArrowLeft":return s.slidePrev(t);case"ArrowRight":return s.slideNext(t)}},s._handleBeforeSlideEnd=function(o){return __awaiter(s,void 0,void 0,function(){var e,i,n;return __generator(this,function(t){switch(t.label){case 0:return (i=this.state,n=i.activeIndex,e=i.itemsCount,i=i.fadeoutAnimationProcessing,Utils.shouldRecalculateSlideIndex(n,e))?(n=Utils.getUpdateSlidePositionIndex(n,e),[4,this._handleUpdateSlidePosition(n)]):[3,2];case 1:return t.sent(),[3,4];case 2:return i?[4,this.setState({fadeoutAnimationIndex:null,fadeoutAnimationPosition:null,fadeoutAnimationProcessing:!1})]:[3,4];case 3:t.sent(),t.label=4;case 4:return this._handleSlideChanged(o),[2]}})})},s._handleMouseEnter=function(){var t=s.props.autoPlayStrategy;Utils.shouldCancelAutoPlayOnHover(t)&&s.state.isAutoPlaying&&(s.isHovered=!0,s._handlePause());},s._handleMouseLeave=function(){s.state.isAutoPlaying&&(s.isHovered=!1,s._handlePlay());},s._handlePause=function(){s._clearAutoPlayTimeout();},s._handlePlayPauseToggle=function(){return __awaiter(s,void 0,void 0,function(){var e;return __generator(this,function(t){switch(t.label){case 0:return e=this.state.isAutoPlaying,this.hasUserAction=!0,[4,this.setState({isAutoPlaying:!e,isAutoPlayCanceledOnAction:!0})];case 1:return t.sent(),e?this._handlePause():this._handlePlay(),[2]}})})},s._setRootComponentRef=function(t){return s.rootElement=t},s._setStageComponentRef=function(t){return s.stageComponent=t},s._renderStageItem=function(t,e){var i=Utils.getRenderStageItemStyles(e,s.state),n=Utils.getRenderStageItemClasses(e,s.state);return react_1.default.createElement(Views.StageItem,{styles:i,className:n,key:"stage-item-"+e,item:t})},s._renderSlideInfo=function(){var t=s.props.renderSlideInfo,e=s.state,i=e.activeIndex,e=e.itemsCount;return react_1.default.createElement(Views.SlideInfo,{itemsCount:e,activeIndex:i,renderSlideInfo:t})},s.state=Utils.calculateInitialState(t,null),s.isHovered=!1,s.isAnimationDisabled=!1,s.isTouchMoveProcessStarted=!1,s.cancelTouchAnimations=!1,s.hasUserAction=!1,s.rootElement=null,s.rootComponentDimensions={},s.stageComponent=null,s.startTouchmovePosition=void 0,s.slideTo=s.slideTo.bind(s),s.slidePrev=s.slidePrev.bind(s),s.slideNext=s.slideNext.bind(s),s._handleTouchmove=s._handleTouchmove.bind(s),s._handleTouchend=s._handleTouchend.bind(s),s._handleDotClick=s._handleDotClick.bind(s),s._handleResize=s._handleResize.bind(s),s._handleResizeDebounced=Utils.debounce(s._handleResize,100),s}return __extends(t,e),t.prototype.componentDidMount=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){switch(t.label){case 0:return [4,this._setInitialState()];case 1:return t.sent(),this._addEventListeners(),this._setupSwipeHandlers(),this.props.autoPlay&&this._handlePlay(),[2]}})})},t.prototype.componentDidUpdate=function(t,e){var i=this.props,n=i.activeIndex,o=i.animationDuration,s=i.autoWidth,a=i.children,r=i.infinite,l=i.items,u=i.paddingLeft,d=i.paddingRight,h=i.responsive,c=i.swipeExtraPadding,p=i.mouseTracking,_=i.swipeDelta,m=i.touchTracking,i=i.touchMoveDefaultEvents;a&&t.children!==a?(a=e.activeIndex,e=__assign(__assign({},this.props),{activeIndex:a}),this._updateComponent(e)):t.autoWidth!==s||t.infinite!==r||t.items!==l||t.paddingLeft!==u||t.paddingRight!==d||t.responsive!==h||t.swipeExtraPadding!==c?this._updateComponent():(t.animationDuration!==o&&this.setState({animationDuration:o}),t.activeIndex!==n&&this.slideTo(n,types_1.EventType.UPDATE)),t.swipeDelta===_&&t.mouseTracking===p&&t.touchTracking===m&&t.touchMoveDefaultEvents===i||this._updateSwipeProps(),this.props.keyboardNavigation!==t.keyboardNavigation&&this._updateEventListeners();},t.prototype.componentWillUnmount=function(){this._cancelTimeoutAnimations(),this._removeEventListeners();},Object.defineProperty(t.prototype,"eventObject",{get:function(){var t=this.state,e=t.itemsInSlide,t=t.activeIndex,i=Utils.getSlideItemInfo(this.state),n=i.isNextSlideDisabled,i=i.isPrevSlideDisabled;return {item:t,slide:Utils.getActiveSlideIndex(n,this.state),itemsInSlide:e,isNextSlideDisabled:n,isPrevSlideDisabled:i,type:types_1.EventType.ACTION}},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isFadeoutAnimationAllowed",{get:function(){var t=this.state.itemsInSlide,e=this.props,i=e.animationType,n=e.paddingLeft,o=e.paddingRight,e=e.autoWidth;return 1===t&&i===types_1.AnimationType.FADEOUT&&!(n||o||e)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"touchmovePosition",{get:function(){return void 0!==this.startTouchmovePosition?this.startTouchmovePosition:this.state.translate3d},enumerable:!1,configurable:!0}),t.prototype.slideTo=function(t,e){var i,n,o;void 0===t&&(t=0),this._handlePause(),this.isFadeoutAnimationAllowed?(i=Utils.getUpdateSlidePositionIndex(t,this.state.itemsCount),n=Utils.getFadeoutAnimationPosition(i,this.state),o=Utils.getFadeoutAnimationIndex(this.state),this._handleSlideTo({activeIndex:i,fadeoutAnimationIndex:o,fadeoutAnimationPosition:n,eventType:e})):this._handleSlideTo({activeIndex:t,eventType:e});},t.prototype.slidePrev=function(t){this._handlePause(),t&&t.isTrusted&&(this.hasUserAction=!0);var e,i,t=this.state.activeIndex-1;this.isFadeoutAnimationAllowed?(e=-this.state.stageWidth,i=Utils.getFadeoutAnimationIndex(this.state),this._handleSlideTo({activeIndex:t,fadeoutAnimationIndex:i,fadeoutAnimationPosition:e})):this._handleSlideTo({activeIndex:t});},t.prototype.slideNext=function(t){this._handlePause(),t&&t.isTrusted&&(this.hasUserAction=!0);var e,i,t=this.state.activeIndex+1;this.isFadeoutAnimationAllowed?(e=this.state.stageWidth,i=Utils.getFadeoutAnimationIndex(this.state),this._handleSlideTo({activeIndex:t,fadeoutAnimationIndex:i,fadeoutAnimationPosition:e})):this._handleSlideTo({activeIndex:t});},t.prototype._addEventListeners=function(){window.addEventListener("resize",this._handleResizeDebounced),this.props.keyboardNavigation&&window.addEventListener("keyup",this._handleKeyboardEvents);},t.prototype._removeEventListeners=function(){this.swipeListener&&this.swipeListener.destroy(),window.removeEventListener("resize",this._handleResizeDebounced),window.removeEventListener("keyup",this._handleKeyboardEvents);},t.prototype._updateEventListeners=function(){this.props.keyboardNavigation?window.addEventListener("keyup",this._handleKeyboardEvents):window.removeEventListener("keyup",this._handleKeyboardEvents);},t.prototype._handleResize=function(o){return __awaiter(this,void 0,void 0,function(){var e,i,n;return __generator(this,function(t){switch(t.label){case 0:return (i=this.props.onResizeEvent,n=Utils.getElementDimensions(this.rootElement),(i||Utils.shouldHandleResizeEvent)(o,this.rootComponentDimensions,n))?(this._cancelTimeoutAnimations(),this.rootComponentDimensions=n,i=this.state,n=i.itemsCount,e=i.isAutoPlaying,i=Utils.getUpdateSlidePositionIndex(this.state.activeIndex,n),n=Utils.calculateInitialState(__assign(__assign({},this.props),{activeIndex:i}),this.stageComponent),i=Utils.getTranslate3dProperty(n.activeIndex,n),n=__assign(__assign({},n),{translate3d:i,isAutoPlaying:e}),Utils.animate(this.stageComponent,{position:-i}),[4,this.setState(n)]):[3,2];case 1:t.sent(),this._handleResized(),this.isAnimationDisabled=!1,e&&this._handlePlay(),t.label=2;case 2:return [2]}})})},t.prototype._handleTouchmove=function(t,e){var i=e.absY,n=e.absX,o=e.deltaX,e=this.props.swipeDelta,s=this.state,a=s.swipeShiftValue,r=s.swipeLimitMin,l=s.swipeLimitMax,u=s.infinite,s=s.fadeoutAnimationProcessing;if(this.hasUserAction=!0,!(s||!this.isTouchMoveProcessStarted&&Utils.isVerticalTouchmoveDetected(n,i,e))){this.isTouchMoveProcessStarted||(this._cancelTimeoutAnimations(),this._setTouchmovePosition(),this.isAnimationDisabled=!0,this.isTouchMoveProcessStarted=!0,this._handleSlideChange());var d=Utils.getTouchmoveTranslatePosition(o,this.touchmovePosition);if(!1===u)return r<d||d<-l?void 0:void Utils.animate(this.stageComponent,{position:d});if(Utils.shouldRecalculateSwipePosition(d,r,l))try{!function t(){Utils.getIsLeftDirection(o)?d+=a:d+=-a;Utils.shouldRecalculateSwipePosition(d,r,l)&&t();}();}catch(t){Utils.debug(t);}Utils.animate(this.stageComponent,{position:d});}},t.prototype._handleTouchend=function(t,e){var i,n,o,e=e.deltaX;this._clearTouchmovePosition(),this.isTouchMoveProcessStarted&&(this.isTouchMoveProcessStarted=!1,i=this.state.animationDuration,n=this.props.animationEasingFunction,o=Utils.getTranslateXProperty(this.stageComponent),e=Utils.getSwipeTouchendPosition(this.state,e,o),Utils.animate(this.stageComponent,{position:e,animationDuration:i,animationEasingFunction:n}),this._handleBeforeTouchEnd(e));},t.prototype._handleBeforeTouchEnd=function(o){var t=this,e=this.state.animationDuration;this.touchEndTimeoutId=window.setTimeout(function(){return __awaiter(t,void 0,void 0,function(){var e,i,n;return __generator(this,function(t){switch(t.label){case 0:return e=Utils.getSwipeTouchendIndex(o,this.state),i=Utils.getTranslate3dProperty(e,this.state),Utils.animate(this.stageComponent,{position:-i}),n=Utils.getTransitionProperty(),[4,this.setState({activeIndex:e,translate3d:i,transition:n})];case 1:return t.sent(),[4,this._handleSlideChanged()];case 2:return t.sent(),[2]}})})},e);},t.prototype._handleSlideTo=function(t){var e=t.activeIndex,a=void 0===e?0:e,e=t.fadeoutAnimationIndex,r=void 0===e?null:e,e=t.fadeoutAnimationPosition,l=void 0===e?null:e,u=t.eventType;return __awaiter(this,void 0,void 0,function(){var e,i,n,o,s=this;return __generator(this,function(t){switch(t.label){case 0:return (i=this.props,n=i.infinite,i=i.animationEasingFunction,e=this.state,o=e.itemsCount,e=e.animationDuration,this.isAnimationDisabled||this.state.activeIndex===a||!n&&Utils.shouldCancelSlideAnimation(a,o))?[2]:(this.isAnimationDisabled=!0,this._cancelTimeoutAnimations(),this._handleSlideChange(u),n=!1,o=Utils.getTranslate3dProperty(a,this.state),i=null!==r&&null!==l?(n=!0,Utils.getTransitionProperty()):Utils.getTransitionProperty({animationDuration:e,animationEasingFunction:i}),[4,this.setState({activeIndex:a,transition:i,translate3d:o,animationDuration:e,fadeoutAnimationIndex:r,fadeoutAnimationPosition:l,fadeoutAnimationProcessing:n})]);case 1:return t.sent(),this.slideEndTimeoutId=window.setTimeout(function(){return s._handleBeforeSlideEnd(u)},e),[2]}})})},t.prototype._handleUpdateSlidePosition=function(o){return __awaiter(this,void 0,void 0,function(){var e,i,n;return __generator(this,function(t){switch(t.label){case 0:return e=this.state.animationDuration,i=Utils.getTranslate3dProperty(o,this.state),n=Utils.getTransitionProperty({animationDuration:0}),[4,this.setState({activeIndex:o,translate3d:i,transition:n,animationDuration:e,fadeoutAnimationIndex:null,fadeoutAnimationPosition:null,fadeoutAnimationProcessing:!1})];case 1:return t.sent(),[2]}})})},t.prototype._handleResized=function(){this.props.onResized&&this.props.onResized(__assign(__assign({},this.eventObject),{type:types_1.EventType.RESIZE}));},t.prototype._handleSlideChange=function(t){this.props.onSlideChange&&(t=t?__assign(__assign({},this.eventObject),{type:t}):this.eventObject,this.props.onSlideChange(t));},t.prototype._handleSlideChanged=function(s){return __awaiter(this,void 0,void 0,function(){var e,i,n,o;return __generator(this,function(t){switch(t.label){case 0:return (i=this.state,e=i.isAutoPlaying,i=i.isAutoPlayCanceledOnAction,n=this.props,o=n.autoPlayStrategy,n=n.onSlideChanged,Utils.shouldCancelAutoPlayOnAction(o)&&this.hasUserAction&&!i)?[4,this.setState({isAutoPlayCanceledOnAction:!0,isAutoPlaying:!1})]:[3,2];case 1:return t.sent(),[3,3];case 2:e&&this._handlePlay(),t.label=3;case 3:return this.isAnimationDisabled=!1,n&&(o=s?__assign(__assign({},this.eventObject),{type:s}):this.eventObject,n(o)),[2]}})})},t.prototype._handleDotClick=function(t){this.hasUserAction=!0,this.slideTo(t);},t.prototype._handlePlay=function(){this._setAutoPlayInterval();},t.prototype._cancelTimeoutAnimations=function(){this._clearAutoPlayTimeout(),this._clearSlideEndTimeout(),this.clearTouchendTimeout();},t.prototype._clearAutoPlayTimeout=function(){window.clearTimeout(this.autoPlayTimeoutId),this.autoPlayTimeoutId=void 0;},t.prototype._clearSlideEndTimeout=function(){clearTimeout(this.slideEndTimeoutId),this.slideEndTimeoutId=void 0;},t.prototype.clearTouchendTimeout=function(){clearTimeout(this.touchEndTimeoutId),this.touchEndTimeoutId=void 0;},t.prototype._clearTouchmovePosition=function(){this.startTouchmovePosition=void 0;},t.prototype._setTouchmovePosition=function(){var t=Utils.getTranslateXProperty(this.stageComponent);this.startTouchmovePosition=-t;},t.prototype._setInitialState=function(){return __awaiter(this,void 0,void 0,function(){var e;return __generator(this,function(t){switch(t.label){case 0:return e=Utils.calculateInitialState(this.props,this.stageComponent),this.rootComponentDimensions=Utils.getElementDimensions(this.rootElement),[4,this.setState(e)];case 1:return t.sent(),this.props.onInitialized&&this.props.onInitialized(__assign(__assign({},this.eventObject),{type:types_1.EventType.INIT})),[2]}})})},t.prototype._setAutoPlayInterval=function(){var t=this,e=this.props,i=e.autoPlayDirection,e=e.autoPlayInterval;this.autoPlayTimeoutId=window.setTimeout(function(){t.isHovered||(i===types_1.AutoplayDirection.RTL?t.slidePrev({}):t.slideNext({}));},e);},t.prototype._setupSwipeHandlers=function(){this.swipeListener=new vanilla_swipe_1.default({element:this.rootElement,delta:this.props.swipeDelta,onSwiping:this._handleTouchmove,onSwiped:this._handleTouchend,rotationAngle:5,mouseTrackingEnabled:this.props.mouseTracking,touchTrackingEnabled:this.props.touchTracking,preventDefaultTouchmoveEvent:!this.props.touchMoveDefaultEvents,preventTrackingOnMouseleave:!0}),this.swipeListener.init();},t.prototype._updateComponent=function(t){var e=this;void 0===t&&(t=this.props),this._cancelTimeoutAnimations(),this.isAnimationDisabled=!1,this.state.isAutoPlaying&&this._handlePlay(),this.setState({clones:Utils.createClones(t)}),requestAnimationFrame(function(){e.setState(Utils.calculateInitialState(t,e.stageComponent));});},t.prototype._updateSwipeProps=function(){this.swipeListener&&this.swipeListener.update({delta:this.props.swipeDelta,mouseTrackingEnabled:this.props.mouseTracking,touchTrackingEnabled:this.props.touchTracking,preventDefaultTouchmoveEvent:!this.props.touchMoveDefaultEvents});},t.prototype._renderDotsNavigation=function(){var t=this.props,e=t.renderDotsItem,t=t.controlsStrategy;return react_1.default.createElement(Views.DotsNavigation,{state:this.state,onClick:this._handleDotClick,renderDotsItem:e,controlsStrategy:t})},t.prototype._renderPrevButton=function(){var t=this.props.renderPrevButton,e=Utils.getSlideItemInfo(this.state).isPrevSlideDisabled;return react_1.default.createElement(Views.PrevNextButton,{name:"prev",onClick:this.slidePrev,isDisabled:e,renderPrevButton:t})},t.prototype._renderNextButton=function(){var t=this.props.renderNextButton,e=Utils.getSlideItemInfo(this.state).isNextSlideDisabled;return react_1.default.createElement(Views.PrevNextButton,{name:"next",onClick:this.slideNext,isDisabled:e,renderNextButton:t})},t.prototype._renderPlayPauseButton=function(){var t=this.props.renderPlayPauseButton,e=this.state.isAutoPlaying;return react_1.default.createElement(Views.PlayPauseButton,{isPlaying:e,onClick:this._handlePlayPauseToggle,renderPlayPauseButton:t})},t.prototype.render=function(){var t=this.state,e=t.translate3d,i=t.clones,n=t.transition,t=t.canUseDom,o=Utils.shouldDisableDots(this.props,this.state),s=Utils.shouldDisableButtons(this.props,this.state),a=Utils.getRenderWrapperStyles(this.props,this.state,this.stageComponent),e=Utils.getRenderStageStyles({translate3d:e},{transition:n}),n=this.props.ssrSilentMode||t?"":types_1.Modifiers.SSR,t=Utils.concatClassnames(types_1.Classnames.ROOT,n);return react_1.default.createElement("div",{className:t},react_1.default.createElement("div",{ref:this._setRootComponentRef},react_1.default.createElement("div",{style:a,className:types_1.Classnames.WRAPPER,onMouseEnter:this._handleMouseEnter,onMouseLeave:this._handleMouseLeave},react_1.default.createElement("ul",{style:e,className:types_1.Classnames.STAGE,ref:this._setStageComponentRef},i.map(this._renderStageItem)))),o?null:this._renderDotsNavigation(),s?null:this._renderPrevButton(),s?null:this._renderNextButton(),this.props.disableSlideInfo?null:this._renderSlideInfo(),this.props.autoPlayControls?this._renderPlayPauseButton():null)},t.defaultProps=defaultProps_1.defaultProps,t}(react_1.default.PureComponent));exports.default=AliceCarousel;
}(reactAliceCarousel));

var AliceCarousel = /*@__PURE__*/getDefaultExportFromCjs(reactAliceCarousel);

var ArrowShortLeft32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2014%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2018%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2222%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%202%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowShortRight32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2018%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2014%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%222%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%2018%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowShortLeft48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2230%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2234%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2030%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2034%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowShortRight48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2218%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%2034%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2030%2026%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowShort = function (_a) {
    var variant = _a.variant, orientation = _a.orientation;
    var icon = '';
    switch (orientation) {
        case HorizontalOrientation.LEFT:
            icon = variant === IconSize.L ? ArrowShortLeft32 : ArrowShortLeft48;
            break;
        case HorizontalOrientation.RIGHT:
            icon = variant === IconSize.L ? ArrowShortRight32 : ArrowShortRight48;
            break;
    }
    return React__default.createElement("img", { src: icon, alt: "ArrowShort Icon" });
};

var ArrowLongLeft32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2222%22%20width%3D%228%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2014%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2010%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2014%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%228%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2018%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2230%22%20width%3D%228%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2022%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2218%22%20width%3D%2228%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2030%2018%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowLongRight32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2218%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2018%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%222%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowLongLeft48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2022%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2230%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2234%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2030%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%2228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2038%2022%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowLongRight48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2226%22%20y%3D%2218%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2030%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2034%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2214%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2034%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ArrowLong = function (_a) {
    var variant = _a.variant, orientation = _a.orientation;
    var icon = '';
    switch (orientation) {
        case HorizontalOrientation.LEFT:
            icon = variant === IconSize.L ? ArrowLongLeft32 : ArrowLongLeft48;
            break;
        case HorizontalOrientation.RIGHT:
            icon = variant === IconSize.L ? ArrowLongRight32 : ArrowLongRight48;
            break;
    }
    return React__default.createElement("img", { src: icon, alt: "ArrowLong Icon" });
};

var BUMPIcon = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Crect%20width%3D%2232%22%20height%3D%2232%22%20fill%3D%22url%28%23pattern0%29%22%2F%3E%3Cdefs%3E%3Cpattern%20id%3D%22pattern0%22%20patternContentUnits%3D%22objectBoundingBox%22%20width%3D%221%22%20height%3D%221%22%3E%3Cuse%20xlink%3Ahref%3D%22%23image0_9789_250081%22%20transform%3D%22scale%280.00684932%29%22%2F%3E%3C%2Fpattern%3E%3Cimage%20id%3D%22image0_9789_250081%22%20width%3D%22146%22%20height%3D%22146%22%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAJIAAACSCAYAAACue5OOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw%2FeHBhY2tldCBiZWdpbj0i77u%2FIiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8%2BIDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0ZGNTE3NzVFQTExRUI4RUQ3RkFFNEM3QzRCMjNEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0ZGNTE4NzVFQTExRUI4RUQ3RkFFNEM3QzRCMjNEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDRkY1MTU3NUVBMTFFQjhFRDdGQUU0QzdDNEIyM0QiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDRkY1MTY3NUVBMTFFQjhFRDdGQUU0QzdDNEIyM0QiLz4gPC9yZGY6RGVzY3JpcHRpb24%2BIDwvcmRmOlJERj4gPC94OnhtcG1ldGE%2BIDw%2FeHBhY2tldCBlbmQ9InIiPz66AC3jAAAE%2FUlEQVR42uyd3U3bUBiGXTf3pBM0170JG%2BANyAZNNzADVBixgJmAsEGYAGeCmhuuwwSFAfpz3BoJooQ48XH8fvbzSFFUFQkTP3nf7%2FjkZxAY5%2Ff3L1N3dx3AC4vyPnO3pbvl4eVD3vQvHXTggTvGnTecrNwXT7Zndzcv5Zo7sZ58%2F9IQkXrBkbt9LZP7pxNr5m6Rz1%2FwoQPV9gdPatVg4hIq67VI5bPqDh%2B8CBXXmaWsVxu15m%2Bu%2BuGemAkigQ%2FOnUy5u436JlLEuffOuLhksOswblYk94cO3d1nzntjq7y78hpd5xOJNGqe66oyWRaJ%2BUhIJhIJqpA6mY5JJPAxM2XlXNodkcpnxxHn9%2BAyzbuWSKRRO5xsumiJSLAr5%2BsuWFoViUG7XWZdEWnMuWy94iLTIvl%2BHQ3sTWI9kZiPBFPJokgkkg4xiQQ%2BOH1ZwZkSqTxodvy1mFhMJNIIkRCpq0O3RZEYtDVHjii0aD%2FoPcFDQ9ZTa8Ijh6VEQiRdhpZEYj4SHjlIJPCCJZHY8Uek%2BstLThUiMR8hEvMRkEiASG%2Fmo1HAW48QiVpDJGoNqrIgkaA3icSOvz6ZtEjs%2BJthqZ5IzEc2yNVFIpEszEeXDzmJBLVXbNLDNh82aoa5%2BqqNWjOyYlMXiVrT5%2FHlaycQCWrXGtUGdZlJi8SOv61aU04kak2f9PU%2FVEWi1rR5DlY%2BRxKRYK%2FZaPV7cVVFYsffUK1JisRbj%2BS5cWm0lBeJWpOfjeJ1%2F6EoEokkXGmrsxGJBLvyuG42khSJHX9pppvSSDGRqDVNrpxE2Xs%2FoCYStaZZacm2HyKRYBuT9yqNRIIqnL3emDUhEl8vKkdx4TGt%2BsNKiUQa6XAfbLjwuImB0MEv3e2CcyhBWmUuAvBOyEMAiASIBIgEgEiASIBIgEgAiASIBIgE%2FWPvTdtfp%2F9264c8hK3z9PE2yM2KFPz%2FbBxeqC%2BAe1J%2FcjK1ulsf7nngvNtDi6nVGSni3CGSD5F4NaMWY9cSIxIJfDAhkcAHkSmRymU%2F7%2FZApNqJRBppctTmnIRI3cKUSAzauhxbEmnM%2BZJlaEIk18GkESJ5SSTmI6rNi0gkEpBIICASO%2F7gK5GoNfAiErWmT25BJBJJnycLIpFIUE8kdvzNkKknEmlEtSFSX2jzbUlVRWLQ1mdhYfnPjj9L%2F3oisePPoO0rkZiPEMmLSCSSPvcW3rJNIukza%2FsAwi3zETv%2BNphLi0Stmam1pbpI1Jo%2BqcJBkEi2eVaoNRKpA7NR26u1rSKVb%2F9lx1%2BbROVAQmrNLDcKQ3YVkag10giRSCMdkU44X7IrtVjtoMINgzbzkXClqazUqiQStaZJcRU7VTwwRLLFVPXAQpb%2BZjhT%2BKqIyiKx4y%2FJQrXS3kskak2Lx6Dlz9DeVyRqTWupP1FcpSGSLWLluYhqs8E3J9HMysGGK4P2KGDHX4ELSxKtSyRqrX2KfbTE2kGH1JoUV06iqcUDHyASM1ETicSOPxLVSyR2%2FFuhuE4UWVniV00kau2w3BePeRckQqQWV2ZlEi278gcNWPofvMpi6%2FPQRpHY8T8IxSeqTbuUQusSiVprNoUS9ZeB%2BBKJWmtuFoot7N4jkm6NxV1ZkVFt7QhU1FjWtz98wI6%2FtwpL%2B5RA6xKJWtuP4oJisYyf9WEGqiIStbZbdRWfRzTv6jIekZpJnEKWoq6yPs49u%2FBXgAEAyd8l4rFQOH8AAAAASUVORK5CYII%3D%22%2F%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var BumpIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20y%3D%228%22%20width%3D%2248%22%20height%3D%2232%22%20fill%3D%22%23023A42%22%2F%3E%3Crect%20x%3D%228%22%20y%3D%2244%22%20width%3D%2232%22%20height%3D%224%22%20fill%3D%22%23023A42%22%2F%3E%3Crect%20x%3D%2240%22%20y%3D%224%22%20width%3D%2232%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2040%204%29%22%20fill%3D%22%23023A42%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%2240%22%20width%3D%2240%22%20height%3D%224%22%20fill%3D%22%23023A42%22%2F%3E%3Crect%20x%3D%2244%22%20y%3D%228%22%20width%3D%2240%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2044%208%29%22%20fill%3D%22%23023A42%22%2F%3E%3Crect%20width%3D%2232%22%20height%3D%2232%22%20transform%3D%22translate%288%208%29%22%20fill%3D%22%23023A42%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M29.6786%2025.8939H30.9418V30.947H30.9417V32.2099H29.6805V33.4736H28.4159V34.7361H25.8905V35.9998H13.2578V34.736H24.6261V33.4723H27.154V32.2098H28.4152V30.9461H29.6786V25.8939ZM17.6774%2026.5259H17.0458V28.4208H17.6774V26.5259Z%22%20fill%3D%22%239E3100%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M34.7313%2015.7878H35.9946V22.1041H34.7313V15.7878ZM33.4698%2023.3665H34.7312V20.84H33.4679V22.1036H18.3105V23.3674H33.4698V23.3665Z%22%20fill%3D%22%23934818%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.6317%2024.634H14.5279V34.7402H24.6341V33.4769H27.1582V32.2137H28.4206V24.634H27.1582H27.1574H24.6341H24.6317ZM13.2634%2030.9499H12V34.7397H14.5265V30.9508H14.5267V25.8977H13.2634V30.9499ZM28.4207%2024.634H29.684V30.9504H28.4207V24.634Z%22%20fill%3D%22%23FF5000%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.5806%2012H29.6844H29.6868H32.211V13.2637H33.4742V14.5262H34.7375V20.8426H33.4742V22.1059H29.6868V22.1062H19.5806V12ZM19.5793%2020.8426H19.5794V14.5262H18.3161V20.8421H17.0527V22.1059H19.5793V20.8426Z%22%20fill%3D%22%23FF7D2B%22%2F%3E%3C%2Fsvg%3E";

var Bump = function (_a) {
    var variant = _a.variant, style = _a.style;
    return (React__default.createElement("img", { src: variant === IconSize.L ? BUMPIcon : BumpIcon48, alt: "Bump Icon", style: style }));
};

var CalendarIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%2226%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2218%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2210%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CalendarIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2234%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2210%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2226%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Calendar$7 = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? CalendarIcon32 : CalendarIcon48, alt: "Calendar Icon" }));
};

var CardViewIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%222%22%20width%3D%2228%22%20height%3D%2228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CardViewIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2210%22%20width%3D%2228%22%20height%3D%2228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CardView = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? CardViewIcon32 : CardViewIcon48, alt: "CardView Icon" }));
};

var CaretDown32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2210%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CaretUp32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2026%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2218%22%20width%3D%2212%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2022%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2018%2014%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CaretDown48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2216%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2220%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2224%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2228%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CaretUp48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2238%22%20y%3D%2232%22%20width%3D%2228%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2038%2032%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2228%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2034%2028%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2224%22%20width%3D%2212%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2030%2024%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2220%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2026%2020%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Check$1 = function (_a) {
    var variant = _a.variant, orientation = _a.orientation;
    var icon = '';
    switch (orientation) {
        case VerticalOrientation.UP:
            icon = variant === IconSize.L ? CaretUp32 : CaretUp48;
            break;
        case VerticalOrientation.DOWN:
            icon = variant === IconSize.L ? CaretDown32 : CaretDown48;
            break;
    }
    return React__default.createElement("img", { src: icon, alt: "Caret Icon" });
};

var CartIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%226%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%222%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CartIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2234%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2234%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2230%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Cart = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? CartIcon32 : CartIcon48, alt: "Cart Icon" }));
};

var CheckIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Check = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? CheckIcon32 : CheckIcon48, alt: "Check Icon" }));
};

var CloseIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%202%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2010%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2018%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2022%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2026%2030%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var CloseIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2234%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2014%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2010%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2018%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2026%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2030%2034%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2034%2038%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Close$4 = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? CloseIcon32 : CloseIcon48, alt: "Close Icon" }));
};

var EarnIcon$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAoCAYAAABjPNNTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAESSURBVHgB7ZgvDsIwFIffCAaYhITADVjAcQJQ8yiugEfSSTxXQOGn4AQ4yLgBhATkAMdIzbY0kP7hITre55q2y0t+X17bOaDJI9owB2AGhiQAQcUbMJ09JbAAKhILR7ZAdDDehRDvQzDF7frg9vx0rOIoxY2FnU7qOng43SE63j7Oe+0adFpV5f3PBILp+sryayhuLOxw8lsHZc6JfVH3+9xRihsLK4osyxa8c3DUb4Aq3L+8g9zR5niRzSvcBShuLKhILKhILIrRJ/m5nD+bed9cbS/p2OTsPi8noAPFjcV/vHFE50RM7o/0xvkVxfgXNB/WWcnJHJX1RRkqDopQ3FgUw0kR0VFdVBwUobixsKLIF3EskkcLk0vgAAAAAElFTkSuQmCC";

var YellowOrangeDiamond96 = "data:image/svg+xml,%3Csvg%20width%3D%2296%22%20height%3D%2296%22%20viewBox%3D%220%200%2096%2096%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2016%2016%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%208%2024%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2016%2088%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%208%2080%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2056%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2064%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2056%2096%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2064%2096%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2072%2088%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2080%2080%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2040%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2024%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%2224%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2024%2096%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2048%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%281%200%200%20-1%2048%2096%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%208%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2088%2056%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2088%2064%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%200%2056%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2016%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2088%2040%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%200%2040%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2088%2024%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%200%2024%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2040%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2040%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2040%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2032%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2032%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2024%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2016%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2040%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2040%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2040%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2032%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%208%2024%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2048%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2056%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2064%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2072%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2032%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2024%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%2016%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2024%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2016%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2056%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2064%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2072%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%208%2056%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2024%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2048%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2056%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2056%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2048%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2040%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2032%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2032%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2032%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2032%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2040%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2048%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2056%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2056%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2056%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2048%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2040%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2048%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2048%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2048%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2016%2048%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%208%2040%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%208%2032%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%208%2048%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2064%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2064%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2072%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2072%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2024%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2016%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2024%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2032%2016%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2016%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2064%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2064%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2040%2072%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2072%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2064%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2072%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%2080%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%2216%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2056%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2064%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2056%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2072%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%2024%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2016%29%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%2024%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2048%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2056%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2064%208%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2032%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2080%2024%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2032%29%22%20fill%3D%22%23EE9146%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2024%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2072%2016%29%22%20fill%3D%22%23FFB880%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%2088%2048%29%22%20fill%3D%22black%22%2F%3E%3Crect%20width%3D%228%22%20height%3D%228%22%20transform%3D%22matrix%28-4.37114e-08%201%201%204.37114e-08%200%2048%29%22%20fill%3D%22black%22%2F%3E%3C%2Fsvg%3E";

var YellowOrangeDiamond = function () {
    var isMobile = useMatchBreakpoints().isMobile;
    return isMobile ? (React__default.createElement("img", { src: EarnIcon$1, alt: "EarnIcon", width: "32px", height: "32px" })) : (React__default.createElement("img", { src: YellowOrangeDiamond96, alt: "YellowOrangeDiamond Icon" }));
};

var DiscordIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2225%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2225%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2221%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%229%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%225%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%223%22%20width%3D%226%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%2210.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2224.999%22%20width%3D%222%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%2224.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2224.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2220%22%20y%3D%2224.999%22%20width%3D%222%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%228%22%20y%3D%223%22%20width%3D%226%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%225%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DiscordIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2233%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2221%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2221%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2221%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2233%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2221%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2229%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2217%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2221%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2211%22%20width%3D%226%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2218.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2218.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2232.999%22%20width%3D%222%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2232.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2232.999%22%20width%3D%222%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2228%22%20y%3D%2232.999%22%20width%3D%222%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2216%22%20y%3D%2211%22%20width%3D%226%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2213%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Discord = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? DiscordIcon32 : DiscordIcon48, alt: "Discord Icon" }));
};

var DocumentIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%224%22%20y%3D%2226%22%20width%3D%2224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%222%22%20width%3D%2216%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%226%22%20width%3D%224%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2224%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2220%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2220%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%228%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DocumentIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2212%22%20y%3D%2234%22%20width%3D%2224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2210%22%20width%3D%2216%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2232%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2228%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2228%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2222%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2216%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Document = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? DocumentIcon32 : DocumentIcon48, alt: "Document Icon" }));
};

var DotsMenuHorizontal32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%206%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%2022%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%2014%2018%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DotsMenuVertical32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DotsMenuHorizontal48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%2014%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%2030%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-90%2022%2026%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DotsMenuVertical48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DotsMenu = function (_a) {
    var variant = _a.variant, orientation = _a.orientation;
    var icon = '';
    switch (orientation) {
        case Orientation.VERTICAL:
            icon = variant === IconSize.L ? DotsMenuVertical32 : DotsMenuVertical48;
            break;
        case Orientation.HORIZONTAL:
            icon =
                variant === IconSize.L ? DotsMenuHorizontal32 : DotsMenuHorizontal48;
            break;
    }
    return React__default.createElement("img", { src: icon, alt: "DotsMenu Icon" });
};

var DownloadIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2022%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%284.37114e-08%20-1%20-1%20-4.37114e-08%2010%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2026%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%284.37114e-08%20-1%20-1%20-4.37114e-08%2014%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%222%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%2018%202%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2226%22%20width%3D%2228%22%20height%3D%224.00001%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var DownloadIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2230%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2030%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%284.37114e-08%20-1%20-1%20-4.37114e-08%2018%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2034%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%284.37114e-08%20-1%20-1%20-4.37114e-08%2022%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%2026%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2234%22%20width%3D%2228%22%20height%3D%224.00001%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Download = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? DownloadIcon32 : DownloadIcon48, alt: "Download Icon" }));
};

var EarnIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB4CAYAAADWpl3sAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIWSURBVHgB7d2xSsNQGEfxryII2lFB9A0suvkEOnV38hVcnRtnV1/Byb2TPoGbUt9AEXSsglNtHJ1yAzfc9JzfHGjo4S5/QjKIAv3MHiaLiCp6arC8943RyVUUYi208owMYGQAIwMYGcDIAEYGMDKAkQGMDGBkgEF0IHWLnj9NY/48jb4aHo5jeDRufH3urduTDGBkACMDGBnAyABGBjAygJEBjAxgZAAjA7TarkvbomdvX/Hy+h25HOxvxmhvK3JJvv9FVJf3n423bk8ygJEBjAxgZAAjAxgZwMgARgYwMoCRAYwM8Ldd932Lzr0tpz5HXdr/40kGMDKAkQGMDGBkACMDGBnAyABGBjAygJEB1qMDbbbos+OdKEW9Q6ds0fXWvXt+0/j63Fu3JxnAyABGBjAygJEBjAxgZAAjAxgZwMgARgYwMoCRAYwMYGQAIwMYGcDIAEYGMDKAkQGMDGBkgE6eu67f55HyTo/6Oe27x4/G15f4zpD324sohScZwMgARgYwMoCRAYwMYGQAIwMYGcDIAEYGWIlvNaZuy6mK+9ak32rUf0YGMDKAkQGMDGBkACMDGBnAyABGBjAyQKvtOtX16fZk+UtV0+tzP0edW+4tOpUnGcDIAEYGMDKAkQGMDGBkACMDGBnAyABGBuhku06VunUXJ/MWncqTDGBkACMDGBnAyABGBjAygJEBjAxgZAAjA/wCpmKPaZ0vqp4AAAAASUVORK5CYII=";

var EarnLogo = function () { return (React__default.createElement("img", { src: EarnIcon, alt: "EarnLogo Icon", width: "40px", height: "40px" })); };

var HairbrushIcon = "data:image/svg+xml,%3Csvg%20width%3D%22400%22%20height%3D%2216%22%20viewBox%3D%220%200%20400%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%224%22%20y%3D%2212.0005%22%20width%3D%224%22%20height%3D%228%22%20transform%3D%22rotate%28180%204%2012.0005%29%22%20fill%3D%22%23000E10%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2012%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2224%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2024%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2224%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2236%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2036%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2236%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2248%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2048%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2248%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2260%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2060%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2260%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2272%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2072%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2272%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2284%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2084%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2284%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%2296%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%2096%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%2296%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22108%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20108%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22108%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22120%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20120%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22120%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22132%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20132%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22132%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22144%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20144%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22144%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22156%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20156%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22156%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22168%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20168%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22168%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22180%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20180%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22180%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22192%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20192%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22192%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22204%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20204%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22204%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22216%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20216%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22216%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22228%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20228%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22228%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22240%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20240%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22240%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20252%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22264%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20264%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22264%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22276%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20276%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22276%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22288%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20288%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22288%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22300%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20300%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22300%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22312%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20312%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22312%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22324%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20324%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22324%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22336%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20336%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22336%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22348%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20348%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22348%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22360%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20360%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22360%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22372%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20372%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22372%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22384%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20384%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22384%22%20y%3D%220.000453949%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22%23195A62%22%2F%3E%3Crect%20x%3D%22396%22%20y%3D%2212.0005%22%20width%3D%228%22%20height%3D%228%22%20transform%3D%22rotate%28180%20396%2012.0005%29%22%20fill%3D%22%23002428%22%2F%3E%3Crect%20x%3D%22400%22%20y%3D%2212.0005%22%20width%3D%224%22%20height%3D%228%22%20transform%3D%22rotate%28180%20400%2012.0005%29%22%20fill%3D%22%23000E10%22%2F%3E%3Crect%20x%3D%22400%22%20y%3D%2216.0005%22%20width%3D%22400%22%20height%3D%224.00003%22%20transform%3D%22rotate%28180%20400%2016.0005%29%22%20fill%3D%22%23000E10%22%2F%3E%3C%2Fsvg%3E";

var Hairbrush = function () { return (React__default.createElement("img", { src: HairbrushIcon, alt: "Hairbrush Icon" })); };

var HamburgerMenuIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%226%22%20width%3D%2228%22%20height%3D%224.00001%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var HamburgerMenuIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2230%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var HamburgerMenu = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? HamburgerMenuIcon32 : HamburgerMenuIcon48, alt: "HamburgerMenu Icon" }));
};

var LinkExternal = "data:image/svg+xml,%3Csvg%20width%3D%2225%22%20height%3D%2224%22%20viewBox%3D%220%200%2025%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%224.5%22%20y%3D%224%22%20width%3D%222%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226.5%22%20y%3D%2218%22%20width%3D%2214%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226.5%22%20y%3D%224%22%20width%3D%224%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214.5%22%20y%3D%224%22%20width%3D%224%22%20height%3D%222%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218.5%22%20y%3D%2214%22%20width%3D%222%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218.5%22%20y%3D%224%22%20width%3D%222%22%20height%3D%226%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M18.5%206L11.5%2013%22%20stroke%3D%22white%22%20stroke-width%3D%222%22%2F%3E%3C%2Fsvg%3E";

var LinkOutIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2234%22%20width%3D%2220%22%20height%3D%224.00001%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var LinkOut = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? LinkExternal : LinkOutIcon48, alt: "LinkOut Icon" }));
};

var ListViewIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%226%22%20width%3D%2220%22%20height%3D%224.00001%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ListViewIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2230%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2222%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ListView = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? ListViewIcon32 : ListViewIcon48, alt: "ListView Icon" }));
};

var LockIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%2226%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2210%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%228%22%20y%3D%222%22%20width%3D%2216%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%224%22%20y%3D%226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2220%22%20y%3D%226%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%2210%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2220%22%20y%3D%2214%22%20width%3D%2210%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var LockIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2234%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2216%22%20y%3D%2210%22%20width%3D%2216%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2212%22%20y%3D%2214%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2228%22%20y%3D%2214%22%20width%3D%228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2210%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2228%22%20y%3D%2222%22%20width%3D%2210%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Lock = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? LockIcon32 : LockIcon48, alt: "Lock Icon" }));
};

var MinusIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var MinusIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Minus = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? MinusIcon32 : MinusIcon48, alt: "Minus Icon" }));
};

var NotificationIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2218%22%20y%3D%229%22%20width%3D%228%22%20height%3D%224%22%20transform%3D%22rotate%2890%2018%209%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%226%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%206%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%226%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%2030%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%226%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2026%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2230%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2026%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2219%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2018%2019%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var NotificationIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2226%22%20y%3D%2217%22%20width%3D%228%22%20height%3D%224%22%20transform%3D%22rotate%2890%2026%2017%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%2014%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2238%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%2890%2038%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2214%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2034%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2238%22%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2034%2038%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2227%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%2890%2026%2027%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Notification = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? NotificationIcon32 : NotificationIcon48, alt: "Notification Icon" }));
};

var PlusIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%222%22%20width%3D%2228%22%20height%3D%224%22%20transform%3D%22rotate%2890%2018%202%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var PlusIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%2222%22%20width%3D%2228%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2210%22%20width%3D%2228%22%20height%3D%224%22%20transform%3D%22rotate%2890%2026%2010%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Plus = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? PlusIcon32 : PlusIcon48, alt: "Plus Icon" }));
};

var ProtectIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHESURBVHgB7d2xSQRRFEDRWdnIJmzA2NBEbEEwEzsQLMMizARbEBPDjW3AJkwVQwODBw67XM6JZ6LLg89j+LNZht4+d18Le3N+fLaZPH+0kCZwnMBxAscJHCdwnMBxAscJHCdwnMBx2+lu+fH9aWF/Tu5PR71McJzAcQLHCRwncJzAcQLHCRwncJzAcQLHbZeVvT6/LPzt4upyWZMJjhM4TuA4geMEjhM4TuA4geMEjhM4TuC41XfRU2vvZtd2c3o9en7t78xNcJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHCRwncJzAcQLHrX5f9PT+5+m/Dte+X/rQ7n+eMsFxAscJHCdwnMBx2/Pjs83khdvd3dfC3nw8vI96meA4geMEjhM4TuC40Ynsx9vnbnSKPrTd7KGZ7t6dovlF4DiB4wSOEzhO4DiB4wSOEzhO4DiB48a76P8y3WlPTXfg053w1HSH/F9McJzAcQLHCRwncJzAcQLHCRwncJzAcQLHfQNW0zNreCuwRgAAAABJRU5ErkJggg==";

var ProtectLogo = function () { return (React__default.createElement("img", { src: ProtectIcon, alt: "ProtectLogo Icon", width: "40px", height: "40px" })); };

var DotActive = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2224%22%20y%3D%228%22%20width%3D%2216%22%20height%3D%2216%22%20transform%3D%22rotate%2890%2024%208%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var SliderDotActive = function () {
    return (React__default.createElement("img", { src: DotActive, alt: "DotActive Icon", style: { cursor: 'pointer' } }));
};

var DotInactive = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2224%22%20y%3D%228%22%20width%3D%2216%22%20height%3D%2216%22%20transform%3D%22rotate%2890%2024%208%29%22%20fill%3D%22%2399B6B9%22%2F%3E%3C%2Fsvg%3E";

var SliderDotInactive = function () {
    return React__default.createElement("img", { src: DotInactive, alt: "DotInactive Icon" });
};

var EarnOnIcon = "data:image/svg+xml,%3Csvg%20width%3D%22524%22%20height%3D%2220%22%20viewBox%3D%220%200%20524%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%220.000976562%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%224.00098%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22260%22%20y%3D%220.000976562%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22256%22%20y%3D%224.00098%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22%2354D3D3%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%200.000976562%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%204.00098%29%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20y%3D%2212.001%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20y%3D%2216.001%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%2212.001%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22246%22%20y%3D%2216.001%22%20width%3D%2232%22%20height%3D%224%22%20fill%3D%22%2354D3D3%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2012.001%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2016.001%29%22%20fill%3D%22%23336D74%22%2F%3E%3C%2Fsvg%3E";

var OffIcon = "data:image/svg+xml,%3Csvg%20width%3D%22524%22%20height%3D%2220%22%20viewBox%3D%220%200%20524%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%224%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22260%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%22256%22%20y%3D%224%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%200%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%204%29%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20y%3D%2212%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20y%3D%2216%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%2212%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%22246%22%20y%3D%2216%22%20width%3D%2232%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2012%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2016%29%22%20fill%3D%22%23336D74%22%2F%3E%3C%2Fsvg%3E";

var ProtectOnIcon = "data:image/svg+xml,%3Csvg%20width%3D%22524%22%20height%3D%2220%22%20viewBox%3D%220%200%20524%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%220.000522614%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%224.00052%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22260%22%20y%3D%220.000522614%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22%232E813B%22%2F%3E%3Crect%20x%3D%22256%22%20y%3D%224.00052%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22%2360C770%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%200.000522614%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%204.00052%29%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20y%3D%2212.0005%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20y%3D%2216.0005%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%2212.0005%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22%232E813B%22%2F%3E%3Crect%20x%3D%22246%22%20y%3D%2216.0005%22%20width%3D%2232%22%20height%3D%224%22%20fill%3D%22%2360C770%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2012.0005%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2016.0005%29%22%20fill%3D%22%23336D74%22%2F%3E%3C%2Fsvg%3E";

var StakeOnIcon = "data:image/svg+xml,%3Csvg%20width%3D%22524%22%20height%3D%2221%22%20viewBox%3D%220%200%20524%2021%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2210%22%20y%3D%220.00146484%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%224.00146%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22260%22%20y%3D%220.00146484%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22%238B4514%22%2F%3E%3Crect%20x%3D%22256%22%20y%3D%224.00146%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%200.00146484%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20514%204.00146%29%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20y%3D%2212.0015%22%20width%3D%22240%22%20height%3D%224%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20y%3D%2216.0015%22%20width%3D%22236%22%20height%3D%224%22%20fill%3D%22%23336D74%22%2F%3E%3Crect%20x%3D%22252%22%20y%3D%2212.0015%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22%238B4514%22%2F%3E%3Crect%20x%3D%22246%22%20y%3D%2216.0015%22%20width%3D%2232%22%20height%3D%224%22%20fill%3D%22%23E07A29%22%2F%3E%3Crect%20width%3D%22240%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2012.0015%29%22%20fill%3D%22%23004047%22%2F%3E%3Crect%20width%3D%22236%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%20524%2016.0015%29%22%20fill%3D%22%23336D74%22%2F%3E%3C%2Fsvg%3E";

var StakeIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG3SURBVHgB7d3BSQNRGEbRUSxAsBItRdd24jKduE460BK0kkA60AqyeMKTeZdz1tmEy7/5GGZutr05nn62lb0832w7cruRJnCcwHECxwkcJ3CcwHECxwkcJ3CcwHHzd9PRbXlnW+6wnf1fFxwncJzAcQLHCRwncJzAcQLHCRwncJzAcXfb4t4vl6nPUb/e3y+9jbvgOIHjBI4TOE7gOIHjBI4TOE7gOIHjBI6bvrNO34o/Prc9efj+Gvr9+XDwXDR/J3CcwHECxwkcJ3CcwHECxwkcJ3CcwHHDO+jotry3rXhvZm/XLjhO4DiB4wSOEzhO4DiB4wSOEzhO4DiB45Z/R8foljvq/Pi0rcwFxwkcJ3CcwHECxwkcJ3CcwHECxwkcJ3Dc8lv0ta14+HnjxTfna1xwnMBxAscJHCdwnMBxAscJHCdwnMBxAscNb9HeubEWFxwncJzAcQLHCRwncJzAcQLHCRwncJzAcdO/XbgdT1O/Xbg3vl3IvxI4TuA4geMEjhM4TuA4geMEjhM4TuC4+Vv0oIe3t6W369nb8igXHCdwnMBxAscJHCdwnMBxAscJHCdwnMBxv50SMxuU0HA6AAAAAElFTkSuQmCC";

var StakeLogo = function () { return (React__default.createElement("img", { src: StakeIcon, alt: "StakeLogo Icon", width: "40px", height: "40px" })); };

var getNextButtonColors = function (cardName) {
    if (cardName === 'Protect') {
        return {
            buttonColor: lightColors.secondary.darkGreen,
            buttonDarkBorderColor: lightColors.secondary.extraDarkGreen,
            buttonLightBorderColor: lightColors.secondary.lightGreen,
        };
    }
    if (cardName === 'Stake') {
        return {
            buttonColor: '#3CB1B1',
            buttonDarkBorderColor: '#188686',
            buttonLightBorderColor: '#54D3D3',
        };
    }
    return {
        buttonColor: lightColors.primary1.vividTangelo,
        buttonDarkBorderColor: lightColors.primary1.chocolate,
        buttonLightBorderColor: lightColors.primary1.bigFootFeet,
    };
};
var getCardLogo = function (cardName) {
    if (cardName === 'Protect') {
        return ProtectLogo;
    }
    if (cardName === 'Earn') {
        return EarnLogo;
    }
    return StakeLogo;
};
var getSocketComponent = function (cardName) {
    switch (cardName) {
        case 'Protect':
            return ProtectOnIcon;
        case 'Earn':
            return StakeOnIcon;
        case 'Stake':
            return EarnOnIcon;
        case 'Off':
            return OffIcon;
    }
};

var SocketProtectOn = function (_a) {
    var name = _a.name;
    var _b = useState(getSocketComponent('Off')), socket = _b[0], setSocket = _b[1];
    useEffect(function () {
        setSocket(getSocketComponent(name));
    }, []);
    return React__default.createElement("img", { src: socket, alt: "socket-on-ico" });
};

var SocketEarnOn = function () { return React__default.createElement("img", { src: EarnOnIcon, alt: "EarnOn Icon" }); };

var SocketStakeOn = function () { return (React__default.createElement("img", { src: StakeOnIcon, alt: "StakeOn Icon" })); };

var SocketOff = function () { return React__default.createElement("img", { src: OffIcon, alt: "Off Icon" }); };

var SupportIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2226%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2211%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%227%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2223%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2225%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2225%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2211%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%227%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%223%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var SupportIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2234%22%20y%3D%2223%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2219%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2231%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2233%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2233%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2219%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2215%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2211%22%20width%3D%2212%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2230%22%20y%3D%2223%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2223%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2223%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Support = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? SupportIcon32 : SupportIcon48, alt: "Support Icon" }));
};

var TransactionLogoIcon = "data:image/svg+xml,%3Csvg%20width%3D%22124%22%20height%3D%22124%22%20viewBox%3D%220%200%20124%20124%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%2262%22%20cy%3D%2262%22%20r%3D%2262%22%20fill%3D%22%2312BFD4%22%20fill-opacity%3D%220.3%22%2F%3E%3Ccircle%20cx%3D%2262%22%20cy%3D%2262%22%20r%3D%2252%22%20fill%3D%22%2312BFD4%22%20fill-opacity%3D%220.3%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M71.9404%2065.3145H74.1511V74.1574H74.1503V76.3665H69.7288V74.1558H71.9404V65.3145ZM67.5205%2076.3674H71.942V78.5781H69.7296V80.7872H63.0974V78.5765H67.5205V76.3674ZM65.3104%2080.788H43.2031V82.9988H65.3104V80.788ZM50.9366%2066.4202H49.8313V69.7363H50.9366V66.4202Z%22%20fill%3D%22%239E3100%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M80.7802%2047.6284H82.9909V58.682H80.7802V47.6284ZM78.5717%2060.8912H80.7794V56.4698H78.5686V58.6813H52.043V60.8921H78.5717V60.8912Z%22%20fill%3D%22%23934818%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M63.1058%2063.1094H45.4231V80.7952H63.1089V78.5845H67.5273V76.3737H69.7364V63.1094H67.5273H67.5257H63.1089H63.1058ZM43.2116%2074.1623H41V80.7945H45.4215V74.1638H45.4223V65.3209H43.2116V74.1623ZM69.7373%2063.1094H71.948V74.163H69.7373V63.1094Z%22%20fill%3D%22%23FF5000%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M54.263%2041H71.9457H71.9488H76.3671V43.2107H71.9488V43.2116H78.5778V45.4207H80.7886V56.4743H78.5778V58.6843H71.9488V58.6858H54.263V41ZM54.2613%2056.4743H54.2621V45.4207H52.0514V56.4736H49.8398V58.6843H54.2613V56.4743Z%22%20fill%3D%22%23FF7D2B%22%2F%3E%3C%2Fsvg%3E";

var TransactionLogo = function () { return (React__default.createElement("img", { src: TransactionLogoIcon, alt: "TransactionLogoIcon Icon" })); };

var WalletIcon32 = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%226%22%20y%3D%2226%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%222%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2210%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%226%22%20width%3D%224%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%226%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var WalletIcon48 = "data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%2214%22%20y%3D%2234%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2210%22%20width%3D%2220%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%2212%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2218%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2218%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2234%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%228%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Wallet = function (_a) {
    var variant = _a.variant;
    return (React__default.createElement("img", { src: variant === IconSize.L ? WalletIcon32 : WalletIcon48, alt: "Wallet Icon" }));
};

var ETHIcon = "data:image/png;base64,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";

var Ethereum = function (_a) {
    var icon = _a.icon;
    if (icon)
        return React__default.createElement("img", { src: icon });
    return React__default.createElement("img", { src: ETHIcon, height: "48", width: "48" });
};

var ETHGreenIcon = "b6fb7d5df30c3622.svg";

var EthereumGreen = function () {
    return React__default.createElement(Ethereum, { icon: ETHGreenIcon });
};

var LoadingIco = "data:image/svg+xml,%3Csvg%20width%3D%2232%22%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222%22%20y%3D%222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%226%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2030%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2210%22%20y%3D%2226%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-180%2010%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%222%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2214%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2226%22%20y%3D%222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%28-1%200%200%201%2026%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%226%22%20y%3D%2230%22%20width%3D%224%22%20height%3D%224%22%20transform%3D%22rotate%28-180%206%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3Crect%20x%3D%2214%22%20y%3D%2222%22%20width%3D%224%22%20height%3D%224%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var Loading = function () { return React__default.createElement("img", { src: LoadingIco, alt: "ListView Icon" }); };

var ProcessIco = "data:image/svg+xml,%3Csvg%20width%3D%2233%22%20height%3D%2232%22%20viewBox%3D%220%200%2033%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206.5%2030%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%2220%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206.5%206%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206.5%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2010.5%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2014.5%2018%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2018.5%2022%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2022.5%2026%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2018.5%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2018.5%2014%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2022.5%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%206.5%2010%29%22%20fill%3D%22white%22%2F%3E%3Crect%20width%3D%224%22%20height%3D%224%22%20transform%3D%22matrix%281%200%200%20-1%2010.5%2014%29%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E";

var ProcessingIco = function () { return (React__default.createElement("img", { src: ProcessIco, alt: "Processing Icon" })); };

var ButtonCarusel = styled(Button$2)(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  z-index: 9999;\n  align-self: center;\n  cursor: pointer;\n"], ["\n  z-index: 9999;\n  align-self: center;\n  cursor: pointer;\n"])));
var Carusel = function (props) {
    var caruselRef = useRef(null);
    var renderDotsItem = function (_a) {
        var isActive = _a.isActive;
        return isActive ? React__default.createElement(SliderDotActive, null) : React__default.createElement(SliderDotInactive, null);
    };
    return (React__default.createElement(Flex, __assign({ width: "900px", flexDirection: "column" }, props),
        React__default.createElement(Flex, { flexDirection: "row", justifyContent: "center" },
            React__default.createElement(ButtonCarusel, { marginRight: "160px", onClick: function () { var _a; return (_a = caruselRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev({}); }, size: IconSize.L },
                React__default.createElement(ArrowLong, { variant: IconSize.L, orientation: HorizontalOrientation.LEFT })),
            React__default.createElement(Flex, { flexDirection: "column", width: "510px", padding: "20px" },
                React__default.createElement(AliceCarousel, { disableButtonsControls: true, renderDotsItem: renderDotsItem, ref: caruselRef }, React__default.Children.map(props.children, function (item) { return item; }))),
            React__default.createElement(ButtonCarusel, { onClick: function () {
                    var _a;
                    console.log('click');
                    (_a = caruselRef.current) === null || _a === void 0 ? void 0 : _a.slideNext({});
                }, marginLeft: "160px", size: IconSize.L },
                React__default.createElement(ArrowLong, { variant: IconSize.L, orientation: HorizontalOrientation.RIGHT })))));
};
var templateObject_1$M;

var CONFIRMATION_BORDER_WIDTH = 0;

var ConfirmationBox = styled(Flex)(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  position: relative;\n  padding: 24px 32px 32px 24px;\n  background: ", ";\n  box-shadow: ", ";\n  ", "\n\n  ", "\n  ", "\n"], ["\n  position: relative;\n  padding: 24px 32px 32px 24px;\n  background: ", ";\n  box-shadow: ", ";\n  ", "\n\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.confirmationBox;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.aqua, 'rgba(18, 191, 212, 0)', 'rgba(18, 191, 212, 0)', CONFIRMATION_BORDER_WIDTH);
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled
        ? "\n   opacity: 0.6;\n   z-index: 100;\n   &:before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0.6;\n      z-index: 99999;\n      background-color: ".concat(theme.colors.background.confirmationBox, ";\n    };")
        : 'opacity: 1;';
}, space, layout);
ConfirmationBox.defaultProps = {
    width: '100%',
    height: 'auto',
};
var MainBorder = styled(Box)(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  background: ", ";\n  border: 4px solid transparent;\n\n  &:before {\n    content: '';\n    position: absolute;\n    width: calc(100% + 8px);\n    height: 100%;\n    top: 0;\n    bottom: 0;\n    left: -4px;\n    right: -4px;\n    box-shadow: -4px 0px 0px ", ",\n      4px 0px 0px ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: calc(100% + 8px);\n    top: -4px;\n    bottom: -4px;\n    left: 0;\n    right: 0;\n    box-shadow: 0 -4px 0 ", ",\n      0 4px 0 ", ";\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  background: ", ";\n  border: 4px solid transparent;\n\n  &:before {\n    content: '';\n    position: absolute;\n    width: calc(100% + 8px);\n    height: 100%;\n    top: 0;\n    bottom: 0;\n    left: -4px;\n    right: -4px;\n    box-shadow: -4px 0px 0px ", ",\n      4px 0px 0px ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: calc(100% + 8px);\n    top: -4px;\n    bottom: -4px;\n    left: 0;\n    right: 0;\n    box-shadow: 0 -4px 0 ", ",\n      0 4px 0 ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, background = _a.background;
    return background || theme.colors.background.confirmationBox;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
});
var InnerBorder = styled('span')(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n  display: block;\n  position: relative;\n  &:before,\n  &:after {\n    content: '';\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    z-index: 1;\n  }\n"], ["\n  display: block;\n  position: relative;\n  &:before,\n  &:after {\n    content: '';\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    z-index: 1;\n  }\n"])));
var InnerBorderTop = styled(InnerBorder)(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  &:after {\n    top: -4px;\n    right: -4px;\n    border: 2px solid ", ";\n  }\n  &:before {\n    top: -4px;\n    left: -4px;\n    border: 2px solid ", ";\n  }\n"], ["\n  &:after {\n    top: -4px;\n    right: -4px;\n    border: 2px solid ", ";\n  }\n  &:before {\n    top: -4px;\n    left: -4px;\n    border: 2px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
});
var InnerBorderBottom = styled(InnerBorder)(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  &:after {\n    bottom: -4px;\n    right: -4px;\n    border: 2px solid ", ";\n  }\n  &:before {\n    bottom: -4px;\n    left: -4px;\n    border: 2px solid ", ";\n  }\n"], ["\n  &:after {\n    bottom: -4px;\n    right: -4px;\n    border: 2px solid ", ";\n  }\n  &:before {\n    bottom: -4px;\n    left: -4px;\n    border: 2px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
});
var Content$1 = styled(Flex)(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  padding: 24px 32px;\n  flex-direction: column;\n  & > * {\n    z-index: 10;\n  }\n  ", "\n\n  ", "\n  ", "\n"], ["\n  padding: 24px 32px;\n  flex-direction: column;\n  & > * {\n    z-index: 10;\n  }\n  ", "\n\n  ", "\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? "\n   opacity: 0.6;\n   z-index: 100;\n   &:before {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0.6;\n      z-index: 99999;\n    };"
        : 'opacity: 1;';
}, space, layout);
var ConfirmationBoxFixed = function (_a) {
    var disabled = _a.disabled, children = _a.children, background = _a.background, mainStyles = _a.mainStyles, props = __rest(_a, ["disabled", "children", "background", "mainStyles"]);
    return (React__default.createElement(MainBorder, __assign({ background: background }, mainStyles),
        React__default.createElement(InnerBorderTop, null),
        React__default.createElement(Content$1, __assign({ disabled: disabled }, props), children),
        React__default.createElement(InnerBorderBottom, null)));
};
var templateObject_1$L, templateObject_2$w, templateObject_3$s, templateObject_4$i, templateObject_5$d, templateObject_6$c;

var ConfirmHorizontalDivider = styled(Box)(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  height: 4px;\n  background-color: ", ";\n"], ["\n  height: 4px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color
        ? getThemeValue("colors.".concat(color), color)(theme)
        : theme.colors.primary2.darkSlateGray;
});
var TXLink = styled.a(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-family: 'Share Tech Mono';\n  font-size: 16px;\n  line-height: 24px;\n  gap: 8px;\n  color: ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    color: #fff;\n  }\n  & .a-text:visited {\n    text-decoration: underline;\n    text-decoration-color: ", " !important;\n  }\n  & svg {\n    path {\n      fill: #fff;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-family: 'Share Tech Mono';\n  font-size: 16px;\n  line-height: 24px;\n  gap: 8px;\n  color: ", ";\n  &:hover,\n  &:focus,\n  &:active {\n    color: #fff;\n  }\n  & .a-text:visited {\n    text-decoration: underline;\n    text-decoration-color: ", " !important;\n  }\n  & svg {\n    path {\n      fill: #fff;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
});
var ClearLink = styled.a(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  font-family: 'Share Tech';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.03em;\n  &:hover {\n    background: none;\n    text-decoration: none;\n    color: ", ";\n  }\n  &:-webkit-any-link {\n    color: ", ";\n    text-decoration: underline;\n    text-decoration-color: ", " !important;\n  }\n"], ["\n  font-family: 'Share Tech';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.03em;\n  &:hover {\n    background: none;\n    text-decoration: none;\n    color: ", ";\n  }\n  &:-webkit-any-link {\n    color: ", ";\n    text-decoration: underline;\n    text-decoration-color: ", " !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
});
var ConfirmCard = function (_a) {
    var iconComponent = _a.iconComponent, amount = _a.amount, subTitle = _a.subTitle, children = _a.children, linkUrl = _a.linkUrl, linkText = _a.linkText, props = __rest(_a, ["iconComponent", "amount", "subTitle", "children", "linkUrl", "linkText"]);
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ConfirmationBoxFixed, __assign({ width: "100%", flexDirection: "column", position: "relative", mt: "20px" }, props),
        iconComponent,
        React__default.createElement(FlexWithGap, { gap: isMobile ? '' : '16px', alignItems: "center", justifyContent: "center", flexDirection: isMobile ? 'column' : 'row' },
            amount ? (React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "32px", lineHeight: "48px", color: "secondary.white" },
                "+",
                amount)) : null,
            subTitle && (React__default.createElement(LargeText, { color: "primary2.cambridgeBlue" }, subTitle))),
        linkUrl && linkText ? (React__default.createElement(Flex, { justifyContent: "center", mt: "16px" },
            React__default.createElement(TXLink, { href: linkUrl, target: "_blank" },
                React__default.createElement(ClearLink, { className: "a-text" }, linkText),
                ' ',
                React__default.createElement("img", { src: LinkExternal, alt: "external", width: "24px", height: "24px" })))) : null,
        React__default.createElement(ConfirmHorizontalDivider, { mt: "32px", mb: "20px", color: "primary2.aqua" }),
        children));
};
var templateObject_1$K, templateObject_2$v, templateObject_3$r;

var getDialogueColor = function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
};

var Dialogue = styled(Box)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  background-color: ", ";\n  min-height: 70px;\n  width: 170px;\n  border-radius: 0;\n  color: ", ";\n  font-size: 12px;\n  font-family: 'Roboto Mono', sans-serif;\n  line-height: 16px;\n  padding: 8px 10px;\n  opacity: 1;\n  max-width: 173px;\n  z-index: 9999;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  margin: 8px 8px 8px 16px;\n  box-shadow: ", ";\n  &:after {\n    position: absolute;\n    top: 20px;\n    ", ": 100%;\n    content: ' ';\n    width: 8px;\n    height: 8px;\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  min-height: 70px;\n  width: 170px;\n  border-radius: 0;\n  color: ", ";\n  font-size: 12px;\n  font-family: 'Roboto Mono', sans-serif;\n  line-height: 16px;\n  padding: 8px 10px;\n  opacity: 1;\n  max-width: 173px;\n  z-index: 9999;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  margin: 8px 8px 8px 16px;\n  box-shadow: ", ";\n  &:after {\n    position: absolute;\n    top: 20px;\n    ", ": 100%;\n    content: ' ';\n    width: 8px;\n    height: 8px;\n    box-shadow: ", ";\n  }\n"])), getDialogueColor, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.black;
}, function (props) {
    return createPixelInsetBorder$1(getDialogueColor(props), getDialogueColor(props), getDialogueColor(props), 4);
}, function (props) { return props.dialogPosition; }, function (props) {
    return createPixelInsetBorder$1(getDialogueColor(props), getDialogueColor(props), getDialogueColor(props), 4);
});
var templateObject_1$J;

var DialogueCloudSvgRaw = function (props) { return (React.createElement("svg", __assign({ width: 173, height: 124, viewBox: "0 0 173 124", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "sc-dIouRR jhTzsQ" }, props),
    React.createElement("rect", { width: 157, height: 4, transform: "matrix(1 0 0 -1 8 4)", fill: "#000E10" }),
    React.createElement("rect", { y: 8, width: 4, height: 72, fill: "#000E10" }),
    React.createElement("rect", { width: 165, height: 80, transform: "translate(4 4)", fill: "#99B6B9" }),
    React.createElement("rect", { x: 165, y: 8, width: 4, height: 72, fill: "#99B6B9" }),
    React.createElement("rect", { x: 169, y: 8, width: 4, height: 72, fill: "#000E10" }),
    React.createElement("rect", { width: 4, height: 4, transform: "matrix(1 0 0 -1 8 88)", fill: "#000E10" }),
    React.createElement("rect", { width: 4, height: 4, transform: "matrix(1 0 0 -1 4 84)", fill: "#000E10" }),
    React.createElement("rect", { width: 4, height: 4, transform: "matrix(1 0 0 -1 8 84)", fill: "#99B6B9" }),
    React.createElement("rect", { x: 161, y: 92, width: 96, height: 4, transform: "rotate(-180 161 92)", fill: "#000E10" }),
    React.createElement("rect", { x: 65, y: 91, width: 32, height: 7, transform: "rotate(-180 65 92)", fill: "#99B6B9" }),
    React.createElement("rect", { x: 33, y: 92, width: 21, height: 4, transform: "rotate(-180 33 92)", fill: "#000E10" }),
    React.createElement("rect", { x: 161, y: 88, width: 149, height: 6, transform: "rotate(-180 161 88)", fill: "#99B6B9" }),
    React.createElement("rect", { x: 161, y: 84, width: 149, height: 4, transform: "rotate(-180 161 84)", fill: "#99B6B9" }),
    React.createElement("rect", { width: 4, height: 4, transform: "matrix(1 0 0 -1 4 8)", fill: "#000E10" }),
    React.createElement("rect", { x: 165, y: 88, width: 4, height: 4, transform: "rotate(-180 165 88)", fill: "#000E10" }),
    React.createElement("rect", { width: 4, height: 4, transform: "matrix(1 0 0 -1 165 8)", fill: "#000E10" }),
    React.createElement("rect", { x: 169, y: 84, width: 4, height: 4, transform: "rotate(-180 169 84)", fill: "#000E10" }),
    React.createElement("rect", { x: 165, y: 84, width: 4, height: 4, transform: "rotate(-180 165 84)", fill: "#99B6B9" }),
    React.createElement("rect", { x: 29, y: 92, width: 4, height: 32, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 92, width: 28, height: 6, fill: "#99B6B9" }),
    React.createElement("rect", { x: 61, y: 92, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 96, width: 24, height: 4, fill: "#99B6B9" }),
    React.createElement("rect", { x: 57, y: 96, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 99, width: 20, height: 6, fill: "#99B6B9" }),
    React.createElement("rect", { x: 53, y: 100, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 104, width: 16, height: 6, fill: "#99B6B9" }),
    React.createElement("rect", { x: 49, y: 104, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 108, width: 12, height: 6, fill: "#99B6B9" }),
    React.createElement("rect", { x: 45, y: 108, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 112, width: 8, height: 6, fill: "#99B6B9" }),
    React.createElement("rect", { x: 41, y: 112, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 33, y: 116, width: 4, height: 4, fill: "#99B6B9" }),
    React.createElement("rect", { x: 37, y: 116, width: 4, height: 4, fill: "#000E10" }),
    React.createElement("rect", { x: 29, y: 120, width: 8, height: 4, fill: "#000E10" }))); };
var DialogueOuterWrapper = styled(Box)(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  width: 193px;\n  height: 144px;\n"], ["\n  width: 193px;\n  height: 144px;\n"])));
var DialogueInnerWrapper = styled(Box)(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  object-fit: cover;\n  scale: 2;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  object-fit: cover;\n  scale: 2;\n"])));
var DialogueCloudSvg = styled(DialogueCloudSvgRaw)(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n"])));
var DialogueInnerContentWrapper = styled(Box)(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  position: absolute;\n  top: 8px;\n  width: 184px;\n  height: 94px;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  text-align: center;\n"], ["\n  position: absolute;\n  top: 8px;\n  width: 184px;\n  height: 94px;\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  text-align: center;\n"])));
var DialogueInnerContent = styled(Box)(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n"])));
var DialogueMsg = function (props) {
    return (React.createElement(DialogueOuterWrapper, null,
        React.createElement(DialogueInnerWrapper, null,
            React.createElement(DialogueCloudSvg, null),
            React.createElement(DialogueInnerContentWrapper, null,
                React.createElement(DialogueInnerContent, null, props.children)))));
};
var templateObject_1$I, templateObject_2$u, templateObject_3$q, templateObject_4$h, templateObject_5$c;

var DialoguePosition;
(function (DialoguePosition) {
    DialoguePosition["LEFT"] = "left";
    DialoguePosition["RIGHT"] = "right";
})(DialoguePosition || (DialoguePosition = {}));

var getLabelBackgroundColor = function (_a) {
    var theme = _a.theme, backgroundColor = _a.backgroundColor;
    return getColorOrDefault(theme, backgroundColor, 'primary2.darkSlateGray');
};
var getLabelBorderColor = function (_a) {
    var theme = _a.theme, borderColor = _a.borderColor;
    return createSimpleShadowBorder(getColorOrDefault(theme, borderColor, 'primary2.myrtleGreen'), BOX_SHADOW_WIDTH$5, getColorOrDefault(theme, borderColor, 'primary2.myrtleGreen'));
};
var getLabelTextColor = function (_a) {
    var theme = _a.theme, color = _a.color;
    return getColorOrDefault(theme, color, 'secondary.white');
};

var createBorderOnlyOnRightAndLeft = function (borderColorRight, borderColorLeft, borderWidth) {
    var width = borderWidth ? borderWidth : 2;
    return "".concat(width, "px 0px ").concat(borderColorRight, ", \n      -").concat(width, "px 0px ").concat(borderColorLeft);
};
var createBorderOnlyOnLeftAndTop = function (borderColorLeft, borderColorTop, borderWidth) {
    var width = borderWidth ? borderWidth : 2;
    return "-".concat(width, "px 0px ").concat(borderColorLeft, ", \n    0px -").concat(width, "px ").concat(borderColorTop, "\n  ");
};
var createBorderOnlyRightAndBottom = function (borderColorRight, borderColorBottom, borderWidth) {
    var width = borderWidth ? borderWidth : 2;
    return "".concat(width, "px 0px ").concat(borderColorRight, ", \n    0px ").concat(width, "px ").concat(borderColorBottom, "\n  ");
};
// LTRB - left-top-right-bottom
var createTwoColorBorderLTRB = function (borderColorLT, borderColorRB, borderWidth) {
    return "".concat(createBorderOnlyOnLeftAndTop(borderColorLT, borderColorLT, borderWidth), ", ").concat(createBorderOnlyRightAndBottom(borderColorRB, borderColorRB, borderWidth));
};

var Label = styled.label(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  display: flex;\n  padding: 4px 12px;\n  min-height: 32px;\n  font-family: 'Roboto Mono', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  padding: 4px 12px;\n  min-height: 32px;\n  font-family: 'Roboto Mono', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"])), getLabelBackgroundColor, getLabelBorderColor, getLabelTextColor, space, typography, layout);
var LightLabel = styled(Label)(templateObject_2$t || (templateObject_2$t = __makeTemplateObject([""], [""])));
var DarkLabel = styled(Label).attrs({
    backgroundColor: 'primary2.midnightGreen',
    borderColor: 'primary2.greenCyprus',
})(templateObject_3$p || (templateObject_3$p = __makeTemplateObject([""], [""])));
var GreenLabel = styled(Label).attrs({
    backgroundColor: 'primary2.blueDianne',
    borderColor: 'secondary.green',
    color: 'primary2.cambridgeBlue',
})(templateObject_4$g || (templateObject_4$g = __makeTemplateObject([""], [""])));
var RedLabel = styled(Label).attrs({
    backgroundColor: 'primary2.blueDianne',
    borderColor: 'secondary.red',
    color: 'primary2.cambridgeBlue',
})(templateObject_5$b || (templateObject_5$b = __makeTemplateObject([""], [""])));
var AssetLabel = styled(Box)(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  max-height: 28px;\n  min-width: ", ";\n  width: 100%;\n  height: 100%;\n  padding: 0.5rem 0.5rem;\n  line-height: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  max-height: 28px;\n  min-width: ", ";\n  width: 100%;\n  height: 100%;\n  padding: 0.5rem 0.5rem;\n  line-height: 20px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return createTwoColorBorderLTRB(theme.colors.primary2.greenCyprus, theme.colors.primary2.desaturatedCyan, 4);
}, function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? minWidth : '144px');
});
var AssetLabelDark = styled(Box)(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  max-height: 28px;\n  min-width: ", ";\n  width: 100%;\n  height: 100%;\n  padding: 0.5rem 0.5rem;\n  line-height: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: ", ";\n  color: ", ";\n  box-shadow: ", ";\n\n  max-height: 28px;\n  min-width: ", ";\n  width: 100%;\n  height: 100%;\n  padding: 0.5rem 0.5rem;\n  line-height: 20px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return createTwoColorBorderLTRB(theme.colors.primary2.greenCyprus, theme.colors.primary2.desaturatedCyan, 4);
}, function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? minWidth : '144px');
});
var templateObject_1$H, templateObject_2$t, templateObject_3$p, templateObject_4$g, templateObject_5$b, templateObject_6$b, templateObject_7$7;

var BOX_SHADOW_WIDTH$3 = 4;
var SELECTOR_PADDING = '4px 12px';
var MAIN_HEIGHT_WITHOUT_ICON = '56px';
var MAIN_HEIGHT_WITH_ICON = '32px';
var ADDITIONAL_TOP_VALUE_WITHOUT_ICON = BOX_SHADOW_WIDTH$3 * 5;
var ADDITIONAL_TOP_VALUE_WITH_ICON = BOX_SHADOW_WIDTH$3 * 3;

var getOptionsWithValueOnTop = function (value, options) {
    var filteredOptions = options.filter(function (option) { return option.key !== value.key; });
    return __spreadArray([value], filteredOptions, true);
};
var getTopAdditionalValueForOptions = function (_a) {
    var withIcon = _a.withIcon;
    if (withIcon)
        return ADDITIONAL_TOP_VALUE_WITH_ICON;
    return ADDITIONAL_TOP_VALUE_WITHOUT_ICON;
};
var getFontColor = function (activeValue, option) {
    if (activeValue.key === option.key)
        return lightColors.primary1.bigFootFeet;
    return lightColors.typography.input;
};
var getCaretOrientation = function (isOpened) {
    return VerticalOrientation[isOpened ? 'UP' : 'DOWN'];
};
var getMainContainerHeight = function (isIconExist) {
    return isIconExist ? MAIN_HEIGHT_WITHOUT_ICON : MAIN_HEIGHT_WITH_ICON;
};

var StyledSelect = styled(Box)(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  background-color: ", ";\n  border: none;\n  padding: ", ";\n  box-shadow: ", ";\n  width: ", ";\n  min-width: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  -webkit-text-fill-color: ", ";\n  ", " {\n    padding: 4px 8px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  background-color: ", ";\n  border: none;\n  padding: ", ";\n  box-shadow: ", ";\n  width: ", ";\n  min-width: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  -webkit-text-fill-color: ", ";\n  ", " {\n    padding: 4px 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var selectorPadding = _a.selectorPadding;
    return selectorPadding ? selectorPadding : SELECTOR_PADDING;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, BOX_SHADOW_WIDTH$3);
}, function (_a) {
    var width = _a.width;
    return (width ? width : 'fit-content');
}, function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? minWidth : '177px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.5' : '1');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
styled(Text)(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  font-size: ", ";\n  font-weight: 400;\n  line-height: ", ";\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-family: 'Roboto Mono';\n  font-size: ", ";\n  font-weight: 400;\n  line-height: ", ";\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var scale = _a.scale;
    return style[scale || scales$1.SM].fontSize;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return (lineHeight ? lineHeight : "110%");
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.lg;
}, function (_a) {
    var scale = _a.scale;
    return style[scale || scales$1.SM].fontSize;
});
var StyledCoinIcon = styled.img(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n"], ["\n  width: 48px;\n  height: 48px;\n"])));
var SelectorInsetWrapper = styled(Flex)(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n"], ["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n"])));
var StyledOptionsWrapper = styled(Box)(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  position: absolute;\n  top: ", ";\n  display: flex;\n  flex-direction: column;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n"], ["\n  position: absolute;\n  top: ", ";\n  display: flex;\n  flex-direction: column;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n"])), function (_a) {
    var topHeight = _a.topHeight;
    return topHeight
        ? "calc(100% + ".concat(topHeight, ")")
        : "calc(100% + ".concat(getTopAdditionalValueForOptions, "px)");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, BOX_SHADOW_WIDTH$3);
}, function (_a) {
    var theme = _a.theme;
    return theme.zIndices.modal;
});
var StyledOption = styled(Flex)(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  padding: 6px 12px;\n  width: 100%;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  padding: 6px 12px;\n  width: 100%;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme;
    return createBorderOnlyOnRightAndLeft(theme.colors.primary2.darkSlateGray, theme.colors.primary2.darkSlateGray, BOX_SHADOW_WIDTH$3);
});
var SelectorHeadingWapper = styled('div')(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var SelectorHeadingKey = styled('span')(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-right: ", ";\n  margin-left: ", ";\n"], ["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-right: ", ";\n  margin-left: ", ";\n"])), function (_a) {
    var rightSpacing = _a.rightSpacing;
    return rightSpacing;
}, function (_a) {
    var leftSpacing = _a.leftSpacing;
    return leftSpacing;
});
var templateObject_1$G, templateObject_2$s, templateObject_3$o, templateObject_4$f, templateObject_5$a, templateObject_6$a, templateObject_7$6, templateObject_8$6;

var Selector = function (props) {
    var container = useRef(null);
    useEffect(function () {
        var onClick = function (e) {
            var _a;
            var target = e.target;
            if (!((_a = container === null || container === void 0 ? void 0 : container.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                props.setIsOpened(false);
            }
        };
        document.addEventListener('click', onClick);
        return function () { return document.removeEventListener('click', onClick); };
    }, []);
    return (React__default.createElement(StyledSelect, __assign({ width: props.width, minWidth: props.minWidth, ref: container, onClick: function () {
            if (!props.disabled)
                props.setIsOpened(function (prev) { return !prev; });
        }, selectorPadding: props.selectorPadding }, props),
        props.withIcon && React__default.createElement(StyledCoinIcon, { src: props.value.icon, alt: "coin" }),
        React__default.createElement(SelectorInsetWrapper, null,
            React__default.createElement(SelectorHeadingWapper, null,
                typeof props.value.value !== 'string' ? (props.value.value) : (React__default.createElement(Heading, { scale: props.headingScale, color: "typography.input" }, props.value.value)),
                props.withKey && (React__default.createElement(SelectorHeadingKey, { leftSpacing: props.leftSpacing, rightSpacing: props.rightSpacing },
                    "(",
                    props.value.key,
                    ")"))),
            React__default.createElement(Check$1, { variant: IconSize.L, orientation: getCaretOrientation(props.isOpened) }))));
};
var Options$1 = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, withIcon = _a.withIcon, topValue = _a.topValue;
    console.log(topValue);
    return (React__default.createElement(StyledOptionsWrapper, { withIcon: withIcon, topHeight: topValue }, options.map(function (option) {
        var fontColor = getFontColor(value, option);
        return (React__default.createElement(StyledOption, { key: option.key, onClick: function () { return onChange(option); } },
            withIcon && React__default.createElement(StyledCoinIcon, { src: option.icon, alt: "coin" }),
            typeof option.value !== 'string' ? (option.value) : (React__default.createElement(Heading, { scale: "md", color: fontColor }, option.value))));
    })));
};
var Select = function (_a) {
    var _b;
    var value = _a.value, onValueChanged = _a.onValueChanged, _c = _a.disabled, disabled = _c === void 0 ? false : _c, options = _a.options, withIcon = _a.withIcon, withKey = _a.withKey, headingScale = _a.headingScale, rightSpacing = _a.rightSpacing, leftSpacing = _a.leftSpacing, selectorPadding = _a.selectorPadding, selectWidth = _a.selectWidth, minWidth = _a.minWidth, topValue = _a.topValue, props = __rest(_a, ["value", "onValueChanged", "disabled", "options", "withIcon", "withKey", "headingScale", "rightSpacing", "leftSpacing", "selectorPadding", "selectWidth", "minWidth", "topValue"]);
    var _d = useState(false), isOpened = _d[0], setIsOpened = _d[1];
    var formattedOptions = getOptionsWithValueOnTop(value, options);
    var handleChange = function (value) {
        onValueChanged(value);
        setIsOpened(false);
    };
    return (React__default.createElement(Box, __assign({ position: "relative", height: getMainContainerHeight(withIcon || false), width: (_b = props.width) !== null && _b !== void 0 ? _b : 'fit-content' }, props),
        React__default.createElement(Selector, { width: selectWidth, minWidth: minWidth, value: value, disabled: disabled, isOpened: isOpened, withIcon: withIcon, withKey: withKey, setIsOpened: setIsOpened, headingScale: headingScale, rightSpacing: rightSpacing, leftSpacing: leftSpacing, selectorPadding: selectorPadding }),
        isOpened && options.length > 0 && (React__default.createElement(Options$1, { topValue: topValue, value: value, options: formattedOptions, onChange: handleChange, withIcon: withIcon || false }))));
};

var BalanceContainer$1 = styled(Flex)(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  flex-direction: column;\n  padding: 16px;\n  max-width: 306px;\n  background-color: ", ";\n  box-shadow: ", ";\n"], ["\n  flex-direction: column;\n  padding: 16px;\n  max-width: 306px;\n  background-color: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return createSimpleShadowBorder(theme.colors.primary2.midnightGreen, 4);
});
var BalanceContainerValue = styled(Flex)(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var BalanceInfo$3 = function (_a) {
    var balance = _a.balance, tokenName = _a.tokenName, balanceInUsd = _a.balanceInUsd;
    return (React__default.createElement(BalanceContainer$1, null,
        React__default.createElement(Heading, { as: "h4", scale: "md", color: "primary2.cambridgeBlue", mb: "8px" }, "Balance"),
        React__default.createElement(BalanceContainerValue, { color: "primary2.midnightGreen" },
            React__default.createElement(Flex, { alignItems: "center" },
                React__default.createElement(MediumText, { color: "secondary.white" }, balance),
                React__default.createElement(SmallText, { color: "primary2.cambridgeBlue", ml: "4px" }, tokenName)),
            React__default.createElement(SmallText, { ml: "6px", color: "primary2.cambridgeBlue" },
                "($",
                balanceInUsd,
                ")"))));
};
var TokenInfo = styled.div(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  gap: 12px;\n  box-shadow: ", ";\n\n  max-width: 306px;\n  margin-bottom: 32px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  gap: 12px;\n  box-shadow: ", ";\n\n  max-width: 306px;\n  margin-bottom: 32px;\n"])), function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenCyprus, 'transparent', 'transparent');
});
var UnitsCard = function (_a) {
    var iconComponent = _a.iconComponent, tokenName = _a.tokenName, pricePerOneToken = _a.pricePerOneToken, balance = _a.balance, balanceInUsd = _a.balanceInUsd;
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column" },
        React__default.createElement(TokenInfo, null,
            iconComponent,
            React__default.createElement(LargeText, { color: "secondary.white" },
                tokenName,
                " ($",
                pricePerOneToken,
                ")")),
        React__default.createElement(BalanceInfo$3, { tokenName: tokenName, balance: balance, balanceInUsd: balanceInUsd })));
};
var templateObject_1$F, templateObject_2$r, templateObject_3$n;

// TODO: earn deposit flow component copy, fix it later
var InfoSummaryText = styled(Box)(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  max-width: 164px;\n  max-height: 28px;\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: 4px 8px;\n  ", " {\n    min-width: 144px;\n  }\n  ", " {\n    max-width: 144px;\n    min-width: 130px;\n  }\n"], ["\n  max-width: 164px;\n  max-height: 28px;\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: 4px 8px;\n  ", " {\n    min-width: 144px;\n  }\n  ", " {\n    max-width: 144px;\n    min-width: 130px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme;
    return createSimpleShadowBorder(theme.colors.primary2.midnightGreen, 4, theme.colors.primary2.myrtleGreen);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var InfoSummary = function (_a) {
    var title = _a.title, value = _a.value, tooltipText = _a.tooltipText, label = _a.label;
    return (React__default.createElement(Box, null,
        React__default.createElement(Flex, { alignItems: "center" },
            React__default.createElement(SmallText, { color: "primary2.cambridgeBlue", mb: "8px", style: { whiteSpace: 'nowrap' }, fontWeight: 500 },
                ' ',
                title,
                ' '),
            tooltipText && (React__default.createElement(Tooltip, { tooltipValue: tooltipText, conntainerStyles: { mt: '-5px' } }))),
        React__default.createElement(InfoSummaryText, null,
            React__default.createElement(Flex, { alignItems: "center" },
                React__default.createElement(MediumText, { color: "secondary.white" },
                    " ",
                    value,
                    " "),
                label && (React__default.createElement(SmallText, { color: "primary2.cambridgeBlue", ml: "2px" }, label))))));
};
var InfoArea = function (_a) {
    var title = _a.title, value = _a.value, subTitle = _a.subTitle;
    return (React__default.createElement(FlexWithGap, { flexDirection: "column", gap: "4px" },
        React__default.createElement(LargeText, { color: "primary2.cambridgeBlue" }, title),
        React__default.createElement(FlexWithGap, { gap: "4px" },
            React__default.createElement(LargeText, { color: "secondary.white" }, value),
            subTitle && (React__default.createElement(Flex, { alignItems: "center" },
                React__default.createElement(SmallText, { color: "primary2.cambridgeBlue" }, subTitle))))));
};
var templateObject_1$E;

var SummaryContainer = styled(Grid$2)(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 80px;\n  width: 70%;\n  ", " {\n    width: 100%;\n    row-gap: 16px;\n    column-gap: 20px;\n  }\n"], ["\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n  row-gap: 20px;\n  column-gap: 80px;\n  width: 70%;\n  ", " {\n    width: 100%;\n    row-gap: 16px;\n    column-gap: 20px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var SummaryCard = function (_a) {
    var stakeAmount = _a.stakeAmount, stakeValue = _a.stakeValue, periodType = _a.periodType, currentStakeRate = _a.currentStakeRate, disabled = _a.disabled;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ConfirmationBoxFixed, { disabled: disabled, background: "none !important", p: isMobile ? '24px 12px 24px 16px' : '' },
        React__default.createElement(SummaryContainer, null,
            React__default.createElement(InfoSummary, { title: "Stake Amount", value: stakeAmount, label: "BUMP" }),
            React__default.createElement(InfoSummary, { title: "Stake Value", value: "$".concat(stakeValue), tooltipText: "Stake" }),
            React__default.createElement(InfoSummary, { title: "Period Type", value: periodType }),
            React__default.createElement(InfoSummary, { title: "Current Stake Rate", value: currentStakeRate, tooltipText: "Stake" }))));
};
var templateObject_1$D;

var AutoRenewCard = function (_a) {
    var autoRenew = _a.autoRenew, icon = _a.icon, text = _a.text;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", position: "relative", mt: "20px", px: isMobile ? '8px' : '' },
        icon ? (icon) : (React__default.createElement(FlexWithGap, { gap: "28px", alignItems: "center", position: "absolute", top: "-28.5%", left: "50%", style: { transform: 'translateX(-50%)' }, zIndex: "10" },
            React__default.createElement(StakeLogo, null),
            React__default.createElement(Bump, { variant: IconSize.XL }))),
        React__default.createElement(FlexWithGap, { gap: "12px", flexDirection: "column" },
            React__default.createElement(Flex, { alignItems: "center", mt: "16px" },
                React__default.createElement(LargeText, { color: "secondary.white", fontFamily: "Share Tech Mono", bold: true, fontSize: isMobile ? '18px' : '16px' }, "Auto-renew:"),
                "\u00A0",
                React__default.createElement(LargeText, { color: 'secondary.white', fontFamily: "Share Tech Mono", bold: true, fontSize: isMobile ? '18px' : '16px' }, autoRenew ? 'ON' : 'OFF')),
            React__default.createElement(ConfirmHorizontalDivider, { mt: "8px", mb: "8px", color: "primary2.aqua" }),
            React__default.createElement(LargeText, { color: "secondary.white", fontSize: "16px" }, text
                ? text
                : 'By turning on auto-renew, you will be able to continue staking at the end of this term for the same period as your current term.'))));
};

var PeriodCardTab = styled(ConfirmationBox)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  z-index: 5;\n  width: 96px !important;\n  padding: 10px 12px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  letter-spacing: 0.03em;\n"], ["\n  z-index: 5;\n  width: 96px !important;\n  padding: 10px 12px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  letter-spacing: 0.03em;\n"])));
var PeriodCardDivider = styled(Box)(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  width: 100%;\n  height: 4px;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 4px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.aqua;
});
var PeriodButton = styled(Button$2)(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", " !important;\n  -webkit-text-fill-color: ", " !important;\n\n  &:hover {\n    background-color: ", ";\n    color: ", " !important;\n    -webkit-text-fill-color: ", " !important;\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  color: ", " !important;\n  -webkit-text-fill-color: ", " !important;\n\n  &:hover {\n    background-color: ", ";\n    color: ", " !important;\n    -webkit-text-fill-color: ", " !important;\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return isActive
        ? theme.colors.secondary.green
        : theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, isActive
        ? theme.colors.secondary.lightGreen
        : theme.colors.primary2.darkSlateGray, isActive
        ? theme.colors.secondary.darkGreen
        : theme.colors.primary2.deepTeal, BOX_SHADOW_WIDTH$5);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return isActive
        ? theme.colors.secondary.green
        : theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, isActive
        ? theme.colors.secondary.lightGreen
        : theme.colors.primary2.darkSlateGray, isActive
        ? theme.colors.secondary.darkGreen
        : theme.colors.primary2.deepTeal, BOX_SHADOW_WIDTH$5);
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return isActive
        ? theme.colors.secondary.green
        : theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, isActive
        ? theme.colors.secondary.lightGreen
        : theme.colors.primary2.darkSlateGray, isActive
        ? theme.colors.secondary.darkGreen
        : theme.colors.primary2.deepTeal, BOX_SHADOW_WIDTH$5);
});
var templateObject_1$C, templateObject_2$q, templateObject_3$m;

var BORDER_WIDTH = 4;
var WIDTH = '110px';
var HEIGHT = '31px';
var FONT_SIZE = '14px';
var LINE_HEIGHT = '18px';
var GAP = '5px';

var getCursor = function (_a) {
    var disabled = _a.disabled;
    return disabled ? 'not-allowed' : 'pointer';
};
var getBoxShadow$3 = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.vividTangelo
            : theme.colors.primary2.myrtleGreen, disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.vividTangelo
            : theme.colors.primary2.myrtleGreen, BORDER_WIDTH);
};
var getColor = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    return checked && !disabled
        ? theme.colors.secondary.white
        : theme.colors.primary2.cambridgeBlue;
};
var getBackgroundColorNormal = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    return disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.vividTangelo
            : theme.colors.primary2.myrtleGreen;
};
var getMenuBackgroundColor = function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled
        ? theme.colors.primary2.darkRichBlack
        : theme.colors.primary2.richBlack;
};
var getMenuItemBackgroundColor = function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? theme.colors.primary2.midnightGreen : theme.colors.secondary.white;
};
var getBackgroundColorHover = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    return disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.bigFootFeet
            : theme.colors.primary2.desaturatedCyan;
};
var getBoxShadowHover = function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.bigFootFeet
            : theme.colors.primary2.desaturatedCyan, disabled
        ? theme.colors.primary2.midnightGreen
        : checked
            ? theme.colors.primary1.bigFootFeet
            : theme.colors.primary2.desaturatedCyan, BORDER_WIDTH);
};
var getBoxParShadow = function (checked, disabled) {
    if (disabled) {
        if (checked) {
            return "\n    0 4px ".concat(lightColors.primary1.sepia, ",\n    -4px 0 ").concat(lightColors.primary1.sepia, ",\n    0 -4px ").concat(lightColors.primary1.sepia, "\n  ");
        }
        return "\n    0 4px ".concat(lightColors.primary2.richBlack, ",\n    4px 0 ").concat(lightColors.primary2.richBlack, ",\n    0 -4px ").concat(lightColors.primary2.richBlack, "\n  ");
    }
    if (!disabled) {
        if (checked) {
            return "\n    0 4px ".concat(lightColors.primary2.richBlack, ",\n    -4px 0 ").concat(lightColors.primary2.richBlack, ",\n    0 -4px ").concat(lightColors.primary2.richBlack, "\n  ");
        }
        return "\n    0 4px ".concat(lightColors.primary1.vividTangelo, ",\n    4px 0 ").concat(lightColors.primary1.vividTangelo, ",\n    0 -4px ").concat(lightColors.primary1.vividTangelo, "\n  ");
    }
};
var getLeft = function (_a) {
    var checked = _a.checked;
    return checked ? '50%' : '0';
};

var ToggleVariants = styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  text-transform: uppercase;\n  color: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: 'Roboto Mono', sans-serif !important;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  text-transform: uppercase;\n  color: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: 'Roboto Mono', sans-serif !important;\n"])), getColor, FONT_SIZE, LINE_HEIGHT);
var ToggleMenuItem = styled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  width: 4px;\n  height: 20px;\n  background-color: ", ";\n"], ["\n  width: 4px;\n  height: 20px;\n  background-color: ", ";\n"])), getMenuItemBackgroundColor);
var ToggleMenu = styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50%;\n  gap: ", ";\n  height: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  position: absolute;\n  top: 0;\n  left: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50%;\n  gap: ", ";\n  height: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  position: absolute;\n  top: 0;\n  left: ", ";\n"])), GAP, getMenuBackgroundColor, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked
        ? "\n    0 4px ".concat(theme.colors.primary2.richBlack, ",\n    4px 0 ").concat(theme.colors.primary2.richBlack, ",\n    0 -4px ").concat(theme.colors.primary2.richBlack, "\n  ")
        : "\n    0 4px ".concat(theme.colors.primary2.richBlack, ",\n    -4px 0 ").concat(theme.colors.primary2.richBlack, ",\n    0 -4px ").concat(theme.colors.primary2.richBlack, "\n  ");
}, getLeft);
var ToggleWrapper = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: ", ";\n  height: ", ";\n  cursor: ", ";\n  position: relative;\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: ", ";\n  height: ", ";\n  cursor: ", ";\n  position: relative;\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), getBoxShadow$3, getBackgroundColorNormal, getColor, WIDTH, HEIGHT, getCursor, getBackgroundColorHover, getBoxShadowHover);
var Toggle = function (props) {
    var _a, _b;
    var _c = useState((_a = props.checked) !== null && _a !== void 0 ? _a : false), checked = _c[0], setChecked = _c[1];
    var variants = (_b = props.variants) !== null && _b !== void 0 ? _b : ['on', 'off'];
    var onToggleClick = function () {
        if (!props.disabled) {
            setChecked(function (prev) { return !prev; });
            if (props.onToggle) {
                props.onToggle(!checked);
            }
        }
    };
    return (React__default.createElement(ToggleWrapper, { checked: checked, disabled: props.disabled, onClick: onToggleClick },
        React__default.createElement(ToggleVariants, { checked: checked, disabled: props.disabled }, variants.map(function (v, i) { return (React__default.createElement("div", { key: i }, v)); })),
        React__default.createElement(ToggleMenu, { checked: checked, disabled: props.disabled },
            React__default.createElement(ToggleMenuItem, { disabled: props.disabled }),
            React__default.createElement(ToggleMenuItem, { disabled: props.disabled }),
            React__default.createElement(ToggleMenuItem, { disabled: props.disabled }))));
};
var ToggleParams = function (props) {
    var _a, _b;
    var _c = useState((_a = props.checked) !== null && _a !== void 0 ? _a : false), checked = _c[0], setChecked = _c[1];
    var variants = (_b = props.variants) !== null && _b !== void 0 ? _b : ['on', 'off'];
    var onToggleClick = function () {
        if (!props.disabled) {
            setChecked(function (prev) { return !prev; });
            if (props.onToggle) {
                props.onToggle(!checked);
            }
        }
    };
    return (React__default.createElement(ToggleWrapper, { checked: checked, disabled: props.disabled, onClick: onToggleClick },
        React__default.createElement(ToggleVariants, { checked: checked, disabled: props.disabled, style: {
                textTransform: 'none',
                backgroundColor: props.disabled
                    ? lightColors.primary1.sepia
                    : lightColors.primary1.vividTangelo,
                boxShadow: getBoxParShadow(props.checked || false, props.disabled || false),
                color: props.disabled ? lightColors.typography.disable : '#ffffff',
            } }, variants.map(function (v, i) { return (React__default.createElement("div", { key: i }, v)); })),
        React__default.createElement(ToggleMenu, { checked: checked, disabled: props.disabled, style: { color: lightColors.primary2.cambridgeBlue } }, checked ? variants[1] : variants[0])));
};
var templateObject_1$B, templateObject_2$p, templateObject_3$l, templateObject_4$e;

var FixedPeriodCard = function (_a) {
    var autorenew = _a.autorenew, setAutorenew = _a.setAutorenew, optionIndex = _a.optionIndex, setOptionIndex = _a.setOptionIndex;
    var periods = [30, 60, 90];
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Flex, { justifyContent: "space-between", alignItems: "center" },
            React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, "Fixed Stake Period"),
            !isMobile && (React__default.createElement(FlexWithGap, { gap: "24px", alignItems: "center" },
                React__default.createElement(Tooltip, { tooltipValue: "Auto-renew" },
                    React__default.createElement(LargeText, { color: "primary2.cambridgeBlue" }, "Auto-renew")),
                React__default.createElement(Toggle, { checked: autorenew, onToggle: function (value) { return setAutorenew(value); } })))),
        React__default.createElement(LargeText, { color: "rgba(255, 255, 255, 0.8)", mb: "30px" }, "Choose your staking term."),
        React__default.createElement(FlexWithGap, { gap: "32px", pl: "8px" }, periods.map(function (v, i) { return (React__default.createElement(PeriodButton, { isActive: i === optionIndex, secondary: true, size: isMobile ? IconSize.L : IconSize.XL, px: isMobile ? '8px' : '12px', style: { whiteSpace: 'nowrap' }, key: i, onClick: function () { return setOptionIndex(i); } },
            v,
            " days")); })),
        isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(PeriodCardDivider, { mb: "16px", mt: "20px" }),
            React__default.createElement(FlexWithGap, { gap: "24px", alignItems: "center" },
                React__default.createElement(Tooltip, { tooltipValue: "Auto-renew" },
                    React__default.createElement(LargeText, { color: "primary2.cambridgeBlue" }, "Auto-renew")),
                React__default.createElement(Toggle, { checked: autorenew, onToggle: function (value) { return setAutorenew(value); } }))))));
};
var FlexiblePeriodCard = function (_a) {
    var confirmed = _a.confirmed, setConfirmed = _a.setConfirmed;
    var isMobile = useMatchBreakpoints();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, "Flexible Stake Period"),
        React__default.createElement(LargeText, { fontSize: isMobile ? '14px' : '16px', color: "rgba(255, 255, 255, 0.8)", mb: "30px" }, "By clicking the below box, you are confirming your choice of the flexible staking option. This means you will be able to unstake at any time but you will be subject to a 10-day cooldown period before you can claim your stake. At that point, there is a two (2) day window to unstake before you will have to activate your cooldown period again."),
        React__default.createElement(FlexWithGap, { gap: "24px", alignItems: "center", pl: "8px" },
            React__default.createElement(Checkbox, { checked: confirmed, onChange: function () { return setConfirmed(function (prev) { return !prev; }); } }),
            React__default.createElement(LargeText, { color: "rgba(255, 255, 255, 0.8)" }, "Confirm Selection"))));
};
var PeriodCard = function (_a) {
    var activeTab = _a.activeTab, setActiveTab = _a.setActiveTab, confirmed = _a.confirmed, setConfirmed = _a.setConfirmed, autorenew = _a.autorenew, setAutorenew = _a.setAutorenew, optionIndex = _a.optionIndex, setOptionIndex = _a.setOptionIndex, disabled = _a.disabled;
    var propsFixed = { autorenew: autorenew, setAutorenew: setAutorenew, optionIndex: optionIndex, setOptionIndex: setOptionIndex };
    var propsFlexible = { confirmed: confirmed, setConfirmed: setConfirmed };
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(FlexWithGap, { gap: "12px", mb: "4px", ml: "8px" },
            React__default.createElement(PeriodCardTab, { style: { opacity: !(activeTab === 0) ? '0.2' : '1' }, onClick: function () { return setActiveTab(0); } },
                React__default.createElement(Heading, { as: "h4", scale: "md", color: "secondary.white" }, "Fixed")),
            React__default.createElement(PeriodCardTab, { ml: "12px", style: { opacity: !(activeTab === 1) ? '0.2' : '1' }, onClick: function () { return setActiveTab(1); } },
                React__default.createElement(Heading, { as: "h4", scale: "md", color: "secondary.white" }, "Flexible"))),
        React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled, zIndex: 10, p: isMobile ? '16px 12px' : '' }, activeTab === 0 ? (React__default.createElement(FixedPeriodCard, __assign({}, propsFixed))) : (React__default.createElement(FlexiblePeriodCard, __assign({}, propsFlexible))))));
};

/**
 * react-number-format - 4.9.3
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2022 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop$2() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil$1(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties$1 (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop$2,
  onChange: noop$2,
  onKeyDown: noop$2,
  onMouseUp: noop$2,
  onFocus: noop$2,
  onBlur: noop$2,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil$1(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm,
          source: 'prop',
          event: null,
        });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(this.getNumberRegex(true)) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(this.getNumberRegex(true)) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil$1(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                               
                   
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var source = params.source;
    var event = params.event;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //calculate caret position if not defined
      if (caretPos === undefined && setCaretPosition) {
        var inputValue = params.inputValue || input.value;

        var currentCaretPosition = getCurrentCaretPosition(input);

        /**
         * set the value imperatively, this is required for IE fix
         * This is also required as if new caret position is beyond the previous value.
         * Caret position will not be set correctly
         */
        input.value = formattedValue;

        //get the caret position
        caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
      }

      /**
       * set the value imperatively, as we set the caret position as well imperatively.
       * This is to keep value and caret position in sync
       */
      input.value = formattedValue;

      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString), { event: event, source: source });
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el,
      event: e,
      source: 'event',
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
          event: e,
          source: 'event',
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
          event: e,
          source: 'event',
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    ref.thousandSeparator;
    ref.decimalSeparator;
    ref.allowedDecimalSeparators;
    ref.thousandsGroupStyle;
    ref.decimalScale;
    ref.fixedDecimalScale;
    ref.prefix;
    ref.suffix;
    ref.removeFormatting;
    ref.mask;
    ref.defaultValue;
    ref.isNumericString;
    ref.allowNegative;
    ref.allowEmptyFormatting;
    ref.allowLeadingZeros;
    ref.onValueChange;
    ref.isAllowed;
    ref.customNumerals;
    ref.onChange;
    ref.onKeyDown;
    ref.onMouseUp;
    ref.onFocus;
    ref.onBlur;
    ref.value;
    var rest = objectWithoutProperties$1( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React__default.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React__default.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React__default.Component));

NumberFormat.defaultProps = defaultProps;

var StyledInput$1 = styled(NumberFormat)(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  -webkit-appearance: none;\n  background-color: ", ";\n  border: 0;\n  box-shadow: ", ";\n  border-radius: 0;\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  display: block;\n  outline: 0;\n  padding: 0 12px;\n  font-size: 16px;\n  line-height: 24px;\n  height: 32px;\n  width: 200px;\n  font-family: ", ";\n  font-weight: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ", ";\n  }\n"], ["\n  -webkit-appearance: none;\n  background-color: ", ";\n  border: 0;\n  box-shadow: ", ";\n  border-radius: 0;\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  display: block;\n  outline: 0;\n  padding: 0 12px;\n  font-size: 16px;\n  line-height: 24px;\n  height: 32px;\n  width: 200px;\n  font-family: ", ";\n  font-weight: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme, isError = _a.isError;
    return createPixelInsetBorder$1(isError ? theme.colors.secondary.red : theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, 4);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily ? fontFamily : 'Share Tech Mono, sans-serif';
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return (fontWeight ? fontWeight : 400);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.placeholder;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.disable;
}, function (_a) {
    var theme = _a.theme, isError = _a.isError;
    return createPixelInsetBorder$1(isError ? theme.colors.secondary.red : theme.colors.secondary.green, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, 4);
});
var Input = function (_a) {
    var _b = _a.isError, isError = _b === void 0 ? false : _b, _c = _a.fontFamily, fontFamily = _c === void 0 ? 'Roboto Mono' : _c, _d = _a.fontWeight, fontWeight = _d === void 0 ? 500 : _d, props = __rest(_a, ["isError", "fontFamily", "fontWeight"]);
    return (React__default.createElement(StyledInput$1, __assign({ isError: isError, fontFamily: fontFamily, fontWeight: fontWeight, decimalScale: 4, fixedDecimalScale: true, allowNegative: false, thousandSeparator: true, isNumericString: true }, props)));
};
var templateObject_1$A;

var getPadding = function (hasIcon) {
    if (!hasIcon) {
        return '16px';
    }
    return '52px';
};

var StyledInputGroup = styled(Box)(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  ", " {\n    padding-left: ", ";\n    padding-right: ", ";\n    min-width: ", ";\n    height: 40px;\n  }\n"], ["\n  ", " {\n    padding-left: ", ";\n    padding-right: ", ";\n    min-width: ", ";\n    height: 40px;\n  }\n"])), StyledInput$1, function (_a) {
    var hasStartIcon = _a.hasStartIcon;
    return getPadding(hasStartIcon);
}, function (_a) {
    var hasUnits = _a.hasUnits;
    return (hasUnits ? '48px' : '12px');
}, function (_a) {
    var minWidth = _a.minWidth;
    return (minWidth ? minWidth : '');
});
var InputIcon = styled.div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 12px;\n"], ["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 12px;\n"])));
var InputUnits = styled(Text)(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var InputGroup = function (_a) {
    var startIcon = _a.startIcon, units = _a.units, children = _a.children, minWidth = _a.minWidth, props = __rest(_a, ["startIcon", "units", "children", "minWidth"]);
    return (React__default.createElement(StyledInputGroup, __assign({ minWidth: minWidth, width: "100%", position: "relative", hasStartIcon: !!startIcon, hasUnits: !!units }, props),
        startIcon && React__default.createElement(InputIcon, null, startIcon),
        units && React__default.createElement(InputUnits, null, units),
        cloneElement(children)));
};
var templateObject_1$z, templateObject_2$o, templateObject_3$k;

var InputErrorWrapper = function (_a) {
    var errorText = _a.errorText, children = _a.children;
    return (React__default.createElement(Flex, { flexDirection: "column" },
        children,
        errorText && (React__default.createElement(MediumText, { color: "red", mt: 2 },
            "Error. ",
            errorText))));
};

// constants for align progress line width in percents
var PROGRESS_START_PERCENTS = 0.5;
var PROGRESS_MIDDLE_PERCENTS = 4;
var PROGRESS_END_PERCENTS = 2.5;

var calculateProgressWidth = function (value, max) {
    var progressPercentage = (value / max) * 100;
    if (progressPercentage <= 10) {
        return "".concat(progressPercentage + PROGRESS_START_PERCENTS, "%");
    }
    if (progressPercentage >= 90) {
        return "".concat(progressPercentage - PROGRESS_MIDDLE_PERCENTS, "%");
    }
    if (progressPercentage >= 60) {
        return "".concat(progressPercentage - PROGRESS_END_PERCENTS, "%");
    }
    return "".concat(progressPercentage, "%");
};

var getBaseThumbStyles = function (_a) {
    var icon = _a.icon, thumbColor = _a.thumbColor, disabled = _a.disabled;
    return "\n  -webkit-appearance: none;\n  filter: ".concat(disabled ? 'grayscale(100%)' : 'none', ";\n  background-image: url(").concat(icon, ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n  background-color: ").concat(thumbColor, ";\n  box-shadow: ").concat(createPixelInsetBorder$1(thumbColor, thumbColor, thumbColor, 4), ";\n  border: 0;\n  width: 32px;\n  height: 32px;\n  transform: translate(-2px, -10px);\n");
};
var PixelatedSlider = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  position: absolute;\n  left: 8px;\n  width: calc(100% - 8px);\n"], ["\n  position: absolute;\n  left: 8px;\n  width: calc(100% - 8px);\n"])));
var StyledInput = styled.input(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  cursor: pointer;\n  height: 32px;\n  position: relative;\n\n  ::-webkit-slider-thumb {\n    ", "\n  }\n\n  ::-moz-range-thumb {\n    ", "\n  }\n\n  ::-ms-thumb {\n    ", "\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  cursor: pointer;\n  height: 32px;\n  position: relative;\n\n  ::-webkit-slider-thumb {\n    ", "\n  }\n\n  ::-moz-range-thumb {\n    ", "\n  }\n\n  ::-ms-thumb {\n    ", "\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"])), getBaseThumbStyles, getBaseThumbStyles, getBaseThumbStyles);
var BarBackground = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  filter: ", ";\n  height: 16px;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  filter: ", ";\n  height: 16px;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.desaturatedCyan, theme.colors.primary2.midnightGreen, 4);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'grayscale(100%)' : 'none');
});
var BarProgress = styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  filter: ", ";\n  height: 16px;\n  position: absolute;\n  top: 0;\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  filter: ", ";\n  height: 16px;\n  position: absolute;\n  top: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.secondary.lightGreen, theme.colors.secondary.darkGreen, 4);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'grayscale(100%)' : 'none');
});
var templateObject_1$y, templateObject_2$n, templateObject_3$j, templateObject_4$d;

var Slider = function (_a) {
    var name = _a.name, min = _a.min, max = _a.max, value = _a.value, onValueChanged = _a.onValueChanged, _b = _a.disabled, disabled = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.thumbColor, thumbColor = _c === void 0 ? '#ffffff' : _c, _d = _a.step, step = _d === void 0 ? 0.0001 : _d, props = __rest(_a, ["name", "min", "max", "value", "onValueChanged", "disabled", "icon", "thumbColor", "step"]);
    var handleChange = function (_a) {
        var target = _a.target;
        onValueChanged(parseFloat(target.value));
    };
    var progressWidth = calculateProgressWidth(value, max);
    return (React__default.createElement(Box, __assign({ position: "relative", height: "48px" }, props),
        React__default.createElement(PixelatedSlider, null,
            React__default.createElement(BarBackground, { disabled: disabled }),
            React__default.createElement(BarProgress, { style: { width: progressWidth }, disabled: disabled }),
            React__default.createElement(StyledInput, { name: name, type: "range", step: step, min: min, max: max, value: value, onChange: handleChange, icon: icon, thumbColor: thumbColor, disabled: disabled }))));
};

var SliderCard = function (_a) {
    var value = _a.value, min = _a.min, max = _a.max, title = _a.title, subTitle = _a.subTitle, onChange = _a.onChange, tokenName = _a.tokenName, toUsd = _a.toUsd, icon = _a.icon, iconComponent = _a.iconComponent, disabled = _a.disabled;
    var isMobile = useMatchBreakpoints().isMobile;
    var handleChange = function (num) {
        onChange(num);
    };
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled, p: isMobile ? '16px 12px' : '' },
        React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, title),
        React__default.createElement(LargeText, { fontSize: isMobile ? '14px' : '16px', color: "primary2.cambridgeBlue", mb: "34px" }, subTitle),
        React__default.createElement(Slider, { name: "sliderBump", min: min, max: max, value: value, icon: icon, onValueChanged: handleChange, thumbColor: lightColors.primary2.cyprus }),
        React__default.createElement(Flex, { justifyContent: "space-between", alignItems: "start" },
            React__default.createElement(FlexWithGap, { gap: '28px', justifyContent: "space-between", flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'start' : 'center' },
                React__default.createElement(Box, { maxWidth: "240px", ml: "8px", mt: "5px" },
                    React__default.createElement(InputGroup, { startIcon: iconComponent, units: "BUMP" },
                        React__default.createElement(Input, { type: "text", value: value, placeholder: tokenName, isAllowed: function (e) { return (e.floatValue ? e.floatValue <= max : false); }, onValueChange: function (e) {
                                if (e.floatValue)
                                    handleChange(e.floatValue);
                            } }))),
                React__default.createElement(MediumText, { color: "primary2.cambridgeBlue" },
                    "Current value: $",
                    toUsd(value))),
            React__default.createElement(Box, { pt: "8px" },
                React__default.createElement(DepositButton, { secondary: true, selected: value === max, size: IconSize.L, onClick: function () { return handleChange(max); } }, "MAX")))));
};

var Cooldown = function (_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ConfirmationBoxFixed, __assign({ flexDirection: "column", position: "relative", mt: "20px", pt: "48px" }, props),
        icon ? (icon) : (React__default.createElement(FlexWithGap, { gap: "28px", alignItems: "center", position: "absolute", top: "-25%", left: "50%", style: { transform: 'translateX(-50%)' } },
            React__default.createElement(StakeLogo, null),
            React__default.createElement(Bump, { variant: IconSize.XL }))),
        React__default.createElement(FlexWithGap, { gap: "12px", flexDirection: "column" },
            React__default.createElement(LargeText, { color: "secondary.white", bold: true, fontFamily: "Share Tech Mono", fontSize: isMobile ? '18px' : '16px' }, "Activate Cooldown"),
            React__default.createElement(LargeText, { color: "secondary.white", fontSize: "16px" },
                React__default.createElement("b", null, "By activating the cooldown, you will have to wait for 10 days before unstaking. At that point you will have a further two (2) days to execute the unstake before your BUMP tokens are returned to the staking pool.")))));
};

var BalanceInfo$2 = function (_a) {
    var balance = _a.balance, units = _a.units, tokenName = _a.tokenName;
    return (React__default.createElement(DarkLabel, { maxWidth: "400px", mt: "35px" },
        React__default.createElement(FlexWithGap, { gap: "32px" },
            React__default.createElement(InfoArea, { title: "Units", value: units, subTitle: tokenName }),
            React__default.createElement(InfoArea, { title: "Value", value: balance, subTitle: "".concat(tokenName) }))));
};
var EarningUnitsCard = function (_a) {
    var units = _a.units, balance = _a.balance, options = _a.options;
    var _b = useState(options[0]), value = _b[0], setValue = _b[1];
    return (React__default.createElement(ConfirmationBox, { flexDirection: "column" },
        React__default.createElement(Select, { value: value, options: options, onValueChanged: setValue, withIcon: true }),
        React__default.createElement(BalanceInfo$2, { tokenName: value.key, units: units, balance: balance })));
};

var RiskTierCard = function (props) {
    var breakpoints = useMatchBreakpoints();
    return (React__default.createElement(React__default.Fragment, null,
        (breakpoints.isDesktop || breakpoints.isTablet) && (React__default.createElement(RiskTierCardDesktop, __assign({}, props))),
        breakpoints.isMobile && React__default.createElement(RiskTierCardMobile, __assign({}, props))));
};
var RiskTierCardMobile = function (_a) {
    var disabled = _a.disabled, onChange = _a.onChange, initialIndex = _a.initialIndex;
    var riskTiers = [1, 2, 3, 4, 5];
    var _b = useState(initialIndex), riskTierIndex = _b[0], setRiskTierIndex = _b[1];
    useEffect(function () { return onChange(riskTierIndex); }, [riskTierIndex]);
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled, padding: "24px 10px 24px 20px" },
        React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "20px", lineHeight: "28px", color: "secondary.white", mb: "8px" }, "Risk Tier"),
        React__default.createElement(MediumText, { fontFamily: "Roboto", color: "typography.earnDepositValue", mb: "30px" },
            "Choose your level of exposure to risk and profit.",
            React__default.createElement("br", null),
            "Higher numbers mean higher exposure.",
            React__default.createElement("br", null),
            "These levels are relative to other active Makers."),
        React__default.createElement(FlexWithGap, { gap: "28px", alignItems: "center", ml: "8px" }, riskTiers.map(function (v, i) { return (React__default.createElement(DepositButton, { key: i, selected: riskTierIndex === i, maxWidth: "32px", secondary: true, size: IconSize.L, onClick: function () { return setRiskTierIndex(i); } },
            "\u00A0",
            v,
            "\u00A0")); }))));
};
var RiskTierCardDesktop = function (_a) {
    var disabled = _a.disabled, onChange = _a.onChange, initialIndex = _a.initialIndex;
    var riskTiers = [1, 2, 3, 4, 5];
    var _b = useState(initialIndex), riskTierIndex = _b[0], setRiskTierIndex = _b[1];
    useEffect(function () { return onChange(riskTierIndex); }, [riskTierIndex]);
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled, p: "24px 32px" },
        React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, "Risk Tier"),
        React__default.createElement(LargeText, { color: "typography.earnDepositValue", mb: "30px" }, "Choose your level of exposure to risk and profit. Higher numbers mean higher exposure. These levels are relative to other active Makers."),
        React__default.createElement(FlexWithGap, { gap: "32px", alignItems: "center", ml: "8px" }, riskTiers.map(function (v, i) { return (React__default.createElement(DepositButton, { secondary: true, selected: riskTierIndex === i, size: IconSize.XL, key: i, onClick: function () { return setRiskTierIndex(i); }, padding: '6px 12px' },
            "\u00A0",
            v,
            "\u00A0")); }))));
};

var Link = styled(function (_a) {
    var href = _a.href, target = _a.target, children = _a.children, props = __rest(_a, ["href", "target", "children"]);
    return (React__default.createElement(Text, __assign({}, props),
        React__default.createElement("a", { href: href, target: target }, children)));
}).attrs({
    size: 'lg',
})(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-block;\n  & a:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n  & a:visited {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  display: inline-block;\n  & a:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n  & a:visited {\n    color: ", ";\n  }\n"])), getColor$1, getColor$1);
Link.defaultProps = {
    color: 'white',
};
var templateObject_1$x;

var ConfirmWithdrawCard = function (props) {
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(Box, { width: "576px" },
        React__default.createElement(Flex, { justifyContent: "center" },
            React__default.createElement(Heading, { as: "h1", scale: "xxl", color: "secondary.white" }, "Confirmation")),
        React__default.createElement(Flex, { marginTop: "24px" },
            React__default.createElement(ConfirmCard, { iconComponent: props.iconComponent, amount: props.stableAmount, subTitle: props.stableSymbol },
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between", mb: "20px" },
                    React__default.createElement(MediumText, { bold: true, color: "secondary.white" }, "Withdrawal Amount:"),
                    React__default.createElement(Flex, { alignItems: "center" },
                        React__default.createElement(MediumText, { color: "secondary.white", mr: "2px" }, "$".concat(props.withdrawAmount)),
                        React__default.createElement(SmallText, { color: "secondary.white" }, props.stableSymbol))),
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between", mb: "20px" },
                    React__default.createElement(MediumText, { bold: true, color: "secondary.white" }, "Yield (estimated):"),
                    React__default.createElement(Flex, { alignItems: "center" },
                        React__default.createElement(MediumText, { color: "secondary.white", mr: "2px" }, "$".concat(props.yieldAmount)),
                        React__default.createElement(SmallText, { color: "secondary.white" }, props.stableSymbol))),
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between", mb: "28px" },
                    React__default.createElement(MediumText, { bold: true, color: "secondary.white" }, "Bond Return:"),
                    React__default.createElement(Flex, { flexDirection: "column", alignItems: "flex-end" },
                        React__default.createElement(MediumText, { color: "secondary.white" }, "$".concat(props.bondInUsdAmount)),
                        React__default.createElement(Tooltip, { tooltipValue: "", reverse: true },
                            React__default.createElement(SmallText, { color: "secondary.white", mr: "2px" }, "(Est. ".concat(props.bondAmount, " BUMP)"))))),
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    React__default.createElement(MediumText, { bold: true, color: "secondary.white" }, "BUMP Incentives:"),
                    React__default.createElement(MediumText, { color: "secondary.white" }, "".concat(props.bumpIncentiveAmount, " BUMP"))),
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    React__default.createElement(SmallText, { color: "secondary.white" }, "Boost:"),
                    React__default.createElement(Flex, null,
                        React__default.createElement(SmallText, { color: "secondary.green", mr: "2px" }, props.networkAmount),
                        React__default.createElement(SmallText, { color: "secondary.white" }, 'BUMP'))),
                React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between" },
                    React__default.createElement(SmallText, { color: "secondary.white" }, "Network:"),
                    React__default.createElement(Flex, null,
                        React__default.createElement(SmallText, { color: "secondary.green", mr: "2px" }, props.boostAmount),
                        React__default.createElement(SmallText, { color: "secondary.white" }, 'BUMP'))))),
        React__default.createElement(Flex, { alignItems: "center", mb: "20px", mt: "20px" },
            React__default.createElement(Checkbox, { onClick: function () { return setIsActive(!isActive); } }),
            React__default.createElement(MediumText, { bold: true, color: "secondary.white", ml: "20px" },
                "By checking this box you acknowledge and agree to our",
                React__default.createElement("br", null),
                React__default.createElement(Link, { color: "secondary.green", href: props.linkPath }, "terms and conditions"),
                ".")),
        React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between", mb: "20px", mt: "20px" },
            React__default.createElement(Button$2, { secondary: true, size: isMobile ? IconSize.L : IconSize.L }, "Back"),
            React__default.createElement(Button$2, { primary: true, size: isMobile ? IconSize.L : IconSize.L, disabled: !isActive }, "Confirm"))));
};

var BOX_SHADOW_WIDTH$2 = 4;
var DOUBLE_BOX_SHADOW_WIDTH = BOX_SHADOW_WIDTH$2 * 2;
var CARD_WIDTH = 1100;

styled(Box)(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  width: ", "px;\n  box-shadow: ", ";\n"], ["\n  width: ", "px;\n  box-shadow: ", ";\n"])), CARD_WIDTH, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkSlateGray, theme.colors.primary2.darkGreen, BOX_SHADOW_WIDTH$2);
});
styled(Box)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", "px 0\n      ", ",\n    0 ", "px ", ";\n  padding: 12px 10%;\n  position: relative;\n  z-index: 2;\n"], ["\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", "px 0\n      ", ",\n    0 ", "px ", ";\n  padding: 12px 10%;\n  position: relative;\n  z-index: 2;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
styled(Box)(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8%;\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8%;\n"])));
styled(Flex)(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
});
var SideLedge = styled(Box)(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: ", "px;\n  height: 40px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: ", "px;\n  height: 40px;\n  background-color: ", ";\n"])), BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
});
styled(SideLedge)(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  left: -", "px;\n  box-shadow: -", "px 0 ", ",\n    -", "px 0 ", ";\n"], ["\n  left: -", "px;\n  box-shadow: -", "px 0 ", ",\n    -", "px 0 ", ";\n"])), BOX_SHADOW_WIDTH$2, DOUBLE_BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
styled(SideLedge)(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  right: -", "px;\n  box-shadow: ", "px 0\n      ", ",\n    ", "px 0 ", ";\n"], ["\n  right: -", "px;\n  box-shadow: ", "px 0\n      ", ",\n    ", "px 0 ", ";\n"])), BOX_SHADOW_WIDTH$2, DOUBLE_BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
});
styled(Flex)(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  align-items: start;\n  position: absolute;\n  top: calc(100% - 14px);\n  left: 50%;\n  transform: translateX(-50%);\n  height: 42px;\n"], ["\n  align-items: start;\n  position: absolute;\n  top: calc(100% - 14px);\n  left: 50%;\n  transform: translateX(-50%);\n  height: 42px;\n"])));
styled(Box)(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  height: 100%;\n  width: 49px;\n  background-image: url(", ");\n  background-position: center center;\n  background-repeat: no-repeat;\n"], ["\n  height: 100%;\n  width: 49px;\n  background-image: url(", ");\n  background-position: center center;\n  background-repeat: no-repeat;\n"])), function (_a) {
    var icon = _a.icon;
    return icon;
});
styled(Box)(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  height: calc(100% - ", "px);\n  width: 884px;\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n"], ["\n  height: calc(100% - ", "px);\n  width: 884px;\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n"])), DOUBLE_BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
}, DOUBLE_BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var templateObject_1$w, templateObject_2$m, templateObject_3$i, templateObject_4$c, templateObject_5$9, templateObject_6$9, templateObject_7$5, templateObject_8$5, templateObject_9$3, templateObject_10$3;

var leftCorner = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAqCAYAAAAajbNEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7SURBVHgB7dgxCoAwEETRidiIIFbiJay8/33EXiy1TgTr2eW/MqT5sFskEgAAyRVt+6PgOiVAhIsUEb3u6//GMMod4+QiyU6cR32yrIqGcXJBhAsiXBDhgggXRLggwkWKiPI5meb6My3A+4JxcpF0J1rtjhhinFykiHgBmKYIC3GhGnYAAAAASUVORK5CYII=";

var rightCorner = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAqCAYAAAAajbNEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7SURBVHgB7dgxCoAwEETRiViLF7Hy/vcRKxHEUlvdQstMlv+6kOrDpthIAAAkVzTNlxrXKQEiXKSI6NWC8/i8Zpxc8CaqWZfXkXFyQYQLIlwQ4YIIF0S4IMJFkn3iZ3+1EPYH7Vt5HhknFykiiobR/0M5vIGIcXKRIuIGKNYOBXDUIewAAAAASUVORK5CYII=";

var StyledHorizontalLine = styled(Box)(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  width: 100%;\n  height: 0;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n"], ["\n  width: 100%;\n  height: 0;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n"])), BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenCyprus;
}, BOX_SHADOW_WIDTH$2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
});
var StyledRadiator = styled(Flex)(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  width: 100%;\n  flex-direction: column;\n  gap: 4px;\n"])));
var Radiator = function () {
    return (React__default.createElement(StyledRadiator, null,
        React__default.createElement(StyledHorizontalLine, null),
        React__default.createElement(StyledHorizontalLine, null),
        React__default.createElement(StyledHorizontalLine, null),
        React__default.createElement(StyledHorizontalLine, null)));
};
var templateObject_1$v, templateObject_2$l;

var ResponsiveContentWrapper = styled(Flex)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n  ", " {\n    flex-direction: column;\n    gap: 32px;\n    padding: 10px 0;\n  }\n"], ["\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n  ", " {\n    flex-direction: column;\n    gap: 32px;\n    padding: 10px 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var templateObject_1$u;

var getFormattedPercents = function (percents) {
    if (percents >= 0)
        return "+".concat(percents.toFixed(2));
    return "".concat(percents.toFixed(2));
};
var isZero = function (amount) {
    return parseFloat(amount) === 0 || amount === '';
};
var getFormattedAmountWithSymbol = function (amount, symbol, color) {
    if (parseFloat(amount) > 0)
        return (React__default.createElement(FlexWithGap, { gap: "4px", alignItems: "baseline" },
            React__default.createElement(LargeText, { fontWeight: 500, color: color !== null && color !== void 0 ? color : lightColors.typography.input }, amount),
            React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue, fontWeight: 500 }, symbol)));
    return (React__default.createElement(LargeText, { fontWeight: 500, color: lightColors.typography.input }, "-"));
};
var getPercentsColor = function (percents) {
    if (percents >= 0)
        return lightColors.secondary.green;
    return lightColors.secondary.red;
};

styled(Flex)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  align-items: center;\n  width: 100%;\n  gap: 24px;\n"], ["\n  align-items: center;\n  width: 100%;\n  gap: 24px;\n"])));
var TokenInfoContainer = styled(Flex)(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  align-items: center;\n  gap: 16px;\n  ", " {\n    flex-direction: column;\n  }\n"], ["\n  align-items: center;\n  gap: 16px;\n  ", " {\n    flex-direction: column;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var TokenIcon = styled(Box)(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  background-color: ", ";\n  background-image: url(", ");\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n\n  box-shadow: ", ";\n"], ["\n  width: 32px;\n  height: 32px;\n  background-color: ", ";\n  background-image: url(", ");\n  background-position: center center;\n  background-size: contain;\n  background-repeat: no-repeat;\n\n  box-shadow: ", ";\n"])), function (_a) {
    var iconBackgroundColor = _a.iconBackgroundColor;
    return iconBackgroundColor;
}, function (_a) {
    var icon = _a.icon;
    return icon;
}, function (_a) {
    var iconBackgroundColor = _a.iconBackgroundColor;
    return createPixelInsetBorder$1(iconBackgroundColor, iconBackgroundColor, iconBackgroundColor, BOX_SHADOW_WIDTH$2);
});
var ButtonsContainer = styled(Flex)(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  align-items: center;\n  padding: 8px;\n  gap: 34px;\n"], ["\n  align-items: center;\n  padding: 8px;\n  gap: 34px;\n"])));
styled(Flex)(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n"], ["\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n"])));
var InfoBoxContent = styled(Flex)(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: start;\n  gap: 4px;\n"], ["\n  flex-direction: column;\n  align-items: start;\n  gap: 4px;\n"])));
var templateObject_1$t, templateObject_2$k, templateObject_3$h, templateObject_4$b, templateObject_5$8, templateObject_6$8;

var ResponsiveHeaderWrapper = styled(Flex)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n  ", " {\n    flex-direction: column;\n    gap: 32px;\n    padding: 10px 10px;\n  }\n"], ["\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  gap: 40px;\n  ", " {\n    flex-direction: column;\n    gap: 32px;\n    padding: 10px 10px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var ProtectCardHeader = function (_a) {
    var tokenIcon = _a.tokenIcon, _b = _a.iconBackgroundColor, iconBackgroundColor = _b === void 0 ? lightColors.secondary.white : _b, tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol, tokenPrice = _a.tokenPrice, onProtect = _a.onProtect, onView = _a.onView;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ResponsiveHeaderWrapper, { justifyContent: "space-between" },
        React__default.createElement(TokenInfoContainer, null,
            React__default.createElement(TokenIcon, { icon: tokenIcon, iconBackgroundColor: iconBackgroundColor }),
            React__default.createElement(Flex, null,
                React__default.createElement(LargeText, { color: lightColors.typography.input, mr: "4px", style: { whiteSpace: 'nowrap' }, fontWeight: 500 }, tokenName),
                React__default.createElement(LargeText, { color: lightColors.typography.placeholder, style: { whiteSpace: 'nowrap' } },
                    "(",
                    tokenSymbol,
                    ")")),
            React__default.createElement(SmallText, { color: lightColors.typography.input, style: { whiteSpace: 'nowrap' } },
                "1 ",
                tokenSymbol,
                " = $",
                tokenPrice)),
        !isMobile && React__default.createElement(Radiator, null),
        React__default.createElement(ButtonsContainer, null,
            React__default.createElement(Button$2, { size: IconSize.L, primary: true, onClick: onProtect }, "Protect"),
            React__default.createElement(Button$2, { size: IconSize.L, secondary: true, onClick: onView }, "View"))));
};
var ProtectCardContent = function (_a) {
    var tokenSymbol = _a.tokenSymbol, positionsCount = _a.positionsCount, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, unprotectedAmount = _a.unprotectedAmount, unprotectedAmountInUsd = _a.unprotectedAmountInUsd, protectedAmount = _a.protectedAmount, protectedAmountInUsd = _a.protectedAmountInUsd, floor = _a.floor, floorPercents = _a.floorPercents;
    return (React__default.createElement(ResponsiveContentWrapper, null,
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Total"),
                getFormattedAmountWithSymbol(totalAmount, tokenSymbol),
                !isZero(totalAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    totalAmountInUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Average Floor"),
                React__default.createElement(LargeText, { fontWeight: 500, color: lightColors.typography.input },
                    "$",
                    floor),
                React__default.createElement(SmallText, { color: getPercentsColor(floorPercents) },
                    getFormattedPercents(floorPercents),
                    "% (24h)"))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(FlexWithGap, { gap: "4px" },
                    React__default.createElement(Tooltip, { tooltipValue: "Unprotected", place: "bottom" },
                        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Unprotected"))),
                getFormattedAmountWithSymbol(unprotectedAmount, tokenSymbol, lightColors.secondary.red),
                !isZero(unprotectedAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    unprotectedAmountInUsd,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(FlexWithGap, { gap: "4px" },
                    React__default.createElement(Tooltip, { tooltipValue: "Protected", place: "bottom" },
                        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Protected"))),
                getFormattedAmountWithSymbol(protectedAmount, tokenSymbol, lightColors.secondary.green),
                !isZero(protectedAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    protectedAmountInUsd,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue, style: { whiteSpace: 'pre-wrap' } }, "Positions"),
                React__default.createElement(LargeText, { fontWeight: 500, color: lightColors.typography.input }, positionsCount)))));
};
var ProtectCard = function (_a) {
    var tokenIcon = _a.tokenIcon, tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol, tokenPrice = _a.tokenPrice, iconBackgroundColor = _a.iconBackgroundColor, positionsCount = _a.positionsCount, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, unprotectedAmount = _a.unprotectedAmount, unprotectedAmountInUsd = _a.unprotectedAmountInUsd, protectedAmount = _a.protectedAmount, protectedAmountInUsd = _a.protectedAmountInUsd, floor = _a.floor, floorPercents = _a.floorPercents, onProtect = _a.onProtect, onView = _a.onView, props = __rest(_a, ["tokenIcon", "tokenName", "tokenSymbol", "tokenPrice", "iconBackgroundColor", "positionsCount", "totalAmount", "totalAmountInUSD", "unprotectedAmount", "unprotectedAmountInUsd", "protectedAmount", "protectedAmountInUsd", "floor", "floorPercents", "onProtect", "onView"]);
    var headerProps = {
        tokenIcon: tokenIcon,
        tokenSymbol: tokenSymbol,
        tokenName: tokenName,
        tokenPrice: tokenPrice,
        iconBackgroundColor: iconBackgroundColor,
        onProtect: onProtect,
        onView: onView,
    };
    var contentProps = {
        tokenSymbol: tokenSymbol,
        positionsCount: positionsCount,
        totalAmount: totalAmount,
        totalAmountInUSD: totalAmountInUSD,
        unprotectedAmount: unprotectedAmount,
        unprotectedAmountInUsd: unprotectedAmountInUsd,
        protectedAmount: protectedAmount,
        protectedAmountInUsd: protectedAmountInUsd,
        floor: floor,
        floorPercents: floorPercents,
    };
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(Card, __assign({ bottomLeftCorner: leftCorner, bottomRightCorner: rightCorner, bottomLedgeHeight: "38px", bottomLedgeCenterWidth: isMobile ? '180px' : '900px', radiatorWidth: isMobile ? '36px' : '90px', mt: "4rem", mb: "3rem", header: React__default.createElement(ProtectCardHeader, __assign({}, headerProps)), content: React__default.createElement(ProtectCardContent, __assign({}, contentProps)) }, props)));
};
var templateObject_1$s;

var EarnCardHeader = function (_a) {
    var tokenIcon = _a.tokenIcon, tokenSymbol = _a.tokenSymbol, tokenName = _a.tokenName, tokenPrice = _a.tokenPrice, _b = _a.iconBackgroundColor, iconBackgroundColor = _b === void 0 ? lightColors.secondary.white : _b, onEarn = _a.onEarn, onView = _a.onView;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ResponsiveHeaderWrapper, { justifyContent: "space-between" },
        React__default.createElement(TokenInfoContainer, null,
            React__default.createElement(TokenIcon, { icon: tokenIcon, iconBackgroundColor: iconBackgroundColor }),
            React__default.createElement(Flex, null,
                React__default.createElement(LargeText, { color: lightColors.typography.input, mr: "4px", style: { whiteSpace: 'nowrap' }, fontWeight: 500 }, tokenName),
                React__default.createElement(LargeText, { color: lightColors.typography.placeholder, style: { whiteSpace: 'nowrap' } },
                    "(",
                    tokenSymbol,
                    ")")),
            React__default.createElement(SmallText, { color: lightColors.typography.input, style: { whiteSpace: 'nowrap' } },
                "1 ",
                tokenSymbol,
                " = $",
                tokenPrice)),
        !isMobile && React__default.createElement(Radiator, null),
        React__default.createElement(ButtonsContainer, null,
            React__default.createElement(Button$2, { size: IconSize.L, primary: true, onClick: onEarn }, "Earn"),
            React__default.createElement(Button$2, { size: IconSize.L, secondary: true, onClick: onView }, "View"))));
};
var EarnCardContent = function (_a) {
    var tokenSymbol = _a.tokenSymbol, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, idleAmount = _a.idleAmount, idleAmountInUsd = _a.idleAmountInUsd, earningAmount = _a.earningAmount, earningAmountInUsd = _a.earningAmountInUsd, risk = _a.risk, riskPercents = _a.riskPercents, totalYield = _a.totalYield, totalYieldInUSD = _a.totalYieldInUSD;
    return (React__default.createElement(ResponsiveContentWrapper, null,
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Total"),
                getFormattedAmountWithSymbol(totalAmount, tokenSymbol),
                !isZero(totalAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    totalAmountInUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(FlexWithGap, { gap: "2px" },
                    React__default.createElement(Tooltip, { tooltipValue: "Average Risk", place: "bottom" },
                        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Average Risk"))),
                React__default.createElement(LargeText, { fontWeight: 500, color: lightColors.typography.input }, risk),
                React__default.createElement(SmallText, { color: getPercentsColor(riskPercents) },
                    getFormattedPercents(riskPercents),
                    "% (24h)"))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(FlexWithGap, { gap: "2px" },
                    React__default.createElement(Tooltip, { tooltipValue: "Idle", place: "bottom" },
                        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Idle"))),
                getFormattedAmountWithSymbol(idleAmount, tokenSymbol, lightColors.secondary.red),
                !isZero(idleAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    idleAmountInUsd,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(FlexWithGap, { gap: "2px" },
                    React__default.createElement(Tooltip, { tooltipValue: "Earning", place: "bottom" },
                        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Earning"))),
                getFormattedAmountWithSymbol(earningAmount, tokenSymbol, lightColors.primary1.vividTangelo),
                !isZero(earningAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    earningAmountInUsd,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Total Yield"),
                getFormattedAmountWithSymbol(totalYield, tokenSymbol),
                !isZero(totalYield) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    totalYieldInUSD,
                    ")"))))));
};
var EarnCard = function (_a) {
    var tokenIcon = _a.tokenIcon, tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol, tokenPrice = _a.tokenPrice, iconBackgroundColor = _a.iconBackgroundColor, totalYield = _a.totalYield, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, idleAmount = _a.idleAmount, idleAmountInUsd = _a.idleAmountInUsd, earningAmount = _a.earningAmount, earningAmountInUsd = _a.earningAmountInUsd, risk = _a.risk, riskPercents = _a.riskPercents, onEarn = _a.onEarn, onView = _a.onView, totalYieldInUSD = _a.totalYieldInUSD, props = __rest(_a, ["tokenIcon", "tokenName", "tokenSymbol", "tokenPrice", "iconBackgroundColor", "totalYield", "totalAmount", "totalAmountInUSD", "idleAmount", "idleAmountInUsd", "earningAmount", "earningAmountInUsd", "risk", "riskPercents", "onEarn", "onView", "totalYieldInUSD"]);
    var headerProps = {
        tokenIcon: tokenIcon,
        tokenSymbol: tokenSymbol,
        tokenName: tokenName,
        tokenPrice: tokenPrice,
        iconBackgroundColor: iconBackgroundColor,
        onEarn: onEarn,
        onView: onView,
    };
    var contentProps = {
        tokenSymbol: tokenSymbol,
        totalAmount: totalAmount,
        totalAmountInUSD: totalAmountInUSD,
        idleAmount: idleAmount,
        idleAmountInUsd: idleAmountInUsd,
        earningAmount: earningAmount,
        earningAmountInUsd: earningAmountInUsd,
        risk: risk,
        riskPercents: riskPercents,
        totalYield: totalYield,
        totalYieldInUSD: totalYieldInUSD,
    };
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(Card, __assign({ bottomLeftCorner: leftCorner, bottomRightCorner: rightCorner, bottomLedgeHeight: "38px", bottomLedgeCenterWidth: isMobile ? '180px' : '900px', radiatorWidth: isMobile ? '36px' : '90px', mt: "4rem", mb: "3rem", header: React__default.createElement(EarnCardHeader, __assign({}, headerProps)), content: React__default.createElement(EarnCardContent, __assign({}, contentProps)) }, props)));
};

var StakeCardHeader = function (_a) {
    var tokenIcon = _a.tokenIcon, _b = _a.iconBackgroundColor, iconBackgroundColor = _b === void 0 ? lightColors.secondary.white : _b, tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol, tokenPrice = _a.tokenPrice, onStake = _a.onStake, onView = _a.onView;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ResponsiveHeaderWrapper, { justifyContent: "space-between" },
        React__default.createElement(TokenInfoContainer, null,
            React__default.createElement(TokenIcon, { icon: tokenIcon, iconBackgroundColor: iconBackgroundColor }),
            React__default.createElement(Flex, null,
                React__default.createElement(LargeText, { color: lightColors.typography.input, mr: "4px", style: { whiteSpace: 'nowrap' }, fontWeight: 500 }, tokenName),
                React__default.createElement(LargeText, { color: lightColors.typography.placeholder, style: { whiteSpace: 'nowrap' } },
                    "(",
                    tokenSymbol,
                    ")")),
            React__default.createElement(SmallText, { color: lightColors.typography.input, style: { whiteSpace: 'nowrap' } },
                "1 ",
                tokenSymbol,
                " = $",
                tokenPrice)),
        !isMobile && React__default.createElement(Radiator, null),
        React__default.createElement(ButtonsContainer, null,
            React__default.createElement(Button$2, { size: IconSize.L, primary: true, onClick: onStake }, "Stake"),
            React__default.createElement(Button$2, { size: IconSize.L, secondary: true, onClick: onView }, "View"))));
};
var StakeCardContent = function (_a) {
    var tokenSymbol = _a.tokenSymbol, positionsCount = _a.positionsCount, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, idleAmount = _a.idleAmount, idleAmountUSD = _a.idleAmountUSD, stakedAmount = _a.stakedAmount, stakedAmountUSD = _a.stakedAmountUSD, rewardsAmount = _a.rewardsAmount, rewardsAmountUSD = _a.rewardsAmountUSD;
    return (React__default.createElement(ResponsiveContentWrapper, null,
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Total"),
                getFormattedAmountWithSymbol(totalAmount, tokenSymbol),
                !isZero(totalAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    totalAmountInUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Idle"),
                getFormattedAmountWithSymbol(idleAmount, tokenSymbol, lightColors.secondary.red),
                !isZero(idleAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    idleAmountUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Staked"),
                getFormattedAmountWithSymbol(stakedAmount, tokenSymbol),
                !isZero(stakedAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    stakedAmountUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, "Total Rewards"),
                getFormattedAmountWithSymbol(rewardsAmount, tokenSymbol),
                !isZero(rewardsAmount) && (React__default.createElement(SmallText, { color: lightColors.primary2.cambridgeBlue },
                    "($",
                    rewardsAmountUSD,
                    ")")))),
        React__default.createElement(DarkInfoBox, { minWidth: "150px", borderColor: "primary2.darkGreen", minHeight: "85px", height: "88px" },
            React__default.createElement(InfoBoxContent, null,
                React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue, style: { whiteSpace: 'pre-wrap' } }, "Positions"),
                React__default.createElement(LargeText, { fontWeight: 500, color: lightColors.typography.input }, positionsCount)))));
};
var StakeCard = function (_a) {
    var tokenIcon = _a.tokenIcon, tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol, tokenPrice = _a.tokenPrice, iconBackgroundColor = _a.iconBackgroundColor, positionsCount = _a.positionsCount, totalAmount = _a.totalAmount, totalAmountInUSD = _a.totalAmountInUSD, stakedAmount = _a.stakedAmount, stakedAmountUSD = _a.stakedAmountUSD, idleAmount = _a.idleAmount, idleAmountUSD = _a.idleAmountUSD, rewardsAmount = _a.rewardsAmount, rewardsAmountUSD = _a.rewardsAmountUSD, onStake = _a.onStake, onView = _a.onView, props = __rest(_a, ["tokenIcon", "tokenName", "tokenSymbol", "tokenPrice", "iconBackgroundColor", "positionsCount", "totalAmount", "totalAmountInUSD", "stakedAmount", "stakedAmountUSD", "idleAmount", "idleAmountUSD", "rewardsAmount", "rewardsAmountUSD", "onStake", "onView"]);
    var headerProps = {
        tokenIcon: tokenIcon,
        tokenSymbol: tokenSymbol,
        tokenName: tokenName,
        tokenPrice: tokenPrice,
        iconBackgroundColor: iconBackgroundColor,
        onStake: onStake,
        onView: onView,
    };
    var contentProps = {
        tokenSymbol: tokenSymbol,
        positionsCount: positionsCount,
        totalAmount: totalAmount,
        totalAmountInUSD: totalAmountInUSD,
        stakedAmount: stakedAmount,
        stakedAmountUSD: stakedAmountUSD,
        idleAmount: idleAmount,
        idleAmountUSD: idleAmountUSD,
        rewardsAmount: rewardsAmount,
        rewardsAmountUSD: rewardsAmountUSD,
    };
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(Card, __assign({ bottomLeftCorner: leftCorner, bottomRightCorner: rightCorner, bottomLedgeHeight: "38px", bottomLedgeCenterWidth: isMobile ? '180px' : '900px', radiatorWidth: isMobile ? '36px' : '90px', mt: "4rem", mb: "3rem", header: React__default.createElement(StakeCardHeader, __assign({}, headerProps)), content: React__default.createElement(StakeCardContent, __assign({}, contentProps)) }, props)));
};

var OperationsEnum;
(function (OperationsEnum) {
    OperationsEnum["Staking"] = "Staking";
    OperationsEnum["Vesting"] = "Vesting";
    OperationsEnum["Epoch"] = "Epoch";
    OperationsEnum["Protection"] = "Protection";
    OperationsEnum["Earning"] = "Earning";
})(OperationsEnum || (OperationsEnum = {}));

var getOperationColor = function (operation, theme) {
    switch (operation) {
        case OperationsEnum.Staking:
            return theme.colors.primary1.vividTangelo;
        case OperationsEnum.Vesting:
            return theme.colors.secondary.blue;
        case OperationsEnum.Protection:
            return theme.colors.secondary.green;
        case OperationsEnum.Earning:
            return theme.colors.secondary.turquoise;
        case OperationsEnum.Epoch:
            return theme.colors.primary2.desaturatedCyan;
        default:
            return theme.colors.primary1.sepia;
    }
};
var comparisonForSorting = function (a, b) {
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    if (typeof a === 'string' && typeof b === 'string') {
        return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
    }
    return 0;
};
var timeInMilliseconds = function (lockTimestamp) {
    var date = new Date(0);
    return date.setUTCSeconds(lockTimestamp);
};
function convertToCSVAndDownload(objArray) {
    var formatLine = function (line) { return Object.values(line).join(','); };
    var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    var str = Object.keys(array[0])
        .join(',')
        .concat('\r\n')
        .concat(array.map(formatLine).join('\r\n'));
    var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
    var dlink = document.createElement('a');
    dlink.download = 'transactions.csv';
    dlink.href = window.URL.createObjectURL(blob);
    dlink.onclick = function () {
        setTimeout(function () {
            window.URL.revokeObjectURL(dlink.href);
        }, 1500);
    };
    dlink.click();
    dlink.remove();
}
var formatDate = function (timestamp, isShort) {
    var months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    var date = new Date(timestamp);
    var hours = date.getUTCHours() + 1 > 12
        ? date.getUTCHours() + 1 - 12
        : date.getUTCHours() + 1;
    var ampm = date.getUTCHours() + 1 > 12 ? 'PM' : 'AM';
    if (isShort)
        return "".concat(date.getUTCDate(), "-").concat(date.getUTCMonth() + 1, "-").concat(date.getUTCFullYear());
    return "".concat(months[date.getUTCMonth()], "-").concat(date.getUTCDate(), "-").concat(date.getUTCFullYear(), " ").concat(hours, ":").concat(date.getUTCMinutes(), ":").concat(date.getUTCSeconds(), " ").concat(ampm, " +UTC");
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g$1=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g$1:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g$1;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g$1};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g$1||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign$1 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction$1() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction$1
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$5(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$8 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$c.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$8(value) && hasOwnProperty$a.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

var isBuffer$3 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$3, isBuffer$3.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$4(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$4 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$5] = typedArrayTags[numberTag$4] =
typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] =
typedArrayTags[setTag$5] = typedArrayTags[stringTag$4] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$3(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$3;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isBuffer$2 = isBuffer$3.exports,
    isIndex$3 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$9(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$2(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$3(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$a = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$a;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$2 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$4;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseGetTag$3 = _baseGetTag,
    isArray$8 = isArray_1,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$3 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$8(value) && isObjectLike$6(value) && baseGetTag$3(value) == stringTag$3);
}

var isString_1 = isString;

var isString$1 = isString_1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$7 = isObject_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$7(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$7(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$2;

var toNumber$1 = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$2(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$2;

var PLACEMENT_4 = ['top', 'bottom', 'right', 'left'];
var PLACEMENT_8 = ['bottomStart', 'bottomEnd', 'topStart', 'topEnd', 'leftStart', 'rightStart', 'leftEnd', 'rightEnd'];
var PLACEMENT_AUTO = ['auto', 'autoVertical', 'autoVerticalStart', 'autoVerticalEnd', 'autoHorizontal', 'autoHorizontalStart', 'autoHorizontalEnd'];
var PLACEMENT = [].concat(PLACEMENT_4, PLACEMENT_8, PLACEMENT_AUTO);
/**
 *  Check Tree Node State
 */

var CHECK_STATE;

(function (CHECK_STATE) {
  CHECK_STATE[CHECK_STATE["UNCHECK"] = 0] = "UNCHECK";
  CHECK_STATE[CHECK_STATE["CHECK"] = 1] = "CHECK";
  CHECK_STATE[CHECK_STATE["INDETERMINATE"] = 2] = "INDETERMINATE";
})(CHECK_STATE || (CHECK_STATE = {}));
/**
 * Tree Node Drag Type
 */

var TREE_NODE_DROP_POSITION;
/**
 * UI Events KeyboardEvent key Values
 * https://www.w3.org/TR/uievents-key
 */

(function (TREE_NODE_DROP_POSITION) {
  TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER"] = 0] = "DRAG_OVER";
  TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER_TOP"] = 1] = "DRAG_OVER_TOP";
  TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER_BOTTOM"] = 2] = "DRAG_OVER_BOTTOM";
})(TREE_NODE_DROP_POSITION || (TREE_NODE_DROP_POSITION = {}));

var KEY_VALUES = {
  // Navigation Keys
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  END: 'End',
  HOME: 'Home',
  PAGE_DOWN: 'PageDown',
  PAGE_UP: 'PageUp',
  // Whitespace Keys
  ENTER: 'Enter',
  TAB: 'Tab',
  SPACE: ' ',
  // Editing Keys
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  COMMA: ',',
  // UI Keys
  ESC: 'Escape'
};
var DATERANGE_DISABLED_TARGET;

(function (DATERANGE_DISABLED_TARGET) {
  DATERANGE_DISABLED_TARGET["CALENDAR"] = "CALENDAR";
  DATERANGE_DISABLED_TARGET["TOOLBAR_BUTTON_OK"] = "TOOLBAR_BUTTON_OK";
  DATERANGE_DISABLED_TARGET["TOOLBAR_SHORTCUT"] = "TOOLBAR_SHORTCUT";
})(DATERANGE_DISABLED_TARGET || (DATERANGE_DISABLED_TARGET = {}));

var getNative$4 = _getNative;

var defineProperty$3 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$3;

var defineProperty$2 = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$1 = eq_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$3(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    castPath$4 = _castPath,
    isIndex$2 = _isIndex,
    isObject$6 = isObject_1,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$6(object)) {
    return object;
  }
  path = castPath$4(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$4(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$6(objValue)
          ? objValue
          : (isIndex$2(path[index + 1]) ? [] : {});
      }
    }
    assignValue$2(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseGet$2 = _baseGet,
    baseSet = _baseSet,
    castPath$3 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$2(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$2(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$3(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$2;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
    isArguments$1 = isArguments_1,
    isArray$7 = isArray_1,
    isIndex$1 = _isIndex,
    isLength = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) &&
    (isArray$7(object) || isArguments$1(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$2;

var basePickBy$1 = _basePickBy,
    hasIn$1 = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy$1(object, paths, function(value, path) {
    return hasIn$1(object, path);
  });
}

var _basePick = basePick$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var Symbol$3 = _Symbol,
    isArguments = isArguments_1,
    isArray$6 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$3 ? Symbol$3.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$6(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$2 = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$2(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$1;

var baseFlatten = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$3(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$3;

var apply$2 = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$4(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$4(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply$2(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

var constant = constant_1,
    defineProperty$1 = _defineProperty,
    identity$3 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty$1 ? identity$3 : function(func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$2(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$2;

var baseSetToString = _baseSetToString,
    shortOut$1 = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$3 = shortOut$1(baseSetToString);

var _setToString = setToString$3;

var flatten = flatten_1,
    overRest$1 = _overRest,
    setToString$2 = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$2(func) {
  return setToString$2(overRest$1(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$2;

var basePick = _basePick,
    flatRest$1 = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest$1(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

var pick_1 = pick;

var ListCache$2 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$2;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;

var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$9 = _root;

/** Built-in value references. */
var Uint8Array$2 = root$9.Uint8Array;

var _Uint8Array = Uint8Array$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$2 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$4 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$2:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag$2:
    case dateTag$2:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$2:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$4:
      var convert = mapToArray;

    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

var arrayPush$1 = _arrayPush,
    isArray$5 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$7.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$3 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$3, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$3 = _getNative,
    root$8 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$3(root$8, 'DataView');

var _DataView = DataView$1;

var getNative$2 = _getNative,
    root$7 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$7, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative$1(root$6, 'Set');

var _Set = Set$1;

var getNative = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative(root$5, 'WeakMap');

var _WeakMap = WeakMap$3;

var DataView = _DataView,
    Map = _Map,
    Promise$1 = _Promise,
    Set = _Set,
    WeakMap$2 = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$3 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$4 = baseGetTag$2;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$4(new DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map && getTag$4(new Map) != mapTag$3) ||
    (Promise$1 && getTag$4(Promise$1.resolve()) != promiseTag) ||
    (Set && getTag$4(new Set) != setTag$3) ||
    (WeakMap$2 && getTag$4(new WeakMap$2) != weakMapTag$1)) {
  getTag$4 = function(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$3 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$4;

var Stack$2 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$3 = _getTag,
    isArray$4 = isArray_1,
    isBuffer$1 = isBuffer$3.exports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$4(object),
      othIsArr = isArray$4(other),
      objTag = objIsArr ? arrayTag$1 : getTag$3(object),
      othTag = othIsArr ? arrayTag$1 : getTag$3(other);

  objTag = objTag == argsTag$1 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$2);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$2);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$5 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$5(value) && !isObjectLike$5(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack$1 = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$5 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$5(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$2 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$2(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$2 = identity_1,
    isArray$3 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$4(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$2;
  }
  if (typeof value == 'object') {
    return isArray$3(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$4;

/** Error message constants. */

var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate$1(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

var negate_1 = negate$1;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var arrayPush = _arrayPush,
    getPrototype$2 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$4 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$4(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$4.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn$1 = _getSymbolsIn,
    keysIn$2 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$3(object) {
  return baseGetAllKeys(object, keysIn$2, getSymbolsIn$1);
}

var _getAllKeysIn = getAllKeysIn$3;

var arrayMap$1 = _arrayMap,
    baseIteratee$3 = _baseIteratee,
    basePickBy = _basePickBy,
    getAllKeysIn$2 = _getAllKeysIn;

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy$1(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap$1(getAllKeysIn$2(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee$3(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

var pickBy_1 = pickBy$1;

var baseIteratee$2 = _baseIteratee,
    negate = negate_1,
    pickBy = pickBy_1;

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee$2(predicate)));
}

var omitBy_1 = omitBy;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

function toInteger$1(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger$1(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger$1(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$3,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale$1 = locale$1;

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger$1(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var lightFormatters = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale$1;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a second
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */

function startOfSecond(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMilliseconds(0);
  return date;
}

/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second (and hour and day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 * 
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 * 
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */

function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger$1(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger$1(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger$1(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger$1(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger$1(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger$1(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */

function setDate(dirtyDate, dirtyDayOfMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = toInteger$1(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger$1(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger$1(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger$1(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger$1(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger$1(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger$1(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger$1(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger$1(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 *
 *
 * @param {String} dateString - the date string to verify
 * @param {String} formatString - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Boolean}
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateString, formatString, options) {
  requiredArgs(2, arguments);
  return isValid(parse(dateString, formatString, new Date(), options));
}

var disabledTimeProps = ['disabledHours', 'disabledMinutes', 'disabledSeconds'];
var hideTimeProps = ['hideHours', 'hideMinutes', 'hideSeconds'];
var calendarOnlyProps = disabledTimeProps.concat(hideTimeProps);

function validTime(calendarProps, date) {
  if (!date) {
    return false;
  }

  return Object.keys(calendarProps).some(function (key) {
    if (/(Hours)/.test(key)) {
      return calendarProps[key](getHours(date), date);
    }

    if (/(Minutes)/.test(key)) {
      return calendarProps[key](getMinutes(date), date);
    }

    if (/(Seconds)/.test(key)) {
      return calendarProps[key](getSeconds(date), date);
    }

    return false;
  });
}
/**
 * Verify that the time is valid.
 * @param props
 * @param date
 */


function disabledTime(props, date) {
  var calendarProps = pick_1(props, disabledTimeProps);
  return validTime(calendarProps, date);
}
var omitHideDisabledProps = function omitHideDisabledProps(props) {
  return omitBy_1(props, function (_val, key) {
    return key.startsWith('disabled') || key.startsWith('hide');
  });
};
var shouldTime = function shouldTime(format) {
  return /([Hhms])/.test(format);
};
var shouldMonth = function shouldMonth(format) {
  return /[Yy]/.test(format) && /[ML]/.test(format);
};
var shouldDate = function shouldDate(format) {
  return /[Yy]/.test(format) && /[ML]/.test(format) && /[Dd]/.test(format);
}; // for date-fns v1 and v2

/**
 * Get all weeks of this month
 * @params monthDate
 * @return date[]
 */

function getMonthView(monthDate, isoWeek) {
  var firstDayOfMonth = getDay(monthDate);
  var distance = 0 - firstDayOfMonth;

  if (isoWeek) {
    distance = 1 - firstDayOfMonth;

    if (firstDayOfMonth === 0) {
      distance = -6;
    }
  }

  var firstWeekendDate = addDays(monthDate, distance);
  var weeks = [firstWeekendDate];
  var nextWeekendDate = addDays(firstWeekendDate, 7);
  weeks.push(nextWeekendDate);

  while (weeks.length < 6) {
    nextWeekendDate = addDays(nextWeekendDate, 7);
    weeks.push(nextWeekendDate);
  }

  return weeks;
}
function getDateMask(formatStr) {
  return Array.from(formatStr).map(function (i) {
    return i.match(/[A-Za-z]/) ? /[\d|A-Za-z]/ : i;
  });
}

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireDefault));

var createSvgIcon = {exports: {}};

var _extends = {exports: {}};

(function (module) {
function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_extends));

var Icon = {exports: {}};

var objectWithoutPropertiesLoose = {exports: {}};

(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(objectWithoutPropertiesLoose));

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var utils = {};

var prefix$2 = {};

var WeakMap$1 = _WeakMap;

/** Used to store function metadata. */
var metaMap$2 = WeakMap$1 && new WeakMap$1;

var _metaMap = metaMap$2;

var identity$1 = identity_1,
    metaMap$1 = _metaMap;

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData$2 = !metaMap$1 ? identity$1 : function(func, data) {
  metaMap$1.set(func, data);
  return func;
};

var _baseSetData = baseSetData$2;

var isObject$3 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$4 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$3(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$4;

var baseCreate$3 = _baseCreate,
    isObject$2 = isObject_1;

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor$4(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate$3(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject$2(result) ? result : thisBinding;
  };
}

var _createCtor = createCtor$4;

var createCtor$3 = _createCtor,
    root$4 = _root;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$6 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind$1(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG$6,
      Ctor = createCtor$3(func);

  function wrapper() {
    var fn = (this && this !== root$4 && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

var _createBind = createBind$1;

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$3 = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs$2(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax$3(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

var _composeArgs = composeArgs$2;

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$2 = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight$2(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax$2(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

var _composeArgsRight = composeArgsRight$2;

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */

function countHolders$1(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

var _countHolders = countHolders$1;

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */

function baseLodash$3() {
  // No operation performed.
}

var _baseLodash = baseLodash$3;

var baseCreate$2 = _baseCreate,
    baseLodash$2 = _baseLodash;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper$3(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper$3.prototype = baseCreate$2(baseLodash$2.prototype);
LazyWrapper$3.prototype.constructor = LazyWrapper$3;

var _LazyWrapper = LazyWrapper$3;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$1() {
  // No operation performed.
}

var noop_1 = noop$1;

var metaMap = _metaMap,
    noop = noop_1;

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData$2 = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

var _getData = getData$2;

/** Used to lookup unminified function names. */

var realNames$1 = {};

var _realNames = realNames$1;

var realNames = _realNames;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName$1(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty$3.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

var _getFuncName = getFuncName$1;

var baseCreate$1 = _baseCreate,
    baseLodash$1 = _baseLodash;

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper$2(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper$2.prototype = baseCreate$1(baseLodash$1.prototype);
LodashWrapper$2.prototype.constructor = LodashWrapper$2;

var _LodashWrapper = LodashWrapper$2;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$3(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$3;

var LazyWrapper$2 = _LazyWrapper,
    LodashWrapper$1 = _LodashWrapper,
    copyArray$2 = _copyArray;

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone$1(wrapper) {
  if (wrapper instanceof LazyWrapper$2) {
    return wrapper.clone();
  }
  var result = new LodashWrapper$1(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray$2(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

var _wrapperClone = wrapperClone$1;

var LazyWrapper$1 = _LazyWrapper,
    LodashWrapper = _LodashWrapper,
    baseLodash = _baseLodash,
    isArray$2 = isArray_1,
    isObjectLike$4 = isObjectLike_1,
    wrapperClone = _wrapperClone;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash$1(value) {
  if (isObjectLike$4(value) && !isArray$2(value) && !(value instanceof LazyWrapper$1)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$2.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash$1.prototype = baseLodash.prototype;
lodash$1.prototype.constructor = lodash$1;

var wrapperLodash = lodash$1;

var LazyWrapper = _LazyWrapper,
    getData$1 = _getData,
    getFuncName = _getFuncName,
    lodash = wrapperLodash;

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable$1(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData$1(other);
  return !!data && func === data[0];
}

var _isLaziable = isLaziable$1;

var baseSetData$1 = _baseSetData,
    shortOut = _shortOut;

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData$2 = shortOut(baseSetData$1);

var _setData = setData$2;

/** Used to match wrap detail comments. */

var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails$1(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

var _getWrapDetails = getWrapDetails$1;

/** Used to match wrap detail comments. */

var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails$1(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

var _insertWrapDetails = insertWrapDetails$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

var arrayEach$1 = _arrayEach,
    arrayIncludes = _arrayIncludes;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$5 = 1,
    WRAP_BIND_KEY_FLAG$4 = 2,
    WRAP_CURRY_FLAG$5 = 8,
    WRAP_CURRY_RIGHT_FLAG$2 = 16,
    WRAP_PARTIAL_FLAG$3 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$2 = 64,
    WRAP_ARY_FLAG$2 = 128,
    WRAP_REARG_FLAG$1 = 256,
    WRAP_FLIP_FLAG$1 = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG$2],
  ['bind', WRAP_BIND_FLAG$5],
  ['bindKey', WRAP_BIND_KEY_FLAG$4],
  ['curry', WRAP_CURRY_FLAG$5],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG$2],
  ['flip', WRAP_FLIP_FLAG$1],
  ['partial', WRAP_PARTIAL_FLAG$3],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG$2],
  ['rearg', WRAP_REARG_FLAG$1]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails$1(details, bitmask) {
  arrayEach$1(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

var _updateWrapDetails = updateWrapDetails$1;

var getWrapDetails = _getWrapDetails,
    insertWrapDetails = _insertWrapDetails,
    setToString$1 = _setToString,
    updateWrapDetails = _updateWrapDetails;

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString$2(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString$1(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

var _setWrapToString = setWrapToString$2;

var isLaziable = _isLaziable,
    setData$1 = _setData,
    setWrapToString$1 = _setWrapToString;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$4 = 1,
    WRAP_BIND_KEY_FLAG$3 = 2,
    WRAP_CURRY_BOUND_FLAG$1 = 4,
    WRAP_CURRY_FLAG$4 = 8,
    WRAP_PARTIAL_FLAG$2 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry$2(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG$4,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG$2 : WRAP_PARTIAL_RIGHT_FLAG$1);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$1 : WRAP_PARTIAL_FLAG$2);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG$1)) {
    bitmask &= ~(WRAP_BIND_FLAG$4 | WRAP_BIND_KEY_FLAG$3);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData$1(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString$1(result, func, bitmask);
}

var _createRecurry = createRecurry$2;

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */

function getHolder$3(func) {
  var object = func;
  return object.placeholder;
}

var _getHolder = getHolder$3;

var copyArray$1 = _copyArray,
    isIndex = _isIndex;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$2 = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder$1(array, indexes) {
  var arrLength = array.length,
      length = nativeMin$2(indexes.length, arrLength),
      oldArray = copyArray$1(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

var _reorder = reorder$1;

/** Used as the internal argument placeholder. */

var PLACEHOLDER$1 = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders$4(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER$1) {
      array[index] = PLACEHOLDER$1;
      result[resIndex++] = index;
    }
  }
  return result;
}

var _replaceHolders = replaceHolders$4;

var composeArgs$1 = _composeArgs,
    composeArgsRight$1 = _composeArgsRight,
    countHolders = _countHolders,
    createCtor$2 = _createCtor,
    createRecurry$1 = _createRecurry,
    getHolder$2 = _getHolder,
    reorder = _reorder,
    replaceHolders$3 = _replaceHolders,
    root$3 = _root;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$3 = 1,
    WRAP_BIND_KEY_FLAG$2 = 2,
    WRAP_CURRY_FLAG$3 = 8,
    WRAP_CURRY_RIGHT_FLAG$1 = 16,
    WRAP_ARY_FLAG$1 = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid$2(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG$1,
      isBind = bitmask & WRAP_BIND_FLAG$3,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2,
      isCurried = bitmask & (WRAP_CURRY_FLAG$3 | WRAP_CURRY_RIGHT_FLAG$1),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor$2(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder$2(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs$1(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight$1(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders$3(args, placeholder);
      return createRecurry$1(
        func, bitmask, createHybrid$2, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root$3 && this instanceof wrapper) {
      fn = Ctor || createCtor$2(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

var _createHybrid = createHybrid$2;

var apply$1 = _apply,
    createCtor$1 = _createCtor,
    createHybrid$1 = _createHybrid,
    createRecurry = _createRecurry,
    getHolder$1 = _getHolder,
    replaceHolders$2 = _replaceHolders,
    root$2 = _root;

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry$1(func, bitmask, arity) {
  var Ctor = createCtor$1(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder$1(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders$2(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid$1, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root$2 && this instanceof wrapper) ? Ctor : func;
    return apply$1(fn, this, args);
  }
  return wrapper;
}

var _createCurry = createCurry$1;

var apply = _apply,
    createCtor = _createCtor,
    root$1 = _root;

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$2 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial$1(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG$2,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root$1 && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

var _createPartial = createPartial$1;

var composeArgs = _composeArgs,
    composeArgsRight = _composeArgsRight,
    replaceHolders$1 = _replaceHolders;

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$1 = 1,
    WRAP_BIND_KEY_FLAG$1 = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG$2 = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData$1(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG$1 | WRAP_BIND_KEY_FLAG$1 | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG$2)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG$2));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG$1) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG$1 ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders$1(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders$1(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin$1(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

var _mergeData = mergeData$1;

var baseSetData = _baseSetData,
    createBind = _createBind,
    createCurry = _createCurry,
    createHybrid = _createHybrid,
    createPartial = _createPartial,
    getData = _getData,
    mergeData = _mergeData,
    setData = _setData,
    setWrapToString = _setWrapToString,
    toInteger = toInteger_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG$1 = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG$1 = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap$2(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG$1 | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax$1(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax$1(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG$1 | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG$1 | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG$1 || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG$1 || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG$1)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

var _createWrap = createWrap$2;

var createWrap$1 = _createWrap;

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap$1(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

var curry_1 = curry;

var _interopRequireDefault$3 = interopRequireDefault.exports;

prefix$2.__esModule = true;
prefix$2.prefix = prefix$2.defaultClassPrefix = prefix$2.getClassNamePrefix = prefix$2.globalKey = void 0;

var _curry = _interopRequireDefault$3(curry_1);

var _classnames = _interopRequireDefault$3(classnames.exports);

var globalKey = 'rs-';
prefix$2.globalKey = globalKey;

var getClassNamePrefix = function getClassNamePrefix() {
  return globalKey;
};

prefix$2.getClassNamePrefix = getClassNamePrefix;

var defaultClassPrefix = function defaultClassPrefix(name) {
  return name ? "" + getClassNamePrefix() + name : undefined;
};

prefix$2.defaultClassPrefix = defaultClassPrefix;
var prefix$1 = (0, _curry["default"])(function (pre, className) {
  if (!pre || !className) {
    return '';
  }

  if (Array.isArray(className)) {
    return (0, _classnames["default"])(className.filter(function (name) {
      return !!name;
    }).map(function (name) {
      return pre + "-" + name;
    }));
  }

  return pre + "-" + className;
});
prefix$2.prefix = prefix$1;

var useClassNames$1 = {exports: {}};

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = useClassNames;

var _prefix = prefix$2;

var _classnames = _interopRequireDefault(classnames.exports);

var _react = React__default;

function useClassNames(componentClassName) {
  var className = (0, _prefix.defaultClassPrefix)('icon');
  var addPrefix = (0, _react.useCallback)(function (blockClassName) {
    return (0, _prefix.prefix)(className, blockClassName);
  }, []);
  return [(0, _classnames["default"])(className, (0, _prefix.defaultClassPrefix)(componentClassName)), addPrefix];
}

module.exports = exports.default;
}(useClassNames$1, useClassNames$1.exports));

var inBrowserEnv = {exports: {}};

(function (module, exports) {

exports.__esModule = true;
exports["default"] = _default;

function _default() {
  return typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function';
}

module.exports = exports.default;
}(inBrowserEnv, inBrowserEnv.exports));

var useInsertStyles = {exports: {}};

var insertCss$1 = {exports: {}};

var containers = []; // will store container HTMLElement references
var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}

var usage = 'insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).';

function insertCss(css, options) {
    options = options || {};

    if (css === undefined) {
        throw new Error(usage);
    }

    var position = options.prepend === true ? 'prepend' : 'append';
    var container = options.container !== undefined ? options.container : document.querySelector('head');
    var containerId = containers.indexOf(container);

    // first time we see this container, create the necessary entries
    if (containerId === -1) {
        containerId = containers.push(container) - 1;
        styleElements[containerId] = {};
    }

    // try to get the correponding container + position styleElement, create it otherwise
    var styleElement;

    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
        styleElement = styleElements[containerId][position];
    } else {
        styleElement = styleElements[containerId][position] = createStyleElement();

        if (position === 'prepend') {
            container.insertBefore(styleElement, container.childNodes[0]);
        } else {
            container.appendChild(styleElement);
        }
    }

    // strip potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xFEFF) { css = css.substr(1, css.length); }

    // actually add the stylesheet
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText += css;
    } else {
        styleElement.textContent += css;
    }

    return styleElement;
}
function createStyleElement() {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    return styleElement;
}

insertCss$1.exports = insertCss;
insertCss$1.exports.insertCss = insertCss;

(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;

var _insertCss = insertCss$1.exports;

var _prefix = prefix$2;

var _react = React__default;

var prefix = (0, _prefix.getClassNamePrefix)(); // Generated with ../less/index.less

var styles = "." + prefix + "icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  vertical-align: middle;\n}\n." + prefix + "icon[tabindex] {\n  cursor: pointer;\n}\n." + prefix + "icon-spin {\n  -webkit-animation: icon-spin 2s infinite linear;\n          animation: icon-spin 2s infinite linear;\n}\n." + prefix + "icon-pulse {\n  -webkit-animation: icon-spin 1s infinite steps(8);\n          animation: icon-spin 1s infinite steps(8);\n}\n." + prefix + "icon-flip-horizontal {\n  -webkit-transform: scaleX(-1);\n      -ms-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n." + prefix + "icon-flip-vertical {\n  -webkit-transform: scaleY(-1);\n      -ms-transform: scaleY(-1);\n          transform: scaleY(-1);\n}\n@-webkit-keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n@keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}";
var cssInjected = false;

var useInsertStyles = function useInsertStyles(styleStr) {
  if (styleStr === void 0) {
    styleStr = styles;
  }

  (0, _react.useEffect)(function () {
    // Make sure css injected once.
    if (!cssInjected) {
      (0, _insertCss.insertCss)(styleStr, {
        prepend: true
      });
      cssInjected = true;
    }
  }, []);
};

var _default = useInsertStyles;
exports["default"] = _default;
module.exports = exports.default;
}(useInsertStyles, useInsertStyles.exports));

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
var _exportNames = {
  useClassNames: true,
  inBrowserEnv: true,
  useInsertStyles: true
};
exports.useInsertStyles = exports.inBrowserEnv = exports.useClassNames = void 0;

var _prefix = prefix$2;

Object.keys(_prefix).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _prefix[key]) return;
  exports[key] = _prefix[key];
});

var _useClassNames = _interopRequireDefault(useClassNames$1.exports);

exports.useClassNames = _useClassNames["default"];

var _inBrowserEnv = _interopRequireDefault(inBrowserEnv.exports);

exports.inBrowserEnv = _inBrowserEnv["default"];

var _useInsertStyles = _interopRequireDefault(useInsertStyles.exports);

exports.useInsertStyles = _useInsertStyles["default"];
}(utils));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(_extends.exports);

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);

var _react = _interopRequireDefault(React__default);

var _classnames = _interopRequireDefault(classnames.exports);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _utils = utils;

var defaultProps = {
  as: 'svg',
  fill: 'currentColor',
  width: '1em',
  height: '1em'
};

function filterProps(props) {
  var nextProps = {};
  Object.entries(props).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];

    if (typeof value !== 'undefined') {
      nextProps[key] = value;
    }
  });
  return nextProps;
}

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _classNames;

  var Component = props.as,
      spin = props.spin,
      pulse = props.pulse,
      flip = props.flip,
      fill = props.fill,
      className = props.className,
      rotate = props.rotate,
      children = props.children,
      viewBox = props.viewBox,
      width = props.width,
      height = props.height,
      style = props.style,
      rest = (0, _objectWithoutPropertiesLoose2["default"])(props, ["as", "spin", "pulse", "flip", "fill", "className", "rotate", "children", "viewBox", "width", "height", "style"]);

  var _useClassNames = (0, _utils.useClassNames)(),
      componentClassName = _useClassNames[0],
      addPrefix = _useClassNames[1];

  var classes = (0, _classnames["default"])(className, componentClassName, (_classNames = {}, _classNames[addPrefix('spin')] = spin, _classNames[addPrefix('pulse')] = pulse, _classNames[addPrefix("flip-" + flip)] = !!flip, _classNames));
  var rotateStyles = {
    msTransform: "rotate(" + rotate + "deg)",
    transform: "rotate(" + rotate + "deg)"
  };
  (0, _utils.useInsertStyles)();
  var svgProps = filterProps({
    width: width,
    height: height,
    fill: fill,
    viewBox: viewBox,
    className: classes,
    style: rotate ? (0, _extends2["default"])({}, rotateStyles, style) : style
  });
  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, svgProps, rest), children);
});

Icon.displayName = 'Icon';
Icon.defaultProps = defaultProps;
Icon.propTypes = {
  spin: _propTypes["default"].bool,
  pulse: _propTypes["default"].bool,
  rotate: _propTypes["default"].number,
  viewBox: _propTypes["default"].string,
  as: _propTypes["default"].oneOfType([_propTypes["default"].elementType, _propTypes["default"].string]),
  flip: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  fill: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;
module.exports = exports.default;
}(Icon, Icon.exports));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(_extends.exports);

var _react = _interopRequireDefault(React__default);

var _Icon = _interopRequireDefault(Icon.exports);

function createSvgIcon(_ref) {
  var as = _ref.as,
      ariaLabel = _ref.ariaLabel,
      displayName = _ref.displayName,
      category = _ref.category;

  var IconComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
      "aria-label": ariaLabel,
      "data-category": category,
      ref: ref,
      as: as
    }, props));
  });

  IconComponent.displayName = displayName;
  return IconComponent;
}

var _default = createSvgIcon;
exports["default"] = _default;
module.exports = exports.default;
}(createSvgIcon, createSvgIcon.exports));

var Close$3 = {};

var Close$2 = {exports: {}};

var Close$1 = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Close(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Close);
var _default = ForwardRef;
exports["default"] = _default;
}(Close$1));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _Close = _interopRequireDefault(Close$1);

// Generated by script, don't edit it please.
var Close = (0, _createSvgIcon["default"])({
  as: _Close["default"],
  ariaLabel: 'close',
  category: 'application',
  displayName: 'Close'
});
var _default = Close;
exports["default"] = _default;
module.exports = exports.default;
}(Close$2, Close$2.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});

var _Close = _interopRequireDefault(Close$2.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(Close$3));

var Close = /*@__PURE__*/getDefaultExportFromCjs(Close$3);

function prefix(pre, className) {
  if (!pre || !className) {
    return '';
  }

  if (Array.isArray(className)) {
    return classNames(className.filter(function (name) {
      return !!name;
    }).map(function (name) {
      return pre + "-" + name;
    }));
  } // TODO Compatible with V4


  if (pre[pre.length - 1] === '-') {
    return "" + pre + className;
  }

  return pre + "-" + className;
}
curry_1(prefix);

/**
 *
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * Largely copied directly from:
 * https://github.com/react-bootstrap/react-bootstrap/blob/master/src/utils/createChainedFunction.js
 *
 * @param {function} functions to chain
 * @returns {function|undefined}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f !== null && typeof f !== 'undefined';
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === undefined) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, undefined);
}

function isOneOf(one, ofTarget) {
  if (Array.isArray(ofTarget)) {
    return ofTarget.indexOf(one) >= 0;
  }

  return one === ofTarget;
}

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
    keys$1 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$1(source), object);
}

var _baseAssign = baseAssign$1;

var copyObject$3 = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$1(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

var copyObject$2 = _copyObject,
    getSymbols = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols(source), object);
}

var _copySymbols = copySymbols$1;

var copyObject$1 = _copyObject,
    getSymbolsIn = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

/** Used for built-in method references. */

var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$1 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$2:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$3(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$2(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$1 = isArray_1,
    isBuffer = isBuffer$3.exports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag$1] = cloneableTags[objectTag$1] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$2(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$2;

var baseGet = _baseGet,
    baseSlice$1 = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice$1(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$1;

var baseGetTag$1 = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$1;

var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var arrayMap = _arrayMap,
    baseClone = _baseClone,
    baseUnset = _baseUnset,
    castPath = _castPath,
    copyObject = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */

function isUndefined(value) {
  return value === undefined;
}

var isUndefined_1 = isUndefined;

var identity = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

var _baseRest = baseRest$1;

var fallback = function fallback(context, node) {
  if (!node) return false;

  do {
    if (node === context) {
      return true;
    }
  } while (node.parentNode && (node = node.parentNode));

  return false;
}; // HTML DOM and SVG DOM may have different support levels,
// so we need to check on context instead of a document root element.


var contains = function contains(context, node) {
  if (!node) return false;

  if (context.contains) {
    return context.contains(node);
  } else if (context.compareDocumentPosition) {
    return context === node || !!(context.compareDocumentPosition(node) & 16);
  }

  return fallback(context, node);
};

var contains$1 = (function () {
  return canUseDOM$1 ? contains : fallback;
})();

var getContainer = (function (container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return container || defaultContainer;
});

var ownerDocument = (function (node) {
  return node && node.ownerDocument || document;
});

var removeClass = (function (target, className) {
  if (className) {
    if (target.classList) {
      target.classList.remove(className);
    } else {
      target.className = target.className.replace(new RegExp("(^|\\s)" + className + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
      .replace(/^\s*|\s*$/g, ''); // trim the ends
    }
  }

  return target;
});

/**
 * Bind `target` event `eventName`'s callback `listener`.
 */
function on(target, eventType, listener, options) {
  if (options === void 0) {
    options = false;
  }

  target.addEventListener(eventType, listener, options);
  return {
    off: function off() {
      target.removeEventListener(eventType, listener, options);
    }
  };
}

var hasClass = (function (target, className) {
  if (target.classList) {
    return !!className && target.classList.contains(className);
  }

  return (" " + target.className + " ").indexOf(" " + className + " ") !== -1;
});

var addClass = (function (target, className) {
  if (className) {
    if (target.classList) {
      target.classList.add(className);
    } else if (!hasClass(target, className)) {
      target.className = target.className + " " + className;
    }
  }

  return target;
});

/* eslint-disable */
/**
 * @example
 * camelize('font-size');
 * => fontSize
 */

function camelize(string) {
  return string.replace(/\-(\w)/g, function (_char) {
    return _char.slice(1).toUpperCase();
  });
}
/**
 * @example
 * camelize('fontSize');
 * => font-size
 */

function hyphenate(string) {
  return string.replace(/([A-Z])/g, '-$1').toLowerCase();
}

var msPattern$1 = /^ms-/;
var hyphenateStyleName = (function (string) {
  return hyphenate(string).replace(msPattern$1, '-ms-');
});

function removeStyle(node, key) {
  var _style, _style$removeProperty;

  (_style = node.style) === null || _style === void 0 ? void 0 : (_style$removeProperty = _style.removeProperty) === null || _style$removeProperty === void 0 ? void 0 : _style$removeProperty.call(_style, key);
}
/**
 * key(s) typeof [string , array] ?
 */


var removeStyle$1 = (function (node, keys) {
  if (typeof keys === 'string') {
    removeStyle(node, keys);
  } else if (Array.isArray(keys)) {
    keys.forEach(function (key) {
      return removeStyle(node, key);
    });
  }
});

var addStyle = (function (node, property, value) {
  var css = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      throw new Error('value is undefined');
    }

    (props = {})[property] = value;
  }

  if (typeof props === 'object') {
    for (var _key in props) {
      if (Object.prototype.hasOwnProperty.call(props, _key)) {
        if (!props[_key] && props[_key] !== 0) {
          removeStyle$1(node, hyphenateStyleName(_key));
        } else {
          css += hyphenateStyleName(_key) + ":" + props[_key] + ";";
        }
      }
    }
  }

  node.style.cssText += ";" + css;
});

var resizeObservers = [];

var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};

var hasSkippedObservations = function () {
    return resizeObservers.some(function (ro) { return ro.skippedTargets.length > 0; });
};

var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function () {
    var event;
    if (typeof ErrorEvent === 'function') {
        event = new ErrorEvent('error', {
            message: msg
        });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};

var ResizeObserverBoxOptions;
(function (ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));

var freeze = function (obj) { return Object.freeze(obj); };

var ResizeObserverSize = (function () {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        freeze(this);
    }
    return ResizeObserverSize;
}());

var DOMRectReadOnly = (function () {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return freeze(this);
    }
    DOMRectReadOnly.prototype.toJSON = function () {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return { x: x, y: y, top: top, right: right, bottom: bottom, left: left, width: width, height: height };
    };
    DOMRectReadOnly.fromRect = function (rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}());

var isSVG = function (target) { return target instanceof SVGElement && 'getBBox' in target; };
var isHidden = function (target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement$2 = function (obj) {
    var _a, _b;
    if (obj instanceof Element) {
        return true;
    }
    var scope = (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function (target) {
    switch (target.tagName) {
        case 'INPUT':
            if (target.type !== 'image') {
                break;
            }
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};

var global$1 = typeof window !== 'undefined' ? window : {};

var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = (/msie|trident/i).test(global$1.navigator && global$1.navigator.userAgent);
var parseDimension = function (pixel) { return parseFloat(pixel || '0'); };
var size$1 = function (inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) { inlineSize = 0; }
    if (blockSize === void 0) { blockSize = 0; }
    if (switchSizes === void 0) { switchSizes = false; }
    return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
    devicePixelContentBoxSize: size$1(),
    borderBoxSize: size$1(),
    contentBoxSize: size$1(),
    contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function (target, forceRecalculation) {
    if (forceRecalculation === void 0) { forceRecalculation = false; }
    if (cache.has(target) && !forceRecalculation) {
        return cache.get(target);
    }
    if (isHidden(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = freeze({
        devicePixelContentBoxSize: size$1(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size$1(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size$1(contentWidth, contentHeight, switchSizes),
        contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function (target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch (observedBox) {
        case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case ResizeObserverBoxOptions.BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

var ResizeObserverEntry = (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = freeze([boxes.borderBoxSize]);
        this.contentBoxSize = freeze([boxes.contentBoxSize]);
        this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
    }
    return ResizeObserverEntry;
}());

var calculateDepthForNode = function (node) {
    if (isHidden(node)) {
        return Infinity;
    }
    var depth = 0;
    var parent = node.parentNode;
    while (parent) {
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

var broadcastActiveObservations = function () {
    var shallowestDepth = Infinity;
    var callbacks = [];
    resizeObservers.forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) {
            return;
        }
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new ResizeObserverEntry(ot.target);
            var targetDepth = calculateDepthForNode(ot.target);
            entries.push(entry);
            ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) {
                shallowestDepth = targetDepth;
            }
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

var gatherActiveObservationsAtDepth = function (depth) {
    resizeObservers.forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if (calculateDepthForNode(ot.target) > depth) {
                    ro.activeTargets.push(ot);
                }
                else {
                    ro.skippedTargets.push(ot);
                }
            }
        });
    });
};

var process$1 = function () {
    var depth = 0;
    gatherActiveObservationsAtDepth(depth);
    while (hasActiveObservations()) {
        depth = broadcastActiveObservations();
        gatherActiveObservationsAtDepth(depth);
    }
    if (hasSkippedObservations()) {
        deliverResizeLoopError();
    }
    return depth > 0;
};

var trigger;
var callbacks = [];
var notify = function () { return callbacks.splice(0).forEach(function (cb) { return cb(); }); };
var queueMicroTask = function (callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = { characterData: true };
        new MutationObserver(function () { return notify(); }).observe(el_1, config);
        trigger = function () { el_1.textContent = "" + (toggle_1 ? toggle_1-- : toggle_1++); };
    }
    callbacks.push(callback);
    trigger();
};

var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

var watching = 0;
var isWatching = function () { return !!watching; };
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = (function () {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function () { return _this.schedule(); };
    }
    Scheduler.prototype.run = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = CATCH_PERIOD; }
        if (scheduled) {
            return;
        }
        scheduled = true;
        var until = time(timeout);
        queueResizeObserver(function () {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = process$1();
            }
            finally {
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) {
                    return;
                }
                if (elementsHaveResized) {
                    _this.run(1000);
                }
                else if (timeout > 0) {
                    _this.run(timeout);
                }
                else {
                    _this.start();
                }
            }
        });
    };
    Scheduler.prototype.schedule = function () {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function () {
        var _this = this;
        var cb = function () { return _this.observer && _this.observer.observe(document.body, observerConfig); };
        document.body ? cb() : global$1.addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function () {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function (name) { return global$1.addEventListener(name, _this.listener, true); });
        }
    };
    Scheduler.prototype.stop = function () {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function (name) { return global$1.removeEventListener(name, _this.listener, true); });
            this.stopped = true;
        }
    };
    return Scheduler;
}());
var scheduler = new Scheduler();
var updateCount = function (n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};

var skipNotifyOnElement = function (target) {
    return !isSVG(target)
        && !isReplacedElement(target)
        && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = (function () {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function () {
        var size = calculateBoxSize(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) {
            this.lastReportedSize = size;
        }
        if (this.lastReportedSize.inlineSize !== size.inlineSize
            || this.lastReportedSize.blockSize !== size.blockSize) {
            return true;
        }
        return false;
    };
    return ResizeObservation;
}());

var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());

var observerMap = new WeakMap();
var getObservationIndex = function (observationTargets, target) {
    for (var i = 0; i < observationTargets.length; i += 1) {
        if (observationTargets[i].target === target) {
            return i;
        }
    }
    return -1;
};
var ResizeObserverController = (function () {
    function ResizeObserverController() {
    }
    ResizeObserverController.connect = function (resizeObserver, callback) {
        var detail = new ResizeObserverDetail(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function (resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && resizeObservers.push(detail);
            detail.observationTargets.push(new ResizeObservation(target, options && options.box));
            updateCount(1);
            scheduler.schedule();
        }
    };
    ResizeObserverController.unobserve = function (resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            updateCount(-1);
        }
    };
    ResizeObserverController.disconnect = function (resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function (ot) { return _this.unobserve(resizeObserver, ot.target); });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}());

var ResizeObserver = (function () {
    function ResizeObserver(callback) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (typeof callback !== 'function') {
            throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        }
        ResizeObserverController.connect(this, callback);
    }
    ResizeObserver.prototype.observe = function (target, options) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement$2(target)) {
            throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function (target) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        }
        if (!isElement$2(target)) {
            throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        }
        ResizeObserverController.unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function () {
        ResizeObserverController.disconnect(this);
    };
    ResizeObserver.toString = function () {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}());

var isElement = function isElement(node) {
  return (node === null || node === void 0 ? void 0 : node.nodeType) === 1 && typeof (node === null || node === void 0 ? void 0 : node.nodeName) === 'string';
};

var isElement$1 = isElement;

var isSymbol = isSymbol_1;

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum$2(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

var _baseExtremum = baseExtremum$2;

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */

function baseGt$1(value, other) {
  return value > other;
}

var _baseGt = baseGt$1;

var baseExtremum$1 = _baseExtremum,
    baseGt = _baseGt,
    baseIteratee$1 = _baseIteratee;

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum$1(array, baseIteratee$1(iteratee), baseGt)
    : undefined;
}

var maxBy_1 = maxBy;

var maxBy$1 = maxBy_1;

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */

function baseLt$1(value, other) {
  return value < other;
}

var _baseLt = baseLt$1;

var baseExtremum = _baseExtremum,
    baseIteratee = _baseIteratee,
    baseLt = _baseLt;

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee), baseLt)
    : undefined;
}

var minBy_1 = minBy;

var minBy$1 = minBy_1;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$3 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$3(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$2 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$2(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$2;

var createCompounder$1 = _createCompounder;

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder$1(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

var kebabCase_1 = kebabCase;

var getWindow = (function (node) {
  if (node === (node === null || node === void 0 ? void 0 : node.window)) {
    return node;
  }

  return (node === null || node === void 0 ? void 0 : node.nodeType) === 9 ? (node === null || node === void 0 ? void 0 : node.defaultView) || (node === null || node === void 0 ? void 0 : node.parentWindow) : null;
});

var getOffset = (function (node) {
  var doc = ownerDocument(node);
  var win = getWindow(doc);
  var docElem = doc && doc.documentElement;
  var box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };

  if (!doc) {
    return null;
  } // Make sure it's not a disconnected DOM node


  if (!contains$1(docElem, node)) {
    return box;
  }

  if ((node === null || node === void 0 ? void 0 : node.getBoundingClientRect) !== undefined) {
    box = node.getBoundingClientRect();
  }

  if ((box.width || box.height) && docElem && win) {
    box = {
      top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
      left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
      width: (box.width === null ? node.offsetWidth : box.width) || 0,
      height: (box.height === null ? node.offsetHeight : box.height) || 0
    };
  }

  return box;
});

var scrollTop = (function (node, val) {
  var win = getWindow(node);
  var top = node.scrollTop;
  var left = 0;

  if (win) {
    top = win.pageYOffset;
    left = win.pageXOffset;
  }

  if (val !== undefined) {
    if (win) {
      win.scrollTo(left, val);
    } else {
      node.scrollTop = val;
    }
  }

  return top;
});

var scrollLeft = (function (node, val) {
  var win = getWindow(node);
  var left = node.scrollLeft;
  var top = 0;

  if (win) {
    left = win.pageXOffset;
    top = win.pageYOffset;
  }

  if (val !== undefined) {
    if (win) {
      win.scrollTo(val, top);
    } else {
      node.scrollLeft = val;
    }
  }

  return left;
});

var nodeName = (function (node) {
  var _node$nodeName;

  return (node === null || node === void 0 ? void 0 : node.nodeName) && (node === null || node === void 0 ? void 0 : (_node$nodeName = node.nodeName) === null || _node$nodeName === void 0 ? void 0 : _node$nodeName.toLowerCase());
});

var msPattern = /^ms-/;
var camelizeStyleName = (function (name) {
  return camelize(name.replace(msPattern, 'ms-'));
});

var getComputedStyle$1 = (function (node) {
  if (!node) {
    throw new TypeError('No Element passed to `getComputedStyle()`');
  }

  var doc = node.ownerDocument;

  if ('defaultView' in doc) {
    if (doc.defaultView.opener) {
      return node.ownerDocument.defaultView.getComputedStyle(node, null);
    }

    return window.getComputedStyle(node, null);
  }

  return null;
});

var getStyle = (function (node, property) {
  if (property) {
    var value = node.style[camelizeStyleName(property)];

    if (value) {
      return value;
    }

    var styles = getComputedStyle$1(node);

    if (styles) {
      return styles.getPropertyValue(hyphenateStyleName(property));
    }
  }

  return node.style || getComputedStyle$1(node);
});

var getOffsetParent = (function (node) {
  var doc = ownerDocument(node);
  var offsetParent = node === null || node === void 0 ? void 0 : node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && getStyle(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
});

var getPosition$1 = (function (node, offsetParent, calcMargin) {
  if (calcMargin === void 0) {
    calcMargin = true;
  }

  var parentOffset = {
    top: 0,
    left: 0
  };
  var offset = null; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if (getStyle(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || getOffsetParent(node);
    offset = getOffset(node);

    if (nodeName(offsetParent) !== 'html') {
      var nextParentOffset = getOffset(offsetParent);

      if (nextParentOffset) {
        parentOffset.top = nextParentOffset.top;
        parentOffset.left = nextParentOffset.left;
      }
    }

    parentOffset.top += parseInt(getStyle(offsetParent, 'borderTopWidth'), 10) - scrollTop(offsetParent) || 0;
    parentOffset.left += parseInt(getStyle(offsetParent, 'borderLeftWidth'), 10) - scrollLeft(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  if (offset) {
    var marginTop = calcMargin ? parseInt(getStyle(node, 'marginTop'), 10) || 0 : 0;
    var marginLeft = calcMargin ? parseInt(getStyle(node, 'marginLeft'), 10) || 0 : 0;
    return _extends$1({}, offset, {
      top: offset.top - parentOffset.top - marginTop,
      left: offset.left - parentOffset.left - marginLeft
    });
  }

  return null;
});

var AutoPlacement = {
  left: 'Start',
  right: 'End',
  top: 'Start',
  bottom: 'End'
};

/**
 * Get the external dimensions of the container
 * @param containerNode
 */
function getContainerDimensions(containerNode) {
  var width;
  var height;
  var scrollX;
  var scrollY;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;
    scrollY = scrollTop(ownerDocument(containerNode).documentElement) || scrollTop(containerNode);
    scrollX = scrollLeft(ownerDocument(containerNode).documentElement) || scrollLeft(containerNode);
  } else {
    var _ref = getOffset(containerNode);

    width = _ref.width;
    height = _ref.height;
    scrollY = scrollTop(containerNode);
    scrollX = scrollLeft(containerNode);
  }

  return {
    width: width,
    height: height,
    scrollX: scrollX,
    scrollY: scrollY
  };
}

var positionUtils = (function (props) {
  var placement = props.placement,
      preventOverflow = props.preventOverflow,
      padding = props.padding;

  function getTopDelta(top, overlayHeight, container) {
    if (!preventOverflow) {
      return 0;
    }

    var containerDimensions = getContainerDimensions(container);
    var containerHeight = containerDimensions.height,
        scrollY = containerDimensions.scrollY;
    var topEdgeOffset = top - padding - scrollY;
    var bottomEdgeOffset = top + padding + overlayHeight - scrollY;

    if (topEdgeOffset < 0) {
      return -topEdgeOffset;
    } else if (bottomEdgeOffset > containerHeight) {
      return containerHeight - bottomEdgeOffset;
    }

    return 0;
  }

  function getLeftDelta(left, overlayWidth, container) {
    if (!preventOverflow) {
      return 0;
    }

    var containerDimensions = getContainerDimensions(container);
    var scrollX = containerDimensions.scrollX,
        containerWidth = containerDimensions.width;
    var leftEdgeOffset = left - padding - scrollX;
    var rightEdgeOffset = left + padding + overlayWidth - scrollX;

    if (leftEdgeOffset < 0) {
      return -leftEdgeOffset;
    } else if (rightEdgeOffset > containerWidth) {
      return containerWidth - rightEdgeOffset;
    }

    return 0;
  }

  function getPositionTop(container, overlayHeight, top) {
    if (!preventOverflow) {
      return top;
    }

    var _getContainerDimensio = getContainerDimensions(container),
        scrollY = _getContainerDimensio.scrollY,
        containerHeight = _getContainerDimensio.height; // 判断 overlay 底部是否溢出，设置 top


    if (overlayHeight + top > containerHeight + scrollY) {
      return containerHeight - overlayHeight + scrollY;
    } // top 的最小值不能少于纵向滚动条 y 的值


    return Math.max(scrollY, top);
  }

  function getPositionLeft(container, overlayWidth, left) {
    if (!preventOverflow) {
      return left;
    }

    var _getContainerDimensio2 = getContainerDimensions(container),
        scrollX = _getContainerDimensio2.scrollX,
        containerWidth = _getContainerDimensio2.width;

    if (overlayWidth + left > containerWidth + scrollX) {
      return containerWidth - overlayWidth + scrollX;
    } // left 的最小值不能少于横向滚动条 x 的值


    return Math.max(scrollX, left);
  }

  return {
    getPosition: function getPosition(target, container) {
      var offset = container.tagName === 'BODY' ? getOffset(target) : getPosition$1(target, container, false);
      return offset;
    },
    calcAutoPlacement: function calcAutoPlacement(targetOffset, container, overlay) {
      var _getContainerDimensio3 = getContainerDimensions(container),
          width = _getContainerDimensio3.width,
          height = _getContainerDimensio3.height,
          scrollX = _getContainerDimensio3.scrollX,
          scrollY = _getContainerDimensio3.scrollY;

      var left = targetOffset.left - scrollX - overlay.width;
      var top = targetOffset.top - scrollY - overlay.height;
      var right = width - targetOffset.left - targetOffset.width + scrollX - overlay.width;
      var bottom = height - targetOffset.top - targetOffset.height + scrollY - overlay.height;
      var horizontal = [{
        key: 'left',
        value: left
      }, {
        key: 'right',
        value: right
      }];
      var vertical = [{
        key: 'top',
        value: top
      }, {
        key: 'bottom',
        value: bottom
      }];
      var AV = 'autoVertical';
      var AH = 'autoHorizontal';
      var direction;
      var align;

      if (placement.indexOf(AV) !== -1) {
        direction = maxBy$1(vertical, function (o) {
          return o.value;
        });
        return placement === AV ? direction.key : "" + direction.key + placement.replace(AV, '');
      } else if (placement.indexOf(AH) !== -1) {
        direction = maxBy$1(horizontal, function (o) {
          return o.value;
        });
        return placement === AH ? direction.key : "" + direction.key + placement.replace(AH, '');
      }
      /**
       * Precedence Vertical
       * [...vertical, ...horizontal]
       */


      direction = maxBy$1([].concat(vertical, horizontal), function (o) {
        return o.value;
      });

      if (direction.key === 'left' || direction.key === 'right') {
        align = minBy$1(vertical, function (o) {
          return o.value;
        });
      } else {
        align = minBy$1(horizontal, function (o) {
          return o.value;
        });
      }

      return "" + direction.key + AutoPlacement[align.key];
    },
    // Calculate the position of the overlay
    calcOverlayPosition: function calcOverlayPosition(overlayNode, target, container) {
      var childOffset = this.getPosition(target, container);

      var _ref2 = getOffset(overlayNode),
          overlayHeight = _ref2.height,
          overlayWidth = _ref2.width;

      var top = childOffset.top,
          left = childOffset.left;
      var nextPlacement = placement;

      if (placement && placement.indexOf('auto') >= 0) {
        nextPlacement = this.calcAutoPlacement(childOffset, container, {
          height: overlayHeight,
          width: overlayWidth
        });
      }

      var positionLeft;
      var positionTop;
      var arrowOffsetLeft;
      var arrowOffsetTop;

      if (nextPlacement === 'left' || nextPlacement === 'right') {
        positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
        var topDelta = getTopDelta(positionTop, overlayHeight, container);
        positionTop += topDelta;
        arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + "%";
        arrowOffsetLeft = undefined;
      } else if (nextPlacement === 'top' || nextPlacement === 'bottom') {
        positionLeft = left + (childOffset.width - overlayWidth) / 2;
        var leftDelta = getLeftDelta(positionLeft, overlayWidth, container);
        positionLeft += leftDelta;
        arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + "%";
        arrowOffsetTop = undefined;
      }

      if (nextPlacement === 'top' || nextPlacement === 'topStart' || nextPlacement === 'topEnd') {
        positionTop = getPositionTop(container, overlayHeight, childOffset.top - overlayHeight);
      }

      if (nextPlacement === 'bottom' || nextPlacement === 'bottomStart' || nextPlacement === 'bottomEnd') {
        positionTop = getPositionTop(container, overlayHeight, childOffset.top + childOffset.height);
      }

      if (nextPlacement === 'left' || nextPlacement === 'leftStart' || nextPlacement === 'leftEnd') {
        positionLeft = getPositionLeft(container, overlayWidth, childOffset.left - overlayWidth);
      }

      if (nextPlacement === 'right' || nextPlacement === 'rightStart' || nextPlacement === 'rightEnd') {
        positionLeft = getPositionLeft(container, overlayWidth, childOffset.left + childOffset.width);
      }

      if (document.dir === 'rtl' && (nextPlacement === 'left' || nextPlacement === 'leftStart' || nextPlacement === 'leftEnd' || nextPlacement === 'right' || nextPlacement === 'rightStart' || nextPlacement === 'rightEnd')) {
        /**
         * When laying out in rtl, if the width of the container
         * is less than the width of the container scrolling,
         * you need to recalculate the left value.
         */
        var _getContainerDimensio4 = getContainerDimensions(container),
            containerWidth = _getContainerDimensio4.width;

        if (container.scrollWidth > containerWidth) {
          positionLeft = containerWidth + positionLeft - container.scrollWidth;
        }
      }

      if (nextPlacement === 'topStart' || nextPlacement === 'bottomStart') {
        if (document.dir === 'rtl') {
          var nextLeft = left + (childOffset.width - overlayWidth);
          positionLeft = nextLeft + getLeftDelta(nextLeft, overlayWidth, container);
        } else {
          positionLeft = left + getLeftDelta(left, overlayWidth, container);
        }
      }

      if (nextPlacement === 'topEnd' || nextPlacement === 'bottomEnd') {
        if (document.dir === 'rtl') {
          positionLeft = left + getLeftDelta(left, overlayWidth, container);
        } else {
          var _nextLeft = left + (childOffset.width - overlayWidth);

          positionLeft = _nextLeft + getLeftDelta(_nextLeft, overlayWidth, container);
        }
      }

      if (nextPlacement === 'leftStart' || nextPlacement === 'rightStart') {
        positionTop = top + getTopDelta(top, overlayHeight, container);
      }

      if (nextPlacement === 'leftEnd' || nextPlacement === 'rightEnd') {
        var nextTop = top + (childOffset.height - overlayHeight);
        positionTop = nextTop + getTopDelta(nextTop, overlayHeight, container);
      }

      return {
        positionLeft: positionLeft,
        positionTop: positionTop,
        arrowOffsetLeft: arrowOffsetLeft,
        arrowOffsetTop: arrowOffsetTop,
        positionClassName: "placement-" + kebabCase_1(nextPlacement)
      };
    }
  };
});

var usePosition = function usePosition(props, ref) {
  var _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$preventOverflo = props.preventOverflow,
      preventOverflow = _props$preventOverflo === void 0 ? false : _props$preventOverflo,
      _props$containerPaddi = props.containerPadding,
      containerPadding = _props$containerPaddi === void 0 ? 0 : _props$containerPaddi,
      container = props.container,
      triggerTarget = props.triggerTarget;
  var containerRef = useRef(null);
  var lastTargetRef = useRef(null);
  var overlayResizeObserver = useRef();
  var defaultPosition = {
    positionLeft: 0,
    positionTop: 0,
    arrowOffsetLeft: null,
    arrowOffsetTop: null
  };

  var _useState = useState(defaultPosition),
      position = _useState[0],
      setPosition = _useState[1];

  var utils = useMemo(function () {
    return positionUtils({
      placement: placement,
      preventOverflow: preventOverflow,
      padding: containerPadding
    });
  }, [placement, preventOverflow, containerPadding]);
  var updatePosition = useCallback(
  /**
   * @param placementChanged  Whether the placement has changed
   * @param forceUpdateDOM Whether to update the DOM directly
   * @returns void
   */
  function (placementChanged, forceUpdateDOM) {
    if (placementChanged === void 0) {
      placementChanged = true;
    }

    if (!(triggerTarget !== null && triggerTarget !== void 0 && triggerTarget.current)) {
      return;
    }

    var targetElement = getDOMNode(triggerTarget);

    if (!isElement$1(targetElement)) {
      throw new Error('`target` should return an HTMLElement');
    } //  If the target and placement do not change, the position is not updated.


    if (targetElement === lastTargetRef.current && !placementChanged) {
      return;
    }

    var overlay = getDOMNode(ref.current);
    var containerElement = getContainer(typeof container === 'function' ? container() : container !== null && container !== void 0 ? container : null, ownerDocument(ref.current).body);
    var posi = utils.calcOverlayPosition(overlay, targetElement, containerElement);

    if (forceUpdateDOM && overlay) {
      var _overlay$className, _overlay$className$ma;

      var preClassName = overlay === null || overlay === void 0 ? void 0 : (_overlay$className = overlay.className) === null || _overlay$className === void 0 ? void 0 : (_overlay$className$ma = _overlay$className.match(/(placement-\S+)/)) === null || _overlay$className$ma === void 0 ? void 0 : _overlay$className$ma[0];
      removeClass(overlay, preClassName);

      if (posi.positionClassName) {
        addClass(overlay, posi.positionClassName);
      }

      addStyle(overlay, {
        left: posi.positionLeft + "px",
        top: posi.positionTop + "px"
      });
    } else {
      setPosition(posi);
    }

    containerRef.current = containerElement;
    lastTargetRef.current = targetElement;
  }, [container, ref, triggerTarget, utils]);
  useEffect(function () {
    updatePosition(false);
    var overlay = getDOMNode(ref.current);
    var containerScrollListener;

    if (containerRef.current && preventOverflow) {
      var _containerRef$current;

      // Update the overlay position when the container scroll bar is scrolling
      containerScrollListener = on(((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.tagName) === 'BODY' ? window : containerRef.current, 'scroll', function () {
        return updatePosition(true, true);
      });
    } // Update the position when the window size changes


    var resizeListener = on(window, 'resize', function () {
      return updatePosition(true, true);
    });

    if (overlay) {
      // Update the position when the size of the overlay changes
      overlayResizeObserver.current = new ResizeObserver(function () {
        return updatePosition(true, true);
      });
      overlayResizeObserver.current.observe(overlay);
    }

    return function () {
      var _containerScrollListe, _overlayResizeObserve;

      lastTargetRef.current = null;
      (_containerScrollListe = containerScrollListener) === null || _containerScrollListe === void 0 ? void 0 : _containerScrollListe.off();
      resizeListener === null || resizeListener === void 0 ? void 0 : resizeListener.off();
      (_overlayResizeObserve = overlayResizeObserver.current) === null || _overlayResizeObserve === void 0 ? void 0 : _overlayResizeObserve.disconnect();
    };
  }, [preventOverflow, ref, updatePosition]);
  useUpdateEffect$1(function () {
    return updatePosition();
  }, [updatePosition, placement]);
  return [position, updatePosition];
};

var Position = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className;
  var childRef = React__default.useRef(null);

  var _usePosition = usePosition(props, childRef),
      position = _usePosition[0],
      updatePosition = _usePosition[1];

  var positionClassName = position.positionClassName,
      arrowOffsetLeft = position.arrowOffsetLeft,
      arrowOffsetTop = position.arrowOffsetTop,
      positionLeft = position.positionLeft,
      positionTop = position.positionTop;
  useImperativeHandle(ref, function () {
    return {
      get child() {
        return childRef.current;
      },

      updatePosition: updatePosition
    };
  });

  if (typeof children === 'function') {
    var childProps = {
      className: classNames(className, positionClassName),
      arrowOffsetLeft: arrowOffsetLeft,
      arrowOffsetTop: arrowOffsetTop,
      left: positionLeft,
      top: positionTop
    };
    return children(childProps, childRef);
  }

  return children;
});
Position.displayName = 'Position';
Position.propTypes = {
  className: PropTypes.string,
  children: PropTypes.func.isRequired,
  container: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
  containerPadding: PropTypes.number,
  placement: PropTypes.any,
  preventOverflow: PropTypes.bool,
  triggerTarget: PropTypes.any
};
var Position$1 = Position;

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function getTransitionProperties() {
  if (!canUseDOM$1) {
    return {};
  }

  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var style = document.createElement('div').style;
  var tempTransitionEnd;
  var tempPrefix = '';

  for (var i = 0; i < vendors.length; i += 1) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      tempPrefix = "-" + vendor.toLowerCase();
      tempTransitionEnd = vendorMap[vendor]('TransitionEnd');
      break;
    }
  }

  if (!tempTransitionEnd && 'transitionProperty' in style) {
    tempTransitionEnd = 'transitionend';
  }

  style = null;

  var addPrefix = function addPrefix(name) {
    return tempPrefix + "-" + name;
  };

  return {
    end: tempTransitionEnd,
    backfaceVisibility: addPrefix('backface-visibility'),
    transform: addPrefix('transform'),
    property: addPrefix('transition-property'),
    timing: addPrefix('transition-timing-function'),
    delay: addPrefix('transition-delay'),
    duration: addPrefix('transition-duration')
  };
}

function getTransitionEnd() {
  return getTransitionProperties().end;
}

function getAnimationEnd() {
  var style = document.createElement('div').style;

  if ('webkitAnimation' in style) {
    return 'webkitAnimationEnd';
  }

  return 'animationend';
}
var animationPropTypes = {
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
};

var STATUS;

(function (STATUS) {
  STATUS[STATUS["UNMOUNTED"] = 0] = "UNMOUNTED";
  STATUS[STATUS["EXITED"] = 1] = "EXITED";
  STATUS[STATUS["ENTERING"] = 2] = "ENTERING";
  STATUS[STATUS["ENTERED"] = 3] = "ENTERED";
  STATUS[STATUS["EXITING"] = 4] = "EXITING";
})(STATUS || (STATUS = {}));

var transitionPropTypes = _extends$1({}, animationPropTypes, {
  animation: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  className: PropTypes.string,
  in: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  timeout: PropTypes.number,
  exitedClassName: PropTypes.string,
  exitingClassName: PropTypes.string,
  enteredClassName: PropTypes.string,
  enteringClassName: PropTypes.string
});

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.animationEventListener = null;
    _this.instanceElement = null;
    _this.nextCallback = null;
    _this.needsUpdate = null;
    _this.childRef = void 0;
    var initialStatus;

    if (props.in) {
      initialStatus = props.transitionAppear ? STATUS.EXITED : STATUS.ENTERED;
    } else {
      initialStatus = props.unmountOnExit ? STATUS.UNMOUNTED : STATUS.EXITED;
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    _this.childRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.in && nextProps.unmountOnExit) {
      if (prevState.status === STATUS.UNMOUNTED) {
        // Start enter transition in componentDidUpdate.
        return {
          status: STATUS.EXITED
        };
      }
    }

    return null;
  };

  var _proto = Transition.prototype;

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate() {
    if (!this.props.in || !this.props.unmountOnExit) {
      this.needsUpdate = true;
    }

    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.transitionAppear && this.props.in) {
      this.performEnter(this.props);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var status = this.state.status;
    var unmountOnExit = this.props.unmountOnExit;

    if (unmountOnExit && status === STATUS.EXITED) {
      if (this.props.in) {
        this.performEnter(this.props);
      } else {
        if (this.instanceElement) {
          this.setState({
            status: STATUS.UNMOUNTED
          });
        }
      }

      return;
    }

    if (this.needsUpdate) {
      this.needsUpdate = false;

      if (this.props.in) {
        if (status === STATUS.EXITING || status === STATUS.EXITED) {
          this.performEnter(this.props);
        }
      } else if (status === STATUS.ENTERING || status === STATUS.ENTERED) {
        this.performExit(this.props);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
    this.instanceElement = null;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, handler) {
    var _this$animationEventL;

    this.setNextCallback(handler);
    (_this$animationEventL = this.animationEventListener) === null || _this$animationEventL === void 0 ? void 0 : _this$animationEventL.off();

    if (!this.nextCallback) {
      return;
    }

    if (node) {
      var _this$props = this.props,
          timeout = _this$props.timeout,
          animation = _this$props.animation;
      this.animationEventListener = on(node, animation ? getAnimationEnd() : getTransitionEnd(), this.nextCallback);

      if (timeout !== null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this2 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (!active) {
        return;
      }

      if (event) {
        if (_this2.instanceElement === event.target) {
          callback(event);
          active = false;
          _this2.nextCallback = null;
        }

        return;
      }

      callback(event);
      active = false;
      _this2.nextCallback = null;
    };

    if (this.nextCallback) {
      this.nextCallback.cancel = function () {
        active = false;
      };
    }

    return this.nextCallback;
  };

  _proto.getChildElement = function getChildElement() {
    if (this.childRef.current) {
      return getDOMNode(this.childRef.current);
    }

    return getDOMNode(this);
  };

  _proto.performEnter = function performEnter(props) {
    var _this3 = this;

    var _ref = props || this.props,
        onEnter = _ref.onEnter,
        onEntering = _ref.onEntering,
        onEntered = _ref.onEntered;

    this.cancelNextCallback();
    var node = this.getChildElement();
    this.instanceElement = node;
    onEnter === null || onEnter === void 0 ? void 0 : onEnter(node);
    this.safeSetState({
      status: STATUS.ENTERING
    }, function () {
      onEntering === null || onEntering === void 0 ? void 0 : onEntering(node);

      _this3.onTransitionEnd(node, function () {
        _this3.safeSetState({
          status: STATUS.ENTERED
        }, function () {
          onEntered === null || onEntered === void 0 ? void 0 : onEntered(node);
        });
      });
    });
  };

  _proto.performExit = function performExit(props) {
    var _this4 = this;

    var _ref2 = props || this.props,
        onExit = _ref2.onExit,
        onExiting = _ref2.onExiting,
        onExited = _ref2.onExited;

    this.cancelNextCallback();
    var node = this.getChildElement();
    this.instanceElement = node;
    onExit === null || onExit === void 0 ? void 0 : onExit(node);
    this.safeSetState({
      status: STATUS.EXITING
    }, function () {
      onExiting === null || onExiting === void 0 ? void 0 : onExiting(node);

      _this4.onTransitionEnd(node, function () {
        _this4.safeSetState({
          status: STATUS.EXITED
        }, function () {
          onExited === null || onExited === void 0 ? void 0 : onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    if (this.instanceElement) {
      var nextCallback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        return nextCallback === null || nextCallback === void 0 ? void 0 : nextCallback();
      });
    }
  };

  _proto.render = function render() {
    var _child$props;

    var status = this.state.status;

    if (status === STATUS.UNMOUNTED) {
      return null;
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        exitedClassName = _this$props2.exitedClassName,
        enteringClassName = _this$props2.enteringClassName,
        enteredClassName = _this$props2.enteredClassName,
        exitingClassName = _this$props2.exitingClassName,
        rest = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "exitedClassName", "enteringClassName", "enteredClassName", "exitingClassName"]);

    var childProps = omit_1(rest, Object.keys(transitionPropTypes));
    var transitionClassName;

    if (status === STATUS.EXITED) {
      transitionClassName = exitedClassName;
    } else if (status === STATUS.ENTERING) {
      transitionClassName = enteringClassName;
    } else if (status === STATUS.ENTERED) {
      transitionClassName = enteredClassName;
    } else if (status === STATUS.EXITING) {
      transitionClassName = exitingClassName;
    }

    if (isFunction_1(children)) {
      childProps.className = classNames(className, transitionClassName);
      return children(childProps, this.childRef);
    }

    var child = React__default.Children.only(children);
    return /*#__PURE__*/React__default.cloneElement(child, _extends$1({}, childProps, {
      ref: this.childRef,
      className: classNames(className, (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className, transitionClassName)
    }));
  };

  return Transition;
}(React__default.Component);

Transition.propTypes = transitionPropTypes;
Transition.displayName = 'Transition';
Transition.defaultProps = {
  timeout: 1000
};
var Transition$1 = Transition;

var Fade = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 300 : _ref$timeout,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["timeout", "className"]);

  var _useClassNames = useClassNames('anim'),
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge;

  return /*#__PURE__*/React__default.createElement(Transition$1, _extends$1({}, props, {
    ref: ref,
    timeout: timeout,
    className: merge(className, prefix('fade')),
    enteredClassName: prefix('in'),
    enteringClassName: prefix('in')
  }));
});
Fade.displayName = 'Fade';
var Fade$1 = Fade;

var OverlayContext = /*#__PURE__*/React__default.createContext({});
OverlayContext.displayName = 'OverlayContext';
var OverlayContext$1 = OverlayContext;

var overlayPropTypes = {
  container: PropTypes.any,
  children: PropTypes.any,
  childrenProps: PropTypes.object,
  className: PropTypes.string,
  containerPadding: PropTypes.number,
  placement: PropTypes.any,
  preventOverflow: PropTypes.bool,
  open: PropTypes.bool,
  rootClose: PropTypes.bool,
  transition: PropTypes.any,
  triggerTarget: PropTypes.any,
  onClose: PropTypes.func,
  onEnter: PropTypes.func,
  onEntering: PropTypes.func,
  onEntered: PropTypes.func,
  onExit: PropTypes.func,
  onExiting: PropTypes.func,
  onExited: PropTypes.func
};
var Overlay = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useContext = useContext(OverlayContext$1),
      overlayContainer = _useContext.overlayContainer;

  var _props$container = props.container,
      container = _props$container === void 0 ? overlayContainer : _props$container,
      containerPadding = props.containerPadding,
      placement = props.placement,
      rootClose = props.rootClose,
      children = props.children,
      childrenProps = props.childrenProps,
      _props$transition = props.transition,
      Transition = _props$transition === void 0 ? Fade$1 : _props$transition,
      open = props.open,
      preventOverflow = props.preventOverflow,
      triggerTarget = props.triggerTarget,
      onClose = props.onClose,
      onExited = props.onExited,
      onExit = props.onExit,
      onExiting = props.onExiting,
      onEnter = props.onEnter,
      onEntering = props.onEntering,
      onEntered = props.onEntered;

  var _useState = useState(!open),
      exited = _useState[0],
      setExited = _useState[1];

  var overlayTarget = useRef(null);

  if (open) {
    if (exited) setExited(false);
  } else if (!Transition && !exited) {
    setExited(true);
  }

  var mountOverlay = open || Transition && !exited;
  var handleExited = useCallback(function (args) {
    setExited(true);
    onExited === null || onExited === void 0 ? void 0 : onExited(args);
  }, [onExited]);
  useRootClose(onClose, {
    triggerTarget: triggerTarget,
    overlayTarget: overlayTarget,
    disabled: !rootClose || !mountOverlay
  });

  if (!mountOverlay) {
    return null;
  }

  var positionProps = {
    container: container,
    containerPadding: containerPadding,
    triggerTarget: triggerTarget,
    placement: placement,
    preventOverflow: preventOverflow
  };

  var renderChildWithPosition = function renderChildWithPosition(transitionProps, transitionRef) {
    return /*#__PURE__*/React__default.createElement(Position$1, _extends$1({}, positionProps, transitionProps, {
      ref: mergeRefs(ref, transitionRef)
    }), function (childProps, childRef) {
      // overlayTarget is the ref on the DOM of the Overlay.
      if (typeof children === 'function') {
        return children(Object.assign(childProps, childrenProps), mergeRefs(childRef, overlayTarget));
      } // Position will return coordinates and className


      var left = childProps.left,
          top = childProps.top,
          className = childProps.className;
      return /*#__PURE__*/React__default.cloneElement(children, _extends$1({}, childrenProps, children.props, {
        className: classNames(className, children.props.className),
        style: _extends$1({
          left: left,
          top: top
        }, children.props.style),
        ref: mergeRefs(childRef, overlayTarget)
      }));
    });
  };

  if (Transition) {
    return /*#__PURE__*/React__default.createElement(Transition, {
      in: open,
      transitionAppear: true,
      onExit: onExit,
      onExiting: onExiting,
      onExited: handleExited,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered
    }, renderChildWithPosition);
  }

  return renderChildWithPosition();
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = overlayPropTypes;
var Overlay$1 = Overlay;

function mergeEvents(events, props) {
  if (events === void 0) {
    events = {};
  }

  if (props === void 0) {
    props = {};
  }

  var nextEvents = {};
  Object.keys(events).forEach(function (eventName) {
    if (events[eventName]) {
      var _props;

      nextEvents[eventName] = createChainedFunction(events[eventName], (_props = props) === null || _props === void 0 ? void 0 : _props[eventName]);
    }
  });
  return nextEvents;
}

/**
 * Useful for mouseover and mouseout.
 * In order to resolve the node entering the mouseover element, a mouseout event and a mouseover event will be triggered.
 * https://javascript.info/mousemove-mouseover-mouseout-mouseenter-mouseleave
 * @param handler
 * @param event
 */
function onMouseEventHandler(handler, event, delay) {
  var target = event.currentTarget;
  var related = event.relatedTarget || get_1(event, ['nativeEvent', 'toElement']);

  if ((!related || related !== target) && !contains$1(target, related)) {
    handler(event, delay);
  }
}

var defaultTrigger = ['hover', 'focus'];
var OverlayTrigger = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useContext = useContext(OverlayContext$1),
      overlayContainer = _useContext.overlayContainer;

  var children = props.children,
      _props$container = props.container,
      container = _props$container === void 0 ? overlayContainer : _props$container,
      controlId = props.controlId,
      defaultOpen = props.defaultOpen,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? defaultTrigger : _props$trigger,
      disabled = props.disabled,
      readOnly = props.readOnly,
      plaintext = props.plaintext,
      openProp = props.open,
      delay = props.delay,
      delayOpenProp = props.delayOpen,
      delayCloseProp = props.delayClose,
      enterable = props.enterable,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomStart' : _props$placement,
      speaker = props.speaker,
      _props$rootClose = props.rootClose,
      rootClose = _props$rootClose === void 0 ? true : _props$rootClose,
      onClick = props.onClick,
      onMouseOver = props.onMouseOver,
      onMouseOut = props.onMouseOut,
      onContextMenu = props.onContextMenu,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onClose = props.onClose,
      rest = _objectWithoutPropertiesLoose(props, ["children", "container", "controlId", "defaultOpen", "trigger", "disabled", "readOnly", "plaintext", "open", "delay", "delayOpen", "delayClose", "enterable", "placement", "speaker", "rootClose", "onClick", "onMouseOver", "onMouseOut", "onContextMenu", "onFocus", "onBlur", "onClose"]);

  var _usePortal = usePortal({
    container: container
  }),
      Portal = _usePortal.Portal;

  var triggerRef = useRef();
  var overlayRef = useRef();

  var _useControlled = useControlled(openProp, defaultOpen),
      open = _useControlled[0],
      setOpen = _useControlled[1]; // Delay the timer to close/open the overlay
  // When the cursor moves from the trigger to the overlay, the overlay will be closed.
  // In order to keep the overlay open, a timer is used to delay the closing.


  var delayOpenTimer = useRef(null);
  var delayCloseTimer = useRef(null);
  var delayOpen = isNil_1(delayOpenProp) ? delay : delayOpenProp;
  var delayClose = isNil_1(delayCloseProp) ? delay : delayCloseProp; // Whether the cursor is on the overlay

  var isOnOverlay = useRef(false); // Whether the cursor is on the trigger

  var isOnTrigger = useRef(false);
  useEffect(function () {
    return function () {
      if (!isNil_1(delayOpenTimer.current)) {
        clearTimeout(delayOpenTimer.current);
      }

      if (!isNil_1(delayCloseTimer.current)) {
        clearTimeout(delayCloseTimer.current);
      }
    };
  }, []);
  var handleOpen = useCallback(function (delay) {
    var ms = isUndefined_1(delay) ? delayOpen : delay;

    if (ms && typeof ms === 'number') {
      return delayOpenTimer.current = setTimeout(function () {
        delayOpenTimer.current = null;
        setOpen(true);
      }, ms);
    }

    setOpen(true);
  }, [delayOpen, setOpen]);
  var handleClose = useCallback(function (delay) {
    var ms = isUndefined_1(delay) ? delayClose : delay;

    if (ms && typeof ms === 'number') {
      return delayCloseTimer.current = setTimeout(function () {
        delayCloseTimer.current = null;
        setOpen(false);
      }, ms);
    }

    setOpen(false);
  }, [delayClose, setOpen]);
  useImperativeHandle(ref, function () {
    return {
      get root() {
        return triggerRef.current;
      },

      get overlay() {
        var _overlayRef$current;

        return (_overlayRef$current = overlayRef.current) === null || _overlayRef$current === void 0 ? void 0 : _overlayRef$current.child;
      },

      open: handleOpen,
      close: handleClose,
      updatePosition: function updatePosition() {
        var _overlayRef$current2, _overlayRef$current2$;

        (_overlayRef$current2 = overlayRef.current) === null || _overlayRef$current2 === void 0 ? void 0 : (_overlayRef$current2$ = _overlayRef$current2.updatePosition) === null || _overlayRef$current2$ === void 0 ? void 0 : _overlayRef$current2$.call(_overlayRef$current2);
      }
    };
  });
  /**
   * Close after the cursor leaves.
   */

  var handleCloseWhenLeave = useCallback(function () {
    // When the cursor is not on the overlay and not on the trigger, it is closed.
    if (!isOnOverlay.current && !isOnTrigger.current) {
      handleClose();
    }
  }, [handleClose]);
  /**
   * Toggle open and closed state.
   */

  var handleOpenState = useCallback(function () {
    if (open) {
      handleCloseWhenLeave();
    } else {
      handleOpen();
    }
  }, [open, handleCloseWhenLeave, handleOpen]);
  var handleDelayedOpen = useCallback(function () {
    if (!enterable) {
      return handleOpen();
    }

    isOnTrigger.current = true;

    if (!isNil_1(delayCloseTimer.current)) {
      clearTimeout(delayCloseTimer.current);
      delayCloseTimer.current = null;
      return handleOpen();
    }

    if (open) {
      return;
    }

    handleOpen();
  }, [enterable, open, handleOpen]);
  var handleDelayedClose = useCallback(function () {
    if (!enterable) {
      handleClose();
    }

    isOnTrigger.current = false;

    if (!isNil_1(delayOpenTimer.current)) {
      clearTimeout(delayOpenTimer.current);
      delayOpenTimer.current = null;
      return;
    }

    if (!open || !isNil_1(delayCloseTimer.current)) {
      return;
    }

    delayCloseTimer.current = setTimeout(function () {
      if (!isNil_1(delayCloseTimer.current)) {
        clearTimeout(delayCloseTimer.current);
        delayCloseTimer.current = null;
      }

      handleCloseWhenLeave();
    }, 200);
  }, [enterable, open, handleClose, handleCloseWhenLeave]);
  var handleSpeakerMouseEnter = useCallback(function () {
    isOnOverlay.current = true;
  }, []);
  var handleSpeakerMouseLeave = useCallback(function () {
    isOnOverlay.current = false;

    if (!isOneOf('click', trigger) && !isOneOf('contextMenu', trigger) && !isOneOf('active', trigger)) {
      handleCloseWhenLeave();
    }
  }, [handleCloseWhenLeave, trigger]);
  var preventDefault = useCallback(function (event) {
    event.preventDefault();
  }, []);
  var triggerEvents = {
    onClick: onClick,
    onContextMenu: onContextMenu,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    onFocus: onFocus,
    onBlur: onBlur
  };

  if (!disabled && !readOnly && !plaintext) {
    if (isOneOf('click', trigger)) {
      triggerEvents.onClick = createChainedFunction(handleOpenState, triggerEvents.onClick);
    }

    if (isOneOf('contextMenu', trigger)) {
      triggerEvents.onContextMenu = createChainedFunction(preventDefault, handleOpenState, triggerEvents.onContextMenu);
    }

    if (isOneOf('active', trigger)) {
      triggerEvents.onClick = createChainedFunction(handleDelayedOpen, triggerEvents.onClick);
    }

    if (isOneOf('hover', trigger)) {
      var onMouseOverListener = null;
      var onMouseOutListener = null;

      if (trigger !== 'none') {
        onMouseOverListener = function onMouseOverListener(e) {
          return onMouseEventHandler(handleDelayedOpen, e);
        };

        onMouseOutListener = function onMouseOutListener(e) {
          return onMouseEventHandler(handleDelayedClose, e);
        };
      }

      triggerEvents.onMouseOver = createChainedFunction(onMouseOverListener, onMouseOver);
      triggerEvents.onMouseOut = createChainedFunction(onMouseOutListener, onMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerEvents.onFocus = createChainedFunction(handleDelayedOpen, onFocus);
      triggerEvents.onBlur = createChainedFunction(handleDelayedClose, onBlur);
    }
  }

  var renderOverlay = function renderOverlay() {
    var overlayProps = _extends$1({}, rest, {
      rootClose: rootClose,
      triggerTarget: triggerRef,
      onClose: trigger !== 'none' ? createChainedFunction(handleClose, onClose) : undefined,
      placement: placement,
      container: container,
      open: open
    });

    var speakerProps = {
      id: controlId
    }; // The purpose of adding mouse entry and exit events to the Overlay is to record whether the current cursor is on the Overlay.
    // When `trigger` is equal to `hover`, if the cursor leaves the `triggerTarget` and stays on the Overlay,
    // the Overlay will continue to remain open.

    if (trigger !== 'none' && enterable) {
      speakerProps.onMouseEnter = handleSpeakerMouseEnter;
      speakerProps.onMouseLeave = handleSpeakerMouseLeave;
    }

    return /*#__PURE__*/React__default.createElement(Overlay$1, _extends$1({}, overlayProps, {
      ref: overlayRef,
      childrenProps: speakerProps
    }), typeof speaker === 'function' ? function (props, ref) {
      return speaker(_extends$1({}, props, {
        onClose: handleClose
      }), ref);
    } : speaker);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, typeof children === 'function' ? children(triggerEvents, triggerRef) : /*#__PURE__*/React__default.cloneElement(children, _extends$1({
    ref: triggerRef,
    'aria-describedby': controlId
  }, mergeEvents(triggerEvents, children.props))), /*#__PURE__*/React__default.createElement(Portal, null, renderOverlay()));
});
OverlayTrigger.displayName = 'OverlayTrigger';
var OverlayTrigger$1 = OverlayTrigger;

var _this = undefined;

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

function emptyFunction() {}

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return _this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

// the only reliable means to get the global object is
// `Function('return this')()`
// However, this causes CSP violations in Chrome apps.
// https://github.com/tc39/proposal-global
function getGlobal() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  throw new Error('unable to locate global object');
}

var g = getGlobal();
var lastTime = 0;

function _setTimeout(callback) {
  var currTime = Date.now();
  var timeDelay = Math.max(0, 16 - (currTime - lastTime));
  lastTime = currTime + timeDelay;
  return g.setTimeout(function () {
    callback(Date.now());
  }, timeDelay);
}
/**
 * @deprecated Use `requestAnimationFrame` instead.
 */


var requestAnimationFramePolyfill = g.requestAnimationFrame || _setTimeout; // Works around a rare bug in Safari 6 where the first request is never invoked.

requestAnimationFramePolyfill(emptyFunction);
var requestAnimationFramePolyfill$1 = requestAnimationFramePolyfill;

var getWidth = (function (node, client) {
  var win = getWindow(node);

  if (win) {
    return win.innerWidth;
  }

  if (client) {
    return node.clientWidth;
  }

  var offset = getOffset(node);
  return offset ? offset.width : 0;
});

var CustomContext = /*#__PURE__*/React__default.createContext({});
var Consumer = CustomContext.Consumer;
    CustomContext.Provider;

function FormattedDate(_ref) {
  var date = _ref.date,
      formatStr = _ref.formatStr;

  var _useCustom = useCustom('Calendar'),
      formatDate = _useCustom.formatDate;

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formatDate(date, formatStr));
}

var omitTriggerPropKeys = ['onEntered', 'onExited', 'onEnter', 'onEntering', 'onExit', 'onExiting', 'open', 'defaultOpen', 'onHide', 'container', 'containerPadding', 'preventOverflow'];
var pickTriggerPropKeys = [].concat(omitTriggerPropKeys, ['disabled', 'plaintext', 'readOnly']);
var PickerToggleTrigger = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var pickerProps = props.pickerProps,
      speaker = props.speaker,
      placement = props.placement,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
      rest = _objectWithoutPropertiesLoose(props, ["pickerProps", "speaker", "placement", "trigger"]);

  return /*#__PURE__*/React__default.createElement(Consumer, null, function (context) {
    return /*#__PURE__*/React__default.createElement(OverlayTrigger$1, _extends$1({}, rest, pick_1(pickerProps, pickTriggerPropKeys), {
      ref: ref,
      trigger: trigger,
      placement: placementPolyfill(placement, context === null || context === void 0 ? void 0 : context.rtl),
      speaker: speaker
    }));
  });
});
PickerToggleTrigger.displayName = 'PickerToggleTrigger';
var PickerToggleTrigger$1 = PickerToggleTrigger;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

var isNumber_1 = isNumber;

var List$2 = {};

var List$1 = {};

var interopRequireWildcard = {exports: {}};

var _typeof = {exports: {}};

(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof));

(function (module) {
var _typeof$1 = _typeof.exports["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireWildcard));

var classCallCheck = {exports: {}};

(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(classCallCheck));

var createClass = {exports: {}};

(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(createClass));

var possibleConstructorReturn = {exports: {}};

var assertThisInitialized = {exports: {}};

(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(assertThisInitialized));

(function (module) {
var _typeof$1 = _typeof.exports["default"];

var assertThisInitialized$1 = assertThisInitialized.exports;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized$1(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(possibleConstructorReturn));

var getPrototypeOf = {exports: {}};

(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(getPrototypeOf));

var inherits = {exports: {}};

var setPrototypeOf = {exports: {}};

(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(setPrototypeOf));

(function (module) {
var setPrototypeOf$1 = setPrototypeOf.exports;

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf$1(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(inherits));

var defineProperty = {exports: {}};

(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(defineProperty));

var Grid$1 = {};

var Grid = {};

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx_m () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

var clsx_m$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': clsx_m
});

var require$$12 = /*@__PURE__*/getAugmentedNamespace(clsx_m$1);

var calculateSizeAndPositionDataAndUpdateScrollOffset = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateSizeAndPositionDataAndUpdateScrollOffset;

/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
}(calculateSizeAndPositionDataAndUpdateScrollOffset));

var ScalingCellSizeAndPositionManager = {};

var objectWithoutProperties = {exports: {}};

(function (module) {
var objectWithoutPropertiesLoose$1 = objectWithoutPropertiesLoose.exports;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(objectWithoutProperties));

var CellSizeAndPositionManager = {};

var types$1 = {};

var _interopRequireDefault$2 = interopRequireDefault.exports;

var _interopRequireWildcard$1 = interopRequireWildcard.exports;

Object.defineProperty(types$1, "__esModule", {
  value: true
});
types$1.bpfrpt_proptype_VisibleCellRange = types$1.bpfrpt_proptype_Alignment = types$1.bpfrpt_proptype_OverscanIndicesGetter = types$1.bpfrpt_proptype_OverscanIndices = types$1.bpfrpt_proptype_OverscanIndicesGetterParams = types$1.bpfrpt_proptype_RenderedSection = types$1.bpfrpt_proptype_ScrollbarPresenceChange = types$1.bpfrpt_proptype_Scroll = types$1.bpfrpt_proptype_NoContentRenderer = types$1.bpfrpt_proptype_CellSize = types$1.bpfrpt_proptype_CellSizeGetter = types$1.bpfrpt_proptype_CellRangeRenderer = types$1.bpfrpt_proptype_CellRangeRendererParams = types$1.bpfrpt_proptype_StyleCache = types$1.bpfrpt_proptype_CellCache = types$1.bpfrpt_proptype_CellRenderer = types$1.bpfrpt_proptype_CellRendererParams = types$1.bpfrpt_proptype_CellPosition = void 0;

_interopRequireWildcard$1(React__default);

var _ScalingCellSizeAndPositionManager = _interopRequireDefault$2(ScalingCellSizeAndPositionManager);

var _propTypes$2 = _interopRequireDefault$2(propTypes.exports);

var bpfrpt_proptype_CellPosition = process.env.NODE_ENV === 'production' ? null : {
  "columnIndex": _propTypes$2["default"].number.isRequired,
  "rowIndex": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
var bpfrpt_proptype_CellRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "columnIndex": _propTypes$2["default"].number.isRequired,
  "isScrolling": _propTypes$2["default"].bool.isRequired,
  "isVisible": _propTypes$2["default"].bool.isRequired,
  "key": _propTypes$2["default"].string.isRequired,
  "parent": _propTypes$2["default"].object.isRequired,
  "rowIndex": _propTypes$2["default"].number.isRequired,
  "style": _propTypes$2["default"].object.isRequired
};
types$1.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
var bpfrpt_proptype_CellRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].func;
types$1.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
var bpfrpt_proptype_CellCache = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].objectOf(_propTypes$2["default"].node.isRequired);
types$1.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
var bpfrpt_proptype_StyleCache = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].objectOf(_propTypes$2["default"].object.isRequired);
types$1.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
var bpfrpt_proptype_CellRangeRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "cellCache": _propTypes$2["default"].objectOf(_propTypes$2["default"].node.isRequired).isRequired,
  "cellRenderer": _propTypes$2["default"].func.isRequired,
  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes$2["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes$2["default"].any.isRequired).apply(this, arguments);
  },
  "columnStartIndex": _propTypes$2["default"].number.isRequired,
  "columnStopIndex": _propTypes$2["default"].number.isRequired,
  "deferredMeasurementCache": _propTypes$2["default"].object,
  "horizontalOffsetAdjustment": _propTypes$2["default"].number.isRequired,
  "isScrolling": _propTypes$2["default"].bool.isRequired,
  "isScrollingOptOut": _propTypes$2["default"].bool.isRequired,
  "parent": _propTypes$2["default"].object.isRequired,
  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager["default"] === "function" ? _propTypes$2["default"].instanceOf(_ScalingCellSizeAndPositionManager["default"]).isRequired : _propTypes$2["default"].any.isRequired).apply(this, arguments);
  },
  "rowStartIndex": _propTypes$2["default"].number.isRequired,
  "rowStopIndex": _propTypes$2["default"].number.isRequired,
  "scrollLeft": _propTypes$2["default"].number.isRequired,
  "scrollTop": _propTypes$2["default"].number.isRequired,
  "styleCache": _propTypes$2["default"].objectOf(_propTypes$2["default"].object.isRequired).isRequired,
  "verticalOffsetAdjustment": _propTypes$2["default"].number.isRequired,
  "visibleColumnIndices": _propTypes$2["default"].object.isRequired,
  "visibleRowIndices": _propTypes$2["default"].object.isRequired
};
types$1.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
var bpfrpt_proptype_CellRangeRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].func;
types$1.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
var bpfrpt_proptype_CellSizeGetter = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].func;
types$1.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
var bpfrpt_proptype_CellSize = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].oneOfType([_propTypes$2["default"].func, _propTypes$2["default"].number]);
types$1.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
var bpfrpt_proptype_NoContentRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].func;
types$1.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
var bpfrpt_proptype_Scroll$1 = process.env.NODE_ENV === 'production' ? null : {
  "clientHeight": _propTypes$2["default"].number.isRequired,
  "clientWidth": _propTypes$2["default"].number.isRequired,
  "scrollHeight": _propTypes$2["default"].number.isRequired,
  "scrollLeft": _propTypes$2["default"].number.isRequired,
  "scrollTop": _propTypes$2["default"].number.isRequired,
  "scrollWidth": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll$1;
var bpfrpt_proptype_ScrollbarPresenceChange = process.env.NODE_ENV === 'production' ? null : {
  "horizontal": _propTypes$2["default"].bool.isRequired,
  "vertical": _propTypes$2["default"].bool.isRequired,
  "size": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
var bpfrpt_proptype_RenderedSection = process.env.NODE_ENV === 'production' ? null : {
  "columnOverscanStartIndex": _propTypes$2["default"].number.isRequired,
  "columnOverscanStopIndex": _propTypes$2["default"].number.isRequired,
  "columnStartIndex": _propTypes$2["default"].number.isRequired,
  "columnStopIndex": _propTypes$2["default"].number.isRequired,
  "rowOverscanStartIndex": _propTypes$2["default"].number.isRequired,
  "rowOverscanStopIndex": _propTypes$2["default"].number.isRequired,
  "rowStartIndex": _propTypes$2["default"].number.isRequired,
  "rowStopIndex": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
var bpfrpt_proptype_OverscanIndicesGetterParams = process.env.NODE_ENV === 'production' ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  "direction": _propTypes$2["default"].oneOf(["horizontal", "vertical"]).isRequired,
  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  "scrollDirection": _propTypes$2["default"].oneOf([-1, 1]).isRequired,
  // Number of rows or columns in the current axis
  "cellCount": _propTypes$2["default"].number.isRequired,
  // Maximum number of cells to over-render in either direction
  "overscanCellsCount": _propTypes$2["default"].number.isRequired,
  // Begin of range of visible cells
  "startIndex": _propTypes$2["default"].number.isRequired,
  // End of range of visible cells
  "stopIndex": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
var bpfrpt_proptype_OverscanIndices = process.env.NODE_ENV === 'production' ? null : {
  "overscanStartIndex": _propTypes$2["default"].number.isRequired,
  "overscanStopIndex": _propTypes$2["default"].number.isRequired
};
types$1.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
var bpfrpt_proptype_OverscanIndicesGetter = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].func;
types$1.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
var bpfrpt_proptype_Alignment = process.env.NODE_ENV === 'production' ? null : _propTypes$2["default"].oneOf(["auto", "end", "start", "center"]);
types$1.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
var bpfrpt_proptype_VisibleCellRange = process.env.NODE_ENV === 'production' ? null : {
  "start": _propTypes$2["default"].number,
  "stop": _propTypes$2["default"].number
};
types$1.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(classCallCheck.exports);

var _createClass2 = _interopRequireDefault(createClass.exports);

var _defineProperty2 = _interopRequireDefault(defineProperty.exports);

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;
    (0, _classCallCheck2["default"])(this, CellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
    (0, _defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
    (0, _defineProperty2["default"])(this, "_lastBatchedIndex", -1);
    (0, _defineProperty2["default"])(this, "_cellCount", void 0);
    (0, _defineProperty2["default"])(this, "_cellSizeGetter", void 0);
    (0, _defineProperty2["default"])(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  (0, _createClass2["default"])(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
  return CellSizeAndPositionManager;
}();

exports["default"] = CellSizeAndPositionManager;
}(CellSizeAndPositionManager));

var maxElementSize = {};

Object.defineProperty(maxElementSize, "__esModule", {
  value: true
});
maxElementSize.getMaxElementSize = void 0;
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};

maxElementSize.getMaxElementSize = getMaxElementSize;

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(objectWithoutProperties.exports);

var _classCallCheck2 = _interopRequireDefault(classCallCheck.exports);

var _createClass2 = _interopRequireDefault(createClass.exports);

var _defineProperty2 = _interopRequireDefault(defineProperty.exports);

var _CellSizeAndPositionManager = _interopRequireDefault(CellSizeAndPositionManager);

var _maxElementSize = maxElementSize;

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
        params = (0, _objectWithoutProperties2["default"])(_ref, ["maxScrollSize"]);
    (0, _classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
    (0, _defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
    (0, _defineProperty2["default"])(this, "_maxScrollSize", void 0);
    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager["default"](params);
    this._maxScrollSize = maxScrollSize;
  }

  (0, _createClass2["default"])(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
  return ScalingCellSizeAndPositionManager;
}();

exports["default"] = ScalingCellSizeAndPositionManager;
}(ScalingCellSizeAndPositionManager));

var createCallbackMemoizer = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCallbackMemoizer;

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
}(createCallbackMemoizer));

var defaultOverscanIndicesGetter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}
}(defaultOverscanIndicesGetter));

var updateScrollIndexHelper = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = updateScrollIndexHelper;

_interopRequireDefault(ScalingCellSizeAndPositionManager);

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}
}(updateScrollIndexHelper));

var defaultCellRangeRenderer = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultCellRangeRenderer;

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (process.env.NODE_ENV !== 'production') {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (process.env.NODE_ENV !== 'production') {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}
}(defaultCellRangeRenderer));

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

var scrollbarSize$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': scrollbarSize
});

var require$$18 = /*@__PURE__*/getAugmentedNamespace(scrollbarSize$1);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    polyfill: polyfill
});

var require$$19 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

var requestAnimationTimeout$1 = {};

var animationFrame = {};

Object.defineProperty(animationFrame, "__esModule", {
  value: true
});
animationFrame.caf = animationFrame.raf = void 0;
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
animationFrame.raf = raf;
var caf = cancel;
animationFrame.caf = caf;

var _interopRequireDefault$1 = interopRequireDefault.exports;

Object.defineProperty(requestAnimationTimeout$1, "__esModule", {
  value: true
});
requestAnimationTimeout$1.bpfrpt_proptype_AnimationTimeoutId = requestAnimationTimeout$1.requestAnimationTimeout = requestAnimationTimeout$1.cancelAnimationTimeout = void 0;

var _animationFrame = animationFrame;

var _propTypes$1 = _interopRequireDefault$1(propTypes.exports);

var bpfrpt_proptype_AnimationTimeoutId = process.env.NODE_ENV === 'production' ? null : {
  "id": _propTypes$1["default"].number.isRequired
};
requestAnimationTimeout$1.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return (0, _animationFrame.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */


requestAnimationTimeout$1.cancelAnimationTimeout = cancelAnimationTimeout;

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = (0, _animationFrame.raf)(timeout);
    }
  };

  var frame = {
    id: (0, _animationFrame.raf)(timeout)
  };
  return frame;
};

requestAnimationTimeout$1.requestAnimationTimeout = requestAnimationTimeout;

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var _extends2 = _interopRequireDefault(_extends.exports);

var _classCallCheck2 = _interopRequireDefault(classCallCheck.exports);

var _createClass2 = _interopRequireDefault(createClass.exports);

var _possibleConstructorReturn2 = _interopRequireDefault(possibleConstructorReturn.exports);

var _getPrototypeOf2 = _interopRequireDefault(getPrototypeOf.exports);

var _assertThisInitialized2 = _interopRequireDefault(assertThisInitialized.exports);

var _inherits2 = _interopRequireDefault(inherits.exports);

var _defineProperty2 = _interopRequireDefault(defineProperty.exports);

var React = _interopRequireWildcard(React__default);

var _clsx = _interopRequireDefault(require$$12);

var _calculateSizeAndPositionDataAndUpdateScrollOffset = _interopRequireDefault(calculateSizeAndPositionDataAndUpdateScrollOffset);

var _ScalingCellSizeAndPositionManager = _interopRequireDefault(ScalingCellSizeAndPositionManager);

var _createCallbackMemoizer = _interopRequireDefault(createCallbackMemoizer);

var _defaultOverscanIndicesGetter = _interopRequireWildcard(defaultOverscanIndicesGetter);

var _updateScrollIndexHelper = _interopRequireDefault(updateScrollIndexHelper);

var _defaultCellRangeRenderer = _interopRequireDefault(defaultCellRangeRenderer);

var _scrollbarSize = _interopRequireDefault(require$$18);

var _reactLifecyclesCompat = require$$19;

var _requestAnimationTimeout = requestAnimationTimeout$1;

var _types = types$1;

var _propTypes = _interopRequireDefault(propTypes.exports);

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = DEFAULT_SCROLLING_RESET_TIME_INTERVAL;
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Grid);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Grid).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onGridRenderedMemoizer", (0, _createCallbackMemoizer["default"])());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollMemoizer", (0, _createCallbackMemoizer["default"])(false));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateColumnIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_deferredInvalidateRowIndex", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollLeftFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_recomputeScrollTopFlag", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_horizontalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_verticalScrollBarSize", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollbarPresenceChanged", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_scrollingContainer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_childrenToDisplay", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_columnStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStartIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_rowStopIndex", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedColumnStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStartIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedRowStopIndex", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollTop", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_initialScrollLeft", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disablePointerEventsTimeoutId", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_styleCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellCache", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });
    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager["default"]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  (0, _createClass2["default"])(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper["default"])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return React.createElement("div", (0, _extends2["default"])({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: (0, _clsx["default"])('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);
  return Grid;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  "aria-label": _propTypes["default"].string.isRequired,
  "aria-readonly": _propTypes["default"].bool,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  "autoContainerWidth": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoWidth": _propTypes["default"].bool.isRequired,

  /** Responsible for rendering a cell given an row and column index.  */
  "cellRenderer": function cellRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRenderer === "function" ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a group of cells given their index ranges.  */
  "cellRangeRenderer": function cellRangeRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === "function" ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },

  /** Optional custom CSS class name to attach to root Grid element.  */
  "className": _propTypes["default"].string,

  /** Number of columns in grid.  */
  "columnCount": _propTypes["default"].number.isRequired,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  "columnWidth": function columnWidth() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Unfiltered props for the Grid container. */
  "containerProps": _propTypes["default"].object,

  /** ARIA role for the cell-container.  */
  "containerRole": _propTypes["default"].string.isRequired,

  /** Optional inline style applied to inner cell-container */
  "containerStyle": _propTypes["default"].object.isRequired,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  "deferredMeasurementCache": _propTypes["default"].object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  "estimatedColumnSize": _propTypes["default"].number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Exposed for testing purposes only.  */
  "getScrollbarSize": _propTypes["default"].func.isRequired,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  "height": _propTypes["default"].number.isRequired,

  /** Optional custom id to attach to root Grid element.  */
  "id": _propTypes["default"].string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  "isScrolling": _propTypes["default"].bool,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  "isScrollingOptOut": _propTypes["default"].bool.isRequired,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  "noContentRenderer": function noContentRenderer() {
    return (typeof _types.bpfrpt_proptype_NoContentRenderer === "function" ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  "onScrollbarPresenceChange": _propTypes["default"].func.isRequired,

  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  "onSectionRendered": _propTypes["default"].func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanColumnCount": _propTypes["default"].number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** ARIA role for the grid element.  */
  "role": _propTypes["default"].string.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  "rowHeight": function rowHeight() {
    return (typeof _types.bpfrpt_proptype_CellSize === "function" ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Number of rows in grid.  */
  "rowCount": _propTypes["default"].number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  "scrollingResetTimeInterval": _propTypes["default"].number.isRequired,

  /** Horizontal offset. */
  "scrollLeft": _propTypes["default"].number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _types.bpfrpt_proptype_Alignment === "function" ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToColumn": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToRow": _propTypes["default"].number.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  "width": _propTypes["default"].number.isRequired
}), _temp);
(0, _defineProperty2["default"])(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: _defaultCellRangeRenderer["default"],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize["default"],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter["default"],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
(0, _reactLifecyclesCompat.polyfill)(Grid);
var _default = Grid;
exports["default"] = _default;
}(Grid));

var accessibilityOverscanIndicesGetter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = defaultOverscanIndicesGetter;
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = void 0;

var SCROLL_DIRECTION_BACKWARD = -1;
exports.SCROLL_DIRECTION_BACKWARD = SCROLL_DIRECTION_BACKWARD;
var SCROLL_DIRECTION_FORWARD = 1;
exports.SCROLL_DIRECTION_FORWARD = SCROLL_DIRECTION_FORWARD;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
exports.SCROLL_DIRECTION_HORIZONTAL = SCROLL_DIRECTION_HORIZONTAL;
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

exports.SCROLL_DIRECTION_VERTICAL = SCROLL_DIRECTION_VERTICAL;

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}
}(accessibilityOverscanIndicesGetter));

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _Grid["default"];
  }
});
Object.defineProperty(exports, "accessibilityOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _accessibilityOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "defaultCellRangeRenderer", {
  enumerable: true,
  get: function get() {
    return _defaultCellRangeRenderer["default"];
  }
});
Object.defineProperty(exports, "defaultOverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _defaultOverscanIndicesGetter["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_NoContentRenderer", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_NoContentRenderer;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Alignment", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Alignment;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellPosition", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellPosition;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellSize", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellSize;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_OverscanIndicesGetter", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_OverscanIndicesGetter;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RenderedSection", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RenderedSection;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_CellRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_CellRendererParams;
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_Scroll", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_Scroll;
  }
});

var _Grid = _interopRequireDefault(Grid);

var _accessibilityOverscanIndicesGetter = _interopRequireDefault(accessibilityOverscanIndicesGetter);

var _defaultCellRangeRenderer = _interopRequireDefault(defaultCellRangeRenderer);

var _defaultOverscanIndicesGetter = _interopRequireDefault(defaultOverscanIndicesGetter);

var _types = types$1;
}(Grid$1));

var types = {};

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(types, "__esModule", {
  value: true
});
types.bpfrpt_proptype_Scroll = types.bpfrpt_proptype_RenderedRows = types.bpfrpt_proptype_RowRenderer = types.bpfrpt_proptype_RowRendererParams = void 0;

_interopRequireWildcard(React__default);

var _propTypes = _interopRequireDefault(propTypes.exports);

var bpfrpt_proptype_RowRendererParams = process.env.NODE_ENV === 'production' ? null : {
  "index": _propTypes["default"].number.isRequired,
  "isScrolling": _propTypes["default"].bool.isRequired,
  "isVisible": _propTypes["default"].bool.isRequired,
  "key": _propTypes["default"].string.isRequired,
  "parent": _propTypes["default"].object.isRequired,
  "style": _propTypes["default"].object.isRequired
};
types.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
var bpfrpt_proptype_RowRenderer = process.env.NODE_ENV === 'production' ? null : _propTypes["default"].func;
types.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
var bpfrpt_proptype_RenderedRows = process.env.NODE_ENV === 'production' ? null : {
  "overscanStartIndex": _propTypes["default"].number.isRequired,
  "overscanStopIndex": _propTypes["default"].number.isRequired,
  "startIndex": _propTypes["default"].number.isRequired,
  "stopIndex": _propTypes["default"].number.isRequired
};
types.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
var bpfrpt_proptype_Scroll = process.env.NODE_ENV === 'production' ? null : {
  "clientHeight": _propTypes["default"].number.isRequired,
  "scrollHeight": _propTypes["default"].number.isRequired,
  "scrollTop": _propTypes["default"].number.isRequired
};
types.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(_extends.exports);

var _classCallCheck2 = _interopRequireDefault(classCallCheck.exports);

var _createClass2 = _interopRequireDefault(createClass.exports);

var _possibleConstructorReturn2 = _interopRequireDefault(possibleConstructorReturn.exports);

var _getPrototypeOf3 = _interopRequireDefault(getPrototypeOf.exports);

var _assertThisInitialized2 = _interopRequireDefault(assertThisInitialized.exports);

var _inherits2 = _interopRequireDefault(inherits.exports);

var _defineProperty2 = _interopRequireDefault(defineProperty.exports);

var _Grid = _interopRequireWildcard(Grid$1);

var React = _interopRequireWildcard(React__default);

var _clsx = _interopRequireDefault(require$$12);

var _types = types;

var _propTypes = _interopRequireDefault(propTypes.exports);

var _class, _temp;

var List = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "Grid", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = (0, _clsx["default"])('ReactVirtualized__List', className);
      return React.createElement(_Grid["default"], (0, _extends2["default"])({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
  return List;
}(React.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  "aria-label": _propTypes["default"].string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  "autoHeight": _propTypes["default"].bool.isRequired,

  /** Optional CSS class name */
  "className": _propTypes["default"].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": _propTypes["default"].number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  "height": _propTypes["default"].number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  "noRowsRenderer": function noRowsRenderer() {
    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === "function" ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes["default"].shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /** Callback invoked with information about the slice of rows that were just rendered.  */
  "onRowsRendered": _propTypes["default"].func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": _propTypes["default"].func.isRequired,

  /** See Grid#overscanIndicesGetter */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === "function" ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes["default"].shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  "overscanRowCount": _propTypes["default"].number.isRequired,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  "rowHeight": function rowHeight() {
    return (typeof _Grid.bpfrpt_proptype_CellSize === "function" ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes["default"].shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  "rowRenderer": function rowRenderer() {
    return (typeof _types.bpfrpt_proptype_RowRenderer === "function" ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes["default"].shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },

  /** Number of rows in list. */
  "rowCount": _propTypes["default"].number.isRequired,

  /** See Grid#scrollToAlignment */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof _Grid.bpfrpt_proptype_Alignment === "function" ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes["default"].shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToIndex": _propTypes["default"].number.isRequired,

  /** Vertical offset. */
  "scrollTop": _propTypes["default"].number,

  /** Optional inline style */
  "style": _propTypes["default"].object.isRequired,

  /** Tab index for focus */
  "tabIndex": _propTypes["default"].number,

  /** Width of list */
  "width": _propTypes["default"].number.isRequired
}), _temp);
exports["default"] = List;
(0, _defineProperty2["default"])(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});
}(List$1));

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function get() {
    return _List["default"];
  }
});
Object.defineProperty(exports, "bpfrpt_proptype_RowRendererParams", {
  enumerable: true,
  get: function get() {
    return _types.bpfrpt_proptype_RowRendererParams;
  }
});

var _List = _interopRequireDefault(List$1);

var _types = types;
}(List$2));

var VirtualizedList = /*@__PURE__*/getDefaultExportFromCjs(List$2);

var AutoSizer$2 = {};

var AutoSizer$1 = {};

var detectElementResize = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createDetectElementResize;

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = commonjsGlobal;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
}(detectElementResize));

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(classCallCheck.exports);

var _createClass2 = _interopRequireDefault(createClass.exports);

var _possibleConstructorReturn2 = _interopRequireDefault(possibleConstructorReturn.exports);

var _getPrototypeOf3 = _interopRequireDefault(getPrototypeOf.exports);

var _assertThisInitialized2 = _interopRequireDefault(assertThisInitialized.exports);

var _inherits2 = _interopRequireDefault(inherits.exports);

var _defineProperty2 = _interopRequireDefault(defineProperty.exports);

var React = _interopRequireWildcard(React__default);

var _detectElementResize = _interopRequireDefault(detectElementResize);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AutoSizer = (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parentNode", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_autoSizer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_window", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_detectElementResize", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }

  (0, _createClass2["default"])(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = (0, _detectElementResize["default"])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return React.createElement("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);
  return AutoSizer;
}(React.Component), (0, _defineProperty2["default"])(_class, "propTypes", process.env.NODE_ENV === 'production' ? null : {
  /** Function responsible for rendering children.*/
  "children": _propTypes["default"].func.isRequired,

  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  "className": _propTypes["default"].string,

  /** Default height to use for initial render; useful for SSR */
  "defaultHeight": _propTypes["default"].number,

  /** Default width to use for initial render; useful for SSR */
  "defaultWidth": _propTypes["default"].number,

  /** Disable dynamic :height property */
  "disableHeight": _propTypes["default"].bool.isRequired,

  /** Disable dynamic :width property */
  "disableWidth": _propTypes["default"].bool.isRequired,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  "nonce": _propTypes["default"].string,

  /** Callback to be invoked on-resize */
  "onResize": _propTypes["default"].func.isRequired,

  /** Optional inline style */
  "style": _propTypes["default"].object
}), _temp);
exports["default"] = AutoSizer;
(0, _defineProperty2["default"])(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});
}(AutoSizer$1));

(function (exports) {

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});
Object.defineProperty(exports, "AutoSizer", {
  enumerable: true,
  get: function get() {
    return _AutoSizer["default"];
  }
});

var _AutoSizer = _interopRequireDefault(AutoSizer$1);
}(AutoSizer$2));

var VirtualizedAutoSizer = /*@__PURE__*/getDefaultExportFromCjs(AutoSizer$2);

var List = VirtualizedList;
var AutoSizer = VirtualizedAutoSizer;

/**
 *  Make the component display in plain text, and display default characters when there is no children.
 */
var Plaintext = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useCustom = useCustom('Plaintext'),
      locale = _useCustom.locale;

  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'plaintext' : _props$classPrefix,
      className = props.className,
      children = props.children,
      _props$localeKey = props.localeKey,
      localeKey = _props$localeKey === void 0 ? '' : _props$localeKey,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? locale[localeKey] : _props$placeholder,
      rest = _objectWithoutPropertiesLoose(props, ["as", "classPrefix", "className", "children", "localeKey", "placeholder"]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var classes = merge(className, withClassPrefix({
    empty: !children
  }));
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    className: classes
  }), children ? children : placeholder);
});
Plaintext.displayName = 'Plaintext';
var Plaintext$1 = Plaintext;

var omitProps = ['placement', 'arrowOffsetLeft', 'arrowOffsetTop', 'positionLeft', 'positionTop', 'getPositionInstance', 'getToggleInstance', 'autoWidth'];
var resizePlacement = ['topStart', 'topEnd', 'leftEnd', 'rightEnd', 'auto', 'autoVerticalStart', 'autoVerticalEnd', 'autoHorizontalEnd'];
var PickerOverlay = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'picker-menu' : _props$classPrefix,
      autoWidth = props.autoWidth,
      className = props.className,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomStart' : _props$placement,
      target = props.target,
      rest = _objectWithoutPropertiesLoose(props, ["as", "classPrefix", "autoWidth", "className", "placement", "target"]);

  var overlayRef = useRef(null);
  var handleResize = useCallback(function () {
    var instance = target === null || target === void 0 ? void 0 : target.current;

    if (instance && resizePlacement.includes(placement)) {
      instance.updatePosition();
    }
  }, [target, placement]);
  useElementResize(useCallback(function () {
    return overlayRef.current;
  }, []), handleResize);
  useEffect(function () {
    var toggle = target === null || target === void 0 ? void 0 : target.current;

    if (autoWidth && toggle !== null && toggle !== void 0 && toggle.root) {
      // Get the width value of the button,
      // and then set it to the menu to make their width consistent.
      var width = getWidth(getDOMNode(toggle.root));

      if (overlayRef.current) {
        addStyle(overlayRef.current, 'min-width', width + "px");
      }
    }
  }, [autoWidth, target, overlayRef]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, omit_1(rest, omitProps), {
    ref: mergeRefs(overlayRef, ref),
    className: classes
  }));
});
PickerOverlay.displayName = 'PickerOverlay';
var PickerOverlay$1 = PickerOverlay;

var root = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

var now_1 = now$1;

var isObject = isObject_1,
    now = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

var ToggleButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(Button$1, _extends$1({}, props, {
    ref: ref,
    as: "div",
    ripple: false
  }));
});
ToggleButton.displayName = 'ToggleButton';
var ToggleButton$1 = ToggleButton;

/**
 * Close button for components such as Message and Notification.
 */
var CloseButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'span' : _props$as,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'btn-close' : _props$classPrefix,
      className = props.className,
      overrideLocale = props.locale,
      rest = _objectWithoutPropertiesLoose(props, ["as", "classPrefix", "className", "locale"]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var _useCustom = useCustom('CloseButton', overrideLocale),
      locale = _useCustom.locale;

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "button"
  }, rest, {
    ref: ref,
    className: classes,
    title: locale === null || locale === void 0 ? void 0 : locale.closeLabel,
    "aria-label": locale === null || locale === void 0 ? void 0 : locale.closeLabel
  }), /*#__PURE__*/React__default.createElement(Close, null));
});
CloseButton.displayName = 'CloseButton';
var CloseButton$1 = CloseButton;

var AngleDown$2 = {};

var AngleDown$1 = {exports: {}};

var AngleDown = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AngleDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 32",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.196 13.143a.612.612 0 01-.179.411l-8.321 8.321c-.107.107-.268.179-.411.179s-.304-.071-.411-.179l-8.321-8.321c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l.893-.893a.582.582 0 01.411-.179c.143 0 .304.071.411.179l7.018 7.018 7.018-7.018c.107-.107.268-.179.411-.179s.304.071.411.179l.893.893a.617.617 0 01.179.411z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(AngleDown);
var _default = ForwardRef;
exports["default"] = _default;
}(AngleDown));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _AngleDown = _interopRequireDefault(AngleDown);

// Generated by script, don't edit it please.
var AngleDown$1 = (0, _createSvgIcon["default"])({
  as: _AngleDown["default"],
  ariaLabel: 'angle down',
  category: 'legacy',
  displayName: 'AngleDown'
});
var _default = AngleDown$1;
exports["default"] = _default;
module.exports = exports.default;
}(AngleDown$1, AngleDown$1.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AngleDown["default"];
  }
});

var _AngleDown = _interopRequireDefault(AngleDown$1.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(AngleDown$2));

var AngleDownIcon = /*@__PURE__*/getDefaultExportFromCjs(AngleDown$2);

var AngleUp$2 = {};

var AngleUp$1 = {exports: {}};

var AngleUp = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AngleUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 32",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.196 21.143a.612.612 0 01-.179.411l-.893.893a.582.582 0 01-.411.179.612.612 0 01-.411-.179l-7.018-7.018-7.018 7.018c-.107.107-.268.179-.411.179s-.304-.071-.411-.179l-.893-.893c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l8.321-8.321c.107-.107.268-.179.411-.179s.304.071.411.179l8.321 8.321a.617.617 0 01.179.411z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(AngleUp);
var _default = ForwardRef;
exports["default"] = _default;
}(AngleUp));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _AngleUp = _interopRequireDefault(AngleUp);

// Generated by script, don't edit it please.
var AngleUp$1 = (0, _createSvgIcon["default"])({
  as: _AngleUp["default"],
  ariaLabel: 'angle up',
  category: 'legacy',
  displayName: 'AngleUp'
});
var _default = AngleUp$1;
exports["default"] = _default;
module.exports = exports.default;
}(AngleUp$1, AngleUp$1.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AngleUp["default"];
  }
});

var _AngleUp = _interopRequireDefault(AngleUp$1.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(AngleUp$2));

var AngleUpIcon = /*@__PURE__*/getDefaultExportFromCjs(AngleUp$2);

var AngleLeft$2 = {};

var AngleLeft$1 = {exports: {}};

var AngleLeft = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AngleLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 32",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.196 9.714a.612.612 0 01-.179.411l-7.018 7.018 7.018 7.018c.107.107.179.268.179.411s-.071.304-.179.411l-.893.893c-.107.107-.268.179-.411.179s-.304-.071-.411-.179L.981 17.555c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l8.321-8.321c.107-.107.268-.179.411-.179s.304.071.411.179l.893.893c.107.107.179.25.179.411z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(AngleLeft);
var _default = ForwardRef;
exports["default"] = _default;
}(AngleLeft));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _AngleLeft = _interopRequireDefault(AngleLeft);

// Generated by script, don't edit it please.
var AngleLeft$1 = (0, _createSvgIcon["default"])({
  as: _AngleLeft["default"],
  ariaLabel: 'angle left',
  category: 'legacy',
  displayName: 'AngleLeft'
});
var _default = AngleLeft$1;
exports["default"] = _default;
module.exports = exports.default;
}(AngleLeft$1, AngleLeft$1.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AngleLeft["default"];
  }
});

var _AngleLeft = _interopRequireDefault(AngleLeft$1.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(AngleLeft$2));

var AngleLeftIcon = /*@__PURE__*/getDefaultExportFromCjs(AngleLeft$2);

var AngleRight$2 = {};

var AngleRight$1 = {exports: {}};

var AngleRight = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AngleRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 32",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 17.143a.612.612 0 01-.179.411l-8.321 8.321c-.107.107-.268.179-.411.179s-.304-.071-.411-.179l-.893-.893a.582.582 0 01-.179-.411c0-.143.071-.304.179-.411l7.018-7.018L.41 10.124c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l.893-.893c.107-.107.268-.179.411-.179s.304.071.411.179l8.321 8.321a.617.617 0 01.179.411z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(AngleRight);
var _default = ForwardRef;
exports["default"] = _default;
}(AngleRight));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _AngleRight = _interopRequireDefault(AngleRight);

// Generated by script, don't edit it please.
var AngleRight$1 = (0, _createSvgIcon["default"])({
  as: _AngleRight["default"],
  ariaLabel: 'angle right',
  category: 'legacy',
  displayName: 'AngleRight'
});
var _default = AngleRight$1;
exports["default"] = _default;
module.exports = exports.default;
}(AngleRight$1, AngleRight$1.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AngleRight["default"];
  }
});

var _AngleRight = _interopRequireDefault(AngleRight$1.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(AngleRight$2));

var AngleRightIcon = /*@__PURE__*/getDefaultExportFromCjs(AngleRight$2);

var dateFormats = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var locale = {
  code: 'en-GB',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var enGB = locale;

var Calendar$6 = {
  sunday: 'Su',
  monday: 'Mo',
  tuesday: 'Tu',
  wednesday: 'We',
  thursday: 'Th',
  friday: 'Fr',
  saturday: 'Sa',
  ok: 'OK',
  today: 'Today',
  yesterday: 'Yesterday',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',

  /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  dateLocale: enGB
};
var defaultLocale = {
  common: {
    loading: 'Loading...',
    emptyMessage: 'No data found'
  },
  Plaintext: {
    unfilled: 'Unfilled',
    notSelected: 'Not selected',
    notUploaded: 'Not uploaded'
  },
  Pagination: {
    more: 'More',
    prev: 'Previous',
    next: 'Next',
    first: 'First',
    last: 'Last',
    limit: '{0} / page',
    total: 'Total Rows: {0}',
    skip: 'Go to{0}'
  },
  Calendar: Calendar$6,
  DatePicker: _extends$1({}, Calendar$6),
  DateRangePicker: _extends$1({}, Calendar$6, {
    last7Days: 'Last 7 Days'
  }),
  Picker: {
    noResultsText: 'No results found',
    placeholder: 'Select',
    searchPlaceholder: 'Search',
    checkAll: 'All'
  },
  InputPicker: {
    newItem: 'New item',
    createOption: 'Create option "{0}"'
  },
  Uploader: {
    inited: 'Initial',
    progress: 'Uploading',
    error: 'Error',
    complete: 'Finished',
    emptyFile: 'Empty',
    upload: 'Upload'
  },
  CloseButton: {
    closeLabel: 'Close'
  },
  Breadcrumb: {
    expandText: 'Show path'
  },
  Toggle: {
    on: 'Open',
    off: 'Close'
  }
};

var mergeObject = function mergeObject(list) {
  return list.reduce(function (a, b) {
    a = _extends$1({}, a, b);
    return a;
  }, {});
};

var getDefaultRTL = function getDefaultRTL() {
  return typeof window !== 'undefined' && (document.body.getAttribute('dir') || document.dir) === 'rtl';
};
/**
 * A hook to get custom configuration of `<CustomProvider>`
 * @param keys
 */


function useCustom(keys, overrideLocale) {
  var _locale$Calendar2, _locale$Calendar4;

  var _useContext = useContext(CustomContext),
      _useContext$locale = _useContext.locale,
      locale = _useContext$locale === void 0 ? defaultLocale : _useContext$locale,
      _useContext$rtl = _useContext.rtl,
      rtl = _useContext$rtl === void 0 ? getDefaultRTL() : _useContext$rtl,
      formatDate = _useContext.formatDate,
      parseDate = _useContext.parseDate;

  var componentLocale = _extends$1({}, locale === null || locale === void 0 ? void 0 : locale.common, typeof keys === 'string' ? locale === null || locale === void 0 ? void 0 : locale[keys] : mergeObject(keys.map(function (key) {
    return locale === null || locale === void 0 ? void 0 : locale[key];
  }))); // Component custom locale


  if (overrideLocale) {
    componentLocale = mergeObject([componentLocale, overrideLocale]);
  }

  var defaultFormatDate = useCallback(function (date, formatStr) {
    var _locale$Calendar;

    return format(date, formatStr, {
      locale: locale === null || locale === void 0 ? void 0 : (_locale$Calendar = locale.Calendar) === null || _locale$Calendar === void 0 ? void 0 : _locale$Calendar.dateLocale
    });
  }, [(_locale$Calendar2 = locale.Calendar) === null || _locale$Calendar2 === void 0 ? void 0 : _locale$Calendar2.dateLocale]);
  var defaultParseDate = useCallback(function (dateString, formatString) {
    var _locale$Calendar3;

    return parse(dateString, formatString, new Date(), {
      locale: locale === null || locale === void 0 ? void 0 : (_locale$Calendar3 = locale.Calendar) === null || _locale$Calendar3 === void 0 ? void 0 : _locale$Calendar3.dateLocale
    });
  }, [(_locale$Calendar4 = locale.Calendar) === null || _locale$Calendar4 === void 0 ? void 0 : _locale$Calendar4.dateLocale]);
  return {
    locale: componentLocale,
    rtl: rtl,
    formatDate: formatDate || defaultFormatDate,
    parseDate: parseDate || defaultParseDate
  };
}

function useToggleCaret(placement) {
  var _useCustom = useCustom('Dropdown'),
      rtl = _useCustom.rtl;

  return useMemo(function () {
    switch (true) {
      case /^top/.test(placement):
        return AngleUpIcon;

      case /^right/.test(placement):
        return rtl ? AngleLeftIcon : AngleRightIcon;

      case /^left/.test(placement):
        return rtl ? AngleRightIcon : AngleLeftIcon;

      case /^bottom/.test(placement):
      default:
        return AngleDownIcon;
    }
  }, [placement, rtl]);
}

var defaultArray = [];
var emptyString$1 = '';
function adjustCaretPosition(_ref) {
  var _ref$previousConforme = _ref.previousConformedValue,
      previousConformedValue = _ref$previousConforme === void 0 ? emptyString$1 : _ref$previousConforme,
      _ref$previousPlacehol = _ref.previousPlaceholder,
      previousPlaceholder = _ref$previousPlacehol === void 0 ? emptyString$1 : _ref$previousPlacehol,
      _ref$currentCaretPosi = _ref.currentCaretPosition,
      currentCaretPosition = _ref$currentCaretPosi === void 0 ? 0 : _ref$currentCaretPosi,
      conformedValue = _ref.conformedValue,
      rawValue = _ref.rawValue,
      placeholderChar = _ref.placeholderChar,
      placeholder = _ref.placeholder,
      _ref$indexesOfPipedCh = _ref.indexesOfPipedChars,
      indexesOfPipedChars = _ref$indexesOfPipedCh === void 0 ? defaultArray : _ref$indexesOfPipedCh,
      _ref$caretTrapIndexes = _ref.caretTrapIndexes,
      caretTrapIndexes = _ref$caretTrapIndexes === void 0 ? defaultArray : _ref$caretTrapIndexes;

  if (currentCaretPosition === 0 || !rawValue.length) {
    return 0;
  } // Store lengths for faster performance?


  var rawValueLength = rawValue.length;
  var previousConformedValueLength = previousConformedValue.length;
  var placeholderLength = placeholder.length;
  var conformedValueLength = conformedValue.length; // This tells us how long the edit is. If user modified input from `(2__)` to `(243__)`,
  // we know the user in this instance pasted two characters

  var editLength = rawValueLength - previousConformedValueLength; // If the edit length is positive, that means the user is adding characters, not deleting.

  var isAddition = editLength > 0; // This is the first raw value the user entered that needs to be conformed to mask

  var isFirstRawValue = previousConformedValueLength === 0; // A partial multi-character edit happens when the user makes a partial selection in their
  // input and edits that selection. That is going from `(123) 432-4348` to `() 432-4348` by
  // selecting the first 3 digits and pressing backspace.
  //
  // Such cases can also happen when the user presses the backspace while holding down the ALT
  // key.

  var isPartialMultiCharEdit = editLength > 1 && !isFirstRawValue; // This algorithm doesn't support all cases of multi-character edits, so we just return
  // the current caret position.
  //
  // This works fine for most cases.

  if (isPartialMultiCharEdit) {
    return currentCaretPosition;
  } // For a mask like (111), if the `previousConformedValue` is (1__) and user attempts to enter
  // `f` so the `rawValue` becomes (1f__), the new `conformedValue` would be (1__), which is the
  // same as the original `previousConformedValue`. We handle this case differently for caret
  // positioning.


  var possiblyHasRejectedChar = isAddition && (previousConformedValue === conformedValue || conformedValue === placeholder);
  var startingSearchIndex = 0;
  var trackRightCharacter;
  var targetChar;

  if (possiblyHasRejectedChar) {
    startingSearchIndex = currentCaretPosition - editLength;
  } else {
    // At this point in the algorithm, we want to know where the caret is right before the raw input
    // has been conformed, and then see if we can find that same spot in the conformed input.
    //
    // We do that by seeing what character lies immediately before the caret, and then look for that
    // same character in the conformed input and place the caret there.
    // First, we need to normalize the inputs so that letter capitalization between raw input and
    // conformed input wouldn't matter.
    var normalizedConformedValue = conformedValue.toLowerCase();
    var normalizedRawValue = rawValue.toLowerCase(); // Then we take all characters that come before where the caret currently is.

    var leftHalfChars = normalizedRawValue.substr(0, currentCaretPosition).split(emptyString$1); // Now we find all the characters in the left half that exist in the conformed input
    // This step ensures that we don't look for a character that was filtered out or rejected by `conformToMask`.

    var intersection = leftHalfChars.filter(function (char) {
      return normalizedConformedValue.indexOf(char) !== -1;
    }); // The last character in the intersection is the character we want to look for in the conformed
    // value and the one we want to adjust the caret close to

    targetChar = intersection[intersection.length - 1]; // Calculate the number of mask characters in the previous placeholder
    // from the start of the string up to the place where the caret is

    var previousLeftMaskChars = previousPlaceholder.substr(0, intersection.length).split(emptyString$1).filter(function (char) {
      return char !== placeholderChar;
    }).length; // Calculate the number of mask characters in the current placeholder
    // from the start of the string up to the place where the caret is

    var leftMaskChars = placeholder.substr(0, intersection.length).split(emptyString$1).filter(function (char) {
      return char !== placeholderChar;
    }).length; // Has the number of mask characters up to the caret changed?

    var masklengthChanged = leftMaskChars !== previousLeftMaskChars; // Detect if `targetChar` is a mask character and has moved to the left

    var targetIsMaskMovingLeft = previousPlaceholder[intersection.length - 1] !== undefined && placeholder[intersection.length - 2] !== undefined && previousPlaceholder[intersection.length - 1] !== placeholderChar && previousPlaceholder[intersection.length - 1] !== placeholder[intersection.length - 1] && previousPlaceholder[intersection.length - 1] === placeholder[intersection.length - 2]; // If deleting and the `targetChar` `is a mask character and `masklengthChanged` is true
    // or the mask is moving to the left, we can't use the selected `targetChar` any longer
    // if we are not at the end of the string.
    // In this case, change tracking strategy and track the character to the right of the caret.

    if (!isAddition && (masklengthChanged || targetIsMaskMovingLeft) && previousLeftMaskChars > 0 && placeholder.indexOf(targetChar) > -1 && rawValue[currentCaretPosition] !== undefined) {
      trackRightCharacter = true;
      targetChar = rawValue[currentCaretPosition];
    } // It is possible that `targetChar` will appear multiple times in the conformed value.
    // We need to know not to select a character that looks like our target character from the placeholder or
    // the piped characters, so we inspect the piped characters and the placeholder to see if they contain
    // characters that match our target character.
    // If the `conformedValue` got piped, we need to know which characters were piped in so that when we look for
    // our `targetChar`, we don't select a piped char by mistake


    var pipedChars = indexesOfPipedChars.map(function (index) {
      return normalizedConformedValue[index];
    }); // We need to know how many times the `targetChar` occurs in the piped characters.

    var countTargetCharInPipedChars = pipedChars.filter(function (char) {
      return char === targetChar;
    }).length; // We need to know how many times it occurs in the intersection

    var countTargetCharInIntersection = intersection.filter(function (char) {
      return char === targetChar;
    }).length; // We need to know if the placeholder contains characters that look like
    // our `targetChar`, so we don't select one of those by mistake.

    var countTargetCharInPlaceholder = placeholder.substr(0, placeholder.indexOf(placeholderChar)).split(emptyString$1).filter(function (char, index) {
      return (// Check if `char` is the same as our `targetChar`, so we account for it
        char === targetChar && // but also make sure that both the `rawValue` and placeholder don't have the same character at the same
        // index because if they are equal, that means we are already counting those characters in
        // `countTargetCharInIntersection`
        rawValue[index] !== char
      );
    }).length; // The number of times we need to see occurrences of the `targetChar` before we know it is the one we're looking
    // for is:

    var requiredNumberOfMatches = countTargetCharInPlaceholder + countTargetCharInIntersection + countTargetCharInPipedChars + ( // The character to the right of the caret isn't included in `intersection`
    // so add one if we are tracking the character to the right
    trackRightCharacter ? 1 : 0); // Now we start looking for the location of the `targetChar`.
    // We keep looping forward and store the index in every iteration. Once we have encountered
    // enough occurrences of the target character, we break out of the loop
    // If are searching for the second `1` in `1214`, `startingSearchIndex` will point at `4`.

    var numberOfEncounteredMatches = 0;

    for (var i = 0; i < conformedValueLength; i++) {
      var conformedValueChar = normalizedConformedValue[i];
      startingSearchIndex = i + 1;

      if (conformedValueChar === targetChar) {
        numberOfEncounteredMatches++;
      }

      if (numberOfEncounteredMatches >= requiredNumberOfMatches) {
        break;
      }
    }
  } // At this point, if we simply return `startingSearchIndex` as the adjusted caret position,
  // most cases would be handled. However, we want to fast forward or rewind the caret to the
  // closest placeholder character if it happens to be in a non-editable spot. That's what the next
  // logic is for.
  // In case of addition, we fast forward.


  if (isAddition) {
    // We want to remember the last placeholder character encountered so that if the mask
    // contains more characters after the last placeholder character, we don't forward the caret
    // that far to the right. Instead, we stop it at the last encountered placeholder character.
    var lastPlaceholderChar = startingSearchIndex;

    for (var _i = startingSearchIndex; _i <= placeholderLength; _i++) {
      if (placeholder[_i] === placeholderChar) {
        lastPlaceholderChar = _i;
      }

      if ( // If we're adding, we can position the caret at the next placeholder character.
      placeholder[_i] === placeholderChar || // If a caret trap was set by a mask function, we need to stop at the trap.
      caretTrapIndexes.indexOf(_i) !== -1 || // This is the end of the placeholder. We cannot move any further. Let's put the caret there.
      _i === placeholderLength) {
        return lastPlaceholderChar;
      }
    }
  } else {
    // In case of deletion, we rewind.
    if (trackRightCharacter) {
      // Searching for the character that was to the right of the caret
      // We start at `startingSearchIndex` - 1 because it includes one character extra to the right
      for (var _i2 = startingSearchIndex - 1; _i2 >= 0; _i2--) {
        // If tracking the character to the right of the cursor, we move to the left until
        // we found the character and then place the caret right before it
        if ( // `targetChar` should be in `conformedValue`, since it was in `rawValue`, just
        // to the right of the caret
        conformedValue[_i2] === targetChar || // If a caret trap was set by a mask function, we need to stop at the trap.
        caretTrapIndexes.indexOf(_i2) !== -1 || // This is the beginning of the placeholder. We cannot move any further.
        // Let's put the caret there.
        _i2 === 0) {
          return _i2;
        }
      }
    } else {
      // Searching for the first placeholder or caret trap to the left
      for (var _i3 = startingSearchIndex; _i3 >= 0; _i3--) {
        // If we're deleting, we stop the caret right before the placeholder character.
        // For example, for mask `(111) 11`, current conformed input `(456) 86`. If user
        // modifies input to `(456 86`. That is, they deleted the `)`, we place the caret
        // right after the first `6`
        if ( // If we're deleting, we can position the caret right before the placeholder character
        placeholder[_i3 - 1] === placeholderChar || // If a caret trap was set by a mask function, we need to stop at the trap.
        caretTrapIndexes.indexOf(_i3) !== -1 || // This is the beginning of the placeholder. We cannot move any further.
        // Let's put the caret there.
        _i3 === 0) {
          return _i3;
        }
      }
    }
  }
}

var emptyArray = [];
var strCaretTrap = '[]';
var defaultPlaceholderChar = '_';
function convertMaskToPlaceholder(mask, placeholderChar) {
  if (mask === void 0) {
    mask = emptyArray;
  }

  if (placeholderChar === void 0) {
    placeholderChar = defaultPlaceholderChar;
  }

  if (!Array.isArray(mask)) {
    throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
  }

  if (mask.indexOf(placeholderChar) !== -1) {
    throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + ("The placeholder character that was received is: " + JSON.stringify(placeholderChar) + "\n\n") + ("The mask that was received is: " + JSON.stringify(mask)));
  }

  return mask.map(function (char) {
    return char instanceof RegExp ? placeholderChar : char;
  }).join('');
}
function processCaretTraps(mask) {
  var indexes = [];
  var indexOfCaretTrap;

  while (indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) {
    indexes.push(indexOfCaretTrap);
    mask.splice(indexOfCaretTrap, 1);
  }

  return {
    maskWithoutCaretTraps: mask,
    indexes: indexes
  };
}

function isArray(value) {
  return Array.isArray && Array.isArray(value) || value instanceof Array;
}
function conformToMask(rawValue, mask, config) {
  if (rawValue === void 0) {
    rawValue = '';
  }

  if (mask === void 0) {
    mask = [];
  }

  if (config === void 0) {
    config = {};
  }

  if (!isArray(mask)) {
    // If someone passes a function as the mask property, we should call the
    // function to get the mask array - Normally this is handled by the
    // `createTextMaskInputElement:update` function - this allows mask functions
    // to be used directly with `conformToMask`
    if (typeof mask === 'function') {
      // call the mask function to get the mask array
      mask = mask(rawValue, config); // mask functions can setup caret traps to have some control over how the caret moves. We need to process
      // the mask for any caret traps. `processCaretTraps` will remove the caret traps from the mask

      mask = processCaretTraps(mask).maskWithoutCaretTraps;
    } else {
      throw new Error('Text-mask:conformToMask; The mask property must be an array.');
    }
  } // These configurations tell us how to conform the mask


  var _config = config,
      _config$guide = _config.guide,
      guide = _config$guide === void 0 ? true : _config$guide,
      _config$previousConfo = _config.previousConformedValue,
      previousConformedValue = _config$previousConfo === void 0 ? '' : _config$previousConfo,
      _config$placeholderCh = _config.placeholderChar,
      placeholderChar = _config$placeholderCh === void 0 ? defaultPlaceholderChar : _config$placeholderCh,
      _config$placeholder = _config.placeholder,
      placeholder = _config$placeholder === void 0 ? convertMaskToPlaceholder(mask, placeholderChar) : _config$placeholder,
      _config$currentCaretP = _config.currentCaretPosition,
      currentCaretPosition = _config$currentCaretP === void 0 ? 0 : _config$currentCaretP,
      keepCharPositions = _config.keepCharPositions; // The configs below indicate that the user wants the algorithm to work in *no guide* mode

  var suppressGuide = guide === false && previousConformedValue !== undefined; // Calculate lengths once for performance

  var rawValueLength = rawValue.length;
  var previousConformedValueLength = previousConformedValue.length;
  var placeholderLength = placeholder.length;
  var maskLength = mask.length; // This tells us the number of edited characters and the direction in which they were edited (+/-)

  var editDistance = rawValueLength - previousConformedValueLength; // In *no guide* mode, we need to know if the user is trying to add a character or not

  var isAddition = editDistance > 0; // Tells us the index of the first change. For (438) 394-4938 to (38) 394-4938, that would be 1

  var indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0); // We're also gonna need the index of last change, which we can derive as follows...

  var indexOfLastChange = indexOfFirstChange + Math.abs(editDistance); // If `conformToMask` is configured to keep character positions, that is, for mask 111, previous value
  // _2_ and raw value 3_2_, the new conformed value should be 32_, not 3_2 (default behavior). That's in the case of
  // addition. And in the case of deletion, previous value _23, raw value _3, the new conformed string should be
  // __3, not _3_ (default behavior)
  //
  // The next block of logic handles keeping character positions for the case of deletion. (Keeping
  // character positions for the case of addition is further down since it is handled differently.)
  // To do this, we want to compensate for all characters that were deleted

  if (keepCharPositions === true && !isAddition) {
    // We will be storing the new placeholder characters in this variable.
    var compensatingPlaceholderChars = ''; // For every character that was deleted from a placeholder position, we add a placeholder char

    for (var i = indexOfFirstChange; i < indexOfLastChange; i++) {
      if (placeholder[i] === placeholderChar) {
        compensatingPlaceholderChars += placeholderChar;
      }
    } // Now we trick our algorithm by modifying the raw value to make it contain additional placeholder characters
    // That way when the we start laying the characters again on the mask, it will keep the non-deleted characters
    // in their positions.


    rawValue = rawValue.slice(0, indexOfFirstChange) + compensatingPlaceholderChars + rawValue.slice(indexOfFirstChange, rawValueLength);
  } // Convert `rawValue` string to an array, and mark characters based on whether they are newly added or have
  // existed in the previous conformed value. Identifying new and old characters is needed for `conformToMask`
  // to work if it is configured to keep character positions.


  var rawValueArr = rawValue.split('').map(function (char, i) {
    return {
      char: char,
      isNew: i >= indexOfFirstChange && i < indexOfLastChange
    };
  }); // The loop below removes masking characters from user input. For example, for mask
  // `00 (111)`, the placeholder would be `00 (___)`. If user input is `00 (234)`, the loop below
  // would remove all characters but `234` from the `rawValueArr`. The rest of the algorithm
  // then would lay `234` on top of the available placeholder positions in the mask.

  for (var _i = rawValueLength - 1; _i >= 0; _i--) {
    var char = rawValueArr[_i].char;

    if (char !== placeholderChar) {
      var shouldOffset = _i >= indexOfFirstChange && previousConformedValueLength === maskLength;

      if (char === placeholder[shouldOffset ? _i - editDistance : _i]) {
        rawValueArr.splice(_i, 1);
      }
    }
  } // This is the variable that we will be filling with characters as we figure them out
  // in the algorithm below


  var conformedValue = '';
  var someCharsRejected = false; // Ok, so first we loop through the placeholder looking for placeholder characters to fill up.

  placeholderLoop: for (var _i2 = 0; _i2 < placeholderLength; _i2++) {
    var charInPlaceholder = placeholder[_i2]; // We see one. Let's find out what we can put in it.

    if (charInPlaceholder === placeholderChar) {
      // But before that, do we actually have any user characters that need a place?
      if (rawValueArr.length > 0) {
        // We will keep chipping away at user input until either we run out of characters
        // or we find at least one character that we can map.
        while (rawValueArr.length > 0) {
          // Let's retrieve the first user character in the queue of characters we have left
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          var _ref = rawValueArr.shift(),
              rawValueChar = _ref.char,
              isNew = _ref.isNew; // If the character we got from the user input is a placeholder character (which happens
          // regularly because user input could be something like (540) 90_-____, which includes
          // a bunch of `_` which are placeholder characters) and we are not in *no guide* mode,
          // then we map this placeholder character to the current spot in the placeholder


          if (rawValueChar === placeholderChar && suppressGuide !== true) {
            conformedValue += placeholderChar; // And we go to find the next placeholder character that needs filling

            continue placeholderLoop; // Else if, the character we got from the user input is not a placeholder, let's see
            // if the current position in the mask can accept it.
          } else if (mask[_i2].test(rawValueChar)) {
            // we map the character differently based on whether we are keeping character positions or not.
            // If any of the conditions below are met, we simply map the raw value character to the
            // placeholder position.
            if (keepCharPositions !== true || isNew === false || previousConformedValue === '' || guide === false || !isAddition) {
              conformedValue += rawValueChar;
            } else {
              // We enter this block of code if we are trying to keep character positions and none of the conditions
              // above is met. In this case, we need to see if there's an available spot for the raw value character
              // to be mapped to. If we couldn't find a spot, we will discard the character.
              //
              // For example, for mask `1111`, previous conformed value `_2__`, raw value `942_2__`. We can map the
              // `9`, to the first available placeholder position, but then, there are no more spots available for the
              // `4` and `2`. So, we discard them and end up with a conformed value of `92__`.
              var rawValueArrLength = rawValueArr.length;
              var indexOfNextAvailablePlaceholderChar = null; // Let's loop through the remaining raw value characters. We are looking for either a suitable spot, ie,
              // a placeholder character or a non-suitable spot, ie, a non-placeholder character that is not new.
              // If we see a suitable spot first, we store its position and exit the loop. If we see a non-suitable
              // spot first, we exit the loop and our `indexOfNextAvailablePlaceholderChar` will stay as `null`.

              for (var _i3 = 0; _i3 < rawValueArrLength; _i3++) {
                var charData = rawValueArr[_i3];

                if (charData.char !== placeholderChar && charData.isNew === false) {
                  break;
                }

                if (charData.char === placeholderChar) {
                  indexOfNextAvailablePlaceholderChar = _i3;
                  break;
                }
              } // If `indexOfNextAvailablePlaceholderChar` is not `null`, that means the character is not blocked.
              // We can map it. And to keep the character positions, we remove the placeholder character
              // from the remaining characters


              if (indexOfNextAvailablePlaceholderChar !== null) {
                conformedValue += rawValueChar;
                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1); // If `indexOfNextAvailablePlaceholderChar` is `null`, that means the character is blocked. We have to
                // discard it.
              } else {
                _i2--;
              }
            } // Since we've mapped this placeholder position. We move on to the next one.


            continue placeholderLoop;
          } else {
            someCharsRejected = true;
          }
        }
      } // We reach this point when we've mapped all the user input characters to placeholder
      // positions in the mask. In *guide* mode, we append the left over characters in the
      // placeholder to the `conformedString`, but in *no guide* mode, we don't wanna do that.
      //
      // That is, for mask `(111)` and user input `2`, we want to return `(2`, not `(2__)`.


      if (suppressGuide === false) {
        conformedValue += placeholder.substr(_i2, placeholderLength);
      } // And we break


      break; // Else, the charInPlaceholder is not a placeholderChar. That is, we cannot fill it
      // with user input. So we just map it to the final output
    } else {
      conformedValue += charInPlaceholder;
    }
  } // The following logic is needed to deal with the case of deletion in *no guide* mode.
  //
  // Consider the silly mask `(111) /// 1`. What if user tries to delete the last placeholder
  // position? Something like `(589) /// `. We want to conform that to `(589`. Not `(589) /// `.
  // That's why the logic below finds the last filled placeholder character, and removes everything
  // from that point on.


  if (suppressGuide && isAddition === false) {
    var indexOfLastFilledPlaceholderChar = null; // Find the last filled placeholder position and substring from there

    for (var _i4 = 0; _i4 < conformedValue.length; _i4++) {
      if (placeholder[_i4] === placeholderChar) {
        indexOfLastFilledPlaceholderChar = _i4;
      }
    }

    if (indexOfLastFilledPlaceholderChar !== null) {
      // We substring from the beginning until the position after the last filled placeholder char.
      conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
    } else {
      // If we couldn't find `indexOfLastFilledPlaceholderChar` that means the user deleted
      // the first character in the mask. So we return an empty string.
      conformedValue = '';
    }
  }

  return {
    conformedValue: conformedValue,
    meta: {
      someCharsRejected: someCharsRejected
    }
  };
}

var emptyString = '';
var strNone = 'none';
var strObject = 'object';
var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
var defer = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : setTimeout;
function createTextMaskInputElement(config) {
  // Anything that we will need to keep between `update` calls, we will store in this `state` object.
  var state = {
    previousConformedValue: undefined,
    previousPlaceholder: undefined
  };
  return {
    state: state,
    // `update` is called by framework components whenever they want to update the `value` of the input element.
    // The caller can send a `rawValue` to be conformed and set on the input element. However, the default use-case
    // is for this to be read from the `inputElement` directly.
    update: function update(rawValue, _temp) {
      var _pipeResults, _pipeResults2;

      var _ref = _temp === void 0 ? config : _temp,
          inputElement = _ref.inputElement,
          providedMask = _ref.mask,
          guide = _ref.guide,
          pipe = _ref.pipe,
          _ref$placeholderChar = _ref.placeholderChar,
          placeholderChar = _ref$placeholderChar === void 0 ? defaultPlaceholderChar : _ref$placeholderChar,
          _ref$keepCharPosition = _ref.keepCharPositions,
          keepCharPositions = _ref$keepCharPosition === void 0 ? false : _ref$keepCharPosition,
          _ref$showMask = _ref.showMask,
          showMask = _ref$showMask === void 0 ? false : _ref$showMask;

      // if `rawValue` is `undefined`, read from the `inputElement`
      if (typeof rawValue === 'undefined') {
        rawValue = inputElement.value;
      } // If `rawValue` equals `state.previousConformedValue`, we don't need to change anything. So, we return.
      // This check is here to handle controlled framework components that repeat the `update` call on every render.


      if (rawValue === state.previousConformedValue) {
        return;
      } // Text Mask accepts masks that are a combination of a `mask` and a `pipe` that work together. If such a `mask` is
      // passed, we destructure it below, so the rest of the code can work normally as if a separate `mask` and a `pipe`
      // were passed.


      if (typeof providedMask === strObject && providedMask.pipe !== undefined && providedMask.mask !== undefined) {
        pipe = providedMask.pipe;
        providedMask = providedMask.mask;
      } // The `placeholder` is an essential piece of how Text Mask works. For a mask like `(111)`, the placeholder would
      // be `(___)` if the `placeholderChar` is set to `_`.


      var placeholder; // We don't know what the mask would be yet. If it is an array, we take it as is, but if it's a function, we will
      // have to call that function to get the mask array.

      var mask; // If the provided mask is an array, we can call `convertMaskToPlaceholder` here once and we'll always have the
      // correct `placeholder`.

      if (providedMask instanceof Array) {
        placeholder = convertMaskToPlaceholder(providedMask, placeholderChar);
      } // In framework components that support reactivity, it's possible to turn off masking by passing
      // `false` for `mask` after initialization. See https://github.com/text-mask/text-mask/pull/359


      if (providedMask === false) {
        return;
      } // We check the provided `rawValue` before moving further.
      // If it's something we can't work with `getSafeRawValue` will throw.


      var safeRawValue = getSafeRawValue(rawValue); // `selectionEnd` indicates to us where the caret position is after the user has typed into the input

      var currentCaretPosition = inputElement.selectionEnd; // We need to know what the `previousConformedValue` and `previousPlaceholder` is from the previous `update` call

      var previousConformedValue = state.previousConformedValue,
          previousPlaceholder = state.previousPlaceholder;
      var caretTrapIndexes; // If the `providedMask` is a function. We need to call it at every `update` to get the `mask` array.
      // Then we also need to get the `placeholder`

      if (typeof providedMask === 'function') {
        mask = providedMask(safeRawValue, {
          currentCaretPosition: currentCaretPosition,
          previousConformedValue: previousConformedValue,
          placeholderChar: placeholderChar
        }); // disable masking if `mask` is `false`

        if (mask === false) {
          return;
        } // mask functions can setup caret traps to have some control over how the caret moves. We need to process
        // the mask for any caret traps. `processCaretTraps` will remove the caret traps from the mask and return
        // the indexes of the caret traps.


        var _processCaretTraps = processCaretTraps(mask),
            maskWithoutCaretTraps = _processCaretTraps.maskWithoutCaretTraps,
            indexes = _processCaretTraps.indexes;

        mask = maskWithoutCaretTraps; // The processed mask is what we're interested in

        caretTrapIndexes = indexes; // And we need to store these indexes because they're needed by `adjustCaretPosition`

        placeholder = convertMaskToPlaceholder(mask, placeholderChar); // If the `providedMask` is not a function, we just use it as-is.
      } else {
        mask = providedMask;
      } // The following object will be passed to `conformToMask` to determine how the `rawValue` will be conformed


      var conformToMaskConfig = {
        previousConformedValue: previousConformedValue,
        guide: guide,
        placeholderChar: placeholderChar,
        pipe: pipe,
        placeholder: placeholder,
        currentCaretPosition: currentCaretPosition,
        keepCharPositions: keepCharPositions
      }; // `conformToMask` returns `conformedValue` as part of an object for future API flexibility

      var _conformToMask = conformToMask(safeRawValue, mask, conformToMaskConfig),
          conformedValue = _conformToMask.conformedValue; // The following few lines are to support the `pipe` feature.


      var piped = typeof pipe === 'function';
      var pipeResults = {}; // If `pipe` is a function, we call it.

      if (piped) {
        // `pipe` receives the `conformedValue` and the configurations with which `conformToMask` was called.
        pipeResults = pipe(conformedValue, _extends$1({
          rawValue: safeRawValue
        }, conformToMaskConfig)); // `pipeResults` should be an object. But as a convenience, we allow the pipe author to just return `false` to
        // indicate rejection. Or return just a string when there are no piped characters.
        // If the `pipe` returns `false` or a string, the block below turns it into an object that the rest
        // of the code can work with.

        if (pipeResults === false) {
          // If the `pipe` rejects `conformedValue`, we use the `previousConformedValue`, and set `rejected` to `true`.
          pipeResults = {
            value: previousConformedValue,
            rejected: true
          };
        } else if (isString$1(pipeResults)) {
          pipeResults = {
            value: pipeResults
          };
        }
      } // Before we proceed, we need to know which conformed value to use, the one returned by the pipe or the one
      // returned by `conformToMask`.


      var finalConformedValue = piped ? (_pipeResults = pipeResults) === null || _pipeResults === void 0 ? void 0 : _pipeResults.value : conformedValue; // After determining the conformed value, we will need to know where to set
      // the caret position. `adjustCaretPosition` will tell us.

      var adjustedCaretPosition = adjustCaretPosition({
        previousConformedValue: previousConformedValue,
        previousPlaceholder: previousPlaceholder,
        conformedValue: finalConformedValue,
        placeholder: placeholder,
        rawValue: safeRawValue,
        currentCaretPosition: currentCaretPosition,
        placeholderChar: placeholderChar,
        indexesOfPipedChars: (_pipeResults2 = pipeResults) === null || _pipeResults2 === void 0 ? void 0 : _pipeResults2.indexesOfPipedChars,
        caretTrapIndexes: caretTrapIndexes
      }); // Text Mask sets the input value to an empty string when the condition below is set. It provides a better UX.

      var inputValueShouldBeEmpty = finalConformedValue === placeholder && adjustedCaretPosition === 0;
      var emptyValue = showMask ? placeholder : emptyString;
      var inputElementValue = inputValueShouldBeEmpty ? emptyValue : finalConformedValue;
      state.previousConformedValue = inputElementValue; // store value for access for next time

      state.previousPlaceholder = placeholder; // In some cases, this `update` method will be repeatedly called with a raw value that has already been conformed
      // and set to `inputElement.value`. The below check guards against needlessly readjusting the input state.
      // See https://github.com/text-mask/text-mask/issues/231

      if (inputElement.value === inputElementValue) {
        return;
      }

      inputElement.value = inputElementValue; // set the input value

      safeSetSelection(inputElement, adjustedCaretPosition); // adjust caret position
    }
  };
}

function safeSetSelection(element, selectionPosition) {
  if (document.activeElement === element) {
    if (isAndroid) {
      defer(function () {
        return element.setSelectionRange(selectionPosition, selectionPosition, strNone);
      }, 0);
    } else {
      element.setSelectionRange(selectionPosition, selectionPosition, strNone);
    }
  }
}

function getSafeRawValue(inputValue) {
  if (isString$1(inputValue)) {
    return inputValue;
  } else if (isNumber_1(inputValue)) {
    return String(inputValue);
  } else if (inputValue === undefined || inputValue === null) {
    return emptyString;
  } else {
    throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(inputValue));
  }
}

/**
 * https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#guide
 */

var defaultRender = function defaultRender(ref, props) {
  return /*#__PURE__*/React__default.createElement("input", _extends$1({
    ref: ref
  }, props));
};

var TextMask = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var mask = props.mask,
      _props$guide = props.guide,
      guide = _props$guide === void 0 ? true : _props$guide,
      placeholderChar = props.placeholderChar,
      value = props.value,
      showMask = props.showMask,
      pipe = props.pipe,
      _props$render = props.render,
      render = _props$render === void 0 ? defaultRender : _props$render,
      onChange = props.onChange,
      rest = _objectWithoutPropertiesLoose(props, ["mask", "guide", "placeholderChar", "value", "showMask", "pipe", "render", "onChange"]);

  var inputRef = useRef(null);
  var textMaskInputElement = useRef();
  var initTextMask = useCallback(function () {
    var _textMaskInputElement;

    textMaskInputElement.current = createTextMaskInputElement(_extends$1({
      inputElement: inputRef.current
    }, props));
    (_textMaskInputElement = textMaskInputElement.current) === null || _textMaskInputElement === void 0 ? void 0 : _textMaskInputElement.update(value);
  }, [props, value]);
  var handleChange = useCallback(function (event) {
    var _textMaskInputElement2;

    (_textMaskInputElement2 = textMaskInputElement.current) === null || _textMaskInputElement2 === void 0 ? void 0 : _textMaskInputElement2.update();
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }, [onChange]);
  useEffect(function () {
    initTextMask();
  }, [guide, placeholderChar, showMask, pipe, mask, value, initTextMask]);
  return render(mergeRefs(inputRef, ref), _extends$1({
    onChange: handleChange,
    defaultValue: value
  }, omit_1(rest, ['keepCharPositions'])));
});
TextMask.displayName = 'TextMask';
TextMask.propTypes = {
  render: PropTypes.func,
  onChange: PropTypes.func,
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.bool]).isRequired,
  guide: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pipe: PropTypes.func,
  placeholderChar: PropTypes.string,
  keepCharPositions: PropTypes.bool,
  showMask: PropTypes.bool
};
var TextMask$1 = TextMask;

var warned = {};
/**
 * Logs a warning message
 * but dont warn a same message twice
 */

function warnOnce(message) {
  if (!warned[message]) {
    console.warn(message);
    warned[message] = true;
  }
}

warnOnce._resetWarned = function () {
  for (var _message in warned) {
    delete warned[_message];
  }
};

// Ref: https://github.com/thefrontside/deprecated-prop-type/blob/master/deprecated.js
function deprecatePropType(propType, explanation) {
  return function validate(props, propName, componentName) {
    // Note ...rest here
    if (props[propName] != null) {
      var message = "\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation;
      warnOnce(message);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest)); // and here
  };
}

var _templateObject$1, _templateObject2;
var defaultInputMask = [];
var PickerToggle = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var activeProp = props.active,
      _props$as = props.as,
      Component = _props$as === void 0 ? ToggleButton$1 : _props$as,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'picker-toggle' : _props$classPrefix,
      children = props.children,
      _props$caret = props.caret,
      caret = _props$caret === void 0 ? true : _props$caret,
      className = props.className,
      disabled = props.disabled,
      readOnly = props.readOnly,
      plaintext = props.plaintext,
      hasValue = props.hasValue,
      cleanableProp = props.cleanable,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      id = props.id,
      value = props.value,
      input = props.input,
      inputPlaceholder = props.inputPlaceholder,
      inputValueProp = props.inputValue,
      _props$inputMask = props.inputMask,
      inputMask = _props$inputMask === void 0 ? defaultInputMask : _props$inputMask,
      onInputChange = props.onInputChange,
      onInputPressEnter = props.onInputPressEnter,
      onInputBlur = props.onInputBlur,
      onInputFocus = props.onInputFocus,
      onClean = props.onClean,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomStart' : _props$placement,
      caretComponent = props.caretComponent,
      _props$caretAs = props.caretAs,
      caretAs = _props$caretAs === void 0 ? caretComponent : _props$caretAs,
      rest = _objectWithoutPropertiesLoose(props, ["active", "as", "classPrefix", "children", "caret", "className", "disabled", "readOnly", "plaintext", "hasValue", "cleanable", "tabIndex", "id", "value", "input", "inputPlaceholder", "inputValue", "inputMask", "onInputChange", "onInputPressEnter", "onInputBlur", "onInputFocus", "onClean", "onFocus", "onBlur", "placement", "caretComponent", "caretAs"]);

  var inputRef = useRef(null);

  var _useState = useState(false),
      activeState = _useState[0],
      setActive = _useState[1];

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix;

  var getInputValue = useCallback(function () {
    return typeof inputValueProp === 'undefined' ? Array.isArray(value) ? value.join(',') : value : inputValueProp;
  }, [inputValueProp, value]);

  var _useState2 = useState(getInputValue),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  useEffect(function () {
    var value = getInputValue();
    setInputValue(value);
  }, [getInputValue]);
  var classes = merge(className, withClassPrefix({
    active: activeProp || activeState
  }));
  var handleFocus = useCallback(function (event) {
    setActive(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);

    if (input) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [input, onFocus]);
  var handleBlur = useCallback(function (event) {
    if (inputRef.current && document.activeElement !== inputRef.current) {
      setActive(false);
      inputRef.current.blur();
    }

    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  }, [onBlur]);

  var handleInputBlur = function handleInputBlur(event) {
    setInputValue(getInputValue());
    onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(event);
  };

  var handleClean = useCallback(function (event) {
    event.stopPropagation();
    onClean === null || onClean === void 0 ? void 0 : onClean(event);
    setActive(false);
  }, [onClean]);
  var handleInputChange = useCallback(function (event) {
    var _event$target;

    var value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
    setInputValue(value);
    onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(value, event);
  }, [onInputChange]);
  var handleInputKeyDown = useCallback(function (event) {
    if (input && event.key === KEY_VALUES.ENTER) {
      onInputPressEnter === null || onInputPressEnter === void 0 ? void 0 : onInputPressEnter(event);
    }
  }, [onInputPressEnter, input]);
  var ToggleCaret = useToggleCaret(placement);
  var Caret = caretAs !== null && caretAs !== void 0 ? caretAs : ToggleCaret;

  if (plaintext) {
    return /*#__PURE__*/React__default.createElement(Plaintext$1, {
      ref: ref,
      localeKey: "notSelected"
    }, hasValue ? children : null);
  }

  var showCleanButton = cleanableProp && hasValue && !readOnly; // When the component is read-only or disabled, the input is not interactive.

  var inputFocused = readOnly || disabled ? false : input && activeState;
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-expanded": activeProp,
    "aria-disabled": disabled,
    "aria-owns": id ? id + "-listbox" : undefined
  }, rest, {
    ref: ref,
    disabled: disabled,
    tabIndex: disabled ? undefined : tabIndex,
    className: classes,
    onFocus: !disabled ? handleFocus : null // The debounce is set to 200 to solve the flicker caused by the switch between input and div.
    ,
    onBlur: !disabled ? debounce_1(handleBlur, 200) : null
  }), /*#__PURE__*/React__default.createElement(TextMask$1, {
    mask: inputMask,
    value: Array.isArray(inputValue) ? inputValue.toString() : inputValue,
    onBlur: handleInputBlur,
    onFocus: onInputFocus,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    id: id,
    "aria-hidden": !inputFocused,
    readOnly: !inputFocused,
    disabled: disabled,
    "aria-controls": id ? id + "-listbox" : undefined,
    tabIndex: -1,
    className: prefix('textbox', {
      'read-only': !inputFocused
    }),
    placeholder: inputPlaceholder,
    render: function render(ref, props) {
      return /*#__PURE__*/React__default.createElement("input", _extends$1({
        ref: mergeRefs(inputRef, ref)
      }, props));
    }
  }), children ? /*#__PURE__*/React__default.createElement("span", {
    className: prefix(hasValue ? 'value' : 'placeholder'),
    "aria-placeholder": typeof children === 'string' ? children : undefined
  }, children) : null, showCleanButton && /*#__PURE__*/React__default.createElement(CloseButton$1, {
    className: prefix(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["clean"]))),
    tabIndex: -1,
    locale: {
      closeLabel: 'Clear'
    },
    onClick: handleClean
  }), caret && /*#__PURE__*/React__default.createElement(Caret, {
    className: prefix(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["caret"])))
  }));
});
PickerToggle.displayName = 'PickerToggle';
PickerToggle.propTypes = {
  classPrefix: PropTypes.string,
  hasValue: PropTypes.bool,
  cleanable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  caret: PropTypes.bool,
  as: PropTypes.elementType,
  onClean: PropTypes.func,
  active: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  plaintext: PropTypes.bool,
  caretComponent: deprecatePropType(PropTypes.elementType, 'Use `caretAs` instead.'),
  caretAs: PropTypes.elementType
};
var PickerToggle$1 = PickerToggle;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

/**
 * The className of the assembled Toggle is on the Picker.
 */
function usePickerClassName(props) {
  var _withClassPrefix;

  var name = props.name,
      classPrefix = props.classPrefix,
      className = props.className,
      placement = props.placement,
      appearance = props.appearance,
      cleanable = props.cleanable,
      block = props.block,
      disabled = props.disabled,
      countable = props.countable,
      readOnly = props.readOnly,
      plaintext = props.plaintext,
      hasValue = props.hasValue,
      rest = _objectWithoutPropertiesLoose(props, ["name", "classPrefix", "className", "placement", "appearance", "cleanable", "block", "disabled", "countable", "readOnly", "plaintext", "hasValue"]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var classes = merge(className, withClassPrefix(name, appearance, 'toggle-wrapper', (_withClassPrefix = {}, _withClassPrefix["placement-" + kebabCase_1(placementPolyfill(placement))] = placement, _withClassPrefix['read-only'] = readOnly, _withClassPrefix['has-value'] = hasValue, _withClassPrefix.cleanable = cleanable, _withClassPrefix.block = block, _withClassPrefix.disabled = disabled, _withClassPrefix.countable = countable, _withClassPrefix.plaintext = plaintext, _withClassPrefix)));
  var usedClassNamePropKeys = Object.keys(omit_1(props, [].concat(Object.keys(rest || {}), ['disabled', 'readOnly', 'plaintext'])));
  return [classes, usedClassNamePropKeys];
}

/**
 * A hook to control the toggle keyboard operation
 * @param props
 */
var useToggleKeyDownEvent = function useToggleKeyDownEvent(props) {
  var _props$toggle = props.toggle,
      toggle = _props$toggle === void 0 ? true : _props$toggle,
      triggerRef = props.triggerRef,
      targetRef = props.targetRef,
      overlayRef = props.overlayRef,
      searchInputRef = props.searchInputRef,
      active = props.active,
      onExit = props.onExit,
      onOpen = props.onOpen,
      onClose = props.onClose,
      onKeyDown = props.onKeyDown,
      onMenuKeyDown = props.onMenuKeyDown,
      onMenuPressEnter = props.onMenuPressEnter,
      onMenuPressBackspace = props.onMenuPressBackspace;
  var handleClose = useCallback(function () {
    var _triggerRef$current, _triggerRef$current$c;

    (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : (_triggerRef$current$c = _triggerRef$current.close) === null || _triggerRef$current$c === void 0 ? void 0 : _triggerRef$current$c.call(_triggerRef$current);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose, triggerRef]);
  var handleOpen = useCallback(function () {
    var _triggerRef$current2, _triggerRef$current2$;

    (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : (_triggerRef$current2$ = _triggerRef$current2.open) === null || _triggerRef$current2$ === void 0 ? void 0 : _triggerRef$current2$.call(_triggerRef$current2);
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
  }, [onOpen, triggerRef]);
  var handleToggleDropdown = useCallback(function () {
    if (active) {
      handleClose();
      return;
    }

    handleOpen();
  }, [active, handleOpen, handleClose]);
  var onToggle = useCallback(function (event) {
    if (event.target === (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current)) {
      // enter
      if (toggle && event.key === KEY_VALUES.ENTER) {
        handleToggleDropdown();
      } // delete


      if (event.key === KEY_VALUES.BACKSPACE) {
        onExit === null || onExit === void 0 ? void 0 : onExit(event);
      }
    }

    if (overlayRef !== null && overlayRef !== void 0 && overlayRef.current) {
      // The keyboard operation callback on the menu.
      onMenuKeyDown === null || onMenuKeyDown === void 0 ? void 0 : onMenuKeyDown(event);

      if (event.key === KEY_VALUES.ENTER) {
        onMenuPressEnter === null || onMenuPressEnter === void 0 ? void 0 : onMenuPressEnter(event);
      }
      /**
       * There is no callback when typing the Backspace key in the search box.
       * The default is to remove search keywords
       */


      if (event.key === KEY_VALUES.BACKSPACE && event.target !== (searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current)) {
        onMenuPressBackspace === null || onMenuPressBackspace === void 0 ? void 0 : onMenuPressBackspace(event);
      } // The search box gets focus when typing characters and numbers.


      if (event.key.length === 1 && /\w/.test(event.key)) {
        var _event$target;

        // Exclude Input
        // eg: <SelectPicker renderExtraFooter={() => <Input />} />
        if (((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.tagName) !== 'INPUT') {
          var _searchInputRef$curre;

          searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
        }
      }
    }

    if (event.key === KEY_VALUES.ESC || event.key === KEY_VALUES.TAB) {
      handleClose();
    } // Native event callback


    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  }, [handleClose, handleToggleDropdown, overlayRef, onExit, onKeyDown, onMenuKeyDown, onMenuPressBackspace, onMenuPressEnter, toggle, targetRef, searchInputRef]);
  return onToggle;
};

/**
 * A hook of the exposed method of Picker
 */
function usePublicMethods(ref, parmas) {
  var triggerRef = parmas.triggerRef,
      overlayRef = parmas.overlayRef,
      targetRef = parmas.targetRef,
      rootRef = parmas.rootRef,
      listRef = parmas.listRef,
      inline = parmas.inline;
  var handleOpen = useCallback(function () {
    var _triggerRef$current3;

    triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current3 = triggerRef.current) === null || _triggerRef$current3 === void 0 ? void 0 : _triggerRef$current3.open();
  }, [triggerRef]);
  var handleClose = useCallback(function () {
    var _triggerRef$current4;

    triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current4 = triggerRef.current) === null || _triggerRef$current4 === void 0 ? void 0 : _triggerRef$current4.close();
  }, [triggerRef]);
  var handleUpdatePosition = useCallback(function () {
    var _triggerRef$current5;

    triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current5 = triggerRef.current) === null || _triggerRef$current5 === void 0 ? void 0 : _triggerRef$current5.updatePosition();
  }, [triggerRef]);
  useImperativeHandle(ref, function () {
    // Tree and CheckTree
    if (inline) {
      return {
        get root() {
          var _triggerRef$current$r, _triggerRef$current6;

          return rootRef !== null && rootRef !== void 0 && rootRef.current ? rootRef === null || rootRef === void 0 ? void 0 : rootRef.current : (_triggerRef$current$r = triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current6 = triggerRef.current) === null || _triggerRef$current6 === void 0 ? void 0 : _triggerRef$current6.root) !== null && _triggerRef$current$r !== void 0 ? _triggerRef$current$r : null;
        },

        get list() {
          if (!(listRef !== null && listRef !== void 0 && listRef.current)) {
            throw new Error('The list is not found, please set `virtualized` for the component.');
          }

          return listRef === null || listRef === void 0 ? void 0 : listRef.current;
        }

      };
    }

    return {
      get root() {
        var _ref, _triggerRef$current7;

        return (_ref = (rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) || (triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef$current7 = triggerRef.current) === null || _triggerRef$current7 === void 0 ? void 0 : _triggerRef$current7.root)) !== null && _ref !== void 0 ? _ref : null;
      },

      get overlay() {
        var _overlayRef$current;

        return (_overlayRef$current = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current) !== null && _overlayRef$current !== void 0 ? _overlayRef$current : null;
      },

      get target() {
        var _targetRef$current;

        return (_targetRef$current = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) !== null && _targetRef$current !== void 0 ? _targetRef$current : null;
      },

      get list() {
        if (!(listRef !== null && listRef !== void 0 && listRef.current)) {
          throw new Error("\n            The list is not found.\n            1.Please set virtualized for the component.\n            2.Please confirm whether the picker is open.\n          ");
        }

        return listRef === null || listRef === void 0 ? void 0 : listRef.current;
      },

      updatePosition: handleUpdatePosition,
      open: handleOpen,
      close: handleClose
    };
  });
}

var pickerPropTypes = _extends$1({}, animationPropTypes, {
  classPrefix: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  locale: PropTypes.any,
  appearance: PropTypes.oneOf(['default', 'subtle']),
  block: PropTypes.bool,
  containerPadding: PropTypes.number,
  container: PropTypes.oneOfType([PropTypes.any, PropTypes.func]),
  disabled: PropTypes.bool,
  // PropTypes.elementType conflictin with React.ElementType
  // toggleAs: PropTypes.elementType,
  menuClassName: PropTypes.string,
  menuStyle: PropTypes.object,
  placeholder: PropTypes.node,
  placement: PropTypes.oneOf(PLACEMENT),

  /**
   * Prevent floating element overflow
   */
  preventOverflow: PropTypes.bool,
  open: PropTypes.bool,
  defaultOpen: PropTypes.bool,
  cleanable: PropTypes.bool,
  renderExtraFooter: PropTypes.func,
  renderValue: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onClean: PropTypes.func,
  listProps: PropTypes.any
});
_extends$1({}, pickerPropTypes, {
  data: PropTypes.array.isRequired,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  childrenKey: PropTypes.string,
  disabledItemValues: PropTypes.array,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
});

/**
 * placementPolyfill('bottomLeft');
 * output 'bottomStart'
 */
function placementPolyfill(placement, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }

  if (typeof placement === 'string') {
    if (rtl) {
      placement = placement.replace(/left|right/, function (m) {
        return m === 'left' ? 'right' : 'left';
      });
    }

    return placement.replace(/Left|Top/, 'Start').replace(/Right|Bottom/, 'End');
  }

  return placement;
}

var getRefTarget = function getRefTarget(ref) {
  return ref && ('current' in ref ? ref.current : ref);
};

function getDOMNode(elementOrRef) {
  // If elementOrRef is an instance of Position, child is returned. [PositionInstance]
  var element = (elementOrRef === null || elementOrRef === void 0 ? void 0 : elementOrRef.root) || (elementOrRef === null || elementOrRef === void 0 ? void 0 : elementOrRef.child) || getRefTarget(elementOrRef); // Native HTML elements

  if (element !== null && element !== void 0 && element.nodeType && typeof (element === null || element === void 0 ? void 0 : element.nodeName) === 'string') {
    return element;
  } // If you can't get the native HTML element, you can only get it through findDOMNode.
  // eslint-disable-next-line react/no-find-dom-node


  return findDOMNode(element);
}

var toFnRef = function toFnRef(ref) {
  return !ref || typeof ref === 'function' ? ref : function (value) {
    ref.current = value;
  };
};

function mergeRefs(refA, refB) {
  var a = toFnRef(refA);
  var b = toFnRef(refB);
  return function (value) {
    if (typeof a === 'function') a(value);
    if (typeof b === 'function') b(value);
  };
}

var composeFunctions = (function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (first) {
    return fns.reduce(function (previousValue, fn) {
      return fn(previousValue);
    }, first);
  };
});

function scrollTopAnimation(target, nextTop, animation, callback) {
  if (animation === void 0) {
    animation = true;
  }

  var top = scrollTop(target);

  var step = function step() {
    scrollTop(target, top > nextTop ? nextTop : top);

    if (top <= nextTop) {
      requestAnimationFramePolyfill$1(step);
    }

    callback === null || callback === void 0 ? void 0 : callback(top);
    top += 20;
  };

  if (animation) {
    requestAnimationFramePolyfill$1(step);
  } else {
    scrollTop(target, nextTop);
  }
}

/**
 * Add a prefix to all classNames.
 *
 * @param str prefix of className
 * @returns { withClassPrefix, merge, prefix }
 *  - withClassPrefix: A function of combining className and adding a prefix to each className.
 *    At the same time, the default `classPrefix` is the first className.
 *  - merge: A merge className function.
 *  - prefix: Add a prefix to className
 *  - rootPrefix
 */
function useClassNames(str) {
  var _ref = useContext(CustomContext) || {},
      _ref$classPrefix = _ref.classPrefix,
      classPrefix = _ref$classPrefix === void 0 ? 'rs' : _ref$classPrefix;

  var componentName = prefix(classPrefix, str);
  /**
   * @example
   *
   * if str = 'button':
   * prefix('red', { active: true }) => 'rs-button-red rs-button-active'
   */

  var prefix$1 = useCallback(function () {
    var mergeClasses = arguments.length ? classNames.apply(void 0, arguments).split(' ').map(function (item) {
      return prefix(componentName, item);
    }) : [];
    return mergeClasses.filter(function (cls) {
      return cls;
    }).join(' ');
  }, [componentName]);
  /**
   * @example
   *
   * if str = 'button':
   * withClassPrefix('red', { active: true }) => 'rs-button rs-button-red rs-button-active'
   */

  var withClassPrefix = useCallback(function () {
    for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
      classes[_key] = arguments[_key];
    }

    var mergeClasses = prefix$1(classes);
    return mergeClasses ? componentName + " " + mergeClasses : componentName;
  }, [componentName, prefix$1]);
  /**
   * @example
   * rootPrefix('btn') => 'rs-btn'
   * rootPrefix('btn', { active: true }) => 'rs-btn rs-active'
   */

  var rootPrefix = function rootPrefix() {
    var mergeClasses = arguments.length ? classNames.apply(void 0, arguments).split(' ').map(function (item) {
      return prefix(classPrefix, item);
    }) : [];
    return mergeClasses.filter(function (cls) {
      return cls;
    }).join(' ');
  };

  return {
    withClassPrefix: withClassPrefix,
    merge: classNames,
    prefix: prefix$1,
    rootPrefix: rootPrefix
  };
}

/**
 * Attach the event handler directly to the specified DOM element,
 * and it will be triggered when the size of the DOM element is changed.
 *
 * @param eventTarget The target to listen for events on
 * @param listener An event handler
 */

function useElementResize(eventTarget, listener) {
  var resizeObserver = useRef();
  useEffect(function () {
    if (!resizeObserver.current) {
      var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;

      if (target) {
        resizeObserver.current = new ResizeObserver(listener);
        resizeObserver.current.observe(target);
      }
    }

    return function () {
      var _resizeObserver$curre;

      (_resizeObserver$curre = resizeObserver.current) === null || _resizeObserver$curre === void 0 ? void 0 : _resizeObserver$curre.disconnect();
    };
  }, [eventTarget, listener]);
}

function usePortal(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      id = _props.id,
      container = _props.container;
  var rootElemRef = useRef(canUseDOM$1 ? document.body : null);
  useEffect(function () {
    var containerElement = typeof container === 'function' ? container() : container; // Look for existing target dom element to append to

    var existingParent = id && document.querySelector("#" + id); // Parent is either a new root or the existing dom element

    var parentElement = containerElement || existingParent || document.body;
    rootElemRef.current = parentElement;
  }, [rootElemRef, container, id]);
  var Portal = useCallback(function (_ref) {
    var children = _ref.children;
    if (rootElemRef.current != null) return /*#__PURE__*/createPortal(children, rootElemRef.current);
    return null;
  }, [rootElemRef]);
  return {
    target: rootElemRef.current,
    Portal: Portal
  };
}

function useControlled(controlledValue, defaultValue) {
  var controlledRef = useRef(false);
  controlledRef.current = controlledValue !== undefined;

  var _useState = useState(defaultValue),
      uncontrolledValue = _useState[0],
      setUncontrolledValue = _useState[1]; // If it is controlled, this directly returns the attribute value.


  var value = controlledRef.current ? controlledValue : uncontrolledValue;
  var setValue = useCallback(function (nextValue) {
    // Only update the value in state when it is not under control.
    if (!controlledRef.current) {
      setUncontrolledValue(nextValue);
    }
  }, [controlledRef]);
  return [value, setValue, controlledRef.current];
}

function isLeftClickEvent(event) {
  return (event === null || event === void 0 ? void 0 : event.button) === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event !== null && event !== void 0 && event.shiftKey);
}

/**
 * A hook that listens to the document click event and closes the overlay.
 * @param onRootClose
 * @param param1
 * @todo Allow different behaviors based on whether clicked element is focusable
 */
function useRootClose(onRootClose, _ref) {
  var disabled = _ref.disabled,
      triggerTarget = _ref.triggerTarget,
      overlayTarget = _ref.overlayTarget,
      _ref$listenEscape = _ref.listenEscape,
      listenEscape = _ref$listenEscape === void 0 ? true : _ref$listenEscape;
  var handleDocumentKeyUp = useCallback(function (event) {
    if (listenEscape && event.key === KEY_VALUES.ESC) {
      onRootClose === null || onRootClose === void 0 ? void 0 : onRootClose(event);
    }
  }, [listenEscape, onRootClose]);
  var handleDocumentMouseDown = useCallback(function (event) {
    var triggerElement = getDOMNode(triggerTarget);
    var overlayElement = getDOMNode(overlayTarget); // Check if the clicked element is a trigger.

    if (triggerElement && contains$1(triggerElement, event.target)) {
      return;
    } // Check if the clicked element is a overlay.


    if (overlayElement && contains$1(overlayElement, event.target)) {
      return;
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    onRootClose === null || onRootClose === void 0 ? void 0 : onRootClose(event);
  }, [onRootClose, triggerTarget, overlayTarget]);
  useEffect(function () {
    var currentTarget = getDOMNode(triggerTarget);
    if (disabled || !currentTarget) return;
    var doc = ownerDocument(currentTarget);
    var onDocumentMouseDownListener = on(doc, 'mousedown', handleDocumentMouseDown, true);
    var onDocumentKeyupListener = on(doc, 'keyup', handleDocumentKeyUp);
    return function () {
      onDocumentMouseDownListener === null || onDocumentMouseDownListener === void 0 ? void 0 : onDocumentMouseDownListener.off();
      onDocumentKeyupListener === null || onDocumentKeyupListener === void 0 ? void 0 : onDocumentKeyupListener.off();
    };
  }, [triggerTarget, disabled, onRootClose, handleDocumentMouseDown, handleDocumentKeyUp]);
}

var useUpdateEffect = function useUpdateEffect(effect, deps) {
  var isMounting = useRef(true);
  useEffect(function () {
    if (isMounting.current) {
      isMounting.current = false;
      return;
    }

    effect(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

var useUpdateEffect$1 = useUpdateEffect;

var ButtonGroupContext = /*#__PURE__*/React__default.createContext(null);
var ButtonGroupContext$1 = ButtonGroupContext;

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

var SafeAnchor = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'a' : _props$as,
      href = props.href,
      disabled = props.disabled,
      onClick = props.onClick,
      restProps = _objectWithoutPropertiesLoose(props, ["as", "href", "disabled", "onClick"]);

  var handleClick = useCallback(function (event) {
    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [disabled, href, onClick]); // There are default role and href attributes on the node to ensure Focus management and keyboard interactions.

  var trivialProps = isTrivialHref(href) ? {
    role: 'button',
    href: '#'
  } : null;

  if (disabled) {
    restProps.tabIndex = -1;
    restProps['aria-disabled'] = true;
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    ref: ref,
    href: href
  }, trivialProps, restProps, {
    onClick: handleClick
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
SafeAnchor.propTypes = {
  href: PropTypes.string,
  disabled: PropTypes.bool,
  as: PropTypes.elementType
};
var SafeAnchor$1 = SafeAnchor;

var getPosition = function getPosition(target, event) {
  var offset = getOffset(target);
  var offsetX = (event.pageX || 0) - offset.left;
  var offsetY = (event.pageY || 0) - offset.top;
  var radiusX = Math.max(offset.width - offsetX, offsetX);
  var radiusY = Math.max(offset.height - offsetY, offsetY);
  var radius = Math.sqrt(Math.pow(radiusX, 2) + Math.pow(radiusY, 2));
  return {
    width: radius * 2,
    height: radius * 2,
    left: offsetX - radius,
    top: offsetY - radius
  };
};

var Ripple = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'span' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'ripple' : _props$classPrefix,
      onMouseDown = props.onMouseDown,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "onMouseDown"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, prefix('pond'));
  var triggerRef = useRef(null);

  var _useState = useState(false),
      rippling = _useState[0],
      setRippling = _useState[1];

  var _useState2 = useState(),
      position = _useState2[0],
      setPosition = _useState2[1];

  var handleRippled = function handleRippled() {
    setRippling(false);
  };

  var handleMouseDown = useCallback(function (event) {
    if (triggerRef.current) {
      var _position = getPosition(triggerRef.current, event);

      setRippling(true);
      setPosition(_position);
      onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(_position, event);
    }
  }, [onMouseDown]);
  useEffect(function () {
    var _triggerRef$current;

    var parentNode = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.parentNode;

    if (parentNode) {
      var mousedownListener = on(parentNode, 'mousedown', handleMouseDown);
      return function () {
        mousedownListener === null || mousedownListener === void 0 ? void 0 : mousedownListener.off();
      };
    }
  }, [handleMouseDown]);
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    className: classes,
    ref: mergeRefs(triggerRef, ref)
  }), /*#__PURE__*/React__default.createElement(Transition$1, {
    in: rippling,
    enteringClassName: prefix('rippling'),
    onEntered: handleRippled
  }, function (props, ref) {
    var className = props.className,
        transitionRest = _objectWithoutPropertiesLoose(props, ["className"]);

    return /*#__PURE__*/React__default.createElement("span", _extends$1({}, transitionRest, {
      ref: ref,
      className: merge(withClassPrefix(), className),
      style: position
    }));
  }));
});
Ripple.displayName = 'Ripple';
Ripple.propTypes = {
  classPrefix: PropTypes.string,
  className: PropTypes.string,
  onMouseDown: PropTypes.func
};
var Ripple$1 = Ripple;

var _templateObject;
var Button = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var as = props.as,
      active = props.active,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'default' : _props$appearance,
      block = props.block,
      className = props.className,
      children = props.children,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'btn' : _props$classPrefix,
      color = props.color,
      disabled = props.disabled,
      loading = props.loading,
      _props$ripple = props.ripple,
      ripple = _props$ripple === void 0 ? true : _props$ripple,
      sizeProp = props.size,
      typeProp = props.type,
      rest = _objectWithoutPropertiesLoose(props, ["as", "active", "appearance", "block", "className", "children", "classPrefix", "color", "disabled", "loading", "ripple", "size", "type"]);

  var buttonGroup = useContext(ButtonGroupContext$1);
  var size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : buttonGroup === null || buttonGroup === void 0 ? void 0 : buttonGroup.size;

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge;

  var classes = merge(className, withClassPrefix(appearance, color, size, {
    active: active,
    disabled: disabled,
    loading: loading,
    block: block
  }));
  var rippleElement = ripple && !isOneOf(appearance, ['link', 'ghost']) ? /*#__PURE__*/React__default.createElement(Ripple$1, null) : null;
  var spin = /*#__PURE__*/React__default.createElement("span", {
    className: prefix(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["spin"])))
  });

  if (rest.href) {
    return /*#__PURE__*/React__default.createElement(SafeAnchor$1, _extends$1({}, rest, {
      as: as,
      ref: ref,
      "aria-disabled": disabled,
      disabled: disabled,
      className: classes
    }), loading && spin, children, rippleElement);
  }

  var Component = as || 'button';
  var type = typeProp || (Component === 'button' ? 'button' : undefined);
  var role = rest.role || (Component !== 'button' ? 'button' : undefined);
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    role: role,
    type: type,
    ref: ref,
    disabled: disabled,
    "aria-disabled": disabled,
    className: classes
  }), loading && spin, children, rippleElement);
});
Button.displayName = 'Button';
Button.propTypes = {
  as: PropTypes.elementType,
  active: PropTypes.bool,
  appearance: PropTypes.oneOf(['default', 'primary', 'link', 'subtle', 'ghost']),
  block: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.oneOf(['red', 'orange', 'yellow', 'green', 'cyan', 'blue', 'violet']),
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool,
  ripple: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs']),
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
};
var Button$1 = Button;

var IconButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var icon = props.icon,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'left' : _props$placement,
      children = props.children,
      circle = props.circle,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'btn-icon' : _props$classPrefix,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, ["icon", "placement", "children", "circle", "classPrefix", "className"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix("placement-" + placement, {
    circle: circle,
    'with-text': typeof children !== 'undefined'
  }));
  return /*#__PURE__*/React__default.createElement(Button$1, _extends$1({}, rest, {
    ref: ref,
    className: classes
  }), icon, children);
});
IconButton.displayName = 'IconButton';
IconButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.any,
  classPrefix: PropTypes.string,
  circle: PropTypes.bool,
  children: PropTypes.node,
  placement: PropTypes.oneOf(['left', 'right'])
};
var IconButton$1 = IconButton;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$1 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$1(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString(string).toLowerCase());
}

var capitalize_1 = capitalize$1;

var Calendar$5 = {};

var Calendar$4 = {exports: {}};

var Calendar$3 = {};

(function (exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(React__default);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Calendar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Calendar);
var _default = ForwardRef;
exports["default"] = _default;
}(Calendar$3));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault.exports;

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon.exports);

var _Calendar = _interopRequireDefault(Calendar$3);

// Generated by script, don't edit it please.
var Calendar = (0, _createSvgIcon["default"])({
  as: _Calendar["default"],
  ariaLabel: 'calendar',
  category: 'legacy',
  displayName: 'Calendar'
});
var _default = Calendar;
exports["default"] = _default;
module.exports = exports.default;
}(Calendar$4, Calendar$4.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});

var _Calendar = _interopRequireDefault(Calendar$4.exports);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
}(Calendar$5));

var IconCalendar = /*@__PURE__*/getDefaultExportFromCjs(Calendar$5);

var CalendarContext = /*#__PURE__*/React__default.createContext({});
var CalendarProvider = CalendarContext.Provider;
var useCalendarContext = function useCalendarContext() {
  return useContext(CalendarContext) || {};
};

var MonthDropdownItem = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-month-dropdown-cell' : _props$classPrefix,
      active = props.active,
      disabled = props.disabled,
      _props$month = props.month,
      month = _props$month === void 0 ? 0 : _props$month,
      year = props.year,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "active", "disabled", "month", "year"]);

  var _useCalendarContext = useCalendarContext(),
      date = _useCalendarContext.date,
      onSelect = _useCalendarContext.onChangePageDate;

  var handleClick = useCallback(function (event) {
    if (disabled) {
      return;
    }

    if (year && month && date) {
      var nextMonth = composeFunctions(function (d) {
        return setYear(d, year);
      }, function (d) {
        return setMonth(d, month - 1);
      })(date);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextMonth, event);
    }
  }, [date, disabled, month, onSelect, year]);

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix({
    active: active
  }), {
    disabled: disabled
  });
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    className: classes,
    onClick: handleClick,
    key: month,
    tabIndex: -1
  }), /*#__PURE__*/React__default.createElement("span", {
    className: prefix('content')
  }, month));
});
MonthDropdownItem.displayName = 'MonthDropdownItem';
MonthDropdownItem.propTypes = {
  month: PropTypes.number,
  year: PropTypes.number,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool
};
var MonthDropdownItem$1 = MonthDropdownItem;

var monthMap = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
/**
 * Set the row height.
 * Add 1px to the first and last lines.
 */

function getRowHeight(count) {
  return function (_ref) {
    var index = _ref.index;

    if (index === 0 || count - 1 === index) {
      return 75 + 1;
    }

    return 75;
  };
}

var MonthDropdown = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-month-dropdown' : _props$classPrefix,
      _props$limitEndYear = props.limitEndYear,
      limitEndYear = _props$limitEndYear === void 0 ? 5 : _props$limitEndYear,
      show = props.show,
      _props$height = props.height,
      defaultHeight = _props$height === void 0 ? 221 : _props$height,
      _props$width = props.width,
      defaultWidth = _props$width === void 0 ? 256 : _props$width,
      disabledMonth = props.disabledMonth,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "limitEndYear", "show", "height", "width", "disabledMonth"]);

  var _useCalendarContext = useCalendarContext(),
      _useCalendarContext$d = _useCalendarContext.date,
      date = _useCalendarContext$d === void 0 ? new Date() : _useCalendarContext$d;

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var getRowCount = useCallback(function () {
    return getYear(new Date()) + limitEndYear;
  }, [limitEndYear]);
  var isMonthDisabled = useCallback(function (year, month) {
    if (disabledMonth) {
      var days = getDaysInMonth(new Date(year, month)); // If all dates in a month are disabled, disable the current month

      for (var i = 1; i <= days; i++) {
        if (!disabledMonth(new Date(year, month, i))) {
          return false;
        }
      }

      return true;
    }

    return false;
  }, [disabledMonth]);

  var rowRenderer = function rowRenderer(_ref2) {
    var index = _ref2.index,
        key = _ref2.key,
        style = _ref2.style;
    var selectedMonth = getMonth(date);
    var selectedYear = getYear(date);
    var year = index + 1;
    var isSelectedYear = year === selectedYear;
    var count = getRowCount();
    var titleClassName = prefix('year', {
      'year-active': isSelectedYear
    });
    var rowClassName = merge(prefix('row'), {
      'first-row': index === 0,
      'last-row': index === count - 1
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: rowClassName,
      role: "row",
      key: key,
      style: style
    }, /*#__PURE__*/React__default.createElement("div", {
      className: titleClassName,
      role: "rowheader"
    }, year), /*#__PURE__*/React__default.createElement("div", {
      className: prefix('list'),
      role: "gridcell"
    }, monthMap.map(function (item, month) {
      return /*#__PURE__*/React__default.createElement(MonthDropdownItem$1, {
        disabled: isMonthDisabled(year, month),
        active: isSelectedYear && month === selectedMonth,
        key: month + "_" + item,
        month: month + 1,
        year: year
      });
    })));
  };

  var count = getRowCount();
  var classes = merge(className, withClassPrefix(), {
    show: show
  });
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "menu"
  }, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement("div", {
    className: prefix('content')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: prefix('scroll')
  }, show && /*#__PURE__*/React__default.createElement(AutoSizer, {
    defaultHeight: defaultHeight,
    defaultWidth: defaultWidth
  }, function (_ref3) {
    var height = _ref3.height,
        width = _ref3.width;
    return /*#__PURE__*/React__default.createElement(List, {
      className: prefix('row-wrapper'),
      width: width || defaultWidth,
      height: height || defaultHeight,
      rowHeight: getRowHeight(count),
      rowCount: count,
      scrollToIndex: getYear(date),
      rowRenderer: rowRenderer
    });
  }))));
});
MonthDropdown.displayName = 'MonthDropdown';
MonthDropdown.propTypes = {
  limitEndYear: PropTypes.number,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  show: PropTypes.bool,
  disabledMonth: PropTypes.func
};
var MonthDropdown$1 = MonthDropdown;

var baseRest = _baseRest,
    createWrap = _createWrap,
    getHolder = _getHolder,
    replaceHolders = _replaceHolders;

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

var partial_1 = partial;

var capitalize = capitalize_1,
    createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

var camelCase_1 = camelCase;

/**
 * Get the effective range of hours, minutes and seconds
 * @param meridian
 */
function getRanges$1(meridian) {
  return {
    hours: {
      start: 0,
      end: meridian ? 11 : 23
    },
    minutes: {
      start: 0,
      end: 59
    },
    seconds: {
      start: 0,
      end: 59
    }
  };
}
/**
 * Convert the 24-hour clock to the 12-hour clock
 * @param hours
 */

function getMeridianHours(hours) {
  return hours >= 12 ? hours - 12 : hours;
}

var getTime = function getTime(props) {
  var format = props.format,
      date = props.date,
      showMeridian = props.showMeridian;
  var time = date || new Date();
  var nextTime = {};

  if (!format) {
    return nextTime;
  }

  if (/(H|h)/.test(format)) {
    var hours = getHours(time);
    nextTime.hours = showMeridian ? getMeridianHours(hours) : hours;
  }

  if (/m/.test(format)) {
    nextTime.minutes = getMinutes(time);
  }

  if (/s/.test(format)) {
    nextTime.seconds = getSeconds(time);
  }

  return nextTime;
};

var scrollTo = function scrollTo(time, row) {
  if (!row) {
    return;
  }

  Object.entries(time).forEach(function (_ref) {
    var type = _ref[0],
        value = _ref[1];
    var container = row.querySelector("[data-type=\"" + type + "\"]");
    var node = container === null || container === void 0 ? void 0 : container.querySelector("[data-key=\"" + type + "-" + value + "\"]");

    if (node && container) {
      var position = getPosition$1(node, container);

      if (position) {
        scrollTopAnimation(container, position.top, scrollTop(container) !== 0);
      }
    }
  });
};

var TimeDropdown = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-time-dropdown' : _props$classPrefix,
      show = props.show,
      _props$showMeridian = props.showMeridian,
      showMeridian = _props$showMeridian === void 0 ? false : _props$showMeridian,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "show", "showMeridian"]);

  var _useCalendarContext = useCalendarContext(),
      locale = _useCalendarContext.locale,
      format = _useCalendarContext.format,
      date = _useCalendarContext.date,
      onSelect = _useCalendarContext.onChangePageTime;

  var rowRef = useRef(null);
  useEffect(function () {
    var time = getTime({
      format: format,
      date: date,
      showMeridian: showMeridian
    }); // The currently selected time scrolls to the visible range.

    if (show && rowRef.current) {
      scrollTo(time, rowRef.current);
    }
  }, [date, format, show, showMeridian]);

  var handleClick = function handleClick(type, d, event) {
    var nextDate = date || new Date();

    switch (type) {
      case 'hours':
        nextDate = setHours(date, showMeridian && getHours(nextDate) >= 12 ? d + 12 : d);
        break;

      case 'minutes':
        nextDate = setMinutes(date, d);
        break;

      case 'seconds':
        nextDate = setSeconds(date, d);
        break;
    }

    onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextDate, event);
  };

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      rootPrefix = _useClassNames.rootPrefix,
      merge = _useClassNames.merge;

  var renderColumn = function renderColumn(type, active) {
    if (!isNumber_1(active)) {
      return null;
    }

    var _getRanges$type = getRanges$1(showMeridian)[type],
        start = _getRanges$type.start,
        end = _getRanges$type.end;
    var items = [];
    var hideFunc = props[camelCase_1("hide_" + type)];
    var disabledFunc = props[camelCase_1("disabled_" + type)];

    for (var i = start; i <= end; i += 1) {
      if (!(hideFunc !== null && hideFunc !== void 0 && hideFunc(i, date))) {
        var disabled = disabledFunc === null || disabledFunc === void 0 ? void 0 : disabledFunc(i, date);
        var itemClasses = prefix('cell', {
          'cell-active': active === i,
          'cell-disabled': disabled
        });
        items.push( /*#__PURE__*/React__default.createElement("li", {
          key: i,
          role: "menuitem"
        }, /*#__PURE__*/React__default.createElement("a", {
          role: "button",
          className: itemClasses,
          tabIndex: -1,
          "data-key": type + "-" + i,
          onClick: !disabled ? partial_1(handleClick, type, i) : undefined
        }, showMeridian && type === 'hours' && i === 0 ? '12' : i)));
      }
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: prefix('column'),
      role: "listitem"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: prefix('column-title')
    }, locale === null || locale === void 0 ? void 0 : locale[type]), /*#__PURE__*/React__default.createElement("ul", {
      "data-type": type,
      role: "menu"
    }, items));
  };

  var time = getTime({
    format: format,
    date: date,
    showMeridian: showMeridian
  });
  var classes = merge(className, rootPrefix(classPrefix));
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "list"
  }, omitHideDisabledProps(rest), {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement("div", {
    className: prefix('content')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: prefix('row'),
    ref: rowRef
  }, renderColumn('hours', time.hours), renderColumn('minutes', time.minutes), renderColumn('seconds', time.seconds))));
});
TimeDropdown.displayName = 'TimeDropdown';
TimeDropdown.propTypes = {
  show: PropTypes.bool,
  showMeridian: PropTypes.bool,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  disabledDate: PropTypes.func,
  disabledHours: PropTypes.func,
  disabledMinutes: PropTypes.func,
  disabledSeconds: PropTypes.func,
  hideHours: PropTypes.func,
  hideMinutes: PropTypes.func,
  hideSeconds: PropTypes.func
};
var TimeDropdown$1 = TimeDropdown;

var TableRow = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-table' : _props$classPrefix,
      _props$weekendDate = props.weekendDate,
      weekendDate = _props$weekendDate === void 0 ? new Date() : _props$weekendDate,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "weekendDate"]);

  var _useCalendarContext = useCalendarContext(),
      _useCalendarContext$d = _useCalendarContext.date,
      selected = _useCalendarContext$d === void 0 ? new Date() : _useCalendarContext$d,
      dateRange = _useCalendarContext.dateRange,
      disabledDate = _useCalendarContext.disabledDate,
      hoverRangeValue = _useCalendarContext.hoverRangeValue,
      inSameMonth = _useCalendarContext.inSameMonth,
      isoWeek = _useCalendarContext.isoWeek,
      onMouseMove = _useCalendarContext.onMouseMove,
      onSelect = _useCalendarContext.onSelect,
      renderCell = _useCalendarContext.renderCell,
      overrideLocale = _useCalendarContext.locale,
      showWeekNumbers = _useCalendarContext.showWeekNumbers;

  var _useCustom = useCustom('Calendar', overrideLocale),
      locale = _useCustom.locale,
      formatDate = _useCustom.formatDate;

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge;

  var handleSelect = useCallback(function (date, disabled, event) {
    if (disabled) {
      return;
    }

    onSelect === null || onSelect === void 0 ? void 0 : onSelect(date, event);
  }, [onSelect]);

  var renderDays = function renderDays() {
    var formatStr = locale.formattedDayPattern;
    var days = [];

    var _ref = dateRange || [],
        selectedStartDate = _ref[0],
        selectedEndDate = _ref[1];

    var _ref2 = hoverRangeValue !== null && hoverRangeValue !== void 0 ? hoverRangeValue : [],
        hoverStartDate = _ref2[0],
        hoverEndDate = _ref2[1];

    var isRangeSelectionMode = typeof dateRange !== 'undefined';
    var todayDate = new Date();

    for (var i = 0; i < 7; i += 1) {
      var thisDate = addDays(weekendDate, i);
      var disabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(thisDate, dateRange, DATERANGE_DISABLED_TARGET.CALENDAR);
      var isToday = isSameDay(thisDate, todayDate);
      var unSameMonth = !(inSameMonth !== null && inSameMonth !== void 0 && inSameMonth(thisDate));
      var isStartSelected = !unSameMonth && selectedStartDate && isSameDay(thisDate, selectedStartDate);
      var isEndSelected = !unSameMonth && selectedEndDate && isSameDay(thisDate, selectedEndDate);
      var isSelected = isRangeSelectionMode ? isStartSelected || isEndSelected : isSameDay(thisDate, selected);
      var inRange = false; // for Selected

      if (selectedStartDate && selectedEndDate) {
        if (isBefore(thisDate, selectedEndDate) && isAfter(thisDate, selectedStartDate)) {
          inRange = true;
        }

        if (isBefore(thisDate, selectedStartDate) && isAfter(thisDate, selectedEndDate)) {
          inRange = true;
        }
      } // for Hovering


      if (!isSelected && hoverStartDate && hoverEndDate) {
        if (!isAfter(thisDate, hoverEndDate) && !isBefore(thisDate, hoverStartDate)) {
          inRange = true;
        }

        if (!isAfter(thisDate, hoverStartDate) && !isBefore(thisDate, hoverEndDate)) {
          inRange = true;
        }
      }

      var _classes = prefix('cell', {
        'cell-un-same-month': unSameMonth,
        'cell-is-today': isToday,
        'cell-selected': isSelected,
        'cell-selected-start': isStartSelected,
        'cell-selected-end': isEndSelected,
        'cell-in-range': !unSameMonth && inRange,
        'cell-disabled': disabled
      });

      var title = formatDate ? formatDate(thisDate, formatStr) : format(thisDate, formatStr);
      days.push( /*#__PURE__*/React__default.createElement("div", {
        role: "gridcell",
        key: title,
        "aria-label": title,
        "aria-selected": isSelected || undefined,
        className: _classes
      }, /*#__PURE__*/React__default.createElement("div", {
        role: "button",
        className: prefix('cell-content'),
        tabIndex: -1,
        title: isToday ? title + " (" + (locale === null || locale === void 0 ? void 0 : locale.today) + ")" : title,
        onMouseEnter: !disabled && onMouseMove ? onMouseMove.bind(null, thisDate) : undefined,
        onClick: partial_1(handleSelect, thisDate, disabled)
      }, /*#__PURE__*/React__default.createElement("span", {
        className: prefix('cell-day')
      }, getDate(thisDate)), renderCell && renderCell(thisDate))));
    }

    return days;
  };

  var classes = merge(className, prefix('row'));
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    role: "row",
    className: classes
  }), showWeekNumbers && /*#__PURE__*/React__default.createElement("div", {
    className: prefix('cell-week-number'),
    role: "rowheader"
  }, format(weekendDate, isoWeek ? 'I' : 'w')), renderDays());
});
TableRow.displayName = 'TableRow';
TableRow.propTypes = {
  weekendDate: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  classPrefix: PropTypes.string
};
var TableRow$1 = TableRow;

var weekKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
var TableHeaderRow = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-table' : _props$classPrefix,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix"]);

  var _useCalendarContext = useCalendarContext(),
      locale = _useCalendarContext.locale,
      showWeekNumbers = _useCalendarContext.showWeekNumbers,
      isoWeek = _useCalendarContext.isoWeek;

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix;

  var classes = merge(className, prefix('row', 'header-row'));
  var items = weekKeys;

  if (isoWeek) {
    items = weekKeys.filter(function (v) {
      return v !== 'sunday';
    });
    items.push('sunday');
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "row"
  }, rest, {
    ref: ref,
    className: classes
  }), showWeekNumbers && /*#__PURE__*/React__default.createElement("div", {
    className: prefix('cell'),
    role: "columnheader"
  }), items.map(function (key) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      className: prefix('cell'),
      role: "columnheader"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: prefix('cell-content')
    }, locale === null || locale === void 0 ? void 0 : locale[key]));
  }));
});
TableHeaderRow.displayName = 'TableHeaderRow';
TableHeaderRow.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  classPrefix: PropTypes.string
};
var TableHeaderRow$1 = TableHeaderRow;

var Table = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-table' : _props$classPrefix,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? [] : _props$rows,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "rows"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({
    role: "grid"
  }, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement(TableHeaderRow$1, null), rows.map(function (week, index) {
    return /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: index,
      weekendDate: week
    });
  }));
});
Table.displayName = 'Table';
Table.propTypes = {
  rows: PropTypes.array,
  className: PropTypes.string,
  classPrefix: PropTypes.string
};
var Table$1 = Table;

var View = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-view' : _props$classPrefix,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix"]);

  var _useCalendarContext = useCalendarContext(),
      _useCalendarContext$d = _useCalendarContext.date,
      date = _useCalendarContext$d === void 0 ? new Date() : _useCalendarContext$d,
      isoWeek = _useCalendarContext.isoWeek,
      overrideLocale = _useCalendarContext.locale;

  var _useCustom = useCustom('Calendar', overrideLocale),
      locale = _useCustom.locale,
      formatDate = _useCustom.formatDate;

  var thisMonthDate = setDate(date, 1);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement(Table$1, {
    rows: getMonthView(thisMonthDate, isoWeek),
    "aria-label": formatDate(thisMonthDate, locale.formattedMonthPattern)
  }));
});
View.displayName = 'View';
View.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  classPrefix: PropTypes.string
};
var View$1 = View;

var Header$2 = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-header' : _props$classPrefix,
      disabledBackward = props.disabledBackward,
      disabledForward = props.disabledForward,
      showDate = props.showDate,
      showMeridian = props.showMeridian,
      showMonth = props.showMonth,
      showTime = props.showTime,
      disabledTime = props.disabledTime,
      onMoveBackward = props.onMoveBackward,
      onMoveForward = props.onMoveForward,
      onToggleMeridian = props.onToggleMeridian,
      onToggleMonthDropdown = props.onToggleMonthDropdown,
      onToggleTimeDropdown = props.onToggleTimeDropdown,
      renderTitleProp = props.renderTitle,
      renderToolbar = props.renderToolbar,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "disabledBackward", "disabledForward", "showDate", "showMeridian", "showMonth", "showTime", "disabledTime", "onMoveBackward", "onMoveForward", "onToggleMeridian", "onToggleMonthDropdown", "onToggleTimeDropdown", "renderTitle", "renderToolbar"]);

  var _useCalendarContext = useCalendarContext(),
      locale = _useCalendarContext.locale,
      _useCalendarContext$d = _useCalendarContext.date,
      date = _useCalendarContext$d === void 0 ? new Date() : _useCalendarContext$d,
      format = _useCalendarContext.format,
      inline = _useCalendarContext.inline,
      disabledDate = _useCalendarContext.disabledDate;

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var btnProps = {
    appearance: 'subtle',
    size: inline ? 'sm' : 'xs'
  };
  var getTimeFormat = useCallback(function () {
    var timeFormat = [];

    if (!format) {
      return '';
    }

    if (/([Hh])/.test(format)) {
      timeFormat.push(showMeridian ? 'hh' : 'HH');
    }

    if (/m/.test(format)) {
      timeFormat.push('mm');
    }

    if (/s/.test(format)) {
      timeFormat.push('ss');
    }

    return timeFormat.join(':');
  }, [format, showMeridian]);
  var getDateFormat = useCallback(function () {
    if (showDate) {
      return (locale === null || locale === void 0 ? void 0 : locale.formattedDayPattern) || 'yyyy-MM-dd';
    } else if (showMonth) {
      return (locale === null || locale === void 0 ? void 0 : locale.formattedMonthPattern) || 'yyyy-MM';
    }

    return 'yyyy';
  }, [locale, showDate, showMonth]);
  var renderTitle = useCallback(function () {
    var _renderTitleProp;

    return (_renderTitleProp = renderTitleProp === null || renderTitleProp === void 0 ? void 0 : renderTitleProp(date)) !== null && _renderTitleProp !== void 0 ? _renderTitleProp : date && /*#__PURE__*/React__default.createElement(FormattedDate, {
      date: date,
      formatStr: getDateFormat()
    });
  }, [date, getDateFormat, renderTitleProp]);
  var dateTitleClasses = prefix('title', 'title-date', {
    error: disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date)
  });
  var timeTitleClasses = prefix('title', 'title-time', {
    error: disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(date)
  });
  var backwardClass = prefix('backward', {
    'btn-disabled': disabledBackward
  });
  var forwardClass = prefix('forward', {
    'btn-disabled': disabledForward
  });
  var monthToolbar = /*#__PURE__*/React__default.createElement("div", {
    className: prefix('month-toolbar')
  }, /*#__PURE__*/React__default.createElement(IconButton$1, _extends$1({}, btnProps, {
    className: backwardClass,
    onClick: disabledBackward ? undefined : onMoveBackward,
    icon: /*#__PURE__*/React__default.createElement(AngleLeftIcon, null)
  })), /*#__PURE__*/React__default.createElement(Button$1, _extends$1({}, btnProps, {
    className: dateTitleClasses,
    onClick: onToggleMonthDropdown
  }), renderTitle()), /*#__PURE__*/React__default.createElement(IconButton$1, _extends$1({}, btnProps, {
    className: forwardClass,
    onClick: disabledForward ? undefined : onMoveForward,
    icon: /*#__PURE__*/React__default.createElement(AngleRightIcon, null)
  })));
  var hasMonth = showDate || showMonth;
  var classes = merge(className, withClassPrefix({
    'has-month': hasMonth,
    'has-time': showTime
  }));
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    className: classes
  }), hasMonth && monthToolbar, showTime && /*#__PURE__*/React__default.createElement("div", {
    className: prefix('time-toolbar')
  }, /*#__PURE__*/React__default.createElement(Button$1, _extends$1({}, btnProps, {
    className: timeTitleClasses,
    onClick: onToggleTimeDropdown
  }), date && /*#__PURE__*/React__default.createElement(FormattedDate, {
    date: date,
    formatStr: getTimeFormat()
  })), showMeridian && /*#__PURE__*/React__default.createElement(Button$1, _extends$1({}, btnProps, {
    className: prefix('meridian'),
    onClick: onToggleMeridian
  }), date && /*#__PURE__*/React__default.createElement(FormattedDate, {
    date: date,
    formatStr: "a"
  }))), renderToolbar === null || renderToolbar === void 0 ? void 0 : renderToolbar(date));
});
Header$2.displayName = 'Header';
Header$2.propTypes = {
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  disabledBackward: PropTypes.bool,
  disabledForward: PropTypes.bool,
  disabledTime: PropTypes.func,
  onMoveBackward: PropTypes.func,
  onMoveForward: PropTypes.func,
  onToggleMeridian: PropTypes.func,
  onToggleMonthDropdown: PropTypes.func,
  onToggleTimeDropdown: PropTypes.func,
  renderTitle: PropTypes.func,
  renderToolbar: PropTypes.func,
  showDate: PropTypes.bool,
  showMeridian: PropTypes.bool,
  showMonth: PropTypes.bool,
  showTime: PropTypes.bool
};
var Header$3 = Header$2;

var CalendarState;

(function (CalendarState) {
  CalendarState["DROP_TIME"] = "DROP_TIME";
  CalendarState["DROP_MONTH"] = "DROP_MONTH";
})(CalendarState || (CalendarState = {}));

var Calendar$2 = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar' : _props$classPrefix,
      calendarState = props.calendarState,
      dateRange = props.dateRange,
      disabledBackward = props.disabledBackward,
      disabledDate = props.disabledDate,
      disabledForward = props.disabledForward,
      format = props.format,
      hoverRangeValue = props.hoverRangeValue,
      inSameMonth = props.inSameMonth,
      _props$isoWeek = props.isoWeek,
      isoWeek = _props$isoWeek === void 0 ? false : _props$isoWeek,
      limitEndYear = props.limitEndYear,
      locale = props.locale,
      onChangePageDate = props.onChangePageDate,
      onChangePageTime = props.onChangePageTime,
      onMouseMove = props.onMouseMove,
      onMoveBackward = props.onMoveBackward,
      onMoveForward = props.onMoveForward,
      onSelect = props.onSelect,
      onToggleMeridian = props.onToggleMeridian,
      onToggleMonthDropdown = props.onToggleMonthDropdown,
      onToggleTimeDropdown = props.onToggleTimeDropdown,
      calendarDate = props.calendarDate,
      renderCell = props.renderCell,
      renderTitle = props.renderTitle,
      renderToolbar = props.renderToolbar,
      showMeridian = props.showMeridian,
      showWeekNumbers = props.showWeekNumbers,
      inline = props.inline,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "calendarState", "dateRange", "disabledBackward", "disabledDate", "disabledForward", "format", "hoverRangeValue", "inSameMonth", "isoWeek", "limitEndYear", "locale", "onChangePageDate", "onChangePageTime", "onMouseMove", "onMoveBackward", "onMoveForward", "onSelect", "onToggleMeridian", "onToggleMonthDropdown", "onToggleTimeDropdown", "calendarDate", "renderCell", "renderTitle", "renderToolbar", "showMeridian", "showWeekNumbers", "inline"]);

  var _useClassNames = useClassNames(classPrefix),
      withClassPrefix = _useClassNames.withClassPrefix,
      merge = _useClassNames.merge;

  var isDisabledDate = useCallback(function (date) {
    var _disabledDate;

    return (_disabledDate = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date)) !== null && _disabledDate !== void 0 ? _disabledDate : false;
  }, [disabledDate]);

  var isTimeDisabled = function isTimeDisabled(date) {
    return disabledTime(props, date);
  };

  var handleMoveForward = useCallback(function () {
    onMoveForward === null || onMoveForward === void 0 ? void 0 : onMoveForward(addMonths(calendarDate, 1));
  }, [onMoveForward, calendarDate]);
  var handleMoveBackward = useCallback(function () {
    onMoveBackward === null || onMoveBackward === void 0 ? void 0 : onMoveBackward(addMonths(calendarDate, -1));
  }, [onMoveBackward, calendarDate]);
  var showDate = shouldDate(format);
  var showTime = shouldTime(format);
  var showMonth = shouldMonth(format);
  var onlyShowTime = showTime && !showDate && !showMonth;
  var onlyShowMonth = showMonth && !showDate && !showTime;
  var dropTime = calendarState === CalendarState.DROP_TIME || onlyShowTime;
  var dropMonth = calendarState === CalendarState.DROP_MONTH || onlyShowMonth;
  var inSameThisMonthDate = useCallback(function (date) {
    return composeFunctions(function (d) {
      return setDate(d, 1);
    }, function (d) {
      return isSameMonth(d, date);
    })(date);
  }, []);
  var calendarClasses = merge(className, withClassPrefix({
    'show-time-dropdown': dropTime,
    'show-month-dropdown': dropMonth,
    'show-week-numbers': showWeekNumbers
  }));
  var timeDropdownProps = pick_1(rest, calendarOnlyProps);
  var contextValue = useMemo(function () {
    return {
      date: calendarDate,
      dateRange: dateRange,
      disabledDate: isDisabledDate,
      format: format,
      hoverRangeValue: hoverRangeValue,
      inSameMonth: inSameMonth !== null && inSameMonth !== void 0 ? inSameMonth : inSameThisMonthDate,
      isoWeek: isoWeek,
      locale: locale,
      onChangePageDate: onChangePageDate,
      onChangePageTime: onChangePageTime,
      onMouseMove: onMouseMove,
      onSelect: onSelect,
      renderCell: renderCell,
      showWeekNumbers: showWeekNumbers,
      inline: inline
    };
  }, [calendarDate, dateRange, format, hoverRangeValue, inSameMonth, inSameThisMonthDate, inline, isDisabledDate, isoWeek, locale, onChangePageDate, onChangePageTime, onMouseMove, onSelect, renderCell, showWeekNumbers]);
  return /*#__PURE__*/React__default.createElement(CalendarProvider, {
    value: contextValue
  }, /*#__PURE__*/React__default.createElement(Component, _extends$1({}, omitHideDisabledProps(rest), {
    className: calendarClasses,
    ref: ref
  }), /*#__PURE__*/React__default.createElement(Header$3, {
    showMonth: showMonth,
    showDate: showDate,
    showTime: showTime,
    showMeridian: showMeridian,
    disabledTime: isTimeDisabled,
    onMoveForward: handleMoveForward,
    onMoveBackward: handleMoveBackward,
    onToggleMonthDropdown: onToggleMonthDropdown,
    onToggleTimeDropdown: onToggleTimeDropdown,
    onToggleMeridian: onToggleMeridian,
    renderTitle: renderTitle,
    renderToolbar: renderToolbar,
    disabledBackward: disabledBackward,
    disabledForward: disabledForward
  }), showDate && /*#__PURE__*/React__default.createElement(View$1, null), showMonth && /*#__PURE__*/React__default.createElement(MonthDropdown$1, {
    show: dropMonth,
    limitEndYear: limitEndYear,
    disabledMonth: isDisabledDate
  }), showTime && /*#__PURE__*/React__default.createElement(TimeDropdown$1, _extends$1({}, timeDropdownProps, {
    show: dropTime,
    showMeridian: showMeridian
  }))));
});
Calendar$2.displayName = 'Calendar';
Calendar$2.propTypes = {
  calendarState: PropTypes.oneOf(Object.values(CalendarState)),
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  disabledDate: PropTypes.func,
  disabledHours: PropTypes.func,
  disabledMinutes: PropTypes.func,
  disabledSeconds: PropTypes.func,
  format: PropTypes.string,
  hideHours: PropTypes.func,
  hideMinutes: PropTypes.func,
  hideSeconds: PropTypes.func,
  inSameMonth: PropTypes.func,
  isoWeek: PropTypes.bool,
  limitEndYear: PropTypes.number,
  locale: PropTypes.object,
  onChangePageDate: PropTypes.func,
  onChangePageTime: PropTypes.func,
  onMoveBackward: PropTypes.func,
  onMoveForward: PropTypes.func,
  onSelect: PropTypes.func,
  onToggleMeridian: PropTypes.func,
  onToggleMonthDropdown: PropTypes.func,
  onToggleTimeDropdown: PropTypes.func,
  calendarDate: PropTypes.instanceOf(Date),
  renderCell: PropTypes.func,
  renderTitle: PropTypes.func,
  renderToolbar: PropTypes.func,
  showMeridian: PropTypes.bool,
  showWeekNumbers: PropTypes.bool
};

var setTimingMargin = function setTimingMargin(date, way) {
  if (way === void 0) {
    way = 'left';
  }

  return way === 'right' ? endOfDay(date) : startOfDay(date);
};
function getCalendarDate(_ref) {
  var _value;

  var value = _ref.value;
  // Update calendarDate if the value is not null
  value = (_value = value) !== null && _value !== void 0 ? _value : [];

  if (value[0] && value[1]) {
    var sameMonth = isSameMonth(value[0], value[1]);
    return [value[0], sameMonth ? addMonths(value[1], 1) : value[1]]; // If only the start date
  } else if (value[0]) {
    return [value[0], addMonths(value[0], 1)];
  }

  var todayDate = new Date();
  return [todayDate, addMonths(todayDate, 1)];
}
var isSameRange = function isSameRange(source, dest, format) {
  // If both are null, reguard as same
  if (null === source && null === dest) return true; // If only one is null, regard as different

  if (null === source || null === dest) return false;
  var result = isSameDay(source[0], dest[0]) && isSameDay(source[1], dest[1]);

  if (shouldTime(format)) {
    result && (result = isSameSecond(source[0], dest[0]) && isSameSecond(source[1], dest[1]));
  }

  return result;
};
var getMonthHoverRange = function getMonthHoverRange(date) {
  return [startOfMonth(date), endOfMonth(date)];
};
var getWeekHoverRange = function getWeekHoverRange(isoWeek, date) {
  if (isoWeek) {
    // set to the first day of this week according to ISO 8601, 12:00 am
    return [startOfISOWeek(date), endOfISOWeek(date)];
  }

  return [startOfWeek(date), endOfWeek(date)];
};

function getDefaultRanges(date) {
  var todayDate = new Date();
  /**
   * Is Date[] type
   * If it is an array type, it returns the default shortcut key suitable for DateRangePicker Toolbar,
   * otherwise it returns the default shortcut key suitable for DatePicker Toolbar
   */

  var isRange = date instanceof Array;
  var rangeKeys = ['today', 'yesterday'];

  function rangeIterator(label) {
    var defaultRange = {
      today: isRange ? {
        value: [setTimingMargin(todayDate), setTimingMargin(todayDate, 'right')]
      } : {
        closeOverlay: true,
        value: todayDate
      },
      yesterday: isRange ? {
        value: [setTimingMargin(subDays(todayDate, 1)), setTimingMargin(subDays(todayDate, 1), 'right')]
      } : {
        closeOverlay: true,
        value: subDays(todayDate, 1)
      },
      last7Days: {
        value: [setTimingMargin(subDays(todayDate, 6)), setTimingMargin(todayDate, 'right')]
      }
    };
    return _extends$1({
      label: label
    }, defaultRange[label]);
  }

  isRange && rangeKeys.push('last7Days');
  return rangeKeys.map(rangeIterator);
}

var generateRangesIterator = function generateRangesIterator(_ref) {
  var calendarDate = _ref.calendarDate;
  return function (_ref2) {
    var value = _ref2.value,
        rest = _objectWithoutPropertiesLoose(_ref2, ["value"]);

    value = typeof value === 'function' ? value(calendarDate) : value;
    return _extends$1({
      value: value
    }, rest);
  };
};
/**
 * get Toolbar ranges from Toolbar props
 * @param ranges
 * @param calendarDate
 */


var getRanges = function getRanges(_ref3) {
  var ranges = _ref3.ranges,
      calendarDate = _ref3.calendarDate;
  return typeof ranges === 'undefined' ? getDefaultRanges(calendarDate) : ranges.map(generateRangesIterator({
    calendarDate: calendarDate
  }));
};

/**
 * Toolbar for DatePicker and DateRangePicker
 */
var Toolbar = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'picker-toolbar' : _props$classPrefix,
      disabledOkBtn = props.disabledOkBtn,
      disabledShortcut = props.disabledShortcut,
      hideOkBtn = props.hideOkBtn,
      onOk = props.onOk,
      onClickShortcut = props.onClickShortcut,
      calendarDate = props.calendarDate,
      rangesProp = props.ranges,
      locale = props.locale,
      rest = _objectWithoutPropertiesLoose(props, ["className", "classPrefix", "disabledOkBtn", "disabledShortcut", "hideOkBtn", "onOk", "onClickShortcut", "calendarDate", "ranges", "locale"]);

  var _useState = useState(getRanges(props)),
      ranges = _useState[0],
      setRanges = _useState[1];

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix,
      withClassPrefix = _useClassNames.withClassPrefix;

  useUpdateEffect$1(function () {
    setRanges(getRanges({
      ranges: rangesProp,
      calendarDate: calendarDate
    }));
  }, [calendarDate, rangesProp]);
  var hasLocaleKey = useCallback(function (key) {
    return getDefaultRanges(calendarDate).some(function (item) {
      return item.label === key;
    });
  }, [calendarDate]);
  var renderOkButton = useCallback(function () {
    if (hideOkBtn) {
      return null;
    }

    var disabled = disabledOkBtn === null || disabledOkBtn === void 0 ? void 0 : disabledOkBtn(calendarDate);
    return /*#__PURE__*/React__default.createElement("div", {
      className: prefix('right')
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      appearance: "primary",
      size: "sm",
      disabled: disabled,
      onClick: disabled ? undefined : onOk
    }, locale === null || locale === void 0 ? void 0 : locale.ok));
  }, [disabledOkBtn, hideOkBtn, locale, onOk, calendarDate, prefix]);

  if (hideOkBtn && ranges.length === 0) {
    return null;
  }

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React__default.createElement("div", _extends$1({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement("div", {
    className: prefix('ranges')
  }, ranges.map(function (_ref, index) {
    var value = _ref.value,
        closeOverlay = _ref.closeOverlay,
        label = _ref.label;
    var disabled = disabledShortcut === null || disabledShortcut === void 0 ? void 0 : disabledShortcut(value);

    var handleClickShortcut = function handleClickShortcut(event) {
      if (disabled) {
        return;
      }

      onClickShortcut === null || onClickShortcut === void 0 ? void 0 : onClickShortcut(value, closeOverlay !== null && closeOverlay !== void 0 ? closeOverlay : false, event);
    };

    return /*#__PURE__*/React__default.createElement(Button$1, {
      appearance: "link",
      size: "sm",
      key: index,
      disabled: disabled,
      onClick: handleClickShortcut
    }, hasLocaleKey(label) && typeof label === 'string' ? locale === null || locale === void 0 ? void 0 : locale[label] : label);
  })), renderOkButton());
});
Toolbar.displayName = 'Toolbar';
Toolbar.propTypes = {
  ranges: PropTypes.array,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  calendarDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.arrayOf(PropTypes.instanceOf(Date))]).isRequired,
  onClickShortcut: PropTypes.func,
  onOk: PropTypes.func,
  disabledShortcut: PropTypes.func,
  disabledOkBtn: PropTypes.func,
  hideOkBtn: PropTypes.bool
};
var Toolbar$1 = Toolbar;

/**
 * Omit the time in the date, which is used to compare and judge the date.
 * eg: isAfter/isBefore
 */
function omitTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

var Calendar = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? Calendar$2 : _props$as,
      _props$calendarDate = props.calendarDate,
      calendarDate = _props$calendarDate === void 0 ? [new Date(), addMonths(new Date(), 1)] : _props$calendarDate,
      _props$format = props.format,
      format = _props$format === void 0 ? 'yyyy-MM-dd' : _props$format,
      disabledDate = props.disabledDate,
      _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      limitEndYear = props.limitEndYear,
      onChangeCalendarDate = props.onChangeCalendarDate,
      onChangeCalendarTime = props.onChangeCalendarTime,
      onToggleMeridian = props.onToggleMeridian,
      showOneCalendar = props.showOneCalendar,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      rest = _objectWithoutPropertiesLoose(props, ["as", "calendarDate", "format", "disabledDate", "index", "limitEndYear", "onChangeCalendarDate", "onChangeCalendarTime", "onToggleMeridian", "showOneCalendar", "value"]);

  var _useState = useState(),
      calendarState = _useState[0],
      setCalendarState = _useState[1];

  var onMoveForward = useCallback(function (nextPageDate) {
    onChangeCalendarDate === null || onChangeCalendarDate === void 0 ? void 0 : onChangeCalendarDate(index, nextPageDate);
  }, [index, onChangeCalendarDate]);
  var onMoveBackward = useCallback(function (nextPageDate) {
    onChangeCalendarDate === null || onChangeCalendarDate === void 0 ? void 0 : onChangeCalendarDate(index, nextPageDate);
  }, [index, onChangeCalendarDate]);
  var handleChangePageDate = useCallback(function (nextPageDate) {
    onChangeCalendarDate === null || onChangeCalendarDate === void 0 ? void 0 : onChangeCalendarDate(index, nextPageDate);
    setCalendarState(undefined);
  }, [index, onChangeCalendarDate]);
  var handleChangePageTime = useCallback(function (nextPageDate) {
    onChangeCalendarTime === null || onChangeCalendarTime === void 0 ? void 0 : onChangeCalendarTime(index, nextPageDate);
  }, [index, onChangeCalendarTime]);
  var handleToggleMeridian = useCallback(function (event) {
    onToggleMeridian(index, event);
  }, [index, onToggleMeridian]);
  var toggleMonthDropdown = useCallback(function () {
    setCalendarState(calendarState === CalendarState.DROP_MONTH ? undefined : CalendarState.DROP_MONTH);
  }, [calendarState]);
  var toggleTimeDropdown = useCallback(function () {
    setCalendarState(calendarState === CalendarState.DROP_TIME ? undefined : CalendarState.DROP_TIME);
  }, [calendarState]);
  var inSameMonth = useCallback(function (date) {
    return isSameMonth(date, calendarDate[index]);
  }, [calendarDate, index]);
  var getCalendarDate = useCallback(function () {
    return calendarDate[index];
  }, [calendarDate, index]);
  var handleMoveForward = useCallback(function () {
    onMoveForward === null || onMoveForward === void 0 ? void 0 : onMoveForward(addMonths(getCalendarDate(), 1));
  }, [getCalendarDate, onMoveForward]);
  var handleMoveBackward = useCallback(function () {
    onMoveBackward === null || onMoveBackward === void 0 ? void 0 : onMoveBackward(addMonths(getCalendarDate(), -1));
  }, [getCalendarDate, onMoveBackward]);
  var disabledBackward = useCallback(function () {
    // Do not disable the Backward button on the first calendar.
    if (index === 0) {
      return false;
    }

    var startDate = setDate(addMonths(calendarDate[0], 1), 1);
    var endDate = setDate(omitTime(calendarDate[1]), 1);
    var after = isAfter(endDate, startDate);
    return !after;
  }, [calendarDate, index]);
  var disabledForward = useCallback(function () {
    // If only one calendar is displayed, do not disable
    if (showOneCalendar) {
      return false;
    } // Do not disable the Forward button on the second calendar.


    if (index === 1) {
      return false;
    }

    var startDate = setDate(addMonths(omitTime(calendarDate[0]), 1), 1);
    var endDate = setDate(omitTime(calendarDate[1]), 1);
    var after = isAfter(endDate, startDate);
    return !after;
  }, [calendarDate, index, showOneCalendar]);
  var disabledMonth = useCallback(function (date) {
    return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, value, DATERANGE_DISABLED_TARGET.CALENDAR);
  }, [disabledDate, value]);
  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    format: format,
    calendarState: calendarState,
    dateRange: value,
    disabledBackward: disabledBackward(),
    disabledDate: disabledMonth,
    disabledForward: disabledForward(),
    inSameMonth: inSameMonth,
    index: index,
    limitEndYear: limitEndYear,
    onChangePageDate: handleChangePageDate,
    onChangePageTime: handleChangePageTime,
    onMoveBackward: handleMoveBackward,
    onMoveForward: handleMoveForward,
    onToggleMonthDropdown: toggleMonthDropdown,
    onToggleTimeDropdown: toggleTimeDropdown,
    onToggleMeridian: handleToggleMeridian,
    calendarDate: getCalendarDate(),
    ref: ref
  }));
});
Calendar.displayName = 'DateRangePicker.Calendar';
Calendar.propTypes = {
  value: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  hoverValue: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  calendarDate: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  index: PropTypes.number,
  format: PropTypes.string,
  isoWeek: PropTypes.bool,
  limitEndYear: PropTypes.number,
  classPrefix: PropTypes.string,
  disabledDate: PropTypes.func,
  onSelect: PropTypes.func,
  onMouseMove: PropTypes.func,
  onChangeCalendarDate: PropTypes.func
};
var Calendar$1 = Calendar;

function isAfterDay(date1, date2) {
  return isAfter(new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()), new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
}

function isBeforeDay(date1, date2) {
  return isBefore(new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()), new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
}
/**
 Allow the maximum number of days specified, other dates are disabled.
 */


function allowedMaxDays(days) {
  return function (date, selectValue, selectedDone, target) {
    var beforeLimit = false;
    var afterLimit = false;

    if (selectValue !== null && selectValue !== void 0 && selectValue[0]) {
      var startDate = selectValue[0];
      beforeLimit = composeFunctions(function (f) {
        return addDays(f, -days + 1);
      }, function (f) {
        return isAfterDay(f, date);
      })(startDate);
      afterLimit = composeFunctions(function (f) {
        return addDays(f, days - 1);
      }, function (f) {
        return isBeforeDay(f, date);
      })(startDate);
    }

    if (target === 'CALENDAR' && !selectedDone && (beforeLimit || afterLimit)) {
      return true;
    }

    return false;
  };
}
/**
 Only allowed days are specified, other dates are disabled.
 */

function allowedDays(days) {
  return function (date, selectValue, selectedDone, target) {
    var beforeLimit = false;
    var afterLimit = false;

    if (selectValue !== null && selectValue !== void 0 && selectValue[0]) {
      var startDate = selectValue[0];
      beforeLimit = composeFunctions(function (f) {
        return addDays(f, -days + 1);
      }, function (f) {
        return !isSameDay(f, date);
      })(startDate);
      afterLimit = composeFunctions(function (f) {
        return addDays(f, days - 1);
      }, function (f) {
        return !isSameDay(f, date);
      })(startDate);
    }

    if (target === 'CALENDAR' && !selectedDone && beforeLimit && afterLimit) {
      return true;
    }

    return false;
  };
}
/**
 Allow specified date range, other dates are disabled.
 */

function allowedRange(startDate, endDate) {
  return function (date) {
    if (isBeforeDay(date, new Date(startDate)) || isAfterDay(date, new Date(endDate))) {
      return true;
    }

    return false;
  };
}
/**
 Disable dates after the specified date.
 */

function before(beforeDate) {
  if (beforeDate === void 0) {
    beforeDate = new Date();
  }

  return function (date) {
    if (isBeforeDay(date, new Date(beforeDate))) {
      return true;
    }

    return false;
  };
}
/**
 Disable dates before the specified date.
 */

function after(afterDate) {
  if (afterDate === void 0) {
    afterDate = new Date();
  }

  return function (date) {
    if (isAfterDay(date, new Date(afterDate))) {
      return true;
    }

    return false;
  };
}
/**
 Disable dates after today.
 */

function beforeToday() {
  return before();
}
/**
 Disable dates before today.
 */

function afterToday() {
  return after();
}
/**
 Used to combine multiple conditions.
 */

function combine() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, disabledDateArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      disabledDateArgs[_key2] = arguments[_key2];
    }

    return args.reduce(function (a, b) {
      return a.apply(void 0, disabledDateArgs) || b.apply(void 0, disabledDateArgs);
    });
  };
}

var DateRangePicker = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _ref, _ref2, _merge;

  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'picker' : _props$classPrefix,
      className = props.className,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'default' : _props$appearance,
      _props$cleanable = props.cleanable,
      cleanable = _props$cleanable === void 0 ? true : _props$cleanable,
      _props$character = props.character,
      character = _props$character === void 0 ? ' ~ ' : _props$character,
      defaultCalendarValue = props.defaultCalendarValue,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      disabledDateProp = props.disabledDate,
      _props$format = props.format,
      formatStr = _props$format === void 0 ? 'yyyy-MM-dd' : _props$format,
      hoverRange = props.hoverRange,
      _props$isoWeek = props.isoWeek,
      isoWeek = _props$isoWeek === void 0 ? false : _props$isoWeek,
      _props$limitEndYear = props.limitEndYear,
      limitEndYear = _props$limitEndYear === void 0 ? 1000 : _props$limitEndYear,
      overrideLocale = props.locale,
      menuClassName = props.menuClassName,
      menuStyle = props.menuStyle,
      oneTap = props.oneTap,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottomStart' : _props$placement,
      ranges = props.ranges,
      renderValue = props.renderValue,
      _props$showOneCalenda = props.showOneCalendar,
      showOneCalendar = _props$showOneCalenda === void 0 ? false : _props$showOneCalenda,
      showWeekNumbers = props.showWeekNumbers,
      showMeridian = props.showMeridian,
      style = props.style,
      toggleAs = props.toggleAs,
      caretAs = props.caretAs,
      valueProp = props.value,
      onChange = props.onChange,
      onClean = props.onClean,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onExited = props.onExited,
      onOk = props.onOk,
      onOpen = props.onOpen,
      onSelect = props.onSelect,
      renderTitle = props.renderTitle,
      rest = _objectWithoutPropertiesLoose(props, ["as", "classPrefix", "className", "appearance", "cleanable", "character", "defaultCalendarValue", "defaultValue", "disabled", "disabledDate", "format", "hoverRange", "isoWeek", "limitEndYear", "locale", "menuClassName", "menuStyle", "oneTap", "placeholder", "placement", "ranges", "renderValue", "showOneCalendar", "showWeekNumbers", "showMeridian", "style", "toggleAs", "caretAs", "value", "onChange", "onClean", "onClose", "onEnter", "onEntered", "onExited", "onOk", "onOpen", "onSelect", "renderTitle"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      prefix = _useClassNames.prefix;

  var _useCustom = useCustom('DateRangePicker', overrideLocale),
      locale = _useCustom.locale,
      formatDate = _useCustom.formatDate,
      parseDate = _useCustom.parseDate;

  var rangeFormatStr = "" + formatStr + character + formatStr;

  var _useControlled = useControlled(valueProp, defaultValue !== null && defaultValue !== void 0 ? defaultValue : null),
      value = _useControlled[0],
      setValue = _useControlled[1];
  /**
   * Whether to complete the selection.
   * Everytime selection will change this value. If the value is false, it means that the selection has not been completed.
   *
   * In `oneTap` mode, select action will not change this value, its value should be true always.
   */


  var hasDoneSelect = useRef(true);
  /**
   * The currently selected date range.
   *
   * The time range is selected by two clicks. After the first click,
   * the cursor will store a temporary event date in the process until
   * the second click to determine the end date of the date range.
   *
   */

  var _useState = useState((_ref = valueProp !== null && valueProp !== void 0 ? valueProp : defaultValue) !== null && _ref !== void 0 ? _ref : []),
      selectedDates = _useState[0],
      setSelectedDates = _useState[1]; // The date of the current hover, used to reduce the calculation of `handleMouseMove`


  var _useState2 = useState(null),
      hoverDateRange = _useState2[0],
      setHoverDateRange = _useState2[1]; // The displayed calendar panel is rendered based on this value.


  var _useState3 = useState(getCalendarDate({
    value: (_ref2 = valueProp !== null && valueProp !== void 0 ? valueProp : defaultCalendarValue) !== null && _ref2 !== void 0 ? _ref2 : null
  })),
      calendarDate = _useState3[0],
      setCalendarDate = _useState3[1];

  var _useState4 = useState(),
      inputState = _useState4[0],
      setInputState = _useState4[1];
  /**
   * When hoverRange is set, `selectValue` will be updated during the hover process,
   * which will cause the `selectValue` to be updated after the first click,
   * so declare a Ref to temporarily store the `selectValue` of the first click.
   */


  var selectRangeValueRef = useRef(null);
  /**
   * Call this function to update the calendar panel rendering benchmark value.
   * If params `value` is not passed, it defaults to [new Date(), addMonth(new Date(), 1)].
   */

  var updateCalendarDate = useCallback(function (value) {
    setCalendarDate(getCalendarDate({
      value: value
    }));
  }, []); // if valueProp changed then update selectValue/hoverValue

  useEffect(function () {
    setSelectedDates(valueProp !== null && valueProp !== void 0 ? valueProp : []);
    setHoverDateRange(valueProp !== null && valueProp !== void 0 ? valueProp : null);
  }, [valueProp]);

  var _useState5 = useState(false),
      isPickerToggleActive = _useState5[0],
      setPickerToggleActive = _useState5[1];

  var rootRef = useRef(null);
  var overlayRef = useRef(null);
  var targetRef = useRef(null);
  var triggerRef = useRef(null);
  var handleCloseDropdown = useCallback(function () {
    var _triggerRef$current, _triggerRef$current$c;

    (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : (_triggerRef$current$c = _triggerRef$current.close) === null || _triggerRef$current$c === void 0 ? void 0 : _triggerRef$current$c.call(_triggerRef$current);
  }, []);
  usePublicMethods(ref, {
    triggerRef: triggerRef,
    overlayRef: overlayRef,
    targetRef: targetRef,
    rootRef: rootRef
  });
  var getDisplayString = useCallback(function (nextValue, isPlaintext) {
    var _nextValue$, _nextValue$2;

    var startDate = (_nextValue$ = nextValue === null || nextValue === void 0 ? void 0 : nextValue[0]) !== null && _nextValue$ !== void 0 ? _nextValue$ : null;
    var endDate = (_nextValue$2 = nextValue === null || nextValue === void 0 ? void 0 : nextValue[1]) !== null && _nextValue$2 !== void 0 ? _nextValue$2 : null;

    if (startDate && endDate) {
      var displayValue = [startDate, endDate].sort(compareAsc);

      if (isPlaintext) {
        return formatDate(displayValue[0], formatStr) + character + formatDate(displayValue[1], formatStr);
      }

      return renderValue ? renderValue(displayValue, formatStr) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormattedDate, {
        date: displayValue[0],
        formatStr: formatStr
      }), character, /*#__PURE__*/React__default.createElement(FormattedDate, {
        date: displayValue[1],
        formatStr: formatStr
      }));
    }

    return isPlaintext ? '' : placeholder || rangeFormatStr;
  }, [character, formatDate, formatStr, placeholder, rangeFormatStr, renderValue]);
  /**
   * preset hover range
   */

  var getHoverRangeValue = useCallback(function (date) {
    function getHoverRangeFunc() {
      if (hoverRange === 'week') {
        return partial_1(getWeekHoverRange, isoWeek);
      } else if (hoverRange === 'month') {
        return getMonthHoverRange;
      }

      return hoverRange;
    }

    var hoverRangeFunc = getHoverRangeFunc();

    if (isNil_1(hoverRangeFunc)) {
      return null;
    }

    var hoverValues = hoverRangeFunc(date);
    var isHoverRangeValid = hoverValues instanceof Array && hoverValues.length === 2;

    if (!isHoverRangeValid) {
      return null;
    }

    if (isAfter(hoverValues[0], hoverValues[1])) {
      hoverValues.reverse();
    }

    return hoverValues;
  }, [hoverRange, isoWeek]);
  var handleValueUpdate = useCallback(function (event, nextValue, closeOverlay) {
    if (closeOverlay === void 0) {
      closeOverlay = true;
    }

    // If nextValue is null, it means that the user is erasing the selected dates.
    setSelectedDates(nextValue !== null && nextValue !== void 0 ? nextValue : []);

    if (!isSameRange(nextValue, value, formatStr)) {
      setValue(nextValue);
      onChange === null || onChange === void 0 ? void 0 : onChange(nextValue, event);
    } // `closeOverlay` default value is `true`


    if (closeOverlay !== false) {
      handleCloseDropdown();
    }
  }, [formatStr, handleCloseDropdown, onChange, setValue, value]);
  /**
   * Select the date range. If oneTap is not set, you need to click twice to select the start time and end time.
   * The MouseMove event is called between the first click and the second click to update the selection state.
   */

  var handleMouseMove = useCallback(function (date) {
    var nextHoverDateRange = getHoverRangeValue(date); // If hasDoneSelect is false,
    // it means there's already one selected date
    // and waiting for user to select the second date to complete the selection.

    if (!hasDoneSelect.current) {
      // If `hoverRange` is set, you need to change the value of hoverDateRange according to the rules
      if (!isNil_1(nextHoverDateRange) && !isNil_1(selectRangeValueRef.current)) {
        var nextSelectedDates = [selectRangeValueRef.current[0], nextHoverDateRange[1]];

        if (isBefore(nextHoverDateRange[0], selectRangeValueRef.current[0])) {
          nextSelectedDates = [nextHoverDateRange[0], selectRangeValueRef.current[1]];
        }

        setSelectedDates(nextSelectedDates);
      } else {
        setHoverDateRange(function (prevHoverValue) {
          return isNil_1(prevHoverValue) ? null : [prevHoverValue[0], date];
        });
      } // Before the first click, if nextHoverDateRange has a value, hoverDateRange needs to be updated

    } else if (!isNil_1(nextHoverDateRange)) {
      setHoverDateRange(nextHoverDateRange);
    }
  }, [getHoverRangeValue]);
  /**
   * Callback for selecting a date cell in the calendar grid
   */

  var handleSelectDate = useCallback(function (date, event) {
    var nextSelectDates = hoverDateRange !== null && hoverDateRange !== void 0 ? hoverDateRange : [];
    var hoverRangeValue = getHoverRangeValue(date);
    var noHoverRangeValid = isNil_1(hoverRangeValue); // in `oneTap` mode

    if (hasDoneSelect.current && oneTap) {
      handleValueUpdate(event, noHoverRangeValid ? [setTimingMargin(date), setTimingMargin(date, 'right')] : hoverRangeValue);
      hasDoneSelect.current = false;
      return;
    } // no preset hover range can use


    if (noHoverRangeValid) {
      // start select
      if (hasDoneSelect.current) {
        nextSelectDates = [date];
      } else {
        // finish select
        nextSelectDates[1] = date;
      }
    } else {
      if (!hasDoneSelect.current) {
        nextSelectDates = selectedDates;
        selectRangeValueRef.current = null;
      } else {
        nextSelectDates = hoverRangeValue;
        selectRangeValueRef.current = hoverRangeValue;
      }
    } // If user have completed the selection, then sort


    if (nextSelectDates.length === 2 && isAfter(nextSelectDates[0], nextSelectDates[1])) {
      nextSelectDates.reverse();
    }

    setHoverDateRange(nextSelectDates.length === 2 ? nextSelectDates : [nextSelectDates[0], nextSelectDates[0]]);
    setSelectedDates(nextSelectDates);
    updateCalendarDate(nextSelectDates);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(date, event);
    hasDoneSelect.current = !hasDoneSelect.current;
  }, [getHoverRangeValue, handleValueUpdate, hoverDateRange, onSelect, oneTap, selectedDates, updateCalendarDate]);
  /**
   * If `selectValue` changed, there will be the following effects.
   * 1. Check if the selection is completed.
   * 2. if the selection is completed, set the temporary `hoverValue` empty.
   */

  useEffect(function () {
    var selectValueLength = selectedDates.length;
    var doneSelected = selectValueLength === 0 || selectValueLength === 2;
    doneSelected && setHoverDateRange(null);
  }, [selectedDates]);
  var handleChangeCalendarDate = useCallback(function (index, date) {
    var nextCalendarDate = Array.from(calendarDate);
    nextCalendarDate[index] = date;
    updateCalendarDate(nextCalendarDate);
  }, [calendarDate, updateCalendarDate]);
  var handleChangeCalendarTime = useCallback(function (index, date) {
    setSelectedDates(function (prev) {
      var next = [].concat(prev);
      var clonedDate = new Date(date.valueOf()); // if next[index] is not empty, only update the time after aligning the year, month and day

      if (next[index]) {
        clonedDate.setFullYear(next[index].getFullYear(), next[index].getMonth(), next[index].getDate());
      }

      next[index] = clonedDate;
      return next;
    });
    handleChangeCalendarDate(index, date);
  }, [handleChangeCalendarDate]);
  /**
   * The callback triggered when PM/AM is switched.
   */

  var handleToggleMeridian = useCallback(function (index) {
    var next = Array.from(calendarDate);
    var clonedDate = new Date(next[index].valueOf());
    var hours = getHours(clonedDate);
    var nextHours = hours >= 12 ? hours - 12 : hours + 12;
    next[index] = setHours(clonedDate, nextHours);
    setCalendarDate(next); // If the value already exists, update the value again.

    if (selectedDates.length === 2) {
      setSelectedDates(next);
    }
  }, [calendarDate, selectedDates]);
  /**
   * Toolbar operation callback function
   */

  var handleShortcutPageDate = useCallback(function (value, closeOverlay, event) {
    if (closeOverlay === void 0) {
      closeOverlay = false;
    }

    handleValueUpdate(event, value, closeOverlay);
  }, [handleValueUpdate]);
  var handleOK = useCallback(function (event) {
    handleValueUpdate(event, selectedDates);
    onOk === null || onOk === void 0 ? void 0 : onOk(selectedDates, event);
  }, [handleValueUpdate, onOk, selectedDates]);
  var handleClean = useCallback(function (event) {
    updateCalendarDate(null);
    handleValueUpdate(event, null);
  }, [handleValueUpdate, updateCalendarDate]);
  /**
   * Callback after the input box value is changed.
   */

  var handleInputChange = useCallback(function (value) {
    setInputState('Typing');
    var rangeValue = value.split(character); // isMatch('01/11/2020', 'MM/dd/yyyy') ==> true
    // isMatch('2020-11-01', 'MM/dd/yyyy') ==> false

    if (!isMatch(rangeValue[0], formatStr, {
      locale: locale.dateLocale
    }) || !isMatch(rangeValue[1], formatStr, {
      locale: locale.dateLocale
    })) {
      setInputState('Error');
      return;
    }

    var startDate = parseDate(rangeValue[0], formatStr);
    var endDate = parseDate(rangeValue[1], formatStr);
    var selectValue = [startDate, endDate];

    if (!isValid(startDate) || !isValid(endDate)) {
      setInputState('Error');
      return;
    }

    if (isDateDisabled(startDate, selectValue, true, DATERANGE_DISABLED_TARGET.CALENDAR)) {
      setInputState('Error');
      return;
    }

    setHoverDateRange(selectValue);
    setSelectedDates(selectValue);
    updateCalendarDate(selectValue);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [character, rangeFormatStr, updateCalendarDate]);
  /**
   * The callback after the enter key is triggered on the input
   */

  var handleInputPressEnd = useCallback(function (event) {
    if (inputState === 'Typing') {
      handleValueUpdate(event, selectedDates.length === 2 ? selectedDates : null);
    }

    setInputState('Initial');
  }, [handleValueUpdate, selectedDates, inputState]);
  var handleEnter = useCallback(function () {
    var nextCalendarDate;

    if (value && value.length) {
      var _startDate = value[0],
          endData = value[1];
      nextCalendarDate = [_startDate, isSameMonth(_startDate, endData) ? addMonths(endData, 1) : endData];
    } else {
      nextCalendarDate = getCalendarDate({
        value: defaultCalendarValue !== null && defaultCalendarValue !== void 0 ? defaultCalendarValue : null
      });
    }

    setSelectedDates(value !== null && value !== void 0 ? value : []);
    updateCalendarDate(nextCalendarDate);
  }, [defaultCalendarValue, updateCalendarDate, setSelectedDates, value]);
  var handleEntered = useCallback(function () {
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    setPickerToggleActive(true);
  }, [onOpen]);
  var handleExited = useCallback(function () {
    setPickerToggleActive(false);
    hasDoneSelect.current = true;
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  var isDateDisabled = useCallback(function (date, selectDate, selectedDone, target) {
    var _disabledDateProp;

    return (_disabledDateProp = disabledDateProp === null || disabledDateProp === void 0 ? void 0 : disabledDateProp(date, selectDate, selectedDone, target)) !== null && _disabledDateProp !== void 0 ? _disabledDateProp : false;
  }, [disabledDateProp]);
  var disabledByBetween = useCallback(function (start, end, type) {
    // If the date is between the start and the end
    // the button is disabled
    while (isBefore(start, end) || isSameDay(start, end)) {
      if (isDateDisabled(start, selectedDates, hasDoneSelect.current, type)) {
        return true;
      }

      start = addDays(start, 1);
    }

    return false;
  }, [isDateDisabled, selectedDates]);
  var disabledOkButton = useCallback(function () {
    var start = selectedDates[0],
        end = selectedDates[1];

    if (!start || !end || !hasDoneSelect.current) {
      return true;
    }

    return disabledByBetween(start, end, DATERANGE_DISABLED_TARGET.TOOLBAR_BUTTON_OK);
  }, [disabledByBetween, selectedDates]);
  var disabledShortcutButton = useCallback(function (value) {
    if (value === void 0) {
      value = [];
    }

    var _value = value,
        start = _value[0],
        end = _value[1];

    if (!start || !end) {
      return true;
    }

    return disabledByBetween(start, end, DATERANGE_DISABLED_TARGET.TOOLBAR_SHORTCUT);
  }, [disabledByBetween]);
  var handleDisabledDate = useCallback(function (date, values, type) {
    return isDateDisabled(date, values, hasDoneSelect.current, type);
  }, [isDateDisabled]);
  var onPickerKeyDown = useToggleKeyDownEvent(_extends$1({
    triggerRef: triggerRef,
    targetRef: targetRef,
    active: isPickerToggleActive,
    onExit: handleClean
  }, rest));

  var renderDropdownMenu = function renderDropdownMenu(positionProps, speakerRef) {
    var left = positionProps.left,
        top = positionProps.top,
        className = positionProps.className;
    var classes = merge(className, menuClassName, prefix('daterange-menu'));
    var panelClasses = prefix('daterange-panel', {
      'daterange-panel-show-one-calendar': showOneCalendar
    });

    var styles = _extends$1({}, menuStyle, {
      left: left,
      top: top
    });

    var panelProps = {
      calendarDate: calendarDate,
      disabledDate: handleDisabledDate,
      format: formatStr,
      hoverRangeValue: hoverDateRange !== null && hoverDateRange !== void 0 ? hoverDateRange : undefined,
      isoWeek: isoWeek,
      limitEndYear: limitEndYear,
      locale: locale,
      showOneCalendar: showOneCalendar,
      showWeekNumbers: showWeekNumbers,
      value: selectedDates,
      showMeridian: showMeridian,
      onChangeCalendarDate: handleChangeCalendarDate,
      onChangeCalendarTime: handleChangeCalendarTime,
      onMouseMove: handleMouseMove,
      onSelect: handleSelectDate,
      onToggleMeridian: handleToggleMeridian,
      renderTitle: renderTitle
    };
    return /*#__PURE__*/React__default.createElement(PickerOverlay$1, {
      className: classes,
      ref: mergeRefs(overlayRef, speakerRef),
      target: triggerRef,
      style: styles
    }, /*#__PURE__*/React__default.createElement("div", {
      className: panelClasses
    }, /*#__PURE__*/React__default.createElement("div", {
      className: prefix('daterange-content')
    }, /*#__PURE__*/React__default.createElement("div", {
      className: prefix('daterange-header')
    }, getDisplayString(selectedDates)), /*#__PURE__*/React__default.createElement("div", {
      className: prefix("daterange-calendar-" + (showOneCalendar ? 'single' : 'group'))
    }, /*#__PURE__*/React__default.createElement(Calendar$1, _extends$1({
      index: 0
    }, panelProps)), !showOneCalendar && /*#__PURE__*/React__default.createElement(Calendar$1, _extends$1({
      index: 1
    }, panelProps)))), /*#__PURE__*/React__default.createElement(Toolbar$1, {
      locale: locale,
      calendarDate: selectedDates,
      disabledOkBtn: disabledOkButton,
      disabledShortcut: disabledShortcutButton,
      hideOkBtn: oneTap,
      onOk: handleOK,
      onClickShortcut: handleShortcutPageDate,
      ranges: ranges
    })));
  };

  var hasValue = !isNil_1(value) && value.length > 1;

  var _usePickerClassName = usePickerClassName(_extends$1({}, props, {
    classPrefix: classPrefix,
    name: 'daterange',
    appearance: appearance,
    hasValue: hasValue,
    cleanable: cleanable
  })),
      classes = _usePickerClassName[0],
      usedClassNamePropKeys = _usePickerClassName[1];

  return /*#__PURE__*/React__default.createElement(PickerToggleTrigger$1, {
    pickerProps: pick_1(props, pickTriggerPropKeys),
    ref: triggerRef,
    placement: placement,
    onEnter: createChainedFunction(handleEnter, onEnter),
    onEntered: createChainedFunction(handleEntered, onEntered),
    onExited: createChainedFunction(handleExited, onExited),
    speaker: renderDropdownMenu
  }, /*#__PURE__*/React__default.createElement(Component, {
    ref: rootRef,
    className: merge(className, classes, (_merge = {}, _merge[prefix('error')] = inputState === 'Error', _merge)),
    style: style
  }, /*#__PURE__*/React__default.createElement(PickerToggle$1, _extends$1({}, omit_1(rest, [].concat(omitTriggerPropKeys, usedClassNamePropKeys, calendarOnlyProps)), {
    as: toggleAs,
    ref: targetRef,
    appearance: appearance,
    input: true,
    inputMask: getDateMask(rangeFormatStr),
    inputValue: value ? getDisplayString(value, true) : '',
    inputPlaceholder: typeof placeholder === 'string' && placeholder ? placeholder : rangeFormatStr,
    onInputChange: handleInputChange,
    onInputBlur: handleInputPressEnd,
    onInputPressEnter: handleInputPressEnd,
    onKeyDown: onPickerKeyDown,
    onClean: createChainedFunction(handleClean, onClean),
    cleanable: cleanable && !disabled,
    hasValue: hasValue,
    active: isPickerToggleActive,
    placement: placement,
    disabled: disabled,
    caretAs: caretAs || IconCalendar
  }), getDisplayString(value))));
});
DateRangePicker.after = after;
DateRangePicker.afterToday = afterToday;
DateRangePicker.allowedDays = allowedDays;
DateRangePicker.allowedMaxDays = allowedMaxDays;
DateRangePicker.allowedRange = allowedRange;
DateRangePicker.before = before;
DateRangePicker.beforeToday = beforeToday;
DateRangePicker.combine = combine;
DateRangePicker.displayName = 'DateRangePicker';
DateRangePicker.propTypes = _extends$1({}, pickerPropTypes, {
  ranges: PropTypes.array,
  value: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  defaultValue: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  defaultCalendarValue: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  hoverRange: PropTypes.oneOfType([PropTypes.oneOf(['week', 'month']), PropTypes.func]),
  format: PropTypes.string,
  isoWeek: PropTypes.bool,
  oneTap: PropTypes.bool,
  limitEndYear: PropTypes.number,
  onChange: PropTypes.func,
  onOk: PropTypes.func,
  disabledDate: PropTypes.func,
  onSelect: PropTypes.func,
  showWeekNumbers: PropTypes.bool,
  showMeridian: PropTypes.bool,
  showOneCalendar: PropTypes.bool
});
var DateRangePicker$1 = DateRangePicker;

var getBoxShadow$2 = function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.darkGreen, theme.colors.primary2.darkRichBlack, theme.colors.primary2.darkRichBlack, 4);
};

var StyledDateRangePicker = styled(DateRangePicker$1)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  & > *:first-child {\n    background-color: transparent !important;\n    border: none;\n    padding: 0 !important;\n    color: #fff !important;\n\n    & > input:first-child {\n      display: none;\n    }\n\n    & > svg:first-child {\n      display: none !important;\n    }\n\n    span {\n      color: rgba(255,255,255,0.95); !important;\n      font-size: 14px;\n      font-family: \"Roboto Mono\";\n      text-decoration: underline dashed;\n      text-underline-offset: 4px;\n      text-decoration-color: #99B6B9;\n      font-weight: 500;\n    }\n  }\n\n  &.rs-picker-daterange-header {\n    border: none !important;\n  }\n"], ["\n  & > *:first-child {\n    background-color: transparent !important;\n    border: none;\n    padding: 0 !important;\n    color: #fff !important;\n\n    & > input:first-child {\n      display: none;\n    }\n\n    & > svg:first-child {\n      display: none !important;\n    }\n\n    span {\n      color: rgba(255,255,255,0.95); !important;\n      font-size: 14px;\n      font-family: \"Roboto Mono\";\n      text-decoration: underline dashed;\n      text-underline-offset: 4px;\n      text-decoration-color: #99B6B9;\n      font-weight: 500;\n    }\n  }\n\n  &.rs-picker-daterange-header {\n    border: none !important;\n  }\n"])));
var ModalWrap$1 = styled(Box)(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  box-shadow: ", ";\n  width: 508px;\n  padding: 24px;\n  z-index: 999;\n  top: 40px;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n\n  &.category-active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.operation-active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.date-range-active {\n    opacity: 1;\n    visibility: visible;\n  }\n"], ["\n  position: absolute;\n  background-color: ", ";\n  box-shadow: ", ";\n  width: 508px;\n  padding: 24px;\n  z-index: 999;\n  top: 40px;\n  left: 0;\n  opacity: 0;\n  visibility: hidden;\n\n  &.category-active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.operation-active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &.date-range-active {\n    opacity: 1;\n    visibility: visible;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkRichBlack;
}, getBoxShadow$2);
var ResetBtn = styled.strong(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  text-decoration: underline dotted;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: ", ";\n  cursor: pointer;\n  &:hover {\n    color: #fff;\n  }\n"], ["\n  font-family: 'Roboto Mono';\n  text-decoration: underline dotted;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: ", ";\n  cursor: pointer;\n  &:hover {\n    color: #fff;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
var FilterTitle = styled.span(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: underline dashed;\n  text-underline-offset: 4px;\n  text-decoration-color: #99b6b9;\n  color: ", ";\n"], ["\n  font-family: 'Roboto Mono';\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n  text-decoration: underline dashed;\n  text-underline-offset: 4px;\n  text-decoration-color: #99b6b9;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
});
var FilterWrap$1 = styled.ul(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  list-style: none;\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 28px;\n  margin-bottom: 28px;\n  justify-items: end;\n"], ["\n  list-style: none;\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 28px;\n  margin-bottom: 28px;\n  justify-items: end;\n"])));
var FilterElement = styled.li(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Roboto Mono';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n  color: ", ";\n  ", " {\n    width: 100%;\n    justify-content: space-between;\n    padding-bottom: 32px;\n    border-bottom: 1px solid\n      ", ";\n    :last-child {\n      padding-bottom: 0;\n      border-bottom: none;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: 'Roboto Mono';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  white-space: nowrap;\n  color: ", ";\n  ", " {\n    width: 100%;\n    justify-content: space-between;\n    padding-bottom: 32px;\n    border-bottom: 1px solid\n      ", ";\n    :last-child {\n      padding-bottom: 0;\n      border-bottom: none;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var HistoryModal = function (_a) {
    var name = _a.name, reset = _a.reset, cancel = _a.cancel, confirm = _a.confirm, activeClass = _a.activeClass, children = _a.children;
    return (React__default.createElement(ModalWrap$1, { className: activeClass },
        React__default.createElement(Flex, { marginBottom: "28px", justifyContent: "space-between" },
            React__default.createElement(FilterTitle, { style: {
                    textDecoration: 'none',
                    color: lightColors.primary2.cambridgeBlue,
                } }, name),
            React__default.createElement(ResetBtn, { onClick: reset }, "Reset")),
        React__default.createElement(FilterWrap$1, null, children),
        React__default.createElement(Flex, { justifyContent: "space-between" },
            React__default.createElement(Button$2, { onClick: cancel, secondary: true, size: IconSize.L }, "Cancel"),
            React__default.createElement(Button$2, { onClick: confirm, secondary: true, size: IconSize.L }, "Confirm"))));
};
var templateObject_1$r, templateObject_2$j, templateObject_3$g, templateObject_4$a, templateObject_5$7, templateObject_6$7;

var getBoxShadow$1 = function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.darkRichBlack, 4);
};
var getBoxShadowModal = function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.midnightGreen, theme.colors.primary2.midnightGreen, BOX_SHADOW_WIDTH$5);
};

var HistoryWrap = styled(Box)(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  padding: 40px 64px;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  ", " {\n    padding: 24px 16px;\n  }\n"], ["\n  padding: 40px 64px;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  ", " {\n    padding: 24px 16px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, getBoxShadow$1, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var FilterWrap = styled.ul(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  list-style: none;\n  display: grid;\n  margin-bottom: 40px;\n  grid-template-columns: 1.5fr repeat(3, 1fr);\n\n  li {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n"], ["\n  list-style: none;\n  display: grid;\n  margin-bottom: 40px;\n  grid-template-columns: 1.5fr repeat(3, 1fr);\n\n  li {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n"])));
styled(Text).attrs({ size: 'md' })(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  font-weight: 500;\n  line-height: 20px;\n  color: #fff;\n  padding-bottom: 4px;\n  text-decoration: underline dotted;\n  cursor: pointer;\n"], ["\n  font-weight: 500;\n  line-height: 20px;\n  color: #fff;\n  padding-bottom: 4px;\n  text-decoration: underline dotted;\n  cursor: pointer;\n"])));
var ColumnsTitlesContainer = styled(Box)(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1.55fr repeat(3, 1fr);\n  grid-template-rows: 1fr;\n  gap: 24px;\n  padding-right: 25px;\n  margin-bottom: 24px;\n"], ["\n  display: grid;\n  align-items: center;\n  grid-template-columns: 1.55fr repeat(3, 1fr);\n  grid-template-rows: 1fr;\n  gap: 24px;\n  padding-right: 25px;\n  margin-bottom: 24px;\n"])));
var HeaderItem = styled(Box)(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 6px;\n  color: #fff;\n  font-family: 'Roboto Mono';\n  font-weight: 700;\n  font-size: 14px;\n  ", " {\n    font-size: 12px;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 6px;\n  color: #fff;\n  font-family: 'Roboto Mono';\n  font-weight: 700;\n  font-size: 14px;\n  ", " {\n    font-size: 12px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var HistoryRow = styled.ul(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  list-style: none;\n  display: grid;\n  width: 100%;\n  grid-template-columns: 1.55fr repeat(3, 1fr);\n  grid-template-rows: 1fr;\n  border-top: 4px solid #195a62;\n  padding: 28px 0;\n  align-items: center;\n  ", " {\n    grid-template-columns: 1.25fr repeat(3, 1fr);\n  }\n"], ["\n  list-style: none;\n  display: grid;\n  width: 100%;\n  grid-template-columns: 1.55fr repeat(3, 1fr);\n  grid-template-rows: 1fr;\n  border-top: 4px solid #195a62;\n  padding: 28px 0;\n  align-items: center;\n  ", " {\n    grid-template-columns: 1.25fr repeat(3, 1fr);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var OpacityContainer = styled.span(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  opacity: 0.2;\n  margin-right: 28%;\n"], ["\n  opacity: 0.2;\n  margin-right: 28%;\n"])));
var RowElement = styled.li(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  letter-spacing: ", ";\n  justify-content: ", ";\n  text-align: center;\n  max-width: ", ";\n  ", " {\n    font-size: 12px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  letter-spacing: ", ";\n  justify-content: ", ";\n  text-align: center;\n  max-width: ", ";\n  ", " {\n    font-size: 12px;\n  }\n"])), function (props) { return props.ff || 'Roboto Mono'; }, function (props) { return props.fs || '14px'; }, function (_a) {
    var theme = _a.theme, name = _a.name;
    return name
        ? getOperationColor(name, theme)
        : theme.colors.primary2.cambridgeBlue;
}, function (_a) {
    var ls = _a.ls;
    return ls || '';
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent || '';
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? maxWidth : '');
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var HistorySpan = styled.span(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, name = _a.name;
    return getOperationColor(name, theme);
});
var FiltersModalWrapper = styled(Flex)(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.7);\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.7);\n"])));
var FiltersModalContainer = styled(Flex)(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  width: 90%;\n  flex-direction: column;\n  gap: 42px;\n  align-items: center;\n  padding: 34px 26px;\n  background-color: ", ";\n  box-shadow: ", ";\n  ", " {\n    padding: 34px 32px;\n  }\n"], ["\n  width: 90%;\n  flex-direction: column;\n  gap: 42px;\n  align-items: center;\n  padding: 34px 26px;\n  background-color: ", ";\n  box-shadow: ", ";\n  ", " {\n    padding: 34px 32px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, getBoxShadowModal, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var FiltersModalField = styled(Flex)(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  align-items: start;\n  width: 100%;\n  padding-bottom: 32px;\n  border-bottom: 1px solid ", ";\n  :last-child {\n    border-bottom: none;\n  }\n"], ["\n  align-items: start;\n  width: 100%;\n  padding-bottom: 32px;\n  border-bottom: 1px solid ", ";\n  :last-child {\n    border-bottom: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var TransactionsContainer = styled(Flex)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  flex-direction: column;\n  width: 100%;\n  align-items: start;\n  padding-right: 12px;\n  min-height: 500px;\n  max-height: 600px;\n  overflow-y: scroll;\n  ", " {\n    max-height: 500px;\n  }\n"], ["\n  flex-direction: column;\n  width: 100%;\n  align-items: start;\n  padding-right: 12px;\n  min-height: 500px;\n  max-height: 600px;\n  overflow-y: scroll;\n  ", " {\n    max-height: 500px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var templateObject_1$q, templateObject_2$i, templateObject_3$f, templateObject_4$9, templateObject_5$6, templateObject_6$6, templateObject_7$4, templateObject_8$4, templateObject_9$2, templateObject_10$2, templateObject_11$2, templateObject_12$1, templateObject_13;

var History = function (_a) {
    var _b;
    var history = _a.history;
    var isMobile = useMatchBreakpoints().isMobile;
    var _c = useState(''), modalActive = _c[0], setModalActive = _c[1];
    var _d = useState(false), openFiltersModal = _d[0], setOpenFiltersModal = _d[1];
    var _e = useState(history), filteredHistory = _e[0], setFilteredHistory = _e[1];
    //Category menu
    var initialCategoryState = {
        Staking: true,
        Vesting: true,
        Epoch: true,
        Earning: true,
        Protection: true,
        Market: false,
    };
    var _f = useState(initialCategoryState), categoryFilter = _f[0], setCategoryFilter = _f[1];
    //Operation menu
    var initialOperationState = (_b = {
            Stake: true,
            Unstake: true,
            Restake: true,
            Claim: true,
            Close: true
        },
        _b['Auto-renew'] = true,
        _b.Protect = true,
        _b.Deposit = true,
        _b.Withdraw = true,
        _b);
    var _g = useState(initialOperationState), operationFilter = _g[0], setOperationFilter = _g[1];
    //Column sorting
    var initialSortingState = {
        timestamp: false,
        category: false,
        operation: false,
        amount: false,
    };
    var _h = useState(initialSortingState), sortingBy = _h[0], setSortingBy = _h[1];
    var _j = useState('ASC'), order = _j[0], setOrder = _j[1];
    var updateSortingBy = function (param) {
        return setSortingBy(function (prev) {
            var _a;
            return (__assign(__assign({}, initialSortingState), (_a = {}, _a[param] = !prev[param], _a)));
        });
    };
    var operationParamBySortingParam = {
        timestamp: 'timestampBlock',
        category: 'category',
        operation: 'operation',
        amount: 'amount',
    };
    var startSorting = function (column) {
        if (filteredHistory && order === 'ASC') {
            var sordedData = __spreadArray([], filteredHistory, true).sort(function (a, b) {
                return comparisonForSorting(b[operationParamBySortingParam[column]], a[operationParamBySortingParam[column]]);
            });
            setFilteredHistory(sordedData);
            setOrder('DSC');
        }
        if (filteredHistory && order === 'DSC') {
            var sordedData = __spreadArray([], filteredHistory, true).sort(function (a, b) {
                return comparisonForSorting(a[operationParamBySortingParam[column]], b[operationParamBySortingParam[column]]);
            });
            setFilteredHistory(sordedData);
            setOrder('ASC');
        }
    };
    var _k = useState(null), datePickerValue = _k[0], setDatePickerValue = _k[1];
    var historyFilter = function () {
        if (!history)
            return;
        var filterByCategory = history.filter(function (_a) {
            var category = _a.category;
            return categoryFilter[category];
        });
        var filterByOperation = filterByCategory.filter(function (_a) {
            var operation = _a.operation;
            return operationFilter[operation];
        });
        if (datePickerValue) {
            var filterByDate = filterByOperation.filter(function (_a) {
                var timestampBlock = _a.timestampBlock;
                return datePickerValue[0].getTime() <= timeInMilliseconds(timestampBlock) &&
                    datePickerValue[1].getTime() >= timeInMilliseconds(timestampBlock);
            });
            setFilteredHistory(filterByDate.sort(function (a, b) {
                return comparisonForSorting(b.timestampBlock, a.timestampBlock);
            }));
        }
        else {
            setFilteredHistory(filterByOperation.sort(function (a, b) {
                return comparisonForSorting(b.timestampBlock, a.timestampBlock);
            }));
        }
        setFilteredHistory(filterByOperation);
    };
    useEffect(function () {
        historyFilter();
    }, [history]);
    return (React__default.createElement(HistoryWrap, null,
        React__default.createElement(Flex, { width: "100%", alignItems: "center", justifyContent: "space-between", mb: "40px" },
            React__default.createElement(Heading, { scale: "xxl", color: "primary2.cambridgeBlue" }, "History"),
            isMobile && (React__default.createElement(FilterTitle, { onClick: function () {
                    setOpenFiltersModal(true);
                } }, "Filters"))),
        openFiltersModal && (React__default.createElement(FiltersModalWrapper, null,
            React__default.createElement(FiltersModalContainer, null,
                React__default.createElement(Flex, { alignItems: "center", width: "100%", justifyContent: "space-between" },
                    React__default.createElement(Heading, { scale: 'lg', color: "primary2.cambridgeBlue" }, "Filters"),
                    React__default.createElement(FlexWithGap, { gap: "12px", alignItems: "center", onClick: function () { return setOpenFiltersModal(false); }, style: { cursor: 'pointer' } },
                        React__default.createElement(Heading, { scale: 'md', color: "secondary.white" }, "Cancel"),
                        React__default.createElement(Close$4, { variant: IconSize.L }))),
                React__default.createElement(FlexWithGap, { gap: "32px", flexDirection: "column", alignItems: "start", width: "100%" },
                    React__default.createElement(FiltersModalField, null,
                        React__default.createElement(StyledDateRangePicker, { onClick: function () {
                                setModalActive(modalActive && '');
                            }, placeholder: "Filter by Period", block: true, isoWeek: true, onChange: function (e) {
                                setDatePickerValue(e);
                                historyFilter();
                            }, onClean: function () {
                                setDatePickerValue(null);
                                historyFilter();
                            } })),
                    React__default.createElement(FiltersModalField, null,
                        React__default.createElement(FilterTitle, { color: "primary", onClick: function () {
                                setModalActive(modalActive !== 'category-active'
                                    ? 'category-active'
                                    : '');
                            } }, "Filter by Category"),
                        modalActive === 'category-active' && (React__default.createElement(FiltersModalWrapper, { zIndex: 10001 },
                            React__default.createElement(FiltersModalContainer, null,
                                React__default.createElement(Heading, { scale: 'xl', color: "primary2.cambridgeBlue" }, "Filter by Category"),
                                React__default.createElement(FlexWithGap, { gap: '24px', width: "100%", alignItems: "start", flexDirection: "column" }, Object.keys(categoryFilter).map(function (name) {
                                    if (name === 'Market')
                                        return;
                                    var checked = categoryFilter[name];
                                    return (React__default.createElement(FilterElement, { key: name },
                                        React__default.createElement(HistorySpan, { name: name }, name),
                                        React__default.createElement(Checkbox, { checked: checked, onChange: function () {
                                                var _a;
                                                setCategoryFilter(__assign(__assign({}, categoryFilter), (_a = {}, _a[name] = !checked, _a)));
                                            } })));
                                })),
                                React__default.createElement(FlexWithGap, { gap: '40px', justifyContent: "center" },
                                    React__default.createElement(Button$2, { onClick: function () { return setModalActive(''); }, secondary: true, size: IconSize.L }, "Cancel"),
                                    React__default.createElement(Button$2, { onClick: function () {
                                            historyFilter();
                                            setModalActive('');
                                        }, secondary: true, size: IconSize.L }, "Confirm")))))),
                    React__default.createElement(FiltersModalField, null,
                        React__default.createElement(FilterTitle, { color: "primary", onClick: function () {
                                setModalActive(modalActive !== 'operation-active'
                                    ? 'operation-active'
                                    : '');
                            } }, "Filter by Operation"),
                        modalActive === 'operation-active' && (React__default.createElement(FiltersModalWrapper, { zIndex: 10001 },
                            React__default.createElement(FiltersModalContainer, null,
                                React__default.createElement(Heading, { scale: 'xl', color: "primary2.cambridgeBlue" }, "Filter by Operation"),
                                React__default.createElement(FlexWithGap, { gap: '24px', width: "100%", alignItems: "start", flexDirection: "column", maxHeight: "500px", p: "8px 12px 8px 0", overflowY: "scroll" }, Object.keys(operationFilter).map(function (name) {
                                    var checked = operationFilter[name];
                                    return (React__default.createElement(FilterElement, { key: name },
                                        React__default.createElement("span", null, name === 'Withdraw' ? 'Withdrawal' : name),
                                        React__default.createElement(Checkbox, { checked: checked, onChange: function () {
                                                var _a;
                                                setOperationFilter(__assign(__assign({}, operationFilter), (_a = {}, _a[name] = !checked, _a)));
                                            } })));
                                })),
                                React__default.createElement(FlexWithGap, { gap: '40px', justifyContent: "center" },
                                    React__default.createElement(Button$2, { onClick: function () { return setModalActive(''); }, secondary: true, size: IconSize.L }, "Cancel"),
                                    React__default.createElement(Button$2, { onClick: function () {
                                            historyFilter();
                                            setModalActive('');
                                        }, secondary: true, size: IconSize.L }, "Confirm")))))))))),
        !isMobile && (React__default.createElement(FilterWrap, null,
            React__default.createElement("li", null,
                React__default.createElement(StyledDateRangePicker, { onClick: function () {
                        setModalActive(modalActive && '');
                    }, placeholder: "Filter by Period", block: true, isoWeek: true, onChange: function (e) {
                        setDatePickerValue(e);
                        historyFilter();
                    }, onClean: function () {
                        setDatePickerValue(null);
                        historyFilter();
                    } })),
            React__default.createElement("li", null,
                React__default.createElement(FilterTitle, { color: "primary", onClick: function () {
                        setModalActive(modalActive !== 'category-active' ? 'category-active' : '');
                    } }, "Filter by Category"),
                React__default.createElement(HistoryModal, { name: "Category filter", activeClass: modalActive === 'category-active' ? modalActive : '', cancel: function () { return setModalActive(''); }, reset: function () { return setCategoryFilter(initialCategoryState); }, confirm: function () {
                        historyFilter();
                        setModalActive('');
                    } }, Object.keys(categoryFilter).map(function (name) {
                    if (name === 'Market')
                        return;
                    var checked = categoryFilter[name];
                    return (React__default.createElement(FilterElement, { key: name },
                        React__default.createElement(HistorySpan, { name: name }, name),
                        React__default.createElement(Checkbox, { checked: checked, onChange: function () {
                                var _a;
                                setCategoryFilter(__assign(__assign({}, categoryFilter), (_a = {}, _a[name] = !checked, _a)));
                            } })));
                }))),
            React__default.createElement("li", null,
                React__default.createElement(FilterTitle, { color: "primary", onClick: function () {
                        setModalActive(modalActive !== 'operation-active' ? 'operation-active' : '');
                    } }, "Filter by Operation"),
                React__default.createElement(HistoryModal, { name: "Filter by operation", activeClass: modalActive === 'operation-active' ? modalActive : '', cancel: function () { return setModalActive(''); }, reset: function () { return setOperationFilter(initialOperationState); }, confirm: function () {
                        historyFilter();
                        setModalActive('');
                    } }, Object.keys(operationFilter).map(function (name) {
                    var checked = operationFilter[name];
                    return (React__default.createElement(FilterElement, { key: name },
                        React__default.createElement("span", null, name),
                        React__default.createElement(Checkbox, { checked: checked, onChange: function () {
                                var _a;
                                setOperationFilter(__assign(__assign({}, operationFilter), (_a = {}, _a[name] = !checked, _a)));
                            } })));
                }))))),
        React__default.createElement(ColumnsTitlesContainer, null,
            React__default.createElement(TableHeaderItem, { title: "Timestamp", isColumnSortingActive: sortingBy.timestamp, onClick: function () {
                    updateSortingBy('timestamp');
                    startSorting('timestamp');
                } }),
            React__default.createElement(TableHeaderItem, { title: "Category", isColumnSortingActive: sortingBy.category, onClick: function () {
                    updateSortingBy('category');
                    startSorting('category');
                } }),
            React__default.createElement(TableHeaderItem, { title: "Operation", isColumnSortingActive: sortingBy.operation, onClick: function () {
                    updateSortingBy('operation');
                    startSorting('operation');
                } }),
            React__default.createElement(TableHeaderItem, { title: "Amount", isColumnSortingActive: sortingBy.amount, onClick: function () {
                    updateSortingBy('amount');
                    startSorting('amount');
                } })),
        React__default.createElement(TransactionsContainer, { marginBottom: "28px" }, filteredHistory.map(function (item, idx) {
            return (React__default.createElement(Row, { key: idx, timestamp: item.timestampBlock, txHash: item.txHash, category: item.category, operation: item.operation, amount: item.formattedAmount, units: item.units }));
        })),
        React__default.createElement(Button$2, { secondary: true, size: IconSize.L, gap: "20px", onClick: function () {
                if (filteredHistory)
                    convertToCSVAndDownload(filteredHistory.map(function (_a) {
                        var timestampBlock = _a.timestampBlock, category = _a.category, operation = _a.operation, amount = _a.amount;
                        return ({
                            timestamp: formatDate(timestampBlock),
                            category: category,
                            operation: operation,
                            amount: amount,
                        });
                    }));
            } },
            React__default.createElement(Download, { variant: IconSize.L }),
            "Download")));
};
var TableHeaderItem = function (_a) {
    var title = _a.title, isColumnSortingActive = _a.isColumnSortingActive, onClick = _a.onClick;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(HeaderItem, { onClick: onClick },
        React__default.createElement("span", null, title),
        !isMobile && (React__default.createElement(Check$1, { orientation: isColumnSortingActive
                ? VerticalOrientation.DOWN
                : VerticalOrientation.UP, variant: IconSize.L }))));
};
var Row = function (_a) {
    var timestamp = _a.timestamp, txHash = _a.txHash, category = _a.category, operation = _a.operation, amount = _a.amount, units = _a.units;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(HistoryRow, null,
        React__default.createElement(RowElement, { ff: "Share Tech Mono", fs: "16px", ls: "0.03em", justifyContent: "space-between", maxWidth: "300px" },
            React__default.createElement("span", null, formatDate(timestamp, isMobile)),
            !isMobile && (React__default.createElement("a", { target: "_blank", href: "https://etherscan.io/tx/".concat(txHash), rel: "noreferrer" },
                React__default.createElement(LinkOut, { variant: IconSize.L })))),
        React__default.createElement(RowElement, { name: category }, category),
        React__default.createElement(RowElement, { justifyContent: isMobile ? 'center' : 'space-between' },
            React__default.createElement("span", null, operation),
            !isMobile && (React__default.createElement(OpacityContainer, null,
                React__default.createElement(ArrowShort, { variant: IconSize.L, orientation: HorizontalOrientation.RIGHT })))),
        React__default.createElement(RowElement, { justifyContent: "center" }, isMobile ? (React__default.createElement(Flex, { flexDirection: "column", alignItems: "flex-start" },
            React__default.createElement("div", null, amount),
            React__default.createElement("div", null, units))) : (React__default.createElement("span", null,
            amount,
            " ",
            units)))));
};

var ProtectFloorCard = function (_a) {
    var onChange = _a.onChange, initialIndex = _a.initialIndex, protectFloors = _a.protectFloors, disabled = _a.disabled;
    var _b = useState(initialIndex), protectFloorIndex = _b[0], setProtectFloorIndex = _b[1];
    var isMobile = useMatchBreakpoints().isMobile;
    useEffect(function () { return onChange(protectFloorIndex); }, [protectFloorIndex]);
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled },
        !isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, "Protection Floor"),
            React__default.createElement(LargeText, { fontFamily: "Roboto Mono", color: "rgba(255, 255, 255, 0.8)", mb: "30px" }, "Choose the protection floor or enter the amount in the field below. You must do either to proceed to the next step."),
            React__default.createElement(FlexWithGap, { gap: "32px", alignItems: "center", pl: "8px" }, protectFloors.map(function (v, i) { return (React__default.createElement(DepositButton, { selected: i === protectFloorIndex, secondary: true, size: IconSize.XL, key: i, px: "30px", onClick: function () { return setProtectFloorIndex(i); } },
                v,
                "%")); })))),
        isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "20px", lineHeight: "28px", color: "secondary.white", mb: "8px" }, "Protection Floor"),
            React__default.createElement(SmallText, { fontSize: "14px", fontFamily: "Roboto", color: "rgba(255, 255, 255, 0.8)", mb: "30px", mr: "50px" }, "Choose the protection floor or enter the amount in the field below. You must do either to proceed to the next step."),
            React__default.createElement(GridWithGap, { gridTemplateColumns: "1fr 1fr 1fr", gridTemplateRows: "1fr 1fr", gridRowGaps: "32px", gridColumnGaps: "32px" }, protectFloors.map(function (v, i) { return (React__default.createElement(DepositButton, { selected: i === protectFloorIndex, secondary: true, size: IconSize.L, key: i, onClick: function () { return setProtectFloorIndex(i); } },
                v,
                "%")); }))))));
};

var BalanceInfo$1 = function (_a) {
    var balance = _a.balance, balanceInUsd = _a.balanceInUsd, tokenName = _a.tokenName;
    return (React__default.createElement(DarkLabel, { maxWidth: "400px", mt: "35px" },
        React__default.createElement(FlexWithGap, { gap: "32px" },
            React__default.createElement(InfoArea, { title: "Balance", value: balance, subTitle: "".concat(tokenName, " ($").concat(balanceInUsd, ")") }))));
};
var ProtectUnitsCard = function (_a) {
    var balanceInUsd = _a.balanceInUsd, balance = _a.balance, options = _a.options;
    var _b = useState(options[0]), value = _b[0], setValue = _b[1];
    return (React__default.createElement(ConfirmationBox, { flexDirection: "column" },
        React__default.createElement(Select, { value: value, options: options, withIcon: true, onValueChanged: setValue }),
        React__default.createElement(BalanceInfo$1, { tokenName: value.key, balanceInUsd: balanceInUsd, balance: balance })));
};

var ProtectTermCard = function (_a) {
    var onChange = _a.onChange, initialIndex = _a.initialIndex, disabled = _a.disabled, protectTerms = _a.protectTerms;
    var _b = useState(false), autoRenew = _b[0], setAutoRenew = _b[1];
    var _c = useState(initialIndex), protectTermsIndex = _c[0], setProtectTermsIndex = _c[1];
    var isMobile = useMatchBreakpoints().isMobile;
    useEffect(function () { return onChange(protectTermsIndex, autoRenew); }, [protectTermsIndex, autoRenew]);
    return (React__default.createElement(ConfirmationBoxFixed, { flexDirection: "column", disabled: disabled },
        !isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "24px", lineHeight: "36px", color: "secondary.white", mb: "8px" }, "Protection Term"),
            React__default.createElement(LargeText, { color: "rgba(255, 255, 255, 0.8)", mb: "30px" }, "Your protection will be active for a fixed period, after which you are able to either make a stablecoin claim, or withdraw your deposited asset, minus your premium."),
            React__default.createElement(FlexWithGap, { gap: "27px", alignItems: "center", pl: "8px" }, protectTerms.map(function (v, i) { return (React__default.createElement(DepositButton, { selected: i === protectTermsIndex, secondary: true, size: IconSize.XL, key: i, p: "4px", style: { whiteSpace: 'nowrap' }, onClick: function () { return setProtectTermsIndex(i); } },
                v,
                " days")); })),
            React__default.createElement(FlexWithGap, { gap: "20px", alignItems: "center", justifyContent: "end", mt: "40px" },
                React__default.createElement(Flex, { flexDirection: "row" },
                    React__default.createElement(LargeText, { color: "rgba(255, 255, 255, 0.8)" }, "Auto-renew"),
                    React__default.createElement(Tooltip, { tooltipValue: "Autorenew" })),
                React__default.createElement(Toggle, { checked: autoRenew, onToggle: setAutoRenew })))),
        isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Text, { fontFamily: "Share Tech Mono", fontSize: "20px", lineHeight: "24px", color: "secondary.white", mb: "8px" }, "Protection Term"),
            React__default.createElement(SmallText, { fontFamily: "Roboto", fontSize: "14px", lineHeight: "20px", maxWidth: "299px", color: "rgba(255, 255, 255, 0.8)", mb: "30px" }, "Your protection will be active for a fixed period, after which you are able to either make a stablecoin claim, or withdraw your deposited asset, minus your premium."),
            React__default.createElement(GridWithGap, { gridTemplateColumns: "repeat(2, 130px)", gridTemplateRows: "repeat(3, 1fr)", gridRowGaps: "32px" }, protectTerms.map(function (v, i) { return (React__default.createElement(DepositButton, { selected: i === protectTermsIndex, secondary: true, size: IconSize.L, key: i, width: "fit-content", onClick: function () { return setProtectTermsIndex(i); } },
                v,
                " days")); })),
            React__default.createElement(Box, { mt: "30px", background: "#00E7FF", height: "4px", width: "100%" }),
            React__default.createElement(FlexWithGap, { gap: "20px", alignItems: "center", justifyContent: "start", mt: "30px" },
                React__default.createElement(Flex, { flexDirection: "row" },
                    React__default.createElement(MediumText, { color: "rgba(255, 255, 255, 0.8)" }, "Auto-renew"),
                    React__default.createElement(Tooltip, { tooltipValue: "Autorenew" })),
                React__default.createElement(Toggle, { checked: autoRenew, onToggle: setAutoRenew }))))));
};

var StepperWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n"])));
var Stepper = function (_a) {
    var children = _a.children;
    var numberOfSteps = React__default.Children.count(children);
    return (React__default.createElement(StepperWrapper, null, React__default.Children.map(children, function (child) {
        if (React__default.isValidElement(child)) {
            return React__default.cloneElement(child, { numberOfSteps: numberOfSteps });
        }
        return child;
    })));
};
var templateObject_1$p;

var BOX_SHADOW_WIDTH$1 = 4;
var STEPPER_PADDING_LARGE = '4px 12px';
var STEPPER_PADDING_SMALL = '2px 8px';
var STEPPER_FONTSIZE_LARGE = '14px';
var STEPPER_FONTSIZE_SMALL = '12px';
var STEPPER_LINEHEIGHT_LARGE = '20px';
var STEPPER_LINEHEIGHT_SMALL = '16px';

var scales = {
    sm: 'sm',
    lg: 'lg',
};

var getStepShadowColor = function (_a) {
    var theme = _a.theme, status = _a.status;
    if (status === 'past') {
        return theme.colors.secondary.blue;
    }
    if (status === 'current') {
        return theme.colors.primary2.aqua;
    }
    return theme.colors.primary2.desaturatedCyan;
};
var getStepTextColor = function (_a) {
    var theme = _a.theme, status = _a.status;
    if (status === 'past') {
        return theme.colors.secondary.blue;
    }
    if (status === 'current') {
        return theme.colors.typography.input;
    }
    return theme.colors.primary2.desaturatedCyan;
};
var getStepFontSize = function (_a) {
    var scale = _a.scale;
    return scale === scales.sm ? STEPPER_FONTSIZE_SMALL : STEPPER_FONTSIZE_LARGE;
};
var getStepLineHeight = function (_a) {
    var scale = _a.scale;
    return scale === scales.sm
        ? STEPPER_LINEHEIGHT_SMALL
        : STEPPER_LINEHEIGHT_LARGE;
};
var getStepPadding = function (_a) {
    var scale = _a.scale;
    return scale === scales.sm ? STEPPER_PADDING_SMALL : STEPPER_PADDING_LARGE;
};

var Connector = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  width: 40px;\n  height: 4px;\n  display: ", ";\n  left: calc(50% - 2px);\n  background-color: ", ";\n"], ["\n  width: 40px;\n  height: 4px;\n  display: ", ";\n  left: calc(50% - 2px);\n  background-color: ", ";\n"])), function (_a) {
    var $isLastStep = _a.$isLastStep;
    return ($isLastStep ? 'none' : 'block');
}, function (_a) {
    var theme = _a.theme, status = _a.status;
    return status === 'past'
        ? theme.colors.secondary.blue
        : theme.colors.primary2.desaturatedCyan;
});
var StepBlock = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  box-shadow: ", ";\n  background-color: ", ";\n  border: none;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: Roboto Mono;\n  padding: ", ";\n  z-index: 5;\n"], ["\n  box-shadow: ", ";\n  background-color: ", ";\n  border: none;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  font-family: Roboto Mono;\n  padding: ", ";\n  z-index: 5;\n"])), function (props) {
    return createPixelInsetBorder$1(getStepShadowColor(props), props.theme.colors.primary2.midnightGreen, props.theme.colors.primary2.midnightGreen, BOX_SHADOW_WIDTH$1);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, getStepTextColor, getStepFontSize, getStepLineHeight, getStepPadding);
var Step = function (_a) {
    var index = _a.index, status = _a.status, scale = _a.scale, _b = _a.numberOfSteps, numberOfSteps = _b === void 0 ? 0 : _b, children = _a.children;
    var isLast = index === numberOfSteps - 1;
    return (React__default.createElement(Flex, { alignItems: "center" },
        React__default.createElement(StepBlock, { status: status, scale: scale }, children),
        React__default.createElement(Connector, { "$isLastStep": isLast, status: status })));
};
var templateObject_1$o, templateObject_2$h;

var LinerBackground = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAADgCAYAAAD1wMEDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAfvSURBVHgB7d3BcSxJDkRBZFc0SeX2uvqL8cnOqhwlgJu7GM9ggfXzv/+fAgAAAACAZq8CAAAAAIABAjQAAAAAACMEaAAAAAAARuR37wIAAAAAgG45xw9CAAAAAAD6meAAAAAAAGCEAA0AAAAAwIh8JwUAAAAAAN2y1ioAAAAAAOhmggMAAAAAgBECNAAAAAAAI/K3dwEAAAAAQLc85xQAAAAAAHQzwQEAAAAAwAgBGgAAAACAEflKCgAAAAAAuuW1VgEAAAAAQDcTHAAAAAAAjBCgAQAAAAAYkc/eBQAAAAAA3XKfUwAAAAAA0M0EBwAAAAAAIwRoAAAAAABG5H2lAAAAAACgW67XKgAAAAAA6GaCAwAAAACAEQI0AAAAAAAjsu+7AAAAAACgW/bzFAAAAAAAdDPBAQAAAADACAEaAAAAAIARudYqAAAAAADolndSAAAAAADQzQQHAAAAAAAjBGgAAAAAAEbkfp4CAAAAAIBu+dx3AQAAAABANxMcAAAAAACMEKABAAAAABiR11oFAAAAAADd8pUUAAAAAAB0M8EBAAAAAMAIARoAAAAAgBF5nlMAAAAAANAtf/cuAAAAAADoZoIDAAAAAIARAjQAAAAAACOy1ioAAAAAAOiW76QAAAAAAKCbCQ4AAAAAAEYI0AAAAAAAjBCgAQAAAAAYkX+fTwEAAAAAQDcX0AAAAAAAjBCgAQAAAAAYIUADAAAAADAiP+93AQAAAABANxfQAAAAAACMEKABAAAAABghQAMAAAAAMCK/excAAAAAAHTLOacAAAAAAKCbCQ4AAAAAAEYI0AAAAAAAjMh3UgAAAAAA0C1rrQIAAAAAgG4mOAAAAAAAGCFAAwAAAAAwIn97FwAAAAAAdMtzTgEAAAAAQDcTHAAAAAAAjBCgAQAAAAAYka+kAAAAAACgW15rFQAAAAAAdDPBAQAAAADACAEaAAAAAIAR+exdAAAAAADQLfc5BQAAAAAA3UxwAAAAAAAwQoAGAAAAAGBE8tKgAQAAAADol1xXAQAAAABAN+fPAAAAAACMEKABAAAAABiRfd8FAAAAAADdsp+nAAAAAACgmwkOAAAAAABGCNAAAAAAAIzItVYBAAAAAEC3vJMCAAAAAIBuJjgAAAAAABghQAMAAAAAMCL38xQAAAAAAHTL574LAAAAAAC6meAAAAAAAGCEAA0AAAAAwIi81ioAAAAAAOiWr6QAAAAAAKCbCQ4AAAAAAEYI0AAAAAAAjMg5pwAAAAAAoFt+9y4AAAAAAOhmggMAAAAAgBECNAAAAAAAI7LWKgAAAAAA6JbvpAAAAAAAoJsJDgAAAAAARgjQAAAAAACMEKABAAAAABiRf59PAQAAAABANxfQAAAAAACMEKABAAAAABghQAMAAAAAMCI/73cBAAAAAEA3F9AAAAAAAIwQoAEAAAAAGCFAAwAAAAAwIr97FwAAAAAAdMs5pwAAAAAAoJsJDgAAAAAARgjQAAAAAACMyHdSAAAAAADQLWutAgAAAACAbiY4AAAAAAAYIUADAAAAADAif3sXAAAAAAB0y3NOAQAAAABANxMcAAAAAACMEKABAAAAABiR95UCAAAAAIBuuV6rAAAAAACgmwkOAAAAAABGCNAAAAAAAIzIZ+8CAAAAAIBuuc8pAAAAAADoZoIDAAAAAIARAjQAAAAAACOSlwYNAAAAAEC/5LoKAAAAAAC6OX8GAAAAAGCEAA0AAAAAwIjs+y4AAAAAAOiW/TwFAAAAAADdTHAAAAAAADBCgAYAAAAAYESutQoAAAAAALrlnRQAAAAAAHQzwQEAAAAAwAgBGgAAAACAEXmeUwAAAAAA0C1/9y4AAAAAAOhmggMAAAAAgBECNAAAAAAAI/JaqwAAAAAAoFu+kgIAAAAAgG4mOAAAAAAAGCFAAwAAAAAwIuecAgAAAACAbvnduwAAAAAAoJsJDgAAAAAARgjQAAAAAACMyFqrAAAAAACgW76TAgAAAACAbiY4AAAAAAAYIUADAAAAADBCgAYAAAAAYET+fT4FAAAAAADdXEADAAAAADBCgAYAAAAAYIQADQAAAADAiPy83wUAAAAAAN1cQAMAAAAAMEKABgAAAABghAANAAAAAMCI/O5dAAAAAADQLeecAgAAAACAbiY4AAAAAAAYIUADAAAAADAiX0kBAAAAAEC3vNYqAAAAAADoZoIDAAAAAIARAjQAAAAAACPyt3cBAAAAAEC3POcUAAAAAAB0M8EBAAAAAMAIARoAAAAAgBF5XykAAAAAAOiW67UKAAAAAAC6meAAAAAAAGCEAA0AAAAAwIh89i4AAAAAAOiW+5wCAAAAAIBuJjgAAAAAABghQAMAAAAAMCJ5adAAAAAAAPRLrqsAAAAAAKCb82cAAAAAAEYI0AAAAAAAjMi+7wIAAAAAgG7Zz1MAAAAAANDNBAcAAAAAACMEaAAAAAAARuRaqwAAAAAAoFveSQEAAAAAQDcTHAAAAAAAjBCgAQAAAAAYkec5BQAAAAAA3fJ37wIAAAAAgG4mOAAAAAAAGCFAAwAAAAAwIq+1CgAAAAAAuuUrKQAAAAAA6GaCAwAAAACAEQI0AAAAAAAjcs4pAAAAAADolt+9CwAAAAAAupngAAAAAABghAANAAAAAMCIrLUKAAAAAAC65TspAAAAAADoZoIDAAAAAIARAjQAAAAAACMEaAAAAAAARvwHBKydNkZFACsAAAAASUVORK5CYII=";

var BannerHeadingYellowBlow = styled(Heading).attrs({
    color: 'primary1.vividTangelo',
    as: 'h2',
    scale: 'xxl',
})(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  text-shadow: 0px 2px 12px\n    ", ";\n"], ["\n  text-shadow: 0px 2px 12px\n    ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.internationalOrange;
});
var BannerTopContainer = styled(Flex)(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  position: relative;\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    //opacity: 0.05;\n    background-color: ", ";\n    background-image: url(", ");\n    //background-repeat: repeat;\n    //background-position: center center;\n  }\n"], ["\n  width: 100%;\n  background-color: ", ";\n  position: relative;\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    //opacity: 0.05;\n    background-color: ", ";\n    background-image: url(", ");\n    //background-repeat: repeat;\n    //background-position: center center;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
}, LinerBackground);
var BannerBottomContainer = styled(Flex)(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  box-shadow: 0px 4px 1px ", ",\n    0px 8px 1px ", ",\n    0px -4px 1px ", ";\n"], ["\n  box-shadow: 0px 4px 1px ", ",\n    0px 8px 1px ", ",\n    0px -4px 1px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
});
var templateObject_1$n, templateObject_2$g, templateObject_3$e;

var BannerCaruselItem = function (props) {
    return (React__default.createElement(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "center" },
        React__default.createElement(Flex, { flexDirection: "column" }, props.icon),
        React__default.createElement(Flex, { flexDirection: "column", marginLeft: "32px" },
            React__default.createElement(BannerHeadingYellowBlow, null, props.headerText),
            React__default.createElement(MediumText, { color: "primary2.cambridgeBlue", marginTop: "4px" },
                props.contentText,
                React__default.createElement(Link, { color: "white" }, props.linkText)))));
};
var Banner = function (_a) {
    var options = _a.options, slides = _a.slides, activeOption = _a.activeOption, setActiveOption = _a.setActiveOption;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BannerTopContainer, { justifyContent: "center" },
            React__default.createElement(Carusel, null, slides.map(function (item, index) { return (React__default.createElement(BannerCaruselItem, __assign({ key: index }, item))); }))),
        React__default.createElement(BannerBottomContainer, { background: lightColors.primary2.darkSlateGray, height: "84px", justifyContent: "center", alignItems: "center" },
            React__default.createElement(Select, { value: activeOption, options: options, onValueChanged: setActiveOption }))));
};

var GridPNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8gAAABfCAYAAAA02e5kAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI+SURBVHgB7dy5DQIBEATBhuhwiRSX7HgGjwgQV5XDGK2V9tTl+ggAAAAO7hwAAAAgkAEAAOBNIAMAAMDLKeD/ff8auN9sH36FfcLvsk84HBdkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAEggAwAAwAhkAAAASCADAADACGQAAABIIAMAAMAIZAAAAAAAAAA+nvOvC1OxFHB0AAAAAElFTkSuQmCC";

var CardNameHeadPNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAAANCAYAAABYd9eWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjSURBVHgB7dYxDkBAEIXhN6IWLS6jc/9DsB3iArR265VX+L9upv4zmVCp628BtV1nvMdGgAHhwYLwYBGal+ynG8ZJQG1pW7OZiwcLwoMF4cGiLRdpPwR8jYsHC8KDBeEB+I8Hs2EKY8z1Ug0AAAAASUVORK5CYII=";

var LeftSideMobilePNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAKgCAYAAADHxx5jAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOxSURBVHgB7dWxbtNgGEZhBzFXXbt36I7UoXeA1IkbhhtgQAws7EUMcAllJX+kRlWcxj5+ni2xlyN9r7yblurq+nk6g3fTxgiu202Xdnv34lZv7h+mOTnpOhs+u2Gzxzb69OfvNCcnXWfDszuy2bk3eoyTrrPhky1ssyMnXWfDr7bwzY6cdJ0NH7WyzY6cdJ0NH1j5ZkdOus6Ga5sdOek6wXWC6zb4HY5/d0dOuk5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrNhf8fvr96+U3fv6YSpx03QY3fMSHj49TiZOus+HR1y+fpxInXSe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNdtLnh38M/V9fP/P28eP+09fvr+bVozJ11nwwdim3bSdTZ81Mo37aTrbPjVVrZpJ11nwydb+KaddJ0Nz25hm3bSdTZ8dhfetJOus+E398abdtJ1NnxxZ960k66z4cWZedNOus6GF+/ETTvpOhtendu7/U3fP+w9HjftpOtsePWG7/TISddtLvgfVgNpC2CIuGAAAAAASUVORK5CYII=";

var LeftSidePNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAEYCAYAAAAAtpXmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIqSURBVHgB7dyxalNhHIfhr+JcOolFcHJwcSo4eAdCJ29Yb8BBHFx0UJCKg15CXO0JTShJmnPePM+W5Cwv/H+cLWdj7s4vVmOPHo0TI7jubBzbi5cbN3r5+s3YJyddZ8MHN9nsXRu9+fN3HIKTrrPhvduy2UNt9S5Ous6GdzazzU456TobvreZb3bKSdfZ8FYL2+yUk66z4TUL3+yUk66z4dpmp5x0neA6wXUn+B6Ov3ennHSd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrju54Mdbn/j6ZZQ46Tobnrp6ez1KnHTdCW7496+ND3z88H6UOOk6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLr/BfPmmfPR4mTrrPhNT9/jBInXSe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuO7kgs/Wvjm/WP3/8fL63a2fbz5/GkvmpOsE1wmu8x5eE3svO+k6G95q4Zt20nU2fG8L27STrrPhnby6Wo3v3259NbdNO+k6G967mb2nnXSdDR/ckTftpOts+ME98KaddJ0NH92BN+2k62x4dva8aSddZ8Ozt+OmnXSdDS/OZNPjydONjzvpOhtevOmmJ5x03ckF/wOL6WbrRoXX8QAAAABJRU5ErkJggg==";

var RightSideMobilePNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAKgCAYAAADHxx5jAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPfSURBVHgB7d09SlxhGIbhb0JqsXURqYQU2UEgK0iZxabIBpLCOooQI4JYmjbzCYo4v/e5ru4w09zwPnPKWY2T08exDXe3q3GA3o2FEVy3Ovv6baMbvvzx/fkvXPza67addN3igt9f3vwdm3T28dOzn1+Osf6bseNNO+m65W14bNhLvwnzxne9aSddZ8PbNm9815t20nU2vGu73rSTrrPhfdv2pp10nQ0fmk1v2knX2fChe+umnXSd4DrBdd7Dx+a172UnXSe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1C/zv0oufI2X679JxfbX26KTrlrfh889fRsnvPzfPfu6k6xYXvBofzh9HycP9+rP38MIIrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1gusE1wmuE1wnuE5wneA6wXWC6wTXCa4TXCe4TnCd4DrBdYLrBNcJrhNcJ7hOcJ3gOsF1iwt+P47dw/368/XV+vPd7er/RyddZ8MH75WbnTnpOhs+OG/c7MxJ19nw3m14szMnXWfDO7flzc6cdJ0Nb92ONztz0nU2vHF73uzMSdfZ8Jsd2GZnTrrOhl/twDc7c9J1NvyiI9vszEnX2fATR77ZmZOus+Enm50d2WZnTrpuccGrcXL6+Ow3jnyzMyddt7jgf5t3lUlX8n0MAAAAAElFTkSuQmCC";

var RightSidePNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAEYCAYAAAAAtpXmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJoSURBVHgB7d2xSsNgGEbhL+Is6lYEHXRxcBIcvAOhkxftIHTqoEMnQSuCtRTEsYJT+6stoUmanP88ixRdDnyvcVBbxN7+PKo0mxbRYjuRGYPpdnv926jS+P5u9feE0eNWN+5J0+W34fHkIyp1dv7zoXd48OenxxHLG2940540XX4bjpr8972hd3W9/HUNb9qTpnPDdUu33fSmPWk6N9y0pjftSdO54W2re9OeNJ0bbpuqN+1J07nhttt00540ncF0BtP5HO6ass9lT5rOYDqD6QymM5jOYDqD6QymM5jOYDqD6QymM5jOYDqD6QymM5jOYDqD6QymM5jOYDqD6QymM5jOYDqD6QymM5jOYLoM/7p09BAoyV+Xpjxpuvw2fHnTD5KX98nKz3vSdNkFF3FxWe278Wzb1+fy67fXpZeeNJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTGUxnMJ3BdAbTZfj/tI6OA2XN/wfzpOky3PDzU+TEk6YzmM5gOoPpDKYzmM5gOoPpDKYzmM5gOoPpDKYzmM5gOoPpDKYzmC7D3+LpujXvoBWzabH40pOmM5jOYDqfw61X8rmb8qTp3HDrbLjZlCdN54a3ruLNpjxpOjfcuHWbPTmNGA422u0iT5rODdeu7HN2OIgqedJ0brhyNf9sXJYnTeeGN9ayzaY8aTo3XFrLN5vypOnc8Fod22zKk6Zzw790fLMpT5ouww2nG011fLMpT5ouu+Ai9vbnK7+i45tNedJ02QV/A9ULl3VNdVr7AAAAAElFTkSuQmCC";

var HeaderContainer = styled(Flex)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  height: 94px;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 22px;\n  background-color: ", ";\n  box-shadow: 0 -", "px ", ",\n    0 -", "px ", ";\n  @media (max-width: 768px) {\n    margin-top: 8px;\n    flex-direction: column;\n    gap: 26px;\n    height: 157px;\n    padding-bottom: 24px;\n  }\n"], ["\n  height: 94px;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 22px;\n  background-color: ", ";\n  box-shadow: 0 -", "px ", ",\n    0 -", "px ", ";\n  @media (max-width: 768px) {\n    margin-top: 8px;\n    flex-direction: column;\n    gap: 26px;\n    height: 157px;\n    padding-bottom: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, BOX_SHADOW_WIDTH$5, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, BOX_SHADOW_WIDTH$5 * 2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var ContentContainer = styled(Flex)(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  position: relative;\n  height: 166px;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 40px;\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n  @media (max-width: 768px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 48px;\n    height: 498px;\n    padding: 40px;\n  }\n"], ["\n  position: relative;\n  height: 166px;\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 40px;\n  background-color: ", ";\n  box-shadow: 0 ", "px\n      ", ",\n    0 ", "px\n      ", ";\n  @media (max-width: 768px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 48px;\n    height: 498px;\n    padding: 40px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
}, BOX_SHADOW_WIDTH$5, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
}, BOX_SHADOW_WIDTH$5 * 2, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var ContendGridBG = styled.img(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: calc(100% + 19px);\n  height: 94px;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: calc(100% + 19px);\n  height: 94px;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])));
var CardSide = styled.img(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  height: calc(100% - ", "px);\n  width: 61px;\n  ", " {\n    height: calc(100% + ", "px);\n  }\n"], ["\n  height: calc(100% - ", "px);\n  width: 61px;\n  ", " {\n    height: calc(100% + ", "px);\n  }\n"])), BOX_SHADOW_WIDTH$5 - 1, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
}, BOX_SHADOW_WIDTH$5 + 1);
var CardNameContainer = styled(Flex)(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  height: 100%;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n"], ["\n  height: 100%;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n"])));
var CardName = styled(Flex)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  position: relative;\n  align-items: center;\n  padding: 8px 12px 8px 15px;\n  width: 150px;\n  background-color: ", ";\n  box-shadow: ", ";\n"], ["\n  position: relative;\n  align-items: center;\n  padding: 8px 12px 8px 15px;\n  width: 150px;\n  background-color: ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenCyprus;
}, function (_a) {
    var theme = _a.theme;
    return createSimpleShadowBorder(theme.colors.primary2.darkGreen, BOX_SHADOW_WIDTH$5);
});
var NextButton = styled(Button$2)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 0;\n  box-shadow: ", ";\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  padding: 0;\n  box-shadow: ", ";\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  &:active:not(:disabled) {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var buttonColor = _a.buttonColor;
    return buttonColor;
}, function (_a) {
    var theme = _a.theme, buttonDarkBorderColor = _a.buttonDarkBorderColor, buttonLightBorderColor = _a.buttonLightBorderColor;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, buttonLightBorderColor, buttonDarkBorderColor, BORDER_WIDTH$1);
}, function (_a) {
    var buttonColor = _a.buttonColor;
    return buttonColor;
}, function (_a) {
    var theme = _a.theme, buttonDarkBorderColor = _a.buttonDarkBorderColor, buttonLightBorderColor = _a.buttonLightBorderColor;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, buttonLightBorderColor, buttonDarkBorderColor, BORDER_WIDTH$1);
}, function (_a) {
    var buttonColor = _a.buttonColor;
    return buttonColor;
}, function (_a) {
    var theme = _a.theme, buttonDarkBorderColor = _a.buttonDarkBorderColor, buttonLightBorderColor = _a.buttonLightBorderColor;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, buttonDarkBorderColor, buttonLightBorderColor, BORDER_WIDTH$1);
});
var CardNameHead = styled.img(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  height: 12px;\n  width: calc(100% + ", "px);\n  position: absolute;\n  left: -", "px;\n  top: -11px;\n"], ["\n  height: 12px;\n  width: calc(100% + ", "px);\n  position: absolute;\n  left: -", "px;\n  top: -11px;\n"])), BOX_SHADOW_WIDTH$5 * 2, BOX_SHADOW_WIDTH$5);
var templateObject_1$m, templateObject_2$f, templateObject_3$d, templateObject_4$8, templateObject_5$5, templateObject_6$5, templateObject_7$3, templateObject_8$3;

var ValueEnum;
(function (ValueEnum) {
    ValueEnum["Staking"] = "Staked";
    ValueEnum["Earning"] = "Earning";
    ValueEnum["Protected"] = "Protected";
})(ValueEnum || (ValueEnum = {}));

var getValueColor = function (operation, theme) {
    switch (operation) {
        case ValueEnum.Staking:
            return theme.colors.secondary.turquoise;
        case ValueEnum.Protected:
            return theme.colors.secondary.green;
        case ValueEnum.Earning:
            return theme.colors.primary1.vividTangelo;
    }
};

var FieldValue = styled.span(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n"], ["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, name = _a.name;
    return getValueColor(name, theme);
});
var DashboardHeaderSocket = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])));
var DashboardCardWrap = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  display: flex;\n  height: 282px;\n  @media (max-width: 768px) {\n    height: 668px;\n  }\n"], ["\n  display: flex;\n  height: 282px;\n  @media (max-width: 768px) {\n    height: 668px;\n  }\n"])));
var CardWrap = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  width: 1020px;\n  height: 283px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  @media (max-width: 768px) {\n    width: 248px;\n    justify-content: center;\n    height: 100%;\n  }\n"], ["\n  width: 1020px;\n  height: 283px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  @media (max-width: 768px) {\n    width: 248px;\n    justify-content: center;\n    height: 100%;\n  }\n"])));
var DashboardCardHeaderSocketIndicator = function (_a) {
    var cardName = _a.cardName;
    return (React__default.createElement(DashboardHeaderSocket, null,
        React__default.createElement(Flex, { width: "400px", marginBottom: "8px" },
            React__default.createElement(Hairbrush, null)),
        React__default.createElement(SocketProtectOn, { name: cardName })));
};
var DashboardCardHeader = function (_a) {
    var detailsIsActive = _a.detailsIsActive, nextIsActive = _a.nextIsActive, cardName = _a.cardName, cardSocketName = _a.cardSocketName, detailsClick = _a.detailsClick, nextClick = _a.nextClick;
    var nextButtonColorsConfig = getNextButtonColors(cardName);
    var CardLogo = getCardLogo(cardName);
    return (React__default.createElement(HeaderContainer, null,
        React__default.createElement(CardNameContainer, null,
            React__default.createElement(CardName, null,
                React__default.createElement(CardNameHead, { src: CardNameHeadPNG }),
                React__default.createElement(CardLogo, null),
                React__default.createElement(LargeText, { color: "white", marginLeft: "12px" }, cardName))),
        React__default.createElement(DashboardCardHeaderSocketIndicator, { cardName: cardSocketName }),
        React__default.createElement(Flex, null,
            React__default.createElement(Flex, null,
                React__default.createElement(Button$2, { primary: false, secondary: true, disabled: detailsIsActive, size: IconSize.L, onClick: detailsClick },
                    React__default.createElement(Heading, { scale: "md", color: "secondary.white" }, "Details"))),
            React__default.createElement(Flex, { marginLeft: "32px" },
                React__default.createElement(NextButton, __assign({ primary: false, secondary: true, size: IconSize.L, disabled: nextIsActive, onClick: nextClick }, nextButtonColorsConfig),
                    React__default.createElement(ArrowLong, { orientation: HorizontalOrientation.RIGHT, variant: IconSize.L }))))));
};
var DashboardCardContent = function (_a) {
    var total = _a.total, secondFieldName = _a.secondFieldName, secondFieldValue = _a.secondFieldValue, secondFieldTooltip = _a.secondFieldTooltip, thirdFieldName = _a.thirdFieldName, thirdFieldValue = _a.thirdFieldValue, thirdFieldTooltip = _a.thirdFieldTooltip, fourthFieldName = _a.fourthFieldName, fourthFieldValue = _a.fourthFieldValue, fourthFieldTooltip = _a.fourthFieldTooltip;
    return (React__default.createElement(ContentContainer, null,
        React__default.createElement(ContendGridBG, { src: GridPNG }),
        React__default.createElement(DarkInfoBox, { borderColor: "primary2.midnightGreen" },
            React__default.createElement(FlexWithGap, { flexDirection: "column", gap: "4px", justifyContent: "space-between" },
                React__default.createElement(Heading, { as: "h4", scale: "md", color: "primary2.cambridgeBlue" }, "Total"),
                React__default.createElement(LargeText, { color: "white", fontWeight: 500 }, total))),
        React__default.createElement(DarkInfoBox, { borderColor: "primary2.midnightGreen" },
            React__default.createElement(FlexWithGap, { flexDirection: "column", gap: "4px", justifyContent: "space-between" },
                React__default.createElement(Tooltip, { tooltipValue: secondFieldTooltip || '', conntainerStyles: { zIndex: 3 } },
                    React__default.createElement(Heading, { as: "h4", scale: "md", color: "primary2.cambridgeBlue" }, secondFieldName)),
                React__default.createElement(FieldValue, { name: secondFieldName }, secondFieldValue))),
        React__default.createElement(DarkInfoBox, { borderColor: "primary2.midnightGreen" },
            React__default.createElement(FlexWithGap, { flexDirection: "column", gap: "4px", justifyContent: "space-between" },
                React__default.createElement(Tooltip, { tooltipValue: thirdFieldTooltip || '', conntainerStyles: { zIndex: 3 } },
                    React__default.createElement(Heading, { as: "h4", scale: "md", color: "primary2.cambridgeBlue" }, thirdFieldName)),
                React__default.createElement(LargeText, { color: thirdFieldValue === '_' ? 'white' : 'red', fontWeight: 500 }, thirdFieldValue))),
        React__default.createElement(DarkInfoBox, { zIndex: 2, borderColor: "primary2.midnightGreen" },
            React__default.createElement(FlexWithGap, { flexDirection: "column", gap: "4px", justifyContent: "space-between" },
                React__default.createElement(Tooltip, { tooltipValue: fourthFieldTooltip || '', conntainerStyles: { zIndex: 3 } },
                    React__default.createElement(Heading, { as: "h4", scale: "md", color: "primary2.cambridgeBlue" }, fourthFieldName)),
                React__default.createElement(LargeText, { color: "white", fontWeight: 500 }, fourthFieldValue)))));
};
var DashboardCard = function (_a) {
    var cardName = _a.cardName, cardSocketName = _a.cardSocketName, detailsIsActive = _a.detailsIsActive, nextIsActive = _a.nextIsActive, detailsClick = _a.detailsClick, nextClick = _a.nextClick, total = _a.total, secondFieldName = _a.secondFieldName, secondFieldValue = _a.secondFieldValue, secondFieldTooltip = _a.secondFieldTooltip, thirdFieldName = _a.thirdFieldName, thirdFieldValue = _a.thirdFieldValue, thirdFieldTooltip = _a.thirdFieldTooltip, fourthFieldName = _a.fourthFieldName, fourthFieldValue = _a.fourthFieldValue, fourthFieldTooltip = _a.fourthFieldTooltip;
    var HeaderProps = {
        cardName: cardName,
        detailsIsActive: detailsIsActive,
        nextIsActive: nextIsActive,
        cardSocketName: cardSocketName,
        detailsClick: detailsClick,
        nextClick: nextClick,
    };
    var ContentProps = {
        total: total,
        secondFieldName: secondFieldName,
        secondFieldValue: secondFieldValue,
        secondFieldTooltip: secondFieldTooltip,
        thirdFieldName: thirdFieldName,
        thirdFieldValue: thirdFieldValue,
        thirdFieldTooltip: thirdFieldTooltip,
        fourthFieldName: fourthFieldName,
        fourthFieldValue: fourthFieldValue,
        fourthFieldTooltip: fourthFieldTooltip,
    };
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(DashboardCardWrap, null,
        React__default.createElement(CardSide, { src: isMobile ? LeftSideMobilePNG : LeftSidePNG }),
        React__default.createElement(CardWrap, null,
            React__default.createElement(DashboardCardHeader, __assign({}, HeaderProps)),
            React__default.createElement(Box, { background: "#002428", width: "100%", height: "4px" }),
            React__default.createElement(Box, { background: "#336D74", width: "100%", height: "4px" }),
            React__default.createElement(DashboardCardContent, __assign({}, ContentProps))),
        React__default.createElement(CardSide, { src: isMobile ? RightSideMobilePNG : RightSidePNG, style: { marginLeft: '-2px' } })));
};
var templateObject_1$l, templateObject_2$e, templateObject_3$c, templateObject_4$7;

var _a;
var SocketType;
(function (SocketType) {
    SocketType[SocketType["ProtectOn"] = 0] = "ProtectOn";
    SocketType[SocketType["EarnOn"] = 1] = "EarnOn";
    SocketType[SocketType["StakeOn"] = 2] = "StakeOn";
    SocketType[SocketType["Off"] = 3] = "Off";
})(SocketType || (SocketType = {}));
var DashboardSocketIndicators = (_a = {},
    _a[SocketType.ProtectOn] = SocketProtectOn,
    _a[SocketType.EarnOn] = SocketEarnOn,
    _a[SocketType.StakeOn] = SocketStakeOn,
    _a[SocketType.Off] = SocketOff,
    _a);

var BG = "da6c00c1945d01c4.png";

var BackgroundImage = styled.img(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  overflow: hidden;\n  top: 0;\n"], ["\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  overflow: hidden;\n  top: 0;\n"])));
var Background = function () {
    return React__default.createElement(BackgroundImage, { src: BG, alt: "background-image" });
};
var templateObject_1$k;

var Options = [
    {
        key: 'Net',
        value: 'Network',
    },
    {
        key: 'Goerli',
        value: 'Goerli',
    },
    {
        key: 'Mainnet',
        value: 'Mainnet',
    },
];
var Slides = [
    {
        icon: React__default.createElement(YellowOrangeDiamond, null),
        headerText: 'God-Mode for Crypto',
        contentText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Purus est pellentesque risus commodo.',
        linkText: 'Learn More',
        linkPath: '',
    },
    {
        icon: React__default.createElement(YellowOrangeDiamond, null),
        headerText: 'God-Mode for Crypto',
        contentText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Purus est pellentesque risus commodo.',
        linkText: 'Learn More',
        linkPath: '',
    },
];
var DashboardWrap = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  max-width: 1092px;\n  padding: 0 24px;\n  margin: 72px auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 68px;\n"], ["\n  max-width: 1092px;\n  padding: 0 24px;\n  margin: 72px auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 68px;\n"])));
var Dashboard = function (_a) {
    var protect = _a.protect, earn = _a.earn, stake = _a.stake, bump = _a.bump;
    var _b = useState(Options[0]), option = _b[0], setActiveOption = _b[1];
    return (React__default.createElement(Box, { position: "relative" },
        React__default.createElement(Background, null),
        React__default.createElement(Banner, { slides: Slides, options: Options, activeOption: option, setActiveOption: setActiveOption }),
        React__default.createElement(DashboardWrap, null,
            React__default.createElement(BumpSection, { balance: bump.balance, vesting: bump === null || bump === void 0 ? void 0 : bump.vesting }),
            React__default.createElement(DashboardCard, { cardName: 'Protect', detailsClick: protect.detailsOnClick, nextClick: protect.nextOnClick, total: protect.total, secondFieldName: 'Protected', secondFieldValue: protect.protected, secondFieldTooltip: 'gfdsgds', thirdFieldName: 'Unprotected', thirdFieldValue: protect.unprotected, thirdFieldTooltip: 'ffdf', fourthFieldName: 'Protected Ratio', fourthFieldValue: protect.protectedRatio, fourthFieldTooltip: 'fgfd' }),
            React__default.createElement(DashboardCard, { cardName: 'Earn', detailsClick: earn.detailsOnClick, nextClick: earn.nextOnClick, total: earn.total, secondFieldName: 'Earning', secondFieldValue: earn.earning, secondFieldTooltip: 'gfdsgds', thirdFieldName: 'Idle', thirdFieldValue: earn.idle, thirdFieldTooltip: 'ffdf', fourthFieldName: 'Earning Ratio', fourthFieldValue: earn.earningRatio, fourthFieldTooltip: 'fgfd' }),
            React__default.createElement(DashboardCard, { cardName: 'Stake', detailsClick: stake.detailsOnClick, nextClick: stake.nextOnClick, total: stake.total, secondFieldName: 'Staking', secondFieldValue: stake.staked, secondFieldTooltip: 'gfdsgds', thirdFieldName: 'Idle', thirdFieldValue: stake.idle, thirdFieldTooltip: 'ffdf', fourthFieldName: 'Staking Ratio', fourthFieldValue: stake.stakingRatio, fourthFieldTooltip: "fgfd" }))));
};
var templateObject_1$j;

var getBoxShadow = function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.midnightGreen, 4);
};

var Logo = "data:image/svg+xml,%3Csvg%20width%3D%22138%22%20height%3D%2218%22%20viewBox%3D%220%200%20138%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M98.9904%209.40973H96.1031L97.1288%204.17603H99.8069C100.686%204.17603%20101.362%204.35618%20101.836%204.71496C102.31%205.07322%20102.548%205.61215%20102.548%206.3297C102.548%207.32055%20102.237%208.08109%20101.617%208.61234C100.996%209.1436%20100.121%209.40973%2098.9904%209.40973ZM105.979%206.00675C105.979%204.52866%20105.477%203.37966%20104.473%202.5618C103.468%201.74292%20102.059%201.3345%20100.246%201.3345H94.2837L91.3541%2016.4092H94.764L95.5805%2012.1883H98.4684L100.77%2016.4092H104.348L101.794%2011.7574C103.105%2011.3413%20104.13%2010.6304%20104.871%209.62571C105.608%208.62002%20105.979%207.41421%20105.979%206.00675ZM88.7223%204.13355L89.2876%201.33398H78.2194L75.2897%2016.4086H86.6299L87.1953%2013.6091H79.2029L79.8727%2010.1201H86.6936L87.2167%207.40705H80.4161L81.0441%204.13355H88.7223V4.13355ZM65.8375%209.40973H62.9715L63.9968%204.17603H66.6534C67.533%204.17603%2068.2058%204.35618%2068.6732%204.71496C69.1401%205.07322%2069.3738%205.61215%2069.3738%206.3297C69.3738%207.32055%2069.067%208.08109%2068.4529%208.61234C67.8388%209.14411%2066.9677%209.40973%2065.8375%209.40973ZM67.0721%201.33398H61.1512L58.222%2016.4086H61.6325L62.4275%2012.2523H65.6913C67.1417%2012.2523%2068.4007%2012.0015%2069.4677%2011.4984C70.5348%2010.9963%2071.3577%2010.2737%2071.9365%209.33399C72.5152%208.39431%2072.8046%207.29138%2072.8046%206.02825C72.8046%204.54965%2072.3054%203.39706%2071.309%202.57153C70.312%201.7465%2068.8994%201.33398%2067.0721%201.33398ZM52.751%201.33398L45.596%2010.7235L41.9344%201.33398H39.1728L36.2437%2016.4086H39.4234L41.1811%207.36354L44.1938%2014.8149H45.7004L51.2867%207.45004L49.5708%2016.4086H52.751L55.6593%201.33398H52.751V1.33398ZM24.7449%2016.6671C28.8455%2016.6671%2031.3421%2014.4203%2032.2351%209.92665L33.8878%201.33398H30.5609L28.929%209.71119C28.6501%2011.1038%2028.2036%2012.1161%2027.59%2012.7477C26.9764%2013.3798%2026.1535%2013.6961%2025.1213%2013.6961C24.2009%2013.6961%2023.4998%2013.4704%2023.0185%2013.0179C22.5377%2012.5655%2022.297%2011.8874%2022.297%2010.982C22.297%2010.6089%2022.3388%2010.1851%2022.4223%209.71221L24.0542%201.33501H20.6438L19.0119%209.7767C18.9005%2010.3796%2018.8448%2010.9175%2018.8448%2011.3919C18.8448%2013.0277%2019.3679%2014.3174%2020.414%2015.2576C21.4602%2016.1978%2022.9037%2016.6671%2024.7449%2016.6671ZM7.88797%2013.7816H3.89178L4.60281%2010.0556H8.70391C10.1682%2010.0556%2010.9007%2010.5726%2010.9007%2011.6064C10.9007%2012.3101%2010.6356%2012.848%2010.1056%2013.2211C9.57505%2013.5948%208.83618%2013.7816%207.88797%2013.7816ZM9.20561%203.96107C10.6421%203.96107%2011.3606%204.435%2011.3606%205.38235C11.3606%206.07175%2011.113%206.59942%2010.6182%206.96536C10.123%207.3313%209.42887%207.51452%208.53635%207.51452H5.08412L5.77477%203.96107H9.20561V3.96107ZM12.3023%208.63435C13.1113%208.28991%2013.7493%207.79141%2014.2166%207.13784C14.684%206.48478%2014.9177%205.69865%2014.9177%204.77996C14.9177%203.67446%2014.4921%202.82384%2013.6414%202.22811C12.7906%201.63237%2011.5769%201.3345%2010.0007%201.3345H2.92915L0%2016.4086H7.67864C9.67301%2016.4086%2011.2701%2016.0069%2012.4699%2015.2028C13.6692%2014.3998%2014.2689%2013.2145%2014.2689%2011.6504C14.2689%2010.917%2014.0978%2010.2962%2013.7562%209.78642C13.4146%209.27718%2012.9298%208.89281%2012.3023%208.63435Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M130.331%2010.3535H131.233V13.9613V14.8633H130.331V15.7652H129.429V16.6672H127.625V17.5691H118.605V16.6672H126.723V15.7652H128.527V14.8633H129.429V13.9613H130.331V10.3535ZM121.762%2010.8045H121.311V12.1574H121.762V10.8045Z%22%20fill%3D%22%239E3100%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M133.936%203.13867H134.838V7.64841H133.936V8.55036H133.034H122.211V7.64841H133.034V6.74647H133.936V3.13867Z%22%20fill%3D%22%23934818%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M126.723%209.45117H119.507L119.507%2010.3531H118.605V13.9609H117.703V16.6668L119.507%2016.6668H126.723V15.7648H128.527V14.8629H129.428V13.9609H130.33V9.45117H129.428H128.527H126.723Z%22%20fill%3D%22%23FF5000%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M123.112%200.431641H130.328H132.132V1.33359H133.034V2.23554H133.936V6.74528H133.034V7.64723H130.328H123.112H121.309V6.74528H122.211V2.23554H123.112L123.112%200.431641Z%22%20fill%3D%22%23FF7D2B%22%2F%3E%3C%2Fsvg%3E";

var BluredBg = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.7);\n"], ["\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.7);\n"])));
var Wrapper = styled(Flex)(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow-y: scroll;\n  padding: 24px 0;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow-y: scroll;\n  padding: 24px 0;\n  align-items: center;\n  justify-content: center;\n"])));
var ModalWrapContainer = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.8);\n  ", " {\n    transform: translate(-50%, -50%) scale(0.6);\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.8);\n  ", " {\n    transform: translate(-50%, -50%) scale(0.6);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var ModalWrap = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  position: relative;\n  padding: 24px 68px 0;\n  background-color: ", ";\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 690px;\n  ", " {\n    padding: 24px;\n  }\n"], ["\n  position: relative;\n  padding: 24px 68px 0;\n  background-color: ", ";\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 690px;\n  ", " {\n    padding: 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, getBoxShadow, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var DescriptionWrapper = styled(Flex)(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  margin: auto;\n  flex-direction: column;\n  align-items: start;\n  gap: 24px;\n  max-width: 690px;\n  color: ", ";\n  margin-top: 72px;\n"], ["\n  margin: auto;\n  flex-direction: column;\n  align-items: start;\n  gap: 24px;\n  max-width: 690px;\n  color: ", ";\n  margin-top: 72px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
});
var GreenLink = styled.a(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  color: ", ";\n  :hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  :hover {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
});
var DescriptionDivider = styled(Box)(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  background-color: #c4c4c4;\n"], ["\n  width: 100%;\n  height: 1px;\n  background-color: #c4c4c4;\n"])));
var Title = styled.span(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  font-family: 'Share Tech Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 36px;\n  letter-spacing: 0.03em;\n  color: #ffffff;\n  margin: 44px 0;\n"], ["\n  font-family: 'Share Tech Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 36px;\n  letter-spacing: 0.03em;\n  color: #ffffff;\n  margin: 44px 0;\n"])));
var WalletWrap = styled.ul(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  width: 100%;\n  justify-content: space-between;\n  align-content: flex-start;\n  gap: 48px;\n"], ["\n  list-style: none;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  width: 100%;\n  justify-content: space-between;\n  align-content: flex-start;\n  gap: 48px;\n"])));
var GreenButton = styled.button(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  font-family: 'Share Tech Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.03em;\n  color: #60c770;\n  margin: 50px 0 64px;\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  font-family: 'Share Tech Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.03em;\n  color: #60c770;\n  margin: 50px 0 64px;\n  border: none;\n  outline: none;\n  background: none;\n"])));
var MoreButton = styled.button(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 1px;\n  width: 100%;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  color: #ffffff;\n"], ["\n  position: absolute;\n  bottom: 1px;\n  width: 100%;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  color: #ffffff;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkRichBlack;
});
var ConnectWalletModal = function (_a) {
    var wallets = _a.wallets, withoutWalletClick = _a.withoutWalletClick, clickOutModal = _a.clickOutModal;
    var _b = useState(3), more = _b[0], setMore = _b[1];
    var showMore = useMemo(function () { return more === wallets.length; }, [more]);
    var container = useRef(null);
    useEffect(function () {
        var onClick = function (e) {
            var _a;
            var target = e.target;
            if (!((_a = container === null || container === void 0 ? void 0 : container.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                clickOutModal();
            }
        };
        document.addEventListener('click', onClick);
        document.body.style.overflowY = 'hidden';
        return function () {
            document.removeEventListener('click', onClick);
            document.body.style.overflowY = 'scroll';
        };
    }, []);
    return (React__default.createElement(BluredBg, null,
        React__default.createElement(Wrapper, null,
            React__default.createElement(ModalWrapContainer, null,
                React__default.createElement(ModalWrap, { ref: container },
                    React__default.createElement(Box, { position: "absolute", right: "10px", top: "10px", onClick: withoutWalletClick },
                        React__default.createElement(Close$4, { variant: IconSize.L })),
                    React__default.createElement("img", { src: Logo, alt: "bumper-logo" }),
                    React__default.createElement(Title, null, "Connect Your Wallet"),
                    React__default.createElement(WalletWrap, null, wallets.map(function (wallet, idx) {
                        return (idx < more && (React__default.createElement(Button$2, { key: idx, secondary: true, size: IconSize.L, flexDirection: "column", width: "142px", justifyContent: "center", padding: "24px 0", disabled: wallet.disabled, onClick: function () {
                                if (wallet.onClick)
                                    wallet.onClick();
                            } },
                            React__default.createElement("img", { src: wallet.logo, alt: "wallet-img" }),
                            React__default.createElement("span", null, wallet.name))));
                    })),
                    React__default.createElement(GreenButton, { onClick: withoutWalletClick }, "Proceed without connecting wallet"),
                    React__default.createElement(MoreButton, { onClick: function () {
                            setMore(showMore ? 3 : wallets.length);
                        } },
                        React__default.createElement(Check$1, { orientation: showMore ? VerticalOrientation.UP : VerticalOrientation.DOWN, variant: IconSize.L }),
                        React__default.createElement("span", null, showMore ? 'Less' : 'More'))),
                React__default.createElement(DescriptionWrapper, null,
                    React__default.createElement(LargeText, { color: "secondary.white" },
                        "By unlocking your wallet you agree to Bumper\u2019s",
                        ' ',
                        React__default.createElement(GreenLink, { href: "https://www.bumper.fi/" }, "Terms and Conditions"),
                        ",",
                        ' ',
                        React__default.createElement(GreenLink, { href: "https://www.bumper.fi/" }, "Privacy Policy"),
                        ' ',
                        "and",
                        ' ',
                        React__default.createElement(GreenLink, { href: "https://www.bumper.fi/" }, "Disclaimer"),
                        "."),
                    React__default.createElement(DescriptionDivider, null),
                    React__default.createElement(LargeText, { color: "secondary.white" },
                        "Need help connecting a wallet? Check out our",
                        ' ',
                        React__default.createElement(GreenLink, { href: "https://www.bumper.fi/" }, "guide"),
                        "."),
                    React__default.createElement(DescriptionDivider, null),
                    React__default.createElement(LargeText, { color: "primary2.cambridgeBlue" }, "Disclaimer: Wallets are provided by External Providers and by selecting you agree to the Terms of those Providers. Your access to the wallet might be reliant on the External Provider being operational. Bumper accepts no responsibility for their services."))))));
};
var templateObject_1$i, templateObject_2$d, templateObject_3$b, templateObject_4$6, templateObject_5$4, templateObject_6$4, templateObject_7$2, templateObject_8$2, templateObject_9$1, templateObject_10$1, templateObject_11$1;

var TotalHubWrapper = styled(Flex)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.03;\n    background-image: url(", ");\n    background-size: cover;\n    background-repeat: repeat;\n    background-position: center center;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.03;\n    background-image: url(", ");\n    background-size: cover;\n    background-repeat: repeat;\n    background-position: center center;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.deepTeal, theme.colors.primary2.darkSlateGray, theme.colors.primary2.greenCyprus, BOX_SHADOW_WIDTH$5);
}, InfoBoxBg);
var TotalHubContainer = styled(Grid$2)(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  width: 100%;\n  grid-template-columns: 1fr 2px 1fr 2px 1fr;\n  grid-template-rows: 1fr;\n  align-items: center;\n  justify-items: center;\n  position: relative;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n\n  @media (max-width: 420px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr;\n    grid-row-gap: 18px;\n  }\n\n  '@media (max-width: 320px)': {\n    grid-template-columns: 1fr 2px 1fr 2px 1fr;\n    grid-template-rows: 1fr;\n  }\n"], ["\n  width: 100%;\n  grid-template-columns: 1fr 2px 1fr 2px 1fr;\n  grid-template-rows: 1fr;\n  align-items: center;\n  justify-items: center;\n  position: relative;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n\n  @media (max-width: 420px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr;\n    grid-row-gap: 18px;\n  }\n\n  '@media (max-width: 320px)': {\n    grid-template-columns: 1fr 2px 1fr 2px 1fr;\n    grid-template-rows: 1fr;\n  }\n"])), space, layout);
var TotalHubFieldContainer = styled(Flex)(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n"], ["\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n"])));
var VerticalLine$1 = styled(Box)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  height: 36px;\n  width: 2px;\n  background-color: ", ";\n  @media (max-width: 420px) {\n    display: none;\n  }\n"], ["\n  height: 36px;\n  width: 2px;\n  background-color: ", ";\n  @media (max-width: 420px) {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var templateObject_1$h, templateObject_2$c, templateObject_3$a, templateObject_4$5;

var TotalHubField = function (_a) {
    var name = _a.name, value = _a.value, _b = _a.color, color = _b === void 0 ? lightColors.typography.input : _b;
    return (React__default.createElement(TotalHubFieldContainer, null,
        React__default.createElement(Heading, { scale: "md", color: lightColors.primary2.cambridgeBlue }, name),
        React__default.createElement(LargeText, { fontWeight: 500, fontFamily: "Roboto Mono", color: color },
            "$",
            value)));
};
var TotalHubInfoBox = function (_a) {
    var mainTitle = _a.mainTitle, firstFieldName = _a.firstFieldName, firstFieldValue = _a.firstFieldValue, secondFieldName = _a.secondFieldName, secondFieldValue = _a.secondFieldValue, thirdFieldName = _a.thirdFieldName, thirdFieldValue = _a.thirdFieldValue;
    return (React__default.createElement(TotalHubWrapper, null,
        React__default.createElement(Box, { width: "fit-content" },
            React__default.createElement(Heading, { scale: "xl", color: lightColors.primary2.cambridgeBlue }, mainTitle)),
        React__default.createElement(TotalHubContainer, null,
            React__default.createElement(TotalHubField, { name: firstFieldName, value: firstFieldValue }),
            React__default.createElement(VerticalLine$1, null),
            React__default.createElement(TotalHubField, { name: secondFieldName, value: secondFieldValue, color: lightColors.secondary.orange }),
            React__default.createElement(VerticalLine$1, null),
            React__default.createElement(TotalHubField, { name: thirdFieldName, value: thirdFieldValue }))));
};

var HubPages;
(function (HubPages) {
    HubPages["protect"] = "protect";
    HubPages["earn"] = "earn";
    HubPages["stake"] = "stake";
})(HubPages || (HubPages = {}));

var getPyramidTopColor = function (hub) {
    switch (hub) {
        case HubPages.protect:
            return lightColors.secondary.lightDarkGreen;
        case HubPages.earn:
            return lightColors.primary1.saddleBrown;
        case HubPages.stake:
            return lightColors.primary1.teal;
        default:
            console.log("Sorry, we are out of ".concat(hub));
    }
};
var getPyramidBottomColor = function (hub) {
    switch (hub) {
        case HubPages.protect:
            return lightColors.secondary.green;
        case HubPages.earn:
            return lightColors.primary1.vividTangelo;
        case HubPages.stake:
            return lightColors.primary2.myrtleGreen;
        default:
            console.log("Sorry, we are out of ".concat(hub));
    }
};

var PyramidWrapper = styled(Flex)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  & > * {\n    margin-bottom: 0.25rem;\n  }\n"], ["\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  & > * {\n    margin-bottom: 0.25rem;\n  }\n"])));
var PyramidLevelWrapper = styled(Flex)(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var PyramidTopLevel = styled(Box)(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  width: ", "px;\n  height: 0;\n  border-top: 4px solid\n    ", ";\n"], ["\n  width: ", "px;\n  height: 0;\n  border-top: 4px solid\n    ", ";\n"])), function (_a) {
    var lineWidth = _a.lineWidth;
    return lineWidth;
}, function (_a) {
    var isHubConnected = _a.isHubConnected, hub = _a.hub, theme = _a.theme;
    return isHubConnected
        ? getPyramidTopColor(hub)
        : theme.colors.primary2.midnightGreen;
});
var PyramidBottomLevel = styled(Box)(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  width: ", "px;\n  height: 0;\n  border-bottom: 4px solid\n    ", ";\n"], ["\n  width: ", "px;\n  height: 0;\n  border-bottom: 4px solid\n    ", ";\n"])), function (_a) {
    var lineWidth = _a.lineWidth;
    return lineWidth && lineWidth + 8;
}, function (_a) {
    var isHubConnected = _a.isHubConnected, hub = _a.hub, theme = _a.theme;
    return isHubConnected
        ? getPyramidBottomColor(hub)
        : theme.colors.primary2.myrtleGreen;
});
var templateObject_1$g, templateObject_2$b, templateObject_3$9, templateObject_4$4;

var PyramidLevel = function (_a) {
    var lineWidth = _a.lineWidth, hub = _a.hub, isHubConnected = _a.isHubConnected;
    return (React__default.createElement(PyramidLevelWrapper, null,
        React__default.createElement(PyramidTopLevel, { lineWidth: lineWidth, hub: hub, isHubConnected: isHubConnected }),
        React__default.createElement(PyramidBottomLevel, { lineWidth: lineWidth, hub: hub, isHubConnected: isHubConnected })));
};
var Pyramid = function (_a) {
    var currentHub = _a.currentHub, isHubConnected = _a.isHubConnected;
    return (React__default.createElement(PyramidWrapper, null,
        React__default.createElement(PyramidLevel, { lineWidth: 8, hub: currentHub, isHubConnected: isHubConnected }),
        React__default.createElement(PyramidLevel, { lineWidth: 24, hub: currentHub, isHubConnected: isHubConnected }),
        React__default.createElement(PyramidLevel, { lineWidth: 48, hub: currentHub, isHubConnected: isHubConnected }),
        React__default.createElement(PyramidLevel, { lineWidth: 72, hub: currentHub, isHubConnected: isHubConnected })));
};

var PYRAMID_HIGHEST_LEVEL_WIDTH = '8';

var PositionHeader = styled(Flex)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  width: 100%;\n  background-color: ", ";\n\n  box-shadow: ", ";\n\n  padding: 1.65rem 1.75rem;\n  z-index: 2;\n"], ["\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n  width: 100%;\n  background-color: ", ";\n\n  box-shadow: ", ";\n\n  padding: 1.65rem 1.75rem;\n  z-index: 2;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.assetConfirmationBox;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary1.teal, theme.colors.background.assetConfirmationBox, theme.colors.background.assetConfirmationBox, 4);
});
var PositionContentToggleWrapper = styled('button')(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  background-color: rgba(18, 191, 212, 0.1);\n  box-shadow: ", ";\n  border: none;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  color: ", ";\n  -webkit-text-fill-color: ", ";\n  background-color: rgba(18, 191, 212, 0.1);\n  box-shadow: ", ";\n  border: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
}, function (_a) {
    var isOpened = _a.isOpened;
    return isOpened
        ? "4px 0 rgba(18, 191, 212, 0.1), 0 4px rgba(18, 191, 212, 0.1), -4px 0 rgba(18, 191, 212, 0.1)"
        : '0 4px rgba(18, 191, 212, 0.1), 0 -4px 0 4px rgba(18, 191, 212, 0.1)';
});
var PositionInfoContainer = styled(Flex)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n"])));
var templateObject_1$f, templateObject_2$a, templateObject_3$8;

var Header$1 = function (_a) {
    var children = _a.children;
    return React__default.createElement(PositionHeader, null, children);
};
var Content = function (_a) {
    var children = _a.children, isCardView = _a.isCardView;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var handleContentToggle = function () { return setIsOpen(!isOpen); };
    return (React__default.createElement(ConfirmationBoxFixed, { p: '8px 0 0 0 ', mainStyles: { maxWidth: 'calc(100% - 14px)' }, alignItems: "center", justifyContent: "center" },
        isOpen && children,
        !isOpen && !isCardView ? (React__default.createElement(PositionContentToggleWrapper, { isOpened: isOpen, onClick: function () { return handleContentToggle(); } },
            React__default.createElement(LargeText, { fontSize: "lg", lineHeight: "24px", letterSpacing: "0.03em" }, "Show Details"),
            React__default.createElement(Check$1, { orientation: VerticalOrientation.DOWN, variant: IconSize.L }))) : isOpen && !isCardView ? (React__default.createElement(PositionContentToggleWrapper, { isOpened: isOpen, onClick: function () { return handleContentToggle(); } },
            React__default.createElement(LargeText, { fontSize: "lg", lineHeight: "24px", letterSpacing: "0.03em" }, "Hide Details"),
            React__default.createElement(Check$1, { orientation: VerticalOrientation.UP, variant: IconSize.L }))) : (children)));
};
var PositionInfo = function (_a) {
    var header = _a.header, content = _a.content, cardView = _a.cardView, props = __rest(_a, ["header", "content", "cardView"]);
    return (React__default.createElement(PositionInfoContainer, __assign({}, props),
        React__default.createElement(Header$1, null, header),
        React__default.createElement(Content, { isCardView: cardView }, content)));
};

var createPixelInsetBorder = function (borderColor, insetTLColor, insetBRColor, borderWidth) {
    var width = borderWidth ? borderWidth : 2;
    return "".concat(width, "px 0px 0px 0px ").concat(insetBRColor, ", \n      0px ").concat(width, "px 0px 0px ").concat(insetBRColor, ", \n      -").concat(width, "px 0px 0px 0px ").concat(insetTLColor, ", \n      0px -").concat(width, "px 0px 0px ").concat(insetTLColor, ", \n      -").concat(2 * width, "px 0px 0px 0px ").concat(borderColor, ", \n      ").concat(2 * width, "px 0px 0px 0px ").concat(borderColor, ", \n      0px ").concat(2 * width, "px 0px 0px ").concat(borderColor, ", \n      0px -").concat(2 * width, "px 0px 0px ").concat(borderColor, ", \n      0px 0px 0px ").concat(width, "px ").concat(borderColor);
};

var StepsWrap = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 486px;\n  width: 100%;\n  padding: 10px 26px;\n  background: ", ";\n  box-shadow: ", ";\n  &.disabled {\n    opacity: 0.3;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 486px;\n  width: 100%;\n  padding: 10px 26px;\n  background: ", ";\n  box-shadow: ", ";\n  &.disabled {\n    opacity: 0.3;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background.confirmationBox;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder(theme.colors.primary2.aqua, 'rgba(18, 191, 212, 0)', 'rgba(18, 191, 212, 0)', 2);
});
var StatusText$1 = styled.span(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #ffffff;\n"], ["\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #ffffff;\n"])));
var templateObject_1$e, templateObject_2$9;

var Steps = function (_a) {
    var name = _a.name, status = _a.status, disabled = _a.disabled;
    return (React__default.createElement(StepsWrap, { className: disabled || status === 'pending' ? 'disabled' : '' },
        React__default.createElement(FlexWithGap, { gap: "10px", alignItems: "center" },
            React__default.createElement(Wallet, { variant: IconSize.L }),
            React__default.createElement(StatusText$1, null, name)),
        status === 'loading' && React__default.createElement(Loading, null),
        status === 'done' && React__default.createElement(Check, { variant: IconSize.L }),
        status === 'pending' && (React__default.createElement(DotsMenu, { variant: IconSize.L, orientation: Orientation.HORIZONTAL }))));
};

var ProcessingWrap = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 486px;\n  width: 100%;\n  padding: 10px 26px 10px 0;\n  height: 48px;\n  background-color: #5e979e;\n  &.disabled {\n    opacity: 0.3;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 486px;\n  width: 100%;\n  padding: 10px 26px 10px 0;\n  height: 48px;\n  background-color: #5e979e;\n  &.disabled {\n    opacity: 0.3;\n  }\n"])));
var StatusText = styled.span(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #ffffff;\n"], ["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #ffffff;\n"])));
var WaitText = styled.span(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n"], ["\n  font-family: 'Roboto Mono';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var templateObject_1$d, templateObject_2$8, templateObject_3$7;

var Processing = function (_a) {
    var name = _a.name, status = _a.status, disabled = _a.disabled;
    return (React__default.createElement(ProcessingWrap, { className: disabled || status === 'pending' ? 'disabled' : '' },
        React__default.createElement(FlexWithGap, { gap: "8px", alignItems: "center" },
            React__default.createElement(StatusText, null, name),
            status === 'loading' && !disabled ? (React__default.createElement(WaitText, null, "Please wait...")) : null),
        status === 'loading' && React__default.createElement(ProcessingIco, null),
        status === 'done' && React__default.createElement(Check, { variant: IconSize.L }),
        status === 'pending' && (React__default.createElement(DotsMenu, { variant: IconSize.L, orientation: Orientation.HORIZONTAL }))));
};

var discordLink = 'https://discord.gg/YyzRws4Ujd';
var docsLink = 'https://docs.bumper.fi/';
var supportLink = 'mailto:support@bumper.fi?subject=Beta Support';
var reportBugLink = 'https://docs.google.com/forms/d/e/1FAIpQLSd1kwjtkV9gWLKTzikUly2uXjq0h__p7pAJtkPPUAd-Da91Dg/viewform';

var BOX_SHADOW_WIDTH = 4;

var getBoxShadowForFooterLink = function (_a) {
    var isDiscord = _a.isDiscord;
    if (isDiscord) {
        return createPixelInsetBorder$1(lightColors.primary2.greenBlack, lightColors.secondary.lightViolet, lightColors.secondary.darkViolet, BOX_SHADOW_WIDTH);
    }
    return createPixelInsetBorder$1(lightColors.primary2.greenBlack, lightColors.primary2.myrtleGreen, lightColors.primary2.richBlack, BOX_SHADOW_WIDTH);
};
var getBackgroundColor = function (_a) {
    var isDiscord = _a.isDiscord;
    if (isDiscord)
        return lightColors.secondary.violet;
    return lightColors.primary2.darkSlateGray;
};
var getBackgroundPressed = function (_a) {
    var isDiscord = _a.isDiscord;
    if (!isDiscord)
        return lightColors.primary2.greenCyprus;
};

var LinkContainer = styled.a(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    color: inherit;\n  }\n"], ["\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    color: inherit;\n  }\n"])));
var FooterLink = styled('a')(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  box-shadow: ", ";\n  background-color: ", ";\n  background-image: url(", ");\n  background-size: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  :hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n  box-shadow: ", ";\n  background-color: ", ";\n  background-image: url(", ");\n  background-size: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  :hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkSlateGray, theme.colors.primary2.deepTeal, BOX_SHADOW_WIDTH);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var icon = _a.icon;
    return icon;
}, getBackgroundColor, getBoxShadowForFooterLink, getBackgroundPressed);
var FooterLinksWrapper = styled(Flex)(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  align-items: center;\n  gap: 32px;\n  padding: 0 8px;\n"], ["\n  align-items: center;\n  gap: 32px;\n  padding: 0 8px;\n"])));
var FooterBlockNumberLabel = styled(Heading)(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n"], ["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
});
var FooterContainer = styled(Flex)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 0;\n  box-sizing: border-box;\n  border-top: ", "px solid\n    ", ";\n  background-color: ", ";\n  ", " {\n    padding: 24px 16px;\n  }\n"], ["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 0;\n  box-sizing: border-box;\n  border-top: ", "px solid\n    ", ";\n  background-color: ", ";\n  ", " {\n    padding: 24px 16px;\n  }\n"])), BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var MobileContainer = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  display: flex;\n  margin: auto;\n  ", " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 24px;\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  margin: auto;\n  ", " {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 24px;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var templateObject_1$c, templateObject_2$7, templateObject_3$6, templateObject_4$3, templateObject_5$3, templateObject_6$3;

var BugIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABhCAYAAAApxKSdAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgB7d1BCsIwEEDRKN7/ytoLdFFI+Kl9b2sR8ROQYWzHAAB4oteIfA9Xrn8drly/+v1neQ9SAsQEiAkQEyAmQEyAmAAxAWICxASIfc5e2G2WcvXzrDbr+3ECYgLEBIgJEBMgJkBMgJgAMQFiAsQEiE2b3+w2q1lt1uzLCYgJEBMgJkBMgJgAMQFiAsQEiAkQEyD2GZHqP1lnqlmWExATICZATICYALFp29Gr3X1b23b0pgSICRATICZATICYADEBYgLEBIgJEDudBa2+S+Hd2Y7+EwLEBIgJEBMgJkBMgJgAMQFiAsQEiGXb0Vfttk09ixMQEyAmQEyAmACx018Wuz3na7XqOWVOQEyAmAAxAWICxASICRATICZATICYAAAA8Dw/6Q84sN95KfIAAAAASUVORK5CYII=";

var DiscordIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgB7d1RisIwFEDROMz+t6xuoEIg8QZ7zrdg5RL6SGs7BgAAAF/1GJs938YCj7eZz1ffO+tvkBIgJkBMgJgAsf+xyKqp4zRXv2vVdGQFxASICRATICZAbNkUNGv3Hku1dzTLCogJEBMgJkBMgFg2Bf3q3tEsKyAmQEyAmAAxAWLT+zGml89m96CsgJgAMQFiAsQEiF2esXdPO7uvWJ12RezqeKyAmAAxAWICxASICRATICZATICYADEBYgLEBIgJEBMgJkBMgJgAMQFiAsQEiAkQEyCW3Rd0N+4LOpQAMQFiAsQEiAkQEyAmQEyAmAAxAWLH/VN+99MUTzt+KyAmQEyAmAAxAWLTT028Osvf7QqaN2j8CAFiAsQEiAkAAADAvbwAjdY4oMibVwgAAAAASUVORK5CYII=";

var DocIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABlSURBVHgB7ZdBCgAgCAQt+v+Xq0sXL6sUqLRzjAIb3SCR32l6YW7kgrbx7O8SDAsYaIO3p3qG0Pn8Bg7em1mpY8CKNoPM1THwqueauilAWI3xKWYKmAIOIVOQ38DtPwHBIQwvgCyerxxa7TwmqgAAAABJRU5ErkJggg==";

var SupportIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABkSURBVHgB7ZfRCgAQDEUv+f9fxrO62VCzuufV6OZIGyCCKdbCPoGDMrHUVQSjANTT6tzq1LtfCv55A7fOd7DzpSA8QGMLr/8BhhQogAL82w/ckqYfaDjE2yUz8t7AjjRzgQhnANF9JDMhZ0PAAAAAAElFTkSuQmCC";

var HorizontalLine = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  height: 0;\n  width: 100%;\n  border-top: ", "px solid\n    ", ";\n  border-bottom: ", "px solid\n    ", ";\n"], ["\n  height: 0;\n  width: 100%;\n  border-top: ", "px solid\n    ", ";\n  border-bottom: ", "px solid\n    ", ";\n"])), BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
}, BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
});
var templateObject_1$b;

var StyledWalletContainer = styled(Flex)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  height: 36px;\n  width: fit-content;\n  padding: 6px 12px;\n  align-items: center;\n  gap: 12px;\n  background-color: ", ";\n  box-shadow: ", ";\n  cursor: ", ";\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  ", " {\n    height: 32px;\n    padding: 0 7px;\n  }\n"], ["\n  height: 36px;\n  width: fit-content;\n  padding: 6px 12px;\n  align-items: center;\n  gap: 12px;\n  background-color: ", ";\n  box-shadow: ", ";\n  cursor: ", ";\n  &:hover {\n    background-color: ", ";\n    box-shadow: ", ";\n  }\n\n  ", " {\n    height: 32px;\n    padding: 0 7px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.darkSlateGray, theme.colors.primary2.deepTeal, BOX_SHADOW_WIDTH);
}, function (_a) {
    var disconnected = _a.disconnected;
    return !disconnected && 'pointer';
}, function (_a) {
    var theme = _a.theme, disconnected = _a.disconnected;
    return !disconnected && theme.colors.primary2.darkSlateGray;
}, function (_a) {
    var theme = _a.theme, disconnected = _a.disconnected;
    return !disconnected &&
        createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.richBlack, BORDER_WIDTH$1);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var PixelatedBlock = function (_a) {
    var children = _a.children, height = _a.height, isConnected = _a.isConnected, props = __rest(_a, ["children", "height", "isConnected"]);
    return (React__default.createElement(Box, __assign({}, props),
        React__default.createElement(StyledWalletContainer, { height: height, disconnected: isConnected }, children)));
};
var templateObject_1$a;

var VerticalLine = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  height: 100%;\n  width: 0;\n  border-right: ", "px solid\n    ", ";\n  border-left: ", "px solid\n    ", ";\n"], ["\n  height: 100%;\n  width: 0;\n  border-right: ", "px solid\n    ", ";\n  border-left: ", "px solid\n    ", ";\n"])), BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.richBlack;
});
var SeparatorContainer = styled(Flex)(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  width: 40px;\n  height: 32px;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n"], ["\n  width: 40px;\n  height: 32px;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n"])));
var Separator = function () { return (React__default.createElement(SeparatorContainer, null,
    React__default.createElement(VerticalLine, null),
    React__default.createElement(VerticalLine, null),
    React__default.createElement(VerticalLine, null))); };
var templateObject_1$9, templateObject_2$6;

var Footer = function (_a) {
    var blockNumber = _a.blockNumber, isSupportEnabled = _a.isSupportEnabled, linkUrl = _a.linkUrl;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(FooterContainer, null,
        !isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(HorizontalLine, null),
            React__default.createElement(Separator, null),
            React__default.createElement(PixelatedBlock, null,
                React__default.createElement(LinkContainer, { href: linkUrl, target: "_blank" },
                    React__default.createElement(FooterBlockNumberLabel, null,
                        "Latest Block No. ",
                        blockNumber))),
            React__default.createElement(Separator, null),
            React__default.createElement(Box, { width: "200%" },
                React__default.createElement(HorizontalLine, null)),
            React__default.createElement(Separator, null))),
        React__default.createElement(MobileContainer, null,
            isMobile && (React__default.createElement(PixelatedBlock, null,
                React__default.createElement(FooterBlockNumberLabel, null,
                    "Latest Block No. ",
                    blockNumber))),
            isMobile && React__default.createElement(HorizontalLine, null),
            React__default.createElement(FooterLinksWrapper, null,
                React__default.createElement(FooterLink, { icon: DocIcon, href: docsLink }),
                React__default.createElement(FooterLink, { icon: SupportIcon, href: supportLink }),
                React__default.createElement(FooterLink, { isDiscord: true, icon: DiscordIcon, href: discordLink }),
                isSupportEnabled && (React__default.createElement(FooterLink, { icon: BugIcon, href: reportBugLink, target: "_blank" })))),
        !isMobile && React__default.createElement(Separator, null),
        !isMobile && React__default.createElement(HorizontalLine, null)));
};

var footerRad = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAA4CAYAAAC47+CuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVHgB7d0hTgNBAIXhgVQQJCiKJMiqXgDHaXAcA8dpcFygqnegitYRHAjUzjaZLNtHWPg+t2H0n8kLDEfl0G5uPwrAFDw/HZWg4wJAhMAChAgsQMj4/aGxuV7MLzvfm+2ue+D9zXnnnXf+V5w/9CbrBgsQIrAAIQILEDIrQ9Wb68lp9+f1pgEwFXXfRm6ybrAAIQILECKwACHtDbbaJJq/VwYwUb2+jdxk3WABQgQWIERgAUL6G6z3XAG+1L/nP3CTdYMFCBFYgBCBBQiZ2VwBvqmxybrBAoQILECIwAKEDH8PFoC9lnf3nU3WDRYgRGABQgQWIERgAUIEFiBEYAFCBBYgRGABQgQWIERgAUIEFiBkVr9fWP8t7Wq9LgD0LReLzvfq8cF7sAA/QWABQgQWIKT3Hmy9IdSb7MvrtgD8R63NteYGCxAisAAhAgsQ0vyfXK1NdrPdFYC/aHl91fluba41N1iAEIEFCBFYgJDmBltrbbLeLgCman5+1vkeurnW3GABQgQWIERgAUJG7Qv71JsswFSM3VxrbrAAIQILECKwACGfYPrFhBVz8OEAAAAASUVORK5CYII=";

var AssetFooterWrapper = styled(Flex)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 90px;\n  border-top: ", "px solid\n    ", ";\n  flex-direction: row;\n  justify-content: center;\n  gap: 40px;\n  align-items: center;\n  margin-bottom: 4px;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 90px;\n  border-top: ", "px solid\n    ", ";\n  flex-direction: row;\n  justify-content: center;\n  gap: 40px;\n  align-items: center;\n  margin-bottom: 4px;\n"])), BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.greenBlack;
});
var AssetFooterTopUpperBackground = styled(Flex)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
});
var AssetFooterTopBackground = styled(Flex)(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 47px;\n  top: 4px;\n  left: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 47px;\n  top: 4px;\n  left: 0;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
var AssetFooterBottomBackground = styled(Flex)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 35px;\n  top: 51px;\n  left: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 35px;\n  top: 51px;\n  left: 0;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
});
var AssetFooterBottomLowerBackground = styled(Flex)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  top: 86px;\n  left: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  top: 86px;\n  left: 0;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.deepTeal;
});
var FooterRadiator = styled.img(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  width: 344px;\n  height: 56px;\n  z-index: 5;\n"], ["\n  width: 344px;\n  height: 56px;\n  z-index: 5;\n"])));
var AssetFooter = function () {
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(AssetFooterWrapper, null,
        React__default.createElement(AssetFooterTopUpperBackground, null),
        React__default.createElement(AssetFooterTopBackground, null),
        React__default.createElement(AssetFooterBottomBackground, null),
        React__default.createElement(AssetFooterBottomLowerBackground, null),
        React__default.createElement(FooterRadiator, { src: footerRad }),
        !isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FooterRadiator, { src: footerRad }),
            React__default.createElement(FooterRadiator, { src: footerRad })))));
};
var templateObject_1$8, templateObject_2$5, templateObject_3$5, templateObject_4$2, templateObject_5$2, templateObject_6$2;

var BurgerMenuWrapper = styled(Flex)(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 10000;\n  visibility: ", ";\n  opacity: ", ";\n  transition: visibility 0.2s, opacity 0.2s ease-in;\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 10000;\n  visibility: ", ";\n  opacity: ", ";\n  transition: visibility 0.2s, opacity 0.2s ease-in;\n"])), function (_a) {
    var isOpened = _a.isOpened;
    return (isOpened ? 'visible' : 'hidden');
}, function (_a) {
    var isOpened = _a.isOpened;
    return (isOpened ? '1' : '0');
});
var BurgerMenuContainer = styled(Flex)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  position: relative;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px 24px;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  color: ", ";\n"], ["\n  position: relative;\n  flex-direction: column;\n  gap: 32px;\n  padding: 32px 24px;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.midnightGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.white;
});
var BurgerMenuOptionContainer = styled(Flex)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  padding: 32px 0;\n  border-bottom: 1px solid ", ";\n  :first-child {\n    border-top: 1px solid ", ";\n  }\n"], ["\n  padding: 32px 0;\n  border-bottom: 1px solid ", ";\n  :first-child {\n    border-top: 1px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.greennyGrey;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.greennyGrey;
});
var templateObject_1$7, templateObject_2$4, templateObject_3$4;

var BalanceContainer = styled(Flex)(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  align-items: center;\n  gap: 5px;\n"], ["\n  align-items: center;\n  gap: 5px;\n"])));
var WalletInfoBalanceDivider = styled(Box)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  width: 2px;\n  height: 16px;\n  background-color: #99b6b9;\n"], ["\n  width: 2px;\n  height: 16px;\n  background-color: #99b6b9;\n"])));
var StyledBumperLogo = styled('img')(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  width: 12px;\n  height: 12px;\n"], ["\n  width: 12px;\n  height: 12px;\n"])));
var WalletInfoContainer = styled(Flex)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 36px 8px 36px;\n  box-sizing: border-box;\n  background-color: ", ";\n  ", " {\n    padding: 16px 24px 8px 24px;\n  }\n"], ["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 36px 8px 36px;\n  box-sizing: border-box;\n  background-color: ", ";\n  ", " {\n    padding: 16px 24px 8px 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cyprus;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var WalletAddressContainer = styled(Flex)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  align-items: center;\n  gap: 10px;\n"], ["\n  align-items: center;\n  gap: 10px;\n"])));
var WalletAddressLabel = styled(Heading)(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n"], ["\n  color: ", ";\n  white-space: nowrap;\n  font-size: 14px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
});
var GreenSquare = styled(Box)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n  background-color: ", ";\n"], ["\n  width: 8px;\n  height: 8px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
});
var RedSquare = styled(Box)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n  background-color: ", ";\n"], ["\n  width: 8px;\n  height: 8px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.red;
});
var templateObject_1$6, templateObject_2$3, templateObject_3$3, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1;

var BalanceInfo = function (_a) {
    var bumpBalance = _a.bumpBalance, bumpInUSDBalance = _a.bumpInUSDBalance, bumpPrice = _a.bumpPrice;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(FlexWithGap, { gap: "14px", alignItems: "center" },
        React__default.createElement(Flex, { alignItems: "center" },
            React__default.createElement(FlexWithGap, { gap: "8px", alignItems: "center" },
                React__default.createElement(StyledBumperLogo, { src: BUMPIcon, alt: "bump" }),
                React__default.createElement(SmallText, { color: lightColors.typography.baliHai, style: { whiteSpace: 'nowrap' }, fontWeight: 500 }, "BUMP Balance")),
            React__default.createElement(Tooltip, { conntainerStyles: { mt: '3px' }, tooltipValue: 'Balance of your BUMPs' })),
        React__default.createElement(FlexWithGap, { gap: "12px", alignItems: "center" },
            React__default.createElement(BalanceContainer, null,
                React__default.createElement(SmallText, { fontWeight: 500, color: lightColors.typography.input }, bumpBalance),
                React__default.createElement(SmallText, { fontWeight: 500, color: lightColors.typography.input },
                    "($",
                    bumpInUSDBalance,
                    ")")),
            !isMobile && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(WalletInfoBalanceDivider, null),
                React__default.createElement(SmallText, { fontWeight: 500, color: lightColors.typography.input },
                    "BUMP = $",
                    bumpPrice))))));
};
var WalletInfo = function (_a) {
    var walletAddress = _a.walletAddress, logoutClick = _a.logoutClick, connectClick = _a.connectClick, props = __rest(_a, ["walletAddress", "logoutClick", "connectClick"]);
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(WalletInfoContainer, null,
        React__default.createElement(BalanceInfo, __assign({}, props)),
        !isMobile && (React__default.createElement(PixelatedBlock, { isConnected: walletAddress },
            walletAddress && (React__default.createElement(WalletAddressContainer, null,
                React__default.createElement(Box, { style: {
                        transform: "scale(1)",
                        cursor: 'pointer',
                    }, onClick: logoutClick },
                    React__default.createElement(Box, null,
                        React__default.createElement(Wallet, { variant: IconSize.L }))),
                React__default.createElement(WalletAddressLabel, null, "".concat(walletAddress.substring(0, 5), "...").concat(walletAddress.substring(walletAddress.length - 5, walletAddress.length))),
                React__default.createElement(GreenSquare, null))),
            !walletAddress && (React__default.createElement(WalletAddressContainer, { onClick: connectClick, style: { cursor: 'pointer' } },
                React__default.createElement(WalletAddressLabel, null, "Connect Wallet"),
                React__default.createElement(RedSquare, null)))))));
};

var BurgerMenu = function (_a) {
    var isOpened = _a.isOpened, walletAddress = _a.walletAddress, setIsOpened = _a.setIsOpened, subMenuOptions = _a.subMenuOptions, logoutClick = _a.logoutClick, connectClick = _a.connectClick;
    return (React__default.createElement(BurgerMenuWrapper, { isOpened: isOpened },
        React__default.createElement(BurgerMenuContainer, null,
            React__default.createElement(Flex, { width: "100%", alignItems: "center", justifyContent: "space-between" },
                React__default.createElement(Heading, { scale: 'xl', color: "primary2.cambridgeBlue" }, "MENU"),
                React__default.createElement(FlexWithGap, { gap: "12px", alignItems: "center", onClick: function () { return setIsOpened(false); }, style: { cursor: 'pointer' } },
                    React__default.createElement(Heading, { scale: 'md', color: "secondary.white", letterSpacing: "0.3em" }, "Cancel"),
                    React__default.createElement(Close$4, { variant: IconSize.L }))),
            React__default.createElement(Flex, { flexDirection: "column", width: "100%", pr: "40px" }, subMenuOptions.map(function (_a) {
                var name = _a.name, onClick = _a.onClick;
                return (React__default.createElement(BurgerMenuOption, { key: name, name: name, onClick: function () {
                        onClick();
                        setIsOpened(false);
                    } }));
            })),
            React__default.createElement(PixelatedBlock, { height: "unset !important", position: "absolute", bottom: "32px", left: "24px", padding: "2px 12px" },
                walletAddress && (React__default.createElement(WalletAddressContainer, null,
                    React__default.createElement(Box, { style: {
                            transform: "scale(1)",
                            cursor: 'pointer',
                        }, onClick: logoutClick },
                        React__default.createElement(Box, null,
                            React__default.createElement(Wallet, { variant: IconSize.L }))),
                    React__default.createElement(WalletAddressLabel, null, "".concat(walletAddress.substring(0, 5), "...").concat(walletAddress.substring(walletAddress.length - 5, walletAddress.length))),
                    React__default.createElement(GreenSquare, null))),
                !walletAddress && (React__default.createElement(WalletAddressContainer, { onClick: function () {
                        connectClick();
                        setIsOpened(false);
                    }, style: { cursor: 'pointer' } },
                    React__default.createElement(WalletAddressLabel, null, "Connect"),
                    React__default.createElement(RedSquare, null)))))));
};
var BurgerMenuOption = function (_a) {
    var name = _a.name, onClick = _a.onClick;
    return (React__default.createElement(BurgerMenuOptionContainer, null,
        React__default.createElement(LargeText, { fontFamily: "Roboto", fontSize: "24px", lineHeight: "32px", color: "secondary.white", bold: true, onClick: onClick }, name)));
};

var NAVIGATION_BUTTON_HEIGHT_ACTIVE = 72;
var NAVIGATION_BUTTON_HEIGHT = 56;
var NAVIGATION_BUTTON_WIDTH_ACTIVE = 145;
var NAVIGATION_BUTTON_WIDTH = 130;
var NAVIGATION_BUTTON_ACTIVE_Z_INDEX = lightTheme.zIndices.dropdown + 2;

var getButtonBackground = function (_a) {
    var isActive = _a.isActive;
    return isActive
        ? lightColors.primary2.darkSlateGray
        : lightColors.primary2.greenCyprus;
};
var getButtonHeight = function (_a) {
    var isActive = _a.isActive;
    return isActive ? NAVIGATION_BUTTON_HEIGHT_ACTIVE : NAVIGATION_BUTTON_HEIGHT;
};
var getButtonWidth = function (_a) {
    var isActive = _a.isActive;
    return isActive ? NAVIGATION_BUTTON_WIDTH_ACTIVE : NAVIGATION_BUTTON_WIDTH;
};
var getButtonBoxShadow = function (_a) {
    var isActive = _a.isActive;
    return isActive
        ? "0 ".concat(BOX_SHADOW_WIDTH, "px 0 ").concat(lightColors.primary2.darkSlateGray)
        : 0;
};
var getProtectButtonZIndex = function (activePage) {
    return activePage === 'protect'
        ? NAVIGATION_BUTTON_ACTIVE_Z_INDEX
        : activePage === 'stake'
            ? lightTheme.zIndices.dropdown - 1
            : lightTheme.zIndices.dropdown + 1;
};
var getEarnButtonZIndex = function (activePage) {
    return activePage === 'earn'
        ? NAVIGATION_BUTTON_ACTIVE_Z_INDEX
        : lightTheme.zIndices.dropdown;
};
var getStakeButtonZIndex = function (activePage) {
    return activePage === 'stake'
        ? NAVIGATION_BUTTON_ACTIVE_Z_INDEX
        : lightTheme.zIndices.dropdown - 1;
};

var LargeBumperLogo$1 = styled.img(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  width: 209px;\n  height: 73px;\n  cursor: pointer;\n"], ["\n  width: 209px;\n  height: 73px;\n  cursor: pointer;\n"])));
var ButtonIcon = styled.img(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n"], ["\n  width: 40px;\n  height: 40px;\n"])));
var NavigationButtonsWrapper = styled(Flex)(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  align-items: end;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n"], ["\n  align-items: end;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n"])));
var NavigationButtonCenter = styled(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: ", "px;\n  width: ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 -", "px 0 ", ";\n  ", " {\n    flex-direction: column;\n    width: fit-content;\n    height: 56px;\n    padding: 0 4px;\n    gap: 7px;\n  }\n"], ["\n  height: ", "px;\n  width: ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  cursor: pointer;\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 -", "px 0 ", ";\n  ", " {\n    flex-direction: column;\n    width: fit-content;\n    height: 56px;\n    padding: 0 4px;\n    gap: 7px;\n  }\n"])), getButtonHeight, getButtonWidth, getButtonBackground, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.input;
}, BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary2.myrtleGreen : theme.colors.primary2.darkSlateGray);
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var ButtonContainer = styled(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: -16px;\n  margin-right: -16px;\n  box-shadow: ", ";\n"], ["\n  margin-left: -16px;\n  margin-right: -16px;\n  box-shadow: ", ";\n"])), getButtonBoxShadow);
var ButtonSide = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  height: 100%;\n  ", " {\n    height: 56px;\n  }\n"], ["\n  height: 100%;\n  ", " {\n    height: 56px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var NavigationContainer = styled(Flex)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cyprus;
});
var NavigationWrapper = styled(Flex)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  background-color: ", ";\n  padding: 0 36px;\n  box-sizing: border-box;\n  ", " {\n    padding: 0 24px;\n  }\n"], ["\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  background-color: ", ";\n  padding: 0 36px;\n  box-sizing: border-box;\n  ", " {\n    padding: 0 24px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cyprus;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var NavigationMobileLogoSection = styled(Flex)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cyprus;
});
var SubNavContainer = styled(Box)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  z-index: 10;\n  display: ", ";\n  flex-direction: column;\n  position: absolute;\n  top: 0;\n  right: 0;\n  box-shadow: ", ";\n  background: ", ";\n"], ["\n  z-index: 10;\n  display: ", ";\n  flex-direction: column;\n  position: absolute;\n  top: 0;\n  right: 0;\n  box-shadow: ", ";\n  background: ", ";\n"])), function (_a) {
    var displayBol = _a.displayBol;
    return (displayBol ? 'flex' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return createPixelInsetBorder$1(theme.colors.primary2.greenBlack, theme.colors.primary2.myrtleGreen, theme.colors.primary2.myrtleGreen, BOX_SHADOW_WIDTH);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
var SubNavButtonsWrapper = styled(Box)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 30px 24px 30px;\n  & div:first-child {\n    padding-top: 0;\n  }\n  & div:last-child {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 30px 24px 30px;\n  & div:first-child {\n    padding-top: 0;\n  }\n  & div:last-child {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n"])));
var SubNavButtons = styled(Box)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  width: 100%;\n  padding: 20px 0;\n  border-bottom: 1px solid ", ";\n"], ["\n  width: 100%;\n  padding: 20px 0;\n  border-bottom: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var templateObject_1$5, templateObject_2$2, templateObject_3$2, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;

var LeftActiveSide = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABICAYAAACwc3YrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADCSURBVGhD7dW7DYNAEAbhg5ZcF5lrJrNbMMlFv5AsxGNupfkSLh1p2Z3a4F7L+9efu+b+LcsA2nD/QM78+vn21z5HiGYAzQBa+QD8Dhzd+8kRohlAM4BWPuDxO3B27ydHiGYAzQBa+YDb78DVez85QjQDaAbQygdcfgfu3vvJEaIZQDOAVj7g9B14eu8nR4hmAM0AWvmAw3eA3vvJEaIZQDOAVj7g7x0Ybe8nR4hmAM0AWvmAKfd8Gm3vJ0eIVjygtQ0ENi4OrQbDFAAAAABJRU5ErkJggg==";

var LeftSide = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA4CAYAAACPKLr2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACJSURBVHgB7dS5DYAwEAVRQxe0RkjvQBmQb2AJDfhiXgrBSGv9KVW2rNuV+z6nxhlITamw+ObOY8/+74kpAykDKXfw6e5FnpgykDKQ+t8O0t2LPDFlIGUgNf4Ovr17kSemDKQMpMbbwa93L/LElIGUgVT/O1h69yJPTBlIGUj1t4O1dy/yxFTzgTcg6yHnliS+1QAAAABJRU5ErkJggg==";

var RightActiveSide = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAABICAYAAACwc3YrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADLSURBVGhD7dW7DYNAEAbhO3fhIhzRjUP368CiCMqA5KJFwkI85laaL4F0pD39tbyGuWwZv7X9denRvmkZQKvP92fzDUzjr/01nb0JT4hmAM0AWvqAvzsQ9bYLnhDNAJoBtPQBu3cgonfBE6IZQDOAlj7g8A5Ed++CJ0QzgGYALX3A6TsQXb0LnhDNAJoBtPQBl+9AdPYueEI0A2gG0NIH3L4D0dFd8IRoBtAMoKUPwHcg2rsLnhDNAJoBtPQB3e1AtNqFwBOiJQ8oZQHLajfmNOsiPgAAAABJRU5ErkJggg==";

var RightSide = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA4CAYAAACPKLr2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACTSURBVHgB7dQ7CoAwFAXRp7gMwcbC/a/Gwr1obQRFRuMnc+oUAy/cKvphjj3TWMWD6ng5A6km2u7ozfqPZv6TnpgykDKQ+sAOHtnuZNZd9MSUgZSB1A92MJV5Fz0xZSBlIPXDHUzdvIuemDKQMpAqYAdTF++iJ6YMpAykCtzBFNxFT0wZSBlIuYMbJ3fRE1OvD1wAo/UYB+OymZkAAAAASUVORK5CYII=";

var BumperLogo$1 = "data:image/png;base64,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";

var NavigationButton = function (_a) {
    var icon = _a.icon, name = _a.name, isActive = _a.isActive, onClick = _a.onClick, props = __rest(_a, ["icon", "name", "isActive", "onClick"]);
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(ButtonContainer, __assign({ isActive: isActive }, props),
        React__default.createElement(ButtonSide, { src: isActive ? LeftActiveSide : LeftSide, style: { marginRight: '-1px' } }),
        React__default.createElement(NavigationButtonCenter, { isActive: isActive, onClick: onClick },
            !isMobile && React__default.createElement(ButtonIcon, { src: icon }),
            React__default.createElement(Heading, { scale: "md", lineHeight: "24px", color: "secondary.white" }, name)),
        React__default.createElement(ButtonSide, { src: isActive ? RightActiveSide : RightSide })));
};
var SubNavButton = function (_a) {
    var name = _a.name, onClick = _a.onClick;
    return (React__default.createElement(SubNavButtons, null,
        React__default.createElement(Heading, { color: lightColors.typography.input, scale: "md", lineHeight: "24px", style: { cursor: 'pointer' }, onClick: onClick }, name)));
};
var Navigation = function (_a) {
    var subMenuOptions = _a.subMenuOptions, activePage = _a.activePage, protectClick = _a.protectClick, earnClick = _a.earnClick, stakeClick = _a.stakeClick, homePageClick = _a.homePageClick, walletAddress = _a.walletAddress, connectClick = _a.connectClick, logoutClick = _a.logoutClick;
    var _b = useState(false), openSubNav = _b[0], setOpenSubNav = _b[1];
    var container = useRef(null);
    var openButton = useRef(null);
    var isMobile = useMatchBreakpoints().isMobile;
    useEffect(function () {
        var onClick = function (e) {
            var _a, _b;
            var target = e.target;
            if (!((_a = container === null || container === void 0 ? void 0 : container.current) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !((_b = openButton === null || openButton === void 0 ? void 0 : openButton.current) === null || _b === void 0 ? void 0 : _b.contains(target))) {
                setOpenSubNav(false);
            }
        };
        if (!isMobile)
            document.addEventListener('click', onClick);
        return function () {
            if (!isMobile)
                document.removeEventListener('click', onClick);
        };
    }, []);
    useEffect(function () {
        if (isMobile && openSubNav) {
            document.body.style.overflowY = 'hidden';
        }
        else {
            document.body.style.overflowY = 'scroll';
        }
    }, [openSubNav]);
    return (React__default.createElement(React__default.Fragment, null,
        isMobile && (React__default.createElement(BurgerMenu, { isOpened: openSubNav, setIsOpened: setOpenSubNav, subMenuOptions: subMenuOptions, walletAddress: walletAddress, connectClick: connectClick, logoutClick: logoutClick })),
        React__default.createElement(NavigationWrapper, null,
            isMobile && (React__default.createElement(NavigationMobileLogoSection, null,
                React__default.createElement(LargeBumperLogo$1, { src: BumperLogo$1, alt: "bumper", onClick: homePageClick }),
                React__default.createElement(Box, { position: "relative" },
                    React__default.createElement(Box, { onClick: function () { return setOpenSubNav(true); }, style: { cursor: 'pointer' }, ref: openButton },
                        React__default.createElement(HamburgerMenu, { variant: IconSize.L })),
                    !isMobile && (React__default.createElement(SubNavContainer, { displayBol: openSubNav, ref: container },
                        React__default.createElement(Flex, { p: "12px 12px 0 12px", justifyContent: "end" },
                            React__default.createElement(Box, { onClick: function () { return setOpenSubNav(false); }, style: { cursor: 'pointer' } },
                                React__default.createElement(Close$4, { variant: IconSize.L }))),
                        React__default.createElement(SubNavButtonsWrapper, null, subMenuOptions.map(function (_a) {
                            var name = _a.name, onClick = _a.onClick;
                            return (React__default.createElement(SubNavButton, { key: name, name: name, onClick: function () {
                                    onClick();
                                    setOpenSubNav(false);
                                } }));
                        }))))))),
            React__default.createElement(NavigationContainer, null,
                !isMobile && (React__default.createElement(LargeBumperLogo$1, { src: BumperLogo$1, alt: "bumper", onClick: homePageClick })),
                React__default.createElement(NavigationButtonsWrapper, null,
                    React__default.createElement(NavigationButton, { name: "Protect", icon: ProtectIcon, isActive: activePage === 'protect', onClick: protectClick, zIndex: getProtectButtonZIndex(activePage) }),
                    React__default.createElement(NavigationButton, { name: "Earn", icon: EarnIcon, isActive: activePage === 'earn', onClick: earnClick, zIndex: getEarnButtonZIndex(activePage) }),
                    React__default.createElement(NavigationButton, { name: "Stake", icon: StakeIcon, isActive: activePage === 'stake', onClick: stakeClick, zIndex: getStakeButtonZIndex(activePage) })),
                !isMobile && (React__default.createElement(Box, { position: "relative" },
                    React__default.createElement(Box, { onClick: function () { return setOpenSubNav(true); }, style: { cursor: 'pointer' }, ref: openButton },
                        React__default.createElement(HamburgerMenu, { variant: IconSize.L })),
                    React__default.createElement(SubNavContainer, { displayBol: openSubNav, ref: container },
                        React__default.createElement(Flex, { p: "12px 12px 0 12px", justifyContent: "end" },
                            React__default.createElement(Box, { onClick: function () { return setOpenSubNav(false); }, style: { cursor: 'pointer' } },
                                React__default.createElement(Close$4, { variant: IconSize.L }))),
                        React__default.createElement(SubNavButtonsWrapper, null, subMenuOptions.map(function (_a) {
                            var name = _a.name, onClick = _a.onClick;
                            return (React__default.createElement(SubNavButton, { key: name, name: name, onClick: function () {
                                    onClick();
                                    setOpenSubNav(false);
                                } }));
                        })))))))));
};

var SummaryTVLFieldText = styled(LargeText)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  line-height: 24px;\n  white-space: nowrap;\n"], ["\n  line-height: 24px;\n  white-space: nowrap;\n"])));
var SummaryTVLFieldContainer = styled(Flex)(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 4px 20px;\n"], ["\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 4px 20px;\n"])));
var SummaryTVLContainer = styled(Flex)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0;\n  box-sizing: border-box;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n  background-color: ", ";\n"], ["\n  width: 100%;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 0;\n  box-sizing: border-box;\n  border-bottom: ", "px solid\n    ", ";\n  border-top: ", "px solid\n    ", ";\n  background-color: ", ";\n"])), BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkRichBlack;
}, BOX_SHADOW_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.myrtleGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkSlateGray;
});
var templateObject_1$4, templateObject_2$1, templateObject_3$1;

var SummaryTVLField = function (_a) {
    var name = _a.name, value = _a.value;
    return (React__default.createElement(SummaryTVLFieldContainer, null,
        React__default.createElement(SummaryTVLFieldText, { color: lightColors.typography.gray }, name),
        React__default.createElement(SummaryTVLFieldText, { fontWeight: 500, color: lightColors.typography.input },
            "$",
            value)));
};
var SummaryTVL = memo(function (_a) {
    var protocolTVL = _a.protocolTVL, takerTVL = _a.takerTVL, makerTVL = _a.makerTVL, stakerTVL = _a.stakerTVL;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(SummaryTVLContainer, null,
        React__default.createElement(HorizontalLine, null),
        isMobile && (React__default.createElement(Flex, { width: "300px" },
            React__default.createElement(AliceCarousel, { autoPlay: true, autoPlayStrategy: "none", autoPlayInterval: 4000, animationDuration: 1000, animationType: "fadeout", infinite: true, touchTracking: false, disableDotsControls: true, disableButtonsControls: true, items: [
                    React__default.createElement(SummaryTVLField, { key: "1", name: "Protocol TVL", value: protocolTVL }),
                    React__default.createElement(SummaryTVLField, { key: "2", name: "Protect TVL", value: takerTVL }),
                    React__default.createElement(SummaryTVLField, { key: "3", name: "Earn TVL", value: makerTVL }),
                    React__default.createElement(SummaryTVLField, { key: "4", name: "Stake TVL", value: stakerTVL }),
                ] }))),
        !isMobile && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SummaryTVLField, { name: "Protocol TVL", value: protocolTVL }),
            React__default.createElement(Separator, null),
            React__default.createElement(SummaryTVLField, { name: "Protect TVL", value: takerTVL }),
            React__default.createElement(Separator, null),
            React__default.createElement(SummaryTVLField, { name: "Earn TVL", value: makerTVL }),
            React__default.createElement(Separator, null),
            React__default.createElement(SummaryTVLField, { name: "Stake TVL", value: stakerTVL }))),
        React__default.createElement(HorizontalLine, null)));
});

var MenuWrapper$1 = styled(Flex)(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  width: 100%;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  flex-direction: column;\n"])));
var Header = function (_a) {
    var subMenuOptions = _a.subMenuOptions, bumpBalance = _a.bumpBalance, bumpInUSDBalance = _a.bumpInUSDBalance, walletAddress = _a.walletAddress, activePage = _a.activePage, protectClick = _a.protectClick, earnClick = _a.earnClick, stakeClick = _a.stakeClick, protocolTVL = _a.protocolTVL, takerTVL = _a.takerTVL, makerTVL = _a.makerTVL, stakerTVL = _a.stakerTVL, isFlowActive = _a.isFlowActive, logoutClick = _a.logoutClick, connectClick = _a.connectClick, homePageClick = _a.homePageClick, bumpPrice = _a.bumpPrice;
    return (React__default.createElement(MenuWrapper$1, null,
        React__default.createElement(WalletInfo, { bumpPrice: bumpPrice, walletAddress: walletAddress, logoutClick: logoutClick, bumpBalance: bumpBalance, bumpInUSDBalance: bumpInUSDBalance, connectClick: connectClick }),
        !isFlowActive && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Navigation, { subMenuOptions: subMenuOptions, walletAddress: walletAddress, activePage: activePage, protectClick: protectClick, earnClick: earnClick, stakeClick: stakeClick, homePageClick: homePageClick, connectClick: connectClick, logoutClick: logoutClick }),
            React__default.createElement(SummaryTVL, { protocolTVL: protocolTVL, takerTVL: takerTVL, makerTVL: makerTVL, stakerTVL: stakerTVL })))));
};
var templateObject_1$3;

var LargeBumperLogo = styled.img(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  width: 209px;\n  height: 73px;\n"], ["\n  width: 209px;\n  height: 73px;\n"])));
var FlowHeaderCenter = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var FlowHeaderContainer = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  background-color: ", ";\n  padding: 0 36px;\n  box-sizing: border-box;\n  border-bottom: 4px solid ", ";\n  ", " {\n    height: unset;\n    flex-direction: column;\n    gap: 8px;\n    padding-bottom: 32px;\n  }\n"], ["\n  width: 100%;\n  height: 76px;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  background-color: ", ";\n  padding: 0 36px;\n  box-sizing: border-box;\n  border-bottom: 4px solid ", ";\n  ", " {\n    height: unset;\n    flex-direction: column;\n    gap: 8px;\n    padding-bottom: 32px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cyprus;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.darkGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.sm;
});
var templateObject_1$2, templateObject_2, templateObject_3;

var BumperLogo = "data:image/svg+xml,%3Csvg%20width%3D%22209%22%20height%3D%2273%22%20viewBox%3D%220%200%20209%2073%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M155.054%2037.1672H150.531L152.138%2028.6338H156.332C157.71%2028.6338%20158.768%2028.9276%20159.511%2029.5125C160.254%2030.0967%20160.626%2030.9754%20160.626%2032.1453C160.626%2033.7608%20160.139%2035.0009%20159.167%2035.8671C158.195%2036.7332%20156.824%2037.1672%20155.054%2037.1672ZM166%2031.6187C166%2029.2088%20165.213%2027.3354%20163.641%2026.0019C162.067%2024.6667%20159.86%2024.0008%20157.021%2024.0008H147.681L143.092%2048.5794H148.434L149.712%2041.6975H154.236L157.841%2048.5794H163.445L159.445%2040.9949C161.499%2040.3165%20163.104%2039.1574%20164.265%2037.5193C165.42%2035.8796%20166%2033.9135%20166%2031.6187ZM138.97%2028.5646L139.856%2024H122.519L117.93%2048.5786H135.693L136.578%2044.014H124.059L125.108%2038.3254H135.792L136.612%2033.9019H125.96L126.943%2028.5646H138.97ZM103.125%2037.1672H98.6353L100.241%2028.6338H104.403C105.78%2028.6338%20106.834%2028.9276%20107.566%2029.5125C108.297%2030.0967%20108.664%2030.9754%20108.664%2032.1453C108.664%2033.7608%20108.183%2035.0009%20107.221%2035.8671C106.259%2036.7341%20104.895%2037.1672%20103.125%2037.1672ZM105.058%2024H95.7841L91.196%2048.5786H96.538L97.7833%2041.8018H102.896C105.167%2041.8018%20107.139%2041.3929%20108.811%2040.5726C110.482%2039.754%20111.771%2038.5758%20112.678%2037.0437C113.584%2035.5116%20114.037%2033.7133%20114.037%2031.6538C114.037%2029.243%20113.255%2027.3638%20111.695%2026.0178C110.133%2024.6726%20107.921%2024%20105.058%2024ZM82.6265%2024L71.4192%2039.3093L65.6839%2024H61.3583L56.7703%2048.5786H61.7509L64.504%2033.8309L69.2229%2045.98H71.5828L80.3329%2033.972L77.6452%2048.5786H82.6265L87.1819%2024H82.6265ZM38.7591%2049C45.1821%2049%2049.0926%2045.3367%2050.4914%2038.01L53.0802%2024H47.8691L45.3129%2037.6587C44.876%2039.9293%2044.1766%2041.5799%2043.2156%2042.6096C42.2545%2043.6402%2040.9655%2044.1559%2039.3487%2044.1559C37.9071%2044.1559%2036.8089%2043.7879%2036.055%2043.0502C35.3019%2042.3125%2034.9249%2041.2068%2034.9249%2039.7307C34.9249%2039.1223%2034.9904%2038.4314%2035.1212%2037.6603L37.6773%2024.0017H32.3353L29.7792%2037.7655C29.6048%2038.7485%2029.5175%2039.6255%2029.5175%2040.3991C29.5175%2043.0661%2030.3369%2045.1689%2031.9755%2046.7019C33.6142%2048.2348%2035.8751%2049%2038.7591%2049ZM12.3553%2044.2952H6.09588L7.2096%2038.2203H13.6334C15.927%2038.2203%2017.0742%2039.0631%2017.0742%2040.7487C17.0742%2041.8961%2016.6591%2042.7732%2015.8289%2043.3815C14.9979%2043.9907%2013.8405%2044.2952%2012.3553%2044.2952ZM14.4192%2028.2834C16.6692%2028.2834%2017.7946%2029.0561%2017.7946%2030.6007C17.7946%2031.7247%2017.4068%2032.5851%2016.6319%2033.1817C15.8561%2033.7784%2014.7689%2034.0771%2013.3709%2034.0771H7.96351L9.0453%2028.2834H14.4192ZM19.2697%2035.9029C20.5369%2035.3413%2021.5361%2034.5286%2022.2682%2033.4629C23.0003%2032.3981%2023.3664%2031.1164%2023.3664%2029.6185C23.3664%2027.816%2022.6997%2026.4292%2021.3671%2025.4578C20.0345%2024.4865%2018.1334%2024.0008%2015.6646%2024.0008H4.58807L0%2048.5786H12.0274C15.1513%2048.5786%2017.6529%2047.9235%2019.5322%2046.6126C21.4107%2045.3033%2022.35%2043.3706%2022.35%2040.8205C22.35%2039.6247%2022.0821%2038.6125%2021.547%2037.7813C21.012%2036.951%2020.2526%2036.3243%2019.2697%2035.9029Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M202.417%2038.4727H203.733V43.7354H203.733V45.0513H201.102V43.7354H202.417V38.4727ZM199.787%2045.0518H202.419V46.3677H201.102V47.6831H197.154V46.3672H199.787V45.0518ZM198.472%2047.6836H185.312V48.9995H198.472V47.6836ZM189.917%2039.1309H189.259V41.1047H189.917V39.1309Z%22%20fill%3D%22%239E3100%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M207.68%2027.9453H208.996V34.5248H207.68V27.9453ZM206.366%2035.8398H207.679V33.208H206.363V34.5244H190.575V35.8404H206.366V35.8398Z%22%20fill%3D%22%23934818%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M197.159%2037.1602H186.633V47.6874H197.16V46.3715H199.791V45.0556H201.105V43.7397H202.42V37.1602H201.105H201.104H199.791H199.789H197.16H197.159ZM185.316%2043.7393H184V47.687H186.632V43.7402H186.632V38.4766H185.316V43.7393Z%22%20fill%3D%22%23FF5000%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M191.896%2024H202.421H202.424H205.053V25.3159H202.424V25.3164H206.369V26.6309H207.685V33.2104H202.424V33.2109H206.37V34.5268H202.424V34.5272H191.896V24ZM189.263%2033.2109H191.895V34.5268H189.263V33.2109ZM191.895%2026.6309H190.579V33.2104H191.895V26.6309Z%22%20fill%3D%22%23FF7D2B%22%2F%3E%3C%2Fsvg%3E";

var FlowHeader = function (_a) {
    var steps = _a.steps, stepsStatus = _a.stepsStatus, cancelClick = _a.cancelClick, logoClick = _a.logoClick;
    var isMobile = useMatchBreakpoints().isMobile;
    return (React__default.createElement(FlowHeaderContainer, null,
        React__default.createElement(Flex, { alignItems: "center", justifyContent: "space-between", width: "100%" },
            React__default.createElement(LargeBumperLogo, { src: BumperLogo, alt: "bumper", onClick: logoClick }),
            !isMobile && (React__default.createElement(FlowHeaderCenter, null,
                React__default.createElement(Stepper, null, steps.map(function (step, index) { return (React__default.createElement(Step, { key: step, index: index, status: stepsStatus[index] }, step)); })))),
            React__default.createElement(Flex, { alignItems: "center", onClick: cancelClick, style: { cursor: 'pointer' } },
                !isMobile && (React__default.createElement(Heading, { mr: "12px", color: lightColors.typography.input }, "Cancel")),
                React__default.createElement(Close$4, { variant: IconSize.L }))),
        isMobile && (React__default.createElement(Stepper, null, steps.map(function (step, index) { return (React__default.createElement(Step, { key: step, index: index, status: stepsStatus[index], scale: "sm" }, step)); })))));
};

var MenuWrapper = styled(Flex)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  min-height: 100vh;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  min-height: 100vh;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var Menu = function (_a) {
    var subMenuOptions = _a.subMenuOptions, bumpBalance = _a.bumpBalance, bumpInUSDBalance = _a.bumpInUSDBalance, walletAddress = _a.walletAddress, activePage = _a.activePage, protectClick = _a.protectClick, earnClick = _a.earnClick, stakeClick = _a.stakeClick, protocolTVL = _a.protocolTVL, takerTVL = _a.takerTVL, makerTVL = _a.makerTVL, stakerTVL = _a.stakerTVL, children = _a.children, isFlowActive = _a.isFlowActive, blockNumber = _a.blockNumber, logoutClick = _a.logoutClick, connectClick = _a.connectClick, homePageClick = _a.homePageClick, linkUrl = _a.linkUrl, bumpPrice = _a.bumpPrice, isSupportEnabled = _a.isSupportEnabled;
    return (React__default.createElement(MenuWrapper, null,
        React__default.createElement(Header, { bumpPrice: bumpPrice, logoutClick: logoutClick, subMenuOptions: subMenuOptions, walletAddress: walletAddress, bumpBalance: bumpBalance, bumpInUSDBalance: bumpInUSDBalance, activePage: activePage, protectClick: protectClick, earnClick: earnClick, stakeClick: stakeClick, protocolTVL: protocolTVL, takerTVL: takerTVL, makerTVL: makerTVL, stakerTVL: stakerTVL, isFlowActive: isFlowActive, connectClick: connectClick, homePageClick: homePageClick }),
        children,
        React__default.createElement(Footer, { blockNumber: blockNumber, linkUrl: linkUrl, isSupportEnabled: isSupportEnabled })));
};
var templateObject_1$1;

var ResetCSS = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* prettier-ignore */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed, \n  figure, figcaption, footer, header, hgroup, \n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  }\n  /* HTML5 display-role reset for older browsers */\n  /* prettier-ignore */\n  article, aside, details, figcaption, figure, \n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n    font-size: 16px;\n  }\n  ol,\n  ul {\n    list-style: disc;\n    list-style-position: inside;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: \"\";\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n  [role=\"button\"] {\n    cursor: pointer;\n  }\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  /* Number */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n\n  /* Scrollbar */\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ", "; \n    border-radius: 8px;\n  }\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px ", "; \n    border-radius: 10px;\n  }\n\n  /* Slider */ \n  input[type=range] {\n    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */\n    width: 100%; /* Specific width is required for Firefox. */\n    background: transparent; /* Otherwise white in Chrome */\n  }\n  input[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n  }\n  input[type=range]:focus {\n    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */\n  }\n  input[type=range]::-ms-track {\n    width: 100%;\n    cursor: pointer;\n    /* Hides the slider so custom styles can be added */\n    background: transparent; \n    border-color: transparent;\n    color: transparent;\n  }  \n"], ["\n  /* prettier-ignore */\n  html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed, \n  figure, figcaption, footer, header, hgroup, \n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    vertical-align: baseline;\n  }\n  /* HTML5 display-role reset for older browsers */\n  /* prettier-ignore */\n  article, aside, details, figcaption, figure, \n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n  body {\n    line-height: 1;\n    font-size: 16px;\n  }\n  ol,\n  ul {\n    list-style: disc;\n    list-style-position: inside;\n  }\n  blockquote,\n  q {\n    quotes: none;\n  }\n  blockquote:before,\n  blockquote:after,\n  q:before,\n  q:after {\n    content: \"\";\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n  [role=\"button\"] {\n    cursor: pointer;\n  }\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  /* Number */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n\n  /* Scrollbar */\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ", "; \n    border-radius: 8px;\n  }\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px ", "; \n    border-radius: 10px;\n  }\n\n  /* Slider */ \n  input[type=range] {\n    -webkit-appearance: none; /* Hides the slider so that custom slider can be made */\n    width: 100%; /* Specific width is required for Firefox. */\n    background: transparent; /* Otherwise white in Chrome */\n  }\n  input[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n  }\n  input[type=range]:focus {\n    outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */\n  }\n  input[type=range]::-ms-track {\n    width: 100%;\n    cursor: pointer;\n    /* Hides the slider so custom styles can be added */\n    background: transparent; \n    border-color: transparent;\n    color: transparent;\n  }  \n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary.green;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary2.cambridgeBlue;
});
var templateObject_1;

export { ArrowLong, ArrowShort, AssetCard, AssetFooter, AssetLabel, AssetLabelDark, AutoRenewCard, BOTTOM_LEDGE_HEIGHT, BOTTOM_LEDGE_WIDTH, BOTTOM_LEDGE_WIDTH_MOBILE, BOX_SHADOW_WIDTH$4 as BOX_SHADOW_WIDTH, Background, BalanceContainer, BalanceInfo, Banner, Box, Bump, BumpSection, Button$2 as Button, Calendar$7 as Calendar, CardView, Check$1 as Caret, Cart, Carusel, Check, Checkbox, Close$4 as Close, ConfirmCard, ConfirmHorizontalDivider, ConfirmWithdrawCard, ConfirmationBox, ConfirmationBoxFixed, ConnectWalletModal, Cooldown, CustomThemeProvider, DOUBLE_BOX_SHADOW_WIDTH$1 as DOUBLE_BOX_SHADOW_WIDTH, DarkInfoBox, DarkInfoBoxSm, DarkLabel, Dashboard, DashboardCard, DashboardSocketIndicators, DepositButton, Dialogue, DialogueMsg as DialogueCloud, DialoguePosition, Discord, Document, DotsMenu, Download, EarnCard, EarnLogo, EarningUnitsCard, Ethereum, EthereumGreen, Flex, FlexWithGap, Card as FlowCard, FlowHeader, Footer, GreenLabel, GreenSquare, Grid$2 as Grid, GridWithGap, Hairbrush, HamburgerMenu, Header, Heading, History, HorizontalOrientation, HubPages, IconSize, InfoArea, InfoBox, InfoSummary, InfoSummaryText, Input, InputErrorWrapper, InputGroup, Label, LargeText, LightInfoBox, LightInfoBoxSm, LightLabel, Link, LinkOut, ListView, Loading, Lock, MediumText, Menu, Minus, Navigation, Notification, OUTSIDE_RADIATOR_WIDTH, OperationsEnum, Orientation, PYRAMID_HIGHEST_LEVEL_WIDTH, PeriodCard, Plus, PositionInfo, Processing, ProcessingIco, ProtectCard, ProtectFloorCard, ProtectLogo, ProtectTermCard, ProtectUnitsCard, Pyramid, QuestionCircle, RADIATOR_WIDTH, Radiator$1 as Radiator, RedLabel, RedSquare, ResetCSS, RiskTierCard, Select, Slider, SliderCard, SliderDotActive, SliderDotInactive, SmallText, SocketEarnOn, SocketOff, SocketProtectOn, SocketStakeOn, SocketType, StakeCard, StakeLogo, Step, Stepper, Steps, StyledBumperLogo, SummaryCard, SummaryTVL, Support, Text, Toggle, ToggleParams, Tooltip, TotalHubInfoBox, TransactionLogo, UnitsCard, VerticalOrientation, Vesting, Wallet, WalletAddressContainer, WalletAddressLabel, WalletInfo, WalletInfoBalanceDivider, WalletInfoContainer, YellowOrangeDiamond, fontWeightReqular, fontWeightSemiBold, getFormattedAmount, getFormattedAmountWithSymbol$1 as getFormattedAmountWithSymbol, getFormattedPercents$1 as getFormattedPercents, getPercentsColor$1 as getPercentsColor, getPyramidBottomColor, getPyramidTopColor, isZero$1 as isZero, lightTheme as light, lightColors, sizes, useHover, useIsomorphicEffect, useMatchBreakpoints };
//# sourceMappingURL=index.js.map
